//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export module WebApiV1 {

export class ApiVersionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getUpdateInfo(deviceType: DeviceType, appVersion: string, osVersion: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfVersionUpdate> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/apiversion/GetUpdateInfo?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (deviceType === undefined || deviceType === null)
            throw new Error("The parameter 'deviceType' must be defined and cannot be null.");
        else
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (appVersion === undefined || appVersion === null)
            throw new Error("The parameter 'appVersion' must be defined and cannot be null.");
        else
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (osVersion === undefined || osVersion === null)
            throw new Error("The parameter 'osVersion' must be defined and cannot be null.");
        else
            url_ += "osVersion=" + encodeURIComponent("" + osVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpdateInfo(_response);
        });
    }

    protected processGetUpdateInfo(response: AxiosResponse): Promise<V2ControllerResultOfVersionUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfVersionUpdate.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfVersionUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfVersionUpdate>(null as any);
    }

    /**
     * @return OK
     */
    getUpdateInfo2(deviceType: DeviceType2, appVersion: string, osVersion: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfVersionUpdate> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/apiversion/GetUpdateInfo?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (deviceType === undefined || deviceType === null)
            throw new Error("The parameter 'deviceType' must be defined and cannot be null.");
        else
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (appVersion === undefined || appVersion === null)
            throw new Error("The parameter 'appVersion' must be defined and cannot be null.");
        else
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (osVersion === undefined || osVersion === null)
            throw new Error("The parameter 'osVersion' must be defined and cannot be null.");
        else
            url_ += "osVersion=" + encodeURIComponent("" + osVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpdateInfo2(_response);
        });
    }

    protected processGetUpdateInfo2(response: AxiosResponse): Promise<V2ControllerResultOfVersionUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfVersionUpdate.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfVersionUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfVersionUpdate>(null as any);
    }

    /**
     * @return OK
     */
    getUpdateInfo3(deviceType: DeviceType3, appVersion: string, osVersion: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfVersionUpdate> {
        let url_ = this.baseUrl + "/api/apiversion/GetUpdateInfo?";
        if (deviceType === undefined || deviceType === null)
            throw new Error("The parameter 'deviceType' must be defined and cannot be null.");
        else
            url_ += "deviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (appVersion === undefined || appVersion === null)
            throw new Error("The parameter 'appVersion' must be defined and cannot be null.");
        else
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (osVersion === undefined || osVersion === null)
            throw new Error("The parameter 'osVersion' must be defined and cannot be null.");
        else
            url_ += "osVersion=" + encodeURIComponent("" + osVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpdateInfo3(_response);
        });
    }

    protected processGetUpdateInfo3(response: AxiosResponse): Promise<V2ControllerResultOfVersionUpdate> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfVersionUpdate.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfVersionUpdate>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfVersionUpdate>(null as any);
    }
}

export class BaseFavoritesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    addToFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basefavorites/AddToFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites(_response);
        });
    }

    protected processAddToFavorites(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basefavorites/RemoveFromFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites(_response);
        });
    }

    protected processRemoveFromFavorites(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basefavorites/IsProductFavorite?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite(_response);
        });
    }

    protected processIsProductFavorite(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basefavorites/AddToFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites2(_response);
        });
    }

    protected processAddToFavorites2(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basefavorites/RemoveFromFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites2(_response);
        });
    }

    protected processRemoveFromFavorites2(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basefavorites/IsProductFavorite?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite2(_response);
        });
    }

    protected processIsProductFavorite2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/basefavorites/AddToFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites3(_response);
        });
    }

    protected processAddToFavorites3(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/basefavorites/RemoveFromFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites3(_response);
        });
    }

    protected processRemoveFromFavorites3(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite3(productSku: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/basefavorites/IsProductFavorite?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite3(_response);
        });
    }

    protected processIsProductFavorite3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class BaseSearchClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult(q: string, hits: number | null | undefined, searchContext: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basesearch/GetAutoSuggestSearchResult?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult(_response);
        });
    }

    protected processGetAutoSuggestSearchResult(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult2(q: string, hits: number | null | undefined, searchContext: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basesearch/GetAutoSuggestSearchResult?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult2(_response);
        });
    }

    protected processGetAutoSuggestSearchResult2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult3(q: string, hits: number | null | undefined, searchContext: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/basesearch/GetAutoSuggestSearchResult?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult3(_response);
        });
    }

    protected processGetAutoSuggestSearchResult3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }
}

export class BasketClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getBasket(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/GetBasket";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasket(_response);
        });
    }

    protected processGetBasket(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateContractProduct(model: AddContractProductModel, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/AddUpdateContractProduct";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateContractProduct(_response);
        });
    }

    protected processAddUpdateContractProduct(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateCatalogProduct(model: AddCatalogProductModel, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/AddUpdateCatalogProduct";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateCatalogProduct(_response);
        });
    }

    protected processAddUpdateCatalogProduct(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    updateCatalogProductQuantity(lineId: string, quantity: number, addressId: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/UpdateCatalogProductQuantity?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        if (quantity === undefined || quantity === null)
            throw new Error("The parameter 'quantity' must be defined and cannot be null.");
        else
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined and cannot be null.");
        else
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogProductQuantity(_response);
        });
    }

    protected processUpdateCatalogProductQuantity(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeBasketLine(lineId: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/RemoveBasketLine?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveBasketLine(_response);
        });
    }

    protected processRemoveBasketLine(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeSoldoutBasketLines(accountId: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/RemoveSoldoutBasketLines?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSoldoutBasketLines(_response);
        });
    }

    protected processRemoveSoldoutBasketLines(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    simulateOrder(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/SimulateOrder";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimulateOrder(_response);
        });
    }

    protected processSimulateOrder(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    placeOrder(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfKPSentResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/PlaceOrder";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlaceOrder(_response);
        });
    }

    protected processPlaceOrder(response: AxiosResponse): Promise<HaGeControllerResultOfKPSentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfKPSentResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfKPSentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfKPSentResult>(null as any);
    }

    /**
     * @param basketId (optional) 
     * @return OK
     */
    resetBasket(basketId: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/ResetBasket?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetBasket(_response);
        });
    }

    protected processResetBasket(response: AxiosResponse): Promise<HaGeControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    acceptTradingConditions(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/basket/AcceptTradingConditions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptTradingConditions(_response);
        });
    }

    protected processAcceptTradingConditions(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getBasket2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/GetBasket";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasket2(_response);
        });
    }

    protected processGetBasket2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateContractProduct2(model: AddContractProductModel, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/AddUpdateContractProduct";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateContractProduct2(_response);
        });
    }

    protected processAddUpdateContractProduct2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateCatalogProduct2(model: AddCatalogProductModel, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/AddUpdateCatalogProduct";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateCatalogProduct2(_response);
        });
    }

    protected processAddUpdateCatalogProduct2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    updateCatalogProductQuantity2(lineId: string, quantity: number, addressId: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/UpdateCatalogProductQuantity?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        if (quantity === undefined || quantity === null)
            throw new Error("The parameter 'quantity' must be defined and cannot be null.");
        else
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined and cannot be null.");
        else
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogProductQuantity2(_response);
        });
    }

    protected processUpdateCatalogProductQuantity2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeBasketLine2(lineId: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/RemoveBasketLine?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveBasketLine2(_response);
        });
    }

    protected processRemoveBasketLine2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeSoldoutBasketLines2(accountId: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/RemoveSoldoutBasketLines?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSoldoutBasketLines2(_response);
        });
    }

    protected processRemoveSoldoutBasketLines2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    simulateOrder2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/SimulateOrder";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimulateOrder2(_response);
        });
    }

    protected processSimulateOrder2(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    placeOrder2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfKPSentResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/PlaceOrder";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlaceOrder2(_response);
        });
    }

    protected processPlaceOrder2(response: AxiosResponse): Promise<HaGeControllerResultOfKPSentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfKPSentResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfKPSentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfKPSentResult>(null as any);
    }

    /**
     * @param basketId (optional) 
     * @return OK
     */
    resetBasket2(basketId: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/ResetBasket?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetBasket2(_response);
        });
    }

    protected processResetBasket2(response: AxiosResponse): Promise<HaGeControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    acceptTradingConditions2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/basket/AcceptTradingConditions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptTradingConditions2(_response);
        });
    }

    protected processAcceptTradingConditions2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getBasket3(  cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/GetBasket";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBasket3(_response);
        });
    }

    protected processGetBasket3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateContractProduct3(model: AddContractProductModel , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/AddUpdateContractProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateContractProduct3(_response);
        });
    }

    protected processAddUpdateContractProduct3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    addUpdateCatalogProduct3(model: AddCatalogProductModel , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/AddUpdateCatalogProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUpdateCatalogProduct3(_response);
        });
    }

    protected processAddUpdateCatalogProduct3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    updateCatalogProductQuantity3(lineId: string, quantity: number, addressId: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/UpdateCatalogProductQuantity?";
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        if (quantity === undefined || quantity === null)
            throw new Error("The parameter 'quantity' must be defined and cannot be null.");
        else
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined and cannot be null.");
        else
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCatalogProductQuantity3(_response);
        });
    }

    protected processUpdateCatalogProductQuantity3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeBasketLine3(lineId: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/RemoveBasketLine?";
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined and cannot be null.");
        else
            url_ += "lineId=" + encodeURIComponent("" + lineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveBasketLine3(_response);
        });
    }

    protected processRemoveBasketLine3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    removeSoldoutBasketLines3(accountId: number , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/RemoveSoldoutBasketLines?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSoldoutBasketLines3(_response);
        });
    }

    protected processRemoveSoldoutBasketLines3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    simulateOrder3(  cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        let url_ = this.baseUrl + "/api/basket/SimulateOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimulateOrder3(_response);
        });
    }

    protected processSimulateOrder3(response: AxiosResponse): Promise<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfHaGeBasketOfHaGeBasketLine.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfHaGeBasketOfHaGeBasketLine>(null as any);
    }

    /**
     * @return OK
     */
    placeOrder3(  cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfKPSentResult> {
        let url_ = this.baseUrl + "/api/basket/PlaceOrder";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlaceOrder3(_response);
        });
    }

    protected processPlaceOrder3(response: AxiosResponse): Promise<HaGeControllerResultOfKPSentResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfKPSentResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfKPSentResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfKPSentResult>(null as any);
    }

    /**
     * @param basketId (optional) 
     * @return OK
     */
    resetBasket3(basketId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/basket/ResetBasket?";
        if (basketId !== undefined && basketId !== null)
            url_ += "basketId=" + encodeURIComponent("" + basketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetBasket3(_response);
        });
    }

    protected processResetBasket3(response: AxiosResponse): Promise<HaGeControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    acceptTradingConditions3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/basket/AcceptTradingConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptTradingConditions3(_response);
        });
    }

    protected processAcceptTradingConditions3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }
}

export class BlogUniverseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getArticlesBySearchTerm(searchTerm: string, page: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/BlogUniverse/GetArticlesBySearchTerm?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesBySearchTerm(_response);
        });
    }

    protected processGetArticlesBySearchTerm(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getArticlesByTag(category: string, page: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/BlogUniverse/GetArticlesByTag?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesByTag(_response);
        });
    }

    protected processGetArticlesByTag(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getArticlesBySearchTerm2(searchTerm: string, page: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/BlogUniverse/GetArticlesBySearchTerm?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesBySearchTerm2(_response);
        });
    }

    protected processGetArticlesBySearchTerm2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getArticlesByTag2(category: string, page: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/BlogUniverse/GetArticlesByTag?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesByTag2(_response);
        });
    }

    protected processGetArticlesByTag2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getArticlesBySearchTerm3(searchTerm: string, page: number , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/BlogUniverse/GetArticlesBySearchTerm?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesBySearchTerm3(_response);
        });
    }

    protected processGetArticlesBySearchTerm3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getArticlesByTag3(category: string, page: number , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/BlogUniverse/GetArticlesByTag?";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticlesByTag3(_response);
        });
    }

    protected processGetArticlesByTag3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CornUniverseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param symbol (optional) 
     * @param months (optional) 
     * @return OK
     */
    getReutersListing(configId: string, symbol: string | null | undefined, months: number | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cornuniverse/GetReutersListing?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined and cannot be null.");
        else
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (symbol !== undefined && symbol !== null)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        if (months !== undefined && months !== null)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReutersListing(_response);
        });
    }

    protected processGetReutersListing(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getQuotesFromMetadataId(quoteConfigItemId: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ReutersQuoteItem[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cornuniverse/GetQuotesFromMetadataId?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (quoteConfigItemId === undefined || quoteConfigItemId === null)
            throw new Error("The parameter 'quoteConfigItemId' must be defined and cannot be null.");
        else
            url_ += "quoteConfigItemId=" + encodeURIComponent("" + quoteConfigItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotesFromMetadataId(_response);
        });
    }

    protected processGetQuotesFromMetadataId(response: AxiosResponse): Promise<ReutersQuoteItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReutersQuoteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReutersQuoteItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersQuoteItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getTimeSeries(startDateTime: Date, endDateTime: Date, symbol: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ReutersTimeSeriesData> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cornuniverse/GetTimeSeries?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (startDateTime === undefined || startDateTime === null)
            throw new Error("The parameter 'startDateTime' must be defined and cannot be null.");
        else
            url_ += "startDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toISOString() : "") + "&";
        if (endDateTime === undefined || endDateTime === null)
            throw new Error("The parameter 'endDateTime' must be defined and cannot be null.");
        else
            url_ += "endDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toISOString() : "") + "&";
        if (symbol === undefined || symbol === null)
            throw new Error("The parameter 'symbol' must be defined and cannot be null.");
        else
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeSeries(_response);
        });
    }

    protected processGetTimeSeries(response: AxiosResponse): Promise<ReutersTimeSeriesData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReutersTimeSeriesData.fromJS(resultData200);
            return Promise.resolve<ReutersTimeSeriesData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersTimeSeriesData>(null as any);
    }

    /**
     * @param symbol (optional) 
     * @param months (optional) 
     * @return OK
     */
    getReutersListing2(configId: string, symbol: string | null | undefined, months: number | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cornuniverse/GetReutersListing?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined and cannot be null.");
        else
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (symbol !== undefined && symbol !== null)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        if (months !== undefined && months !== null)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReutersListing2(_response);
        });
    }

    protected processGetReutersListing2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getQuotesFromMetadataId2(quoteConfigItemId: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ReutersQuoteItem[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cornuniverse/GetQuotesFromMetadataId?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (quoteConfigItemId === undefined || quoteConfigItemId === null)
            throw new Error("The parameter 'quoteConfigItemId' must be defined and cannot be null.");
        else
            url_ += "quoteConfigItemId=" + encodeURIComponent("" + quoteConfigItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotesFromMetadataId2(_response);
        });
    }

    protected processGetQuotesFromMetadataId2(response: AxiosResponse): Promise<ReutersQuoteItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReutersQuoteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReutersQuoteItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersQuoteItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getTimeSeries2(startDateTime: Date, endDateTime: Date, symbol: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ReutersTimeSeriesData> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cornuniverse/GetTimeSeries?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (startDateTime === undefined || startDateTime === null)
            throw new Error("The parameter 'startDateTime' must be defined and cannot be null.");
        else
            url_ += "startDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toISOString() : "") + "&";
        if (endDateTime === undefined || endDateTime === null)
            throw new Error("The parameter 'endDateTime' must be defined and cannot be null.");
        else
            url_ += "endDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toISOString() : "") + "&";
        if (symbol === undefined || symbol === null)
            throw new Error("The parameter 'symbol' must be defined and cannot be null.");
        else
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeSeries2(_response);
        });
    }

    protected processGetTimeSeries2(response: AxiosResponse): Promise<ReutersTimeSeriesData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReutersTimeSeriesData.fromJS(resultData200);
            return Promise.resolve<ReutersTimeSeriesData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersTimeSeriesData>(null as any);
    }

    /**
     * @param symbol (optional) 
     * @param months (optional) 
     * @return OK
     */
    getReutersListing3(configId: string, symbol: string | null | undefined, months: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/cornuniverse/GetReutersListing?";
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined and cannot be null.");
        else
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (symbol !== undefined && symbol !== null)
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        if (months !== undefined && months !== null)
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReutersListing3(_response);
        });
    }

    protected processGetReutersListing3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getQuotesFromMetadataId3(quoteConfigItemId: string , cancelToken?: CancelToken | undefined): Promise<ReutersQuoteItem[]> {
        let url_ = this.baseUrl + "/api/cornuniverse/GetQuotesFromMetadataId?";
        if (quoteConfigItemId === undefined || quoteConfigItemId === null)
            throw new Error("The parameter 'quoteConfigItemId' must be defined and cannot be null.");
        else
            url_ += "quoteConfigItemId=" + encodeURIComponent("" + quoteConfigItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuotesFromMetadataId3(_response);
        });
    }

    protected processGetQuotesFromMetadataId3(response: AxiosResponse): Promise<ReutersQuoteItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReutersQuoteItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReutersQuoteItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersQuoteItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getTimeSeries3(startDateTime: Date, endDateTime: Date, symbol: string , cancelToken?: CancelToken | undefined): Promise<ReutersTimeSeriesData> {
        let url_ = this.baseUrl + "/api/cornuniverse/GetTimeSeries?";
        if (startDateTime === undefined || startDateTime === null)
            throw new Error("The parameter 'startDateTime' must be defined and cannot be null.");
        else
            url_ += "startDateTime=" + encodeURIComponent(startDateTime ? "" + startDateTime.toISOString() : "") + "&";
        if (endDateTime === undefined || endDateTime === null)
            throw new Error("The parameter 'endDateTime' must be defined and cannot be null.");
        else
            url_ += "endDateTime=" + encodeURIComponent(endDateTime ? "" + endDateTime.toISOString() : "") + "&";
        if (symbol === undefined || symbol === null)
            throw new Error("The parameter 'symbol' must be defined and cannot be null.");
        else
            url_ += "symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeSeries3(_response);
        });
    }

    protected processGetTimeSeries3(response: AxiosResponse): Promise<ReutersTimeSeriesData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReutersTimeSeriesData.fromJS(resultData200);
            return Promise.resolve<ReutersTimeSeriesData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReutersTimeSeriesData>(null as any);
    }
}

export class CorporateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    searchProducts(query: SearchQuery, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Corporate/SearchProducts";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProducts(_response);
        });
    }

    protected processSearchProducts(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getAutoSuggestAdvanced(q: string, hits: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Corporate/GetAutoSuggestAdvanced?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits === undefined || hits === null)
            throw new Error("The parameter 'hits' must be defined and cannot be null.");
        else
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestAdvanced(_response);
        });
    }

    protected processGetAutoSuggestAdvanced(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    searchProducts2(query: SearchQuery, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Corporate/SearchProducts";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProducts2(_response);
        });
    }

    protected processSearchProducts2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getAutoSuggestAdvanced2(q: string, hits: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Corporate/GetAutoSuggestAdvanced?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits === undefined || hits === null)
            throw new Error("The parameter 'hits' must be defined and cannot be null.");
        else
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestAdvanced2(_response);
        });
    }

    protected processGetAutoSuggestAdvanced2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    searchProducts3(query: SearchQuery , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/Corporate/SearchProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchProducts3(_response);
        });
    }

    protected processSearchProducts3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getAutoSuggestAdvanced3(q: string, hits: number , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/Corporate/GetAutoSuggestAdvanced?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits === undefined || hits === null)
            throw new Error("The parameter 'hits' must be defined and cannot be null.");
        else
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestAdvanced3(_response);
        });
    }

    protected processGetAutoSuggestAdvanced3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }
}

export class CropDocumentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getCropDocumentIdentifiers(contractNumber: string, documentType: string, contractPositionNumber: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropdocument/GetCropDocumentIdentifiers?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (contractPositionNumber === undefined || contractPositionNumber === null)
            throw new Error("The parameter 'contractPositionNumber' must be defined and cannot be null.");
        else
            url_ += "contractPositionNumber=" + encodeURIComponent("" + contractPositionNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropDocumentIdentifiers(_response);
        });
    }

    protected processGetCropDocumentIdentifiers(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    downloadCropDocumentByIdentifier(documentIdentifier: string, documentType: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropdocument/DownloadCropDocumentByIdentifier?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (documentIdentifier === undefined || documentIdentifier === null)
            throw new Error("The parameter 'documentIdentifier' must be defined and cannot be null.");
        else
            url_ += "documentIdentifier=" + encodeURIComponent("" + documentIdentifier) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocumentByIdentifier(_response);
        });
    }

    protected processDownloadCropDocumentByIdentifier(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    downloadCropDocument(dlgnamespace: string, hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropdocument/DownloadCropDocument?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocument(_response);
        });
    }

    protected processDownloadCropDocument(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getCropDocumentIdentifiers2(contractNumber: string, documentType: string, contractPositionNumber: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropdocument/GetCropDocumentIdentifiers?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (contractPositionNumber === undefined || contractPositionNumber === null)
            throw new Error("The parameter 'contractPositionNumber' must be defined and cannot be null.");
        else
            url_ += "contractPositionNumber=" + encodeURIComponent("" + contractPositionNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropDocumentIdentifiers2(_response);
        });
    }

    protected processGetCropDocumentIdentifiers2(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    downloadCropDocumentByIdentifier2(documentIdentifier: string, documentType: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropdocument/DownloadCropDocumentByIdentifier?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (documentIdentifier === undefined || documentIdentifier === null)
            throw new Error("The parameter 'documentIdentifier' must be defined and cannot be null.");
        else
            url_ += "documentIdentifier=" + encodeURIComponent("" + documentIdentifier) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocumentByIdentifier2(_response);
        });
    }

    protected processDownloadCropDocumentByIdentifier2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    downloadCropDocument2(virtualFolder: string, dlgnamespace: string, hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropdocument/DownloadCropDocument?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocument2(_response);
        });
    }

    protected processDownloadCropDocument2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getCropDocumentIdentifiers3(contractNumber: string, documentType: string, contractPositionNumber: string , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/cropdocument/GetCropDocumentIdentifiers?";
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (contractPositionNumber === undefined || contractPositionNumber === null)
            throw new Error("The parameter 'contractPositionNumber' must be defined and cannot be null.");
        else
            url_ += "contractPositionNumber=" + encodeURIComponent("" + contractPositionNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropDocumentIdentifiers3(_response);
        });
    }

    protected processGetCropDocumentIdentifiers3(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    downloadCropDocumentByIdentifier3(documentIdentifier: string, documentType: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/cropdocument/DownloadCropDocumentByIdentifier?";
        if (documentIdentifier === undefined || documentIdentifier === null)
            throw new Error("The parameter 'documentIdentifier' must be defined and cannot be null.");
        else
            url_ += "documentIdentifier=" + encodeURIComponent("" + documentIdentifier) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocumentByIdentifier3(_response);
        });
    }

    protected processDownloadCropDocumentByIdentifier3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    downloadCropDocument3(hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/cropdocument/DownloadCropDocument?";
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCropDocument3(_response);
        });
    }

    protected processDownloadCropDocument3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getCropPreanalysis(contractNumber: string, positionsNumber: string, action: string , cancelToken?: CancelToken | undefined): Promise<CropPreanalysis> {
        let url_ = this.baseUrl + "/api/cropdocument/GetCropPreanalysis?";
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (positionsNumber === undefined || positionsNumber === null)
            throw new Error("The parameter 'positionsNumber' must be defined and cannot be null.");
        else
            url_ += "positionsNumber=" + encodeURIComponent("" + positionsNumber) + "&";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropPreanalysis(_response);
        });
    }

    protected processGetCropPreanalysis(response: AxiosResponse): Promise<CropPreanalysis> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropPreanalysis.fromJS(resultData200);
            return Promise.resolve<CropPreanalysis>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropPreanalysis>(null as any);
    }
}

export class CropGraphClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getCropGraph(material: string, date: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropGraph> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/CropGraph/GetCropGraph?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (material === undefined || material === null)
            throw new Error("The parameter 'material' must be defined and cannot be null.");
        else
            url_ += "material=" + encodeURIComponent("" + material) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropGraph(_response);
        });
    }

    protected processGetCropGraph(response: AxiosResponse): Promise<CropGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropGraph.fromJS(resultData200);
            return Promise.resolve<CropGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropGraph>(null as any);
    }

    /**
     * @return OK
     */
    getCropGraph2(material: string, date: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropGraph> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/CropGraph/GetCropGraph?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (material === undefined || material === null)
            throw new Error("The parameter 'material' must be defined and cannot be null.");
        else
            url_ += "material=" + encodeURIComponent("" + material) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropGraph2(_response);
        });
    }

    protected processGetCropGraph2(response: AxiosResponse): Promise<CropGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropGraph.fromJS(resultData200);
            return Promise.resolve<CropGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropGraph>(null as any);
    }

    /**
     * @return OK
     */
    getCropGraph3(material: string, date: string , cancelToken?: CancelToken | undefined): Promise<CropGraph> {
        let url_ = this.baseUrl + "/api/CropGraph/GetCropGraph?";
        if (material === undefined || material === null)
            throw new Error("The parameter 'material' must be defined and cannot be null.");
        else
            url_ += "material=" + encodeURIComponent("" + material) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropGraph3(_response);
        });
    }

    protected processGetCropGraph3(response: AxiosResponse): Promise<CropGraph> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropGraph.fromJS(resultData200);
            return Promise.resolve<CropGraph>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropGraph>(null as any);
    }
}

export class CropOverviewClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    get(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropOverviewOld> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropoverview/Get";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CropOverviewOld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverviewOld.fromJS(resultData200);
            return Promise.resolve<CropOverviewOld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverviewOld>(null as any);
    }

    /**
     * @return OK
     */
    get2(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropOverview> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropoverview/Get2";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: AxiosResponse): Promise<CropOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverview.fromJS(resultData200);
            return Promise.resolve<CropOverview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverview>(null as any);
    }

    /**
     * @return OK
     */
    getCropFutures(contractNumber: string, posNumber: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropFutures> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropoverview/GetCropFutures?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (posNumber === undefined || posNumber === null)
            throw new Error("The parameter 'posNumber' must be defined and cannot be null.");
        else
            url_ += "posNumber=" + encodeURIComponent("" + posNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropFutures(_response);
        });
    }

    protected processGetCropFutures(response: AxiosResponse): Promise<CropFutures> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropFutures.fromJS(resultData200);
            return Promise.resolve<CropFutures>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropFutures>(null as any);
    }

    /**
     * @return OK
     */
    checkIfTradeIsClosed(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropoverview/CheckIfTradeIsClosed?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfTradeIsClosed(_response);
        });
    }

    protected processCheckIfTradeIsClosed(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return No Content
     */
    setOpenStatus(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/cropoverview/SetOpenStatus";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOpenStatus(_response);
        });
    }

    protected processSetOpenStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    get22(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropOverviewOld> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropoverview/Get";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet22(_response);
        });
    }

    protected processGet22(response: AxiosResponse): Promise<CropOverviewOld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverviewOld.fromJS(resultData200);
            return Promise.resolve<CropOverviewOld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverviewOld>(null as any);
    }

    /**
     * @return OK
     */
    get23(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropOverview> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropoverview/Get2";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet23(_response);
        });
    }

    protected processGet23(response: AxiosResponse): Promise<CropOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverview.fromJS(resultData200);
            return Promise.resolve<CropOverview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverview>(null as any);
    }

    /**
     * @return OK
     */
    getCropFutures2(contractNumber: string, posNumber: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropFutures> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropoverview/GetCropFutures?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (posNumber === undefined || posNumber === null)
            throw new Error("The parameter 'posNumber' must be defined and cannot be null.");
        else
            url_ += "posNumber=" + encodeURIComponent("" + posNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropFutures2(_response);
        });
    }

    protected processGetCropFutures2(response: AxiosResponse): Promise<CropFutures> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropFutures.fromJS(resultData200);
            return Promise.resolve<CropFutures>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropFutures>(null as any);
    }

    /**
     * @return OK
     */
    checkIfTradeIsClosed2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropoverview/CheckIfTradeIsClosed?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfTradeIsClosed2(_response);
        });
    }

    protected processCheckIfTradeIsClosed2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return No Content
     */
    setOpenStatus2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/cropoverview/SetOpenStatus";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOpenStatus2(_response);
        });
    }

    protected processSetOpenStatus2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    get3(  cancelToken?: CancelToken | undefined): Promise<CropOverviewOld> {
        let url_ = this.baseUrl + "/api/cropoverview/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: AxiosResponse): Promise<CropOverviewOld> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverviewOld.fromJS(resultData200);
            return Promise.resolve<CropOverviewOld>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverviewOld>(null as any);
    }

    /**
     * @return OK
     */
    get24(  cancelToken?: CancelToken | undefined): Promise<CropOverview> {
        let url_ = this.baseUrl + "/api/cropoverview/Get2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet24(_response);
        });
    }

    protected processGet24(response: AxiosResponse): Promise<CropOverview> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverview.fromJS(resultData200);
            return Promise.resolve<CropOverview>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverview>(null as any);
    }

    /**
     * @return OK
     */
    getCropoverviewOverlay(contractNumber: string, positionNumber: string, action: string , cancelToken?: CancelToken | undefined): Promise<CropOverviewOverlay> {
        let url_ = this.baseUrl + "/api/cropoverview/GetCropoverviewOverlay?";
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (positionNumber === undefined || positionNumber === null)
            throw new Error("The parameter 'positionNumber' must be defined and cannot be null.");
        else
            url_ += "positionNumber=" + encodeURIComponent("" + positionNumber) + "&";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropoverviewOverlay(_response);
        });
    }

    protected processGetCropoverviewOverlay(response: AxiosResponse): Promise<CropOverviewOverlay> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverviewOverlay.fromJS(resultData200);
            return Promise.resolve<CropOverviewOverlay>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverviewOverlay>(null as any);
    }

    /**
     * @return OK
     */
    getCropoverviewAnalysisData(contractNumber: string, positionNumber: string, action: string , cancelToken?: CancelToken | undefined): Promise<CropOverviewOverlay> {
        let url_ = this.baseUrl + "/api/cropoverview/GetCropoverviewAnalysisData?";
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (positionNumber === undefined || positionNumber === null)
            throw new Error("The parameter 'positionNumber' must be defined and cannot be null.");
        else
            url_ += "positionNumber=" + encodeURIComponent("" + positionNumber) + "&";
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropoverviewAnalysisData(_response);
        });
    }

    protected processGetCropoverviewAnalysisData(response: AxiosResponse): Promise<CropOverviewOverlay> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropOverviewOverlay.fromJS(resultData200);
            return Promise.resolve<CropOverviewOverlay>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropOverviewOverlay>(null as any);
    }

    /**
     * @return OK
     */
    getCropFutures3(contractNumber: string, posNumber: string , cancelToken?: CancelToken | undefined): Promise<CropFutures> {
        let url_ = this.baseUrl + "/api/cropoverview/GetCropFutures?";
        if (contractNumber === undefined || contractNumber === null)
            throw new Error("The parameter 'contractNumber' must be defined and cannot be null.");
        else
            url_ += "contractNumber=" + encodeURIComponent("" + contractNumber) + "&";
        if (posNumber === undefined || posNumber === null)
            throw new Error("The parameter 'posNumber' must be defined and cannot be null.");
        else
            url_ += "posNumber=" + encodeURIComponent("" + posNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCropFutures3(_response);
        });
    }

    protected processGetCropFutures3(response: AxiosResponse): Promise<CropFutures> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CropFutures.fromJS(resultData200);
            return Promise.resolve<CropFutures>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropFutures>(null as any);
    }

    /**
     * @return OK
     */
    checkIfTradeIsClosed3(sku: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/cropoverview/CheckIfTradeIsClosed?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfTradeIsClosed3(_response);
        });
    }

    protected processCheckIfTradeIsClosed3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return No Content
     */
    setOpenStatus3(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/cropoverview/SetOpenStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetOpenStatus3(_response);
        });
    }

    protected processSetOpenStatus3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CustomerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    hasInvoicePdf(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/HasInvoicePdf";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasInvoicePdf(_response);
        });
    }

    protected processHasInvoicePdf(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getInvoicePdf(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/GetInvoicePdf";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf(_response);
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    hasAccountBalancePdf(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/HasAccountBalancePdf";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasAccountBalancePdf(_response);
        });
    }

    protected processHasAccountBalancePdf(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAccountBalancePdf(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/GetAccountBalancePdf";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountBalancePdf(_response);
        });
    }

    protected processGetAccountBalancePdf(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail(newEmail: string, newEmail2: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/UpdateEmail?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        if (newEmail2 === undefined || newEmail2 === null)
            throw new Error("The parameter 'newEmail2' must be defined and cannot be null.");
        else
            url_ += "newEmail2=" + encodeURIComponent("" + newEmail2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone(phone: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/UpdatePhone?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword(oldPassword: string, newPassword: string, newPassword2: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/UpdatePassword?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (oldPassword === undefined || oldPassword === null)
            throw new Error("The parameter 'oldPassword' must be defined and cannot be null.");
        else
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (newPassword2 === undefined || newPassword2 === null)
            throw new Error("The parameter 'newPassword2' must be defined and cannot be null.");
        else
            url_ += "newPassword2=" + encodeURIComponent("" + newPassword2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getLocationsForActiveAccount(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/GetLocationsForActiveAccount";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsForActiveAccount(_response);
        });
    }

    protected processGetLocationsForActiveAccount(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfDigiAddress.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(null as any);
    }

    /**
     * @return No Content
     */
    createLocation(deliveryPlaceWrapper: Location, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/CreateLocation";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    updateLocation(deliveryPlaceWrapper: Location, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/UpdateLocation";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteLocation(deliveryPlaceWrapper: Location, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/DeleteLocation";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLocationTypes(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfLocType> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/GetLocationTypes";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationTypes(_response);
        });
    }

    protected processGetLocationTypes(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfLocType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfLocType.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customer/DeleteAccount";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    hasInvoicePdf2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/HasInvoicePdf";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasInvoicePdf2(_response);
        });
    }

    protected processHasInvoicePdf2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getInvoicePdf2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/GetInvoicePdf";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf2(_response);
        });
    }

    protected processGetInvoicePdf2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    hasAccountBalancePdf2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/HasAccountBalancePdf";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasAccountBalancePdf2(_response);
        });
    }

    protected processHasAccountBalancePdf2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAccountBalancePdf2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/GetAccountBalancePdf";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountBalancePdf2(_response);
        });
    }

    protected processGetAccountBalancePdf2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail2(newEmail: string, newEmail2: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/UpdateEmail?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        if (newEmail2 === undefined || newEmail2 === null)
            throw new Error("The parameter 'newEmail2' must be defined and cannot be null.");
        else
            url_ += "newEmail2=" + encodeURIComponent("" + newEmail2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail2(_response);
        });
    }

    protected processUpdateEmail2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone2(phone: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/UpdatePhone?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone2(_response);
        });
    }

    protected processUpdatePhone2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword2(oldPassword: string, newPassword: string, newPassword2: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/UpdatePassword?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (oldPassword === undefined || oldPassword === null)
            throw new Error("The parameter 'oldPassword' must be defined and cannot be null.");
        else
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (newPassword2 === undefined || newPassword2 === null)
            throw new Error("The parameter 'newPassword2' must be defined and cannot be null.");
        else
            url_ += "newPassword2=" + encodeURIComponent("" + newPassword2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword2(_response);
        });
    }

    protected processUpdatePassword2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getLocationsForActiveAccount2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/GetLocationsForActiveAccount";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsForActiveAccount2(_response);
        });
    }

    protected processGetLocationsForActiveAccount2(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfDigiAddress.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(null as any);
    }

    /**
     * @return No Content
     */
    createLocation2(deliveryPlaceWrapper: Location, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/CreateLocation";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLocation2(_response);
        });
    }

    protected processCreateLocation2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    updateLocation2(deliveryPlaceWrapper: Location, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/UpdateLocation";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocation2(_response);
        });
    }

    protected processUpdateLocation2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteLocation2(deliveryPlaceWrapper: Location, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/DeleteLocation";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation2(_response);
        });
    }

    protected processDeleteLocation2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLocationTypes2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfLocType> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/GetLocationTypes";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationTypes2(_response);
        });
    }

    protected processGetLocationTypes2(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfLocType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfLocType.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customer/DeleteAccount";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount2(_response);
        });
    }

    protected processDeleteAccount2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    hasInvoicePdf3(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/HasInvoicePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasInvoicePdf3(_response);
        });
    }

    protected processHasInvoicePdf3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getInvoicePdf3(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/customer/GetInvoicePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf3(_response);
        });
    }

    protected processGetInvoicePdf3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    hasAccountBalancePdf3(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/HasAccountBalancePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasAccountBalancePdf3(_response);
        });
    }

    protected processHasAccountBalancePdf3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getAccountBalancePdf3(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/customer/GetAccountBalancePdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountBalancePdf3(_response);
        });
    }

    protected processGetAccountBalancePdf3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail3(newEmail: string, newEmail2: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/UpdateEmail?";
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        if (newEmail2 === undefined || newEmail2 === null)
            throw new Error("The parameter 'newEmail2' must be defined and cannot be null.");
        else
            url_ += "newEmail2=" + encodeURIComponent("" + newEmail2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail3(_response);
        });
    }

    protected processUpdateEmail3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone3(phone: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/UpdatePhone?";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone3(_response);
        });
    }

    protected processUpdatePhone3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword3(oldPassword: string, newPassword: string, newPassword2: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customer/UpdatePassword?";
        if (oldPassword === undefined || oldPassword === null)
            throw new Error("The parameter 'oldPassword' must be defined and cannot be null.");
        else
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&";
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        if (newPassword2 === undefined || newPassword2 === null)
            throw new Error("The parameter 'newPassword2' must be defined and cannot be null.");
        else
            url_ += "newPassword2=" + encodeURIComponent("" + newPassword2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword3(_response);
        });
    }

    protected processUpdatePassword3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getLocationsForActiveAccount3(  cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        let url_ = this.baseUrl + "/api/customer/GetLocationsForActiveAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsForActiveAccount3(_response);
        });
    }

    protected processGetLocationsForActiveAccount3(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfDigiAddress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfDigiAddress.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfDigiAddress>(null as any);
    }

    /**
     * @return No Content
     */
    createLocation3(deliveryPlaceWrapper: Location , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/CreateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLocation3(_response);
        });
    }

    protected processCreateLocation3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    updateLocation3(deliveryPlaceWrapper: Location , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/UpdateLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLocation3(_response);
        });
    }

    protected processUpdateLocation3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    deleteLocation3(deliveryPlaceWrapper: Location , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/customer/DeleteLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryPlaceWrapper);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLocation3(_response);
        });
    }

    protected processDeleteLocation3(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getLocationTypes3(  cancelToken?: CancelToken | undefined): Promise<DigifarmDefaultResponseOfListOfLocType> {
        let url_ = this.baseUrl + "/api/customer/GetLocationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationTypes3(_response);
        });
    }

    protected processGetLocationTypes3(response: AxiosResponse): Promise<DigifarmDefaultResponseOfListOfLocType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DigifarmDefaultResponseOfListOfLocType.fromJS(resultData200);
            return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigifarmDefaultResponseOfListOfLocType>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount3(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/customer/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount3(_response);
        });
    }

    protected processDeleteAccount3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CustomerDataClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getCustomerData(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ICustomerData> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customerdata/GetCustomerData";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerData(_response);
        });
    }

    protected processGetCustomerData(response: AxiosResponse): Promise<ICustomerData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICustomerData.fromJS(resultData200);
            return Promise.resolve<ICustomerData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICustomerData>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount(account: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customerdata/SetActiveAccount?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount(_response);
        });
    }

    protected processSetActiveAccount(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSettings(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CustomerSettings> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customerdata/GetSettings";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<CustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSettings.fromJS(resultData200);
            return Promise.resolve<CustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSettings>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerData2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ICustomerData> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customerdata/GetCustomerData";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerData2(_response);
        });
    }

    protected processGetCustomerData2(response: AxiosResponse): Promise<ICustomerData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICustomerData.fromJS(resultData200);
            return Promise.resolve<ICustomerData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICustomerData>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount2(account: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customerdata/SetActiveAccount?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount2(_response);
        });
    }

    protected processSetActiveAccount2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSettings2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CustomerSettings> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customerdata/GetSettings";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings2(_response);
        });
    }

    protected processGetSettings2(response: AxiosResponse): Promise<CustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSettings.fromJS(resultData200);
            return Promise.resolve<CustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSettings>(null as any);
    }

    /**
     * @return OK
     */
    getCustomerData3(  cancelToken?: CancelToken | undefined): Promise<ICustomerData> {
        let url_ = this.baseUrl + "/api/customerdata/GetCustomerData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerData3(_response);
        });
    }

    protected processGetCustomerData3(response: AxiosResponse): Promise<ICustomerData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ICustomerData.fromJS(resultData200);
            return Promise.resolve<ICustomerData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ICustomerData>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount3(account: number , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/customerdata/SetActiveAccount?";
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount3(_response);
        });
    }

    protected processSetActiveAccount3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getSettings3(  cancelToken?: CancelToken | undefined): Promise<CustomerSettings> {
        let url_ = this.baseUrl + "/api/customerdata/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings3(_response);
        });
    }

    protected processGetSettings3(response: AxiosResponse): Promise<CustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerSettings.fromJS(resultData200);
            return Promise.resolve<CustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerSettings>(null as any);
    }
}

export class CustomersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getSettings(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCustomerSettings> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/GetSettings";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<V2ControllerResultOfCustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCustomerSettings.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCustomerSettings>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount(account: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/SetActiveAccount?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount(_response);
        });
    }

    protected processSetActiveAccount(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail(newEmail: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/UpdateEmail?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone(newPhone: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/UpdatePhone?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newPhone === undefined || newPhone === null)
            throw new Error("The parameter 'newPhone' must be defined and cannot be null.");
        else
            url_ += "newPhone=" + encodeURIComponent("" + newPhone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword(updatePasswordData: UpdatePassword, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/UpdatePassword";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePasswordData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getDeleteAccountText(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/GetDeleteAccountText";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeleteAccountText(_response);
        });
    }

    protected processGetDeleteAccountText(response: AxiosResponse): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfDeleteAccountTextModel.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfString> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/customers/DeleteAccount";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<V2ControllerResultOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfString.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfString>(null as any);
    }

    /**
     * @return OK
     */
    getSettings2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCustomerSettings> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/GetSettings";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings2(_response);
        });
    }

    protected processGetSettings2(response: AxiosResponse): Promise<V2ControllerResultOfCustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCustomerSettings.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCustomerSettings>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount2(account: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/SetActiveAccount?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount2(_response);
        });
    }

    protected processSetActiveAccount2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail2(newEmail: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/UpdateEmail?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail2(_response);
        });
    }

    protected processUpdateEmail2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone2(newPhone: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/UpdatePhone?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (newPhone === undefined || newPhone === null)
            throw new Error("The parameter 'newPhone' must be defined and cannot be null.");
        else
            url_ += "newPhone=" + encodeURIComponent("" + newPhone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone2(_response);
        });
    }

    protected processUpdatePhone2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword2(updatePasswordData: UpdatePassword, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/UpdatePassword";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePasswordData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword2(_response);
        });
    }

    protected processUpdatePassword2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getDeleteAccountText2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/GetDeleteAccountText";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeleteAccountText2(_response);
        });
    }

    protected processGetDeleteAccountText2(response: AxiosResponse): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfDeleteAccountTextModel.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfString> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/customers/DeleteAccount";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount2(_response);
        });
    }

    protected processDeleteAccount2(response: AxiosResponse): Promise<V2ControllerResultOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfString.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfString>(null as any);
    }

    /**
     * @return OK
     */
    getSettings3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCustomerSettings> {
        let url_ = this.baseUrl + "/api/customers/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings3(_response);
        });
    }

    protected processGetSettings3(response: AxiosResponse): Promise<V2ControllerResultOfCustomerSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCustomerSettings.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCustomerSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCustomerSettings>(null as any);
    }

    /**
     * @return OK
     */
    setActiveAccount3(account: number , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/customers/SetActiveAccount?";
        if (account === undefined || account === null)
            throw new Error("The parameter 'account' must be defined and cannot be null.");
        else
            url_ += "account=" + encodeURIComponent("" + account) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetActiveAccount3(_response);
        });
    }

    protected processSetActiveAccount3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updateEmail3(newEmail: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/customers/UpdateEmail?";
        if (newEmail === undefined || newEmail === null)
            throw new Error("The parameter 'newEmail' must be defined and cannot be null.");
        else
            url_ += "newEmail=" + encodeURIComponent("" + newEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail3(_response);
        });
    }

    protected processUpdateEmail3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePhone3(newPhone: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/customers/UpdatePhone?";
        if (newPhone === undefined || newPhone === null)
            throw new Error("The parameter 'newPhone' must be defined and cannot be null.");
        else
            url_ += "newPhone=" + encodeURIComponent("" + newPhone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePhone3(_response);
        });
    }

    protected processUpdatePhone3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    updatePassword3(updatePasswordData: UpdatePassword , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/customers/UpdatePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatePasswordData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword3(_response);
        });
    }

    protected processUpdatePassword3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getDeleteAccountText3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        let url_ = this.baseUrl + "/api/customers/GetDeleteAccountText";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeleteAccountText3(_response);
        });
    }

    protected processGetDeleteAccountText3(response: AxiosResponse): Promise<V2ControllerResultOfDeleteAccountTextModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfDeleteAccountTextModel.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfDeleteAccountTextModel>(null as any);
    }

    /**
     * @return OK
     */
    deleteAccount3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfString> {
        let url_ = this.baseUrl + "/api/customers/DeleteAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount3(_response);
        });
    }

    protected processDeleteAccount3(response: AxiosResponse): Promise<V2ControllerResultOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfString.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfString>(null as any);
    }
}

export class DialogPortalClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    listGeneralPermissionsGET(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/ListGeneralPermissions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsGET(_response);
        });
    }

    protected processListGeneralPermissionsGET(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listGeneralPermissionsPOST(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/ListGeneralPermissions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsPOST(_response);
        });
    }

    protected processListGeneralPermissionsPOST(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsGET(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/ListSMSSubscriptions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsGET(_response);
        });
    }

    protected processListSMSSubscriptionsGET(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsPOST(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/ListSMSSubscriptions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsPOST(_response);
        });
    }

    protected processListSMSSubscriptionsPOST(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMS(salesOffice: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMS?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMS(_response);
        });
    }

    protected processSubscribeHarvestSMS(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    unsubscribeHarvestSMS(salesOffice: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/UnsubscribeHarvestSMS?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeHarvestSMS(_response);
        });
    }

    protected processUnsubscribeHarvestSMS(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAdditionalNumbers(value: SubscribeHarvestSMSAdditionalNumbersParameters, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMSAdditionalNumbers";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAdditionalNumbers(_response);
        });
    }

    protected processSubscribeHarvestSMSAdditionalNumbers(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAnon(value: SubscribeHarvestSMSAnonParameters, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMSAnon";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAnon(_response);
        });
    }

    protected processSubscribeHarvestSMSAnon(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setEmailSubscription(data: SubscriptionData, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/SetEmailSubscription";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmailSubscription(_response);
        });
    }

    protected processSetEmailSubscription(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    listEmailSubscriptions(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/ListEmailSubscriptions";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEmailSubscriptions(_response);
        });
    }

    protected processListEmailSubscriptions(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriberLists(subscriberListType: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/GetAllSubscriberLists?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (subscriberListType === undefined || subscriberListType === null)
            throw new Error("The parameter 'subscriberListType' must be defined and cannot be null.");
        else
            url_ += "subscriberListType=" + encodeURIComponent("" + subscriberListType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSubscriberLists(_response);
        });
    }

    protected processGetAllSubscriberLists(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getGeneralPermissionsForUser(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/dialogportal/GetGeneralPermissionsForUser";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser(_response);
        });
    }

    protected processGetGeneralPermissionsForUser(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listGeneralPermissionsGET2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/ListGeneralPermissions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsGET2(_response);
        });
    }

    protected processListGeneralPermissionsGET2(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listGeneralPermissionsPOST2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/ListGeneralPermissions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsPOST2(_response);
        });
    }

    protected processListGeneralPermissionsPOST2(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsGET2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/ListSMSSubscriptions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsGET2(_response);
        });
    }

    protected processListSMSSubscriptionsGET2(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsPOST2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/ListSMSSubscriptions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsPOST2(_response);
        });
    }

    protected processListSMSSubscriptionsPOST2(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMS2(salesOffice: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMS?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMS2(_response);
        });
    }

    protected processSubscribeHarvestSMS2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    unsubscribeHarvestSMS2(salesOffice: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/UnsubscribeHarvestSMS?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeHarvestSMS2(_response);
        });
    }

    protected processUnsubscribeHarvestSMS2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAdditionalNumbers2(value: SubscribeHarvestSMSAdditionalNumbersParameters, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMSAdditionalNumbers";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAdditionalNumbers2(_response);
        });
    }

    protected processSubscribeHarvestSMSAdditionalNumbers2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAnon2(value: SubscribeHarvestSMSAnonParameters, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/SubscribeHarvestSMSAnon";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAnon2(_response);
        });
    }

    protected processSubscribeHarvestSMSAnon2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setEmailSubscription2(data: SubscriptionData, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/SetEmailSubscription";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmailSubscription2(_response);
        });
    }

    protected processSetEmailSubscription2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    listEmailSubscriptions2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/ListEmailSubscriptions";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEmailSubscriptions2(_response);
        });
    }

    protected processListEmailSubscriptions2(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriberLists2(subscriberListType: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/GetAllSubscriberLists?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (subscriberListType === undefined || subscriberListType === null)
            throw new Error("The parameter 'subscriberListType' must be defined and cannot be null.");
        else
            url_ += "subscriberListType=" + encodeURIComponent("" + subscriberListType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSubscriberLists2(_response);
        });
    }

    protected processGetAllSubscriberLists2(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getGeneralPermissionsForUser2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/dialogportal/GetGeneralPermissionsForUser";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser2(_response);
        });
    }

    protected processGetGeneralPermissionsForUser2(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listGeneralPermissionsGET3(  cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/dialogportal/ListGeneralPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsGET3(_response);
        });
    }

    protected processListGeneralPermissionsGET3(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listGeneralPermissionsPOST3(  cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/dialogportal/ListGeneralPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListGeneralPermissionsPOST3(_response);
        });
    }

    protected processListGeneralPermissionsPOST3(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsGET3(  cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/dialogportal/ListSMSSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsGET3(_response);
        });
    }

    protected processListSMSSubscriptionsGET3(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    listSMSSubscriptionsPOST3(  cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/dialogportal/ListSMSSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListSMSSubscriptionsPOST3(_response);
        });
    }

    protected processListSMSSubscriptionsPOST3(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMS3(salesOffice: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/dialogportal/SubscribeHarvestSMS?";
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMS3(_response);
        });
    }

    protected processSubscribeHarvestSMS3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    unsubscribeHarvestSMS3(salesOffice: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/dialogportal/UnsubscribeHarvestSMS?";
        if (salesOffice === undefined || salesOffice === null)
            throw new Error("The parameter 'salesOffice' must be defined and cannot be null.");
        else
            url_ += "salesOffice=" + encodeURIComponent("" + salesOffice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeHarvestSMS3(_response);
        });
    }

    protected processUnsubscribeHarvestSMS3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAdditionalNumbers3(value: SubscribeHarvestSMSAdditionalNumbersParameters , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/dialogportal/SubscribeHarvestSMSAdditionalNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAdditionalNumbers3(_response);
        });
    }

    protected processSubscribeHarvestSMSAdditionalNumbers3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    subscribeHarvestSMSAnon3(value: SubscribeHarvestSMSAnonParameters , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/dialogportal/SubscribeHarvestSMSAnon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribeHarvestSMSAnon3(_response);
        });
    }

    protected processSubscribeHarvestSMSAnon3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setEmailSubscription3(data: SubscriptionData , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/dialogportal/SetEmailSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetEmailSubscription3(_response);
        });
    }

    protected processSetEmailSubscription3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    listEmailSubscriptions3(  cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/dialogportal/ListEmailSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEmailSubscriptions3(_response);
        });
    }

    protected processListEmailSubscriptions3(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllSubscriberLists3(subscriberListType: string , cancelToken?: CancelToken | undefined): Promise<SubscriberList[]> {
        let url_ = this.baseUrl + "/api/dialogportal/GetAllSubscriberLists?";
        if (subscriberListType === undefined || subscriberListType === null)
            throw new Error("The parameter 'subscriberListType' must be defined and cannot be null.");
        else
            url_ += "subscriberListType=" + encodeURIComponent("" + subscriberListType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSubscriberLists3(_response);
        });
    }

    protected processGetAllSubscriberLists3(response: AxiosResponse): Promise<SubscriberList[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriberList.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubscriberList[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubscriberList[]>(null as any);
    }

    /**
     * @return OK
     */
    getGeneralPermissionsForUser3(  cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/dialogportal/GetGeneralPermissionsForUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser3(_response);
        });
    }

    protected processGetGeneralPermissionsForUser3(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }
}

export class DictionaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getLanguageSpecificDictionary(language: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Dictionary/GetLanguageSpecificDictionary?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageSpecificDictionary(_response);
        });
    }

    protected processGetLanguageSpecificDictionary(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    createTextKey(path: string, key: string, value: string, valueMultiple: string, tkType: string, language: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Dictionary/CreateTextKey?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (valueMultiple === undefined || valueMultiple === null)
            throw new Error("The parameter 'valueMultiple' must be defined and cannot be null.");
        else
            url_ += "valueMultiple=" + encodeURIComponent("" + valueMultiple) + "&";
        if (tkType === undefined || tkType === null)
            throw new Error("The parameter 'tkType' must be defined and cannot be null.");
        else
            url_ += "TkType=" + encodeURIComponent("" + tkType) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTextKey(_response);
        });
    }

    protected processCreateTextKey(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getLanguageSpecificDictionary2(language: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Dictionary/GetLanguageSpecificDictionary?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageSpecificDictionary2(_response);
        });
    }

    protected processGetLanguageSpecificDictionary2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    createTextKey2(path: string, key: string, value: string, valueMultiple: string, tkType: string, language: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Dictionary/CreateTextKey?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (valueMultiple === undefined || valueMultiple === null)
            throw new Error("The parameter 'valueMultiple' must be defined and cannot be null.");
        else
            url_ += "valueMultiple=" + encodeURIComponent("" + valueMultiple) + "&";
        if (tkType === undefined || tkType === null)
            throw new Error("The parameter 'tkType' must be defined and cannot be null.");
        else
            url_ += "TkType=" + encodeURIComponent("" + tkType) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTextKey2(_response);
        });
    }

    protected processCreateTextKey2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getLanguageSpecificDictionary3(language: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Dictionary/GetLanguageSpecificDictionary?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLanguageSpecificDictionary3(_response);
        });
    }

    protected processGetLanguageSpecificDictionary3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    createTextKey3(path: string, key: string, value: string, valueMultiple: string, tkType: string, language: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Dictionary/CreateTextKey?";
        if (path === undefined || path === null)
            throw new Error("The parameter 'path' must be defined and cannot be null.");
        else
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (valueMultiple === undefined || valueMultiple === null)
            throw new Error("The parameter 'valueMultiple' must be defined and cannot be null.");
        else
            url_ += "valueMultiple=" + encodeURIComponent("" + valueMultiple) + "&";
        if (tkType === undefined || tkType === null)
            throw new Error("The parameter 'tkType' must be defined and cannot be null.");
        else
            url_ += "TkType=" + encodeURIComponent("" + tkType) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTextKey3(_response);
        });
    }

    protected processCreateTextKey3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class FavoriteClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    addToFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorite/AddToFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites(_response);
        });
    }

    protected processAddToFavorites(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorite/RemoveFromFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites(_response);
        });
    }

    protected processRemoveFromFavorites(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorite/IsProductFavorite?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite(_response);
        });
    }

    protected processIsProductFavorite(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorite/AddToFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites2(_response);
        });
    }

    protected processAddToFavorites2(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorite/RemoveFromFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites2(_response);
        });
    }

    protected processRemoveFromFavorites2(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorite/IsProductFavorite?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite2(_response);
        });
    }

    protected processIsProductFavorite2(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/api/favorite/AddToFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites3(_response);
        });
    }

    protected processAddToFavorites3(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfInt32> {
        let url_ = this.baseUrl + "/api/favorite/RemoveFromFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites3(_response);
        });
    }

    protected processRemoveFromFavorites3(response: AxiosResponse): Promise<V2ControllerResultOfInt32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfInt32.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfInt32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfInt32>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite3(productSku: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfBoolean> {
        let url_ = this.baseUrl + "/api/favorite/IsProductFavorite?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite3(_response);
        });
    }

    protected processIsProductFavorite3(response: AxiosResponse): Promise<V2ControllerResultOfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfBoolean.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfBoolean>(null as any);
    }
}

export class FavoritesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    addToFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorites/AddToFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites(_response);
        });
    }

    protected processAddToFavorites(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorites/RemoveFromFavorites?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites(_response);
        });
    }

    protected processRemoveFromFavorites(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite(productSku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/favorites/IsProductFavorite?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite(_response);
        });
    }

    protected processIsProductFavorite(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorites/AddToFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites2(_response);
        });
    }

    protected processAddToFavorites2(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorites/RemoveFromFavorites?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites2(_response);
        });
    }

    protected processRemoveFromFavorites2(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite2(productSku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/favorites/IsProductFavorite?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite2(_response);
        });
    }

    protected processIsProductFavorite2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    addToFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/favorites/AddToFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToFavorites3(_response);
        });
    }

    protected processAddToFavorites3(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    removeFromFavorites3(productSku: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/favorites/RemoveFromFavorites?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromFavorites3(_response);
        });
    }

    protected processRemoveFromFavorites3(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return OK
     */
    isProductFavorite3(productSku: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/favorites/IsProductFavorite?";
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined and cannot be null.");
        else
            url_ += "productSku=" + encodeURIComponent("" + productSku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsProductFavorite3(_response);
        });
    }

    protected processIsProductFavorite3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class FrontpageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getCatalogFrontpageGET(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/frontpage/GetCatalogFrontpage";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpageGET(_response);
        });
    }

    protected processGetCatalogFrontpageGET(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogFrontpagePOST(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/frontpage/GetCatalogFrontpage";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpagePOST(_response);
        });
    }

    protected processGetCatalogFrontpagePOST(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogFrontpageGET2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/frontpage/GetCatalogFrontpage";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpageGET2(_response);
        });
    }

    protected processGetCatalogFrontpageGET2(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogFrontpagePOST2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/frontpage/GetCatalogFrontpage";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpagePOST2(_response);
        });
    }

    protected processGetCatalogFrontpagePOST2(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogFrontpageGET3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/api/frontpage/GetCatalogFrontpage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpageGET3(_response);
        });
    }

    protected processGetCatalogFrontpageGET3(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }

    /**
     * @return OK
     */
    getCatalogFrontpagePOST3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpage> {
        let url_ = this.baseUrl + "/api/frontpage/GetCatalogFrontpage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCatalogFrontpagePOST3(_response);
        });
    }

    protected processGetCatalogFrontpagePOST3(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpage.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpage>(null as any);
    }
}

export class GeneralClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    setTempUserGET(accountId: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/general/SetTempUser?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserGET(_response);
        });
    }

    protected processSetTempUserGET(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setTempUserPOST(accountId: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/general/SetTempUser?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserPOST(_response);
        });
    }

    protected processSetTempUserPOST(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setTempUserGET2(accountId: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/general/SetTempUser?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserGET2(_response);
        });
    }

    protected processSetTempUserGET2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setTempUserPOST2(accountId: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/general/SetTempUser?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserPOST2(_response);
        });
    }

    protected processSetTempUserPOST2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setTempUserGET3(accountId: number , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/general/SetTempUser?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserGET3(_response);
        });
    }

    protected processSetTempUserGET3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    setTempUserPOST3(accountId: number , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/general/SetTempUser?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined and cannot be null.");
        else
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTempUserPOST3(_response);
        });
    }

    protected processSetTempUserPOST3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class HaGeCatalogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search(q: string, searchContext: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/Search?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/GetProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET(_response);
        });
    }

    protected processGetProductsGET(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST(query: SearchQuery, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/GetProducts";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST(_response);
        });
    }

    protected processGetProductsPOST(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts(lastVersion: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/GetPowerBiProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts(_response);
        });
    }

    protected processGetPowerBiProducts(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult(q: string, hits: number | null | undefined, searchContext: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/GetAutoSuggestSearchResult?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult(_response);
        });
    }

    protected processGetAutoSuggestSearchResult(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts(lastVersion: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HaGeCatalog/BaseGetPowerBiProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts(_response);
        });
    }

    protected processBaseGetPowerBiProducts(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search2(q: string, searchContext: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/Search?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch2(_response);
        });
    }

    protected processSearch2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET2(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/GetProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET2(_response);
        });
    }

    protected processGetProductsGET2(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST2(query: SearchQuery, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/GetProducts";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST2(_response);
        });
    }

    protected processGetProductsPOST2(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts2(lastVersion: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/GetPowerBiProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts2(_response);
        });
    }

    protected processGetPowerBiProducts2(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult2(q: string, hits: number | null | undefined, searchContext: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/GetAutoSuggestSearchResult?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult2(_response);
        });
    }

    protected processGetAutoSuggestSearchResult2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts2(lastVersion: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HaGeCatalog/BaseGetPowerBiProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts2(_response);
        });
    }

    protected processBaseGetPowerBiProducts2(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search3(q: string, searchContext: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/Search?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch3(_response);
        });
    }

    protected processSearch3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET3(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/GetProducts?";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET3(_response);
        });
    }

    protected processGetProductsGET3(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST3(query: SearchQuery , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST3(_response);
        });
    }

    protected processGetProductsPOST3(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts3(lastVersion: number , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/GetPowerBiProducts?";
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts3(_response);
        });
    }

    protected processGetPowerBiProducts3(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult3(q: string, hits: number | null | undefined, searchContext: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/GetAutoSuggestSearchResult?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult3(_response);
        });
    }

    protected processGetAutoSuggestSearchResult3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts3(lastVersion: number , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/HaGeCatalog/BaseGetPowerBiProducts?";
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts3(_response);
        });
    }

    protected processBaseGetPowerBiProducts3(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }
}

export class HarvestLocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getSalesOffices(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HarvestLocation/GetSalesOffices";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOffices(_response);
        });
    }

    protected processGetSalesOffices(response: AxiosResponse): Promise<SalesOfficeMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeMapping[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping[]>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeName(salesOfficeId: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HarvestLocation/GetSalesOfficeName?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId === undefined || salesOfficeId === null)
            throw new Error("The parameter 'salesOfficeId' must be defined and cannot be null.");
        else
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeName(_response);
        });
    }

    protected processGetSalesOfficeName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeByPlantOrLocation(plantOrLocation: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HarvestLocation/GetSalesOfficeByPlantOrLocation?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (plantOrLocation === undefined || plantOrLocation === null)
            throw new Error("The parameter 'plantOrLocation' must be defined and cannot be null.");
        else
            url_ += "plantOrLocation=" + encodeURIComponent("" + plantOrLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeByPlantOrLocation(_response);
        });
    }

    protected processGetSalesOfficeByPlantOrLocation(response: AxiosResponse): Promise<SalesOfficeMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalesOfficeMapping.fromJS(resultData200);
            return Promise.resolve<SalesOfficeMapping>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping>(null as any);
    }

    /**
     * @return OK
     */
    getActiveSubscriptionsForUser(userName: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HarvestSMSSubscriber[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HarvestLocation/GetActiveSubscriptionsForUser?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSubscriptionsForUser(_response);
        });
    }

    protected processGetActiveSubscriptionsForUser(response: AxiosResponse): Promise<HarvestSMSSubscriber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HarvestSMSSubscriber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HarvestSMSSubscriber[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HarvestSMSSubscriber[]>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOffices2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HarvestLocation/GetSalesOffices";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOffices2(_response);
        });
    }

    protected processGetSalesOffices2(response: AxiosResponse): Promise<SalesOfficeMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeMapping[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping[]>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeName2(salesOfficeId: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HarvestLocation/GetSalesOfficeName?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId === undefined || salesOfficeId === null)
            throw new Error("The parameter 'salesOfficeId' must be defined and cannot be null.");
        else
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeName2(_response);
        });
    }

    protected processGetSalesOfficeName2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeByPlantOrLocation2(plantOrLocation: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HarvestLocation/GetSalesOfficeByPlantOrLocation?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (plantOrLocation === undefined || plantOrLocation === null)
            throw new Error("The parameter 'plantOrLocation' must be defined and cannot be null.");
        else
            url_ += "plantOrLocation=" + encodeURIComponent("" + plantOrLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeByPlantOrLocation2(_response);
        });
    }

    protected processGetSalesOfficeByPlantOrLocation2(response: AxiosResponse): Promise<SalesOfficeMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalesOfficeMapping.fromJS(resultData200);
            return Promise.resolve<SalesOfficeMapping>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping>(null as any);
    }

    /**
     * @return OK
     */
    getActiveSubscriptionsForUser2(userName: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HarvestSMSSubscriber[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HarvestLocation/GetActiveSubscriptionsForUser?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSubscriptionsForUser2(_response);
        });
    }

    protected processGetActiveSubscriptionsForUser2(response: AxiosResponse): Promise<HarvestSMSSubscriber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HarvestSMSSubscriber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HarvestSMSSubscriber[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HarvestSMSSubscriber[]>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOffices3(  cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping[]> {
        let url_ = this.baseUrl + "/api/HarvestLocation/GetSalesOffices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOffices3(_response);
        });
    }

    protected processGetSalesOffices3(response: AxiosResponse): Promise<SalesOfficeMapping[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeMapping.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeMapping[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping[]>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeName3(salesOfficeId: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/HarvestLocation/GetSalesOfficeName?";
        if (salesOfficeId === undefined || salesOfficeId === null)
            throw new Error("The parameter 'salesOfficeId' must be defined and cannot be null.");
        else
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeName3(_response);
        });
    }

    protected processGetSalesOfficeName3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getSalesOfficeByPlantOrLocation3(plantOrLocation: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeMapping> {
        let url_ = this.baseUrl + "/api/HarvestLocation/GetSalesOfficeByPlantOrLocation?";
        if (plantOrLocation === undefined || plantOrLocation === null)
            throw new Error("The parameter 'plantOrLocation' must be defined and cannot be null.");
        else
            url_ += "plantOrLocation=" + encodeURIComponent("" + plantOrLocation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficeByPlantOrLocation3(_response);
        });
    }

    protected processGetSalesOfficeByPlantOrLocation3(response: AxiosResponse): Promise<SalesOfficeMapping> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SalesOfficeMapping.fromJS(resultData200);
            return Promise.resolve<SalesOfficeMapping>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeMapping>(null as any);
    }

    /**
     * @return OK
     */
    getActiveSubscriptionsForUser3(userName: string , cancelToken?: CancelToken | undefined): Promise<HarvestSMSSubscriber[]> {
        let url_ = this.baseUrl + "/api/HarvestLocation/GetActiveSubscriptionsForUser?";
        if (userName === undefined || userName === null)
            throw new Error("The parameter 'userName' must be defined and cannot be null.");
        else
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveSubscriptionsForUser3(_response);
        });
    }

    protected processGetActiveSubscriptionsForUser3(response: AxiosResponse): Promise<HarvestSMSSubscriber[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HarvestSMSSubscriber.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HarvestSMSSubscriber[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HarvestSMSSubscriber[]>(null as any);
    }
}

export class HarvestOverviewClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getHarvestOverview(from: Date, to: Date, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/harvestoverview/GetHarvestOverview?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverview(_response);
        });
    }

    protected processGetHarvestOverview(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(null as any);
    }

    /**
     * @return OK
     */
    getHarvestOverviewByCropType(from: Date, to: Date, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/harvestoverview/GetHarvestOverviewByCropType?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverviewByCropType(_response);
        });
    }

    protected processGetHarvestOverviewByCropType(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewByCropTypeResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(null as any);
    }

    /**
     * @return OK
     */
    downloadHarvestOverviewExcel(from: Date, to: Date, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/harvestoverview/DownloadHarvestOverviewExcel?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadHarvestOverviewExcel(_response);
        });
    }

    protected processDownloadHarvestOverviewExcel(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getHarvestOverview2(from: Date, to: Date, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/harvestoverview/GetHarvestOverview?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverview2(_response);
        });
    }

    protected processGetHarvestOverview2(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(null as any);
    }

    /**
     * @return OK
     */
    getHarvestOverviewByCropType2(from: Date, to: Date, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/harvestoverview/GetHarvestOverviewByCropType?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverviewByCropType2(_response);
        });
    }

    protected processGetHarvestOverviewByCropType2(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewByCropTypeResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(null as any);
    }

    /**
     * @return OK
     */
    downloadHarvestOverviewExcel2(from: Date, to: Date, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/harvestoverview/DownloadHarvestOverviewExcel?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadHarvestOverviewExcel2(_response);
        });
    }

    protected processDownloadHarvestOverviewExcel2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getHarvestOverview3(from: Date, to: Date , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        let url_ = this.baseUrl + "/api/harvestoverview/GetHarvestOverview?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverview3(_response);
        });
    }

    protected processGetHarvestOverview3(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewResult>(null as any);
    }

    /**
     * @return OK
     */
    getHarvestOverviewByCropType3(from: Date, to: Date , cancelToken?: CancelToken | undefined): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        let url_ = this.baseUrl + "/api/harvestoverview/GetHarvestOverviewByCropType?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHarvestOverviewByCropType3(_response);
        });
    }

    protected processGetHarvestOverviewByCropType3(response: AxiosResponse): Promise<HaGeControllerResultOfIHarvestOverviewByCropTypeResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HaGeControllerResultOfIHarvestOverviewByCropTypeResult.fromJS(resultData200);
            return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HaGeControllerResultOfIHarvestOverviewByCropTypeResult>(null as any);
    }

    /**
     * @return OK
     */
    downloadHarvestOverviewExcel3(from: Date, to: Date , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/harvestoverview/DownloadHarvestOverviewExcel?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadHarvestOverviewExcel3(_response);
        });
    }

    protected processDownloadHarvestOverviewExcel3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class HeadlessDialogPortalClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    setSubscriptionsForMedia(subscribe: boolean, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HeadlessDialogPortal/SetSubscriptionsForMedia?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (subscribe === undefined || subscribe === null)
            throw new Error("The parameter 'subscribe' must be defined and cannot be null.");
        else
            url_ += "subscribe=" + encodeURIComponent("" + subscribe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionsForMedia(_response);
        });
    }

    protected processSetSubscriptionsForMedia(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOldCrmUserName(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HeadlessDialogPortal/GetOldCrmUserName";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOldCrmUserName(_response);
        });
    }

    protected processGetOldCrmUserName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the "general permission" flags for email and sms from the logged-in User.
     * @param code (optional) 
     * @return OK
     */
    getGeneralPermissionsForUser(code: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HeadlessDialogPortal/GetGeneralPermissionsForUser?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser(_response);
        });
    }

    protected processGetGeneralPermissionsForUser(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    setSubscriptionsForMedia2(subscribe: boolean, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HeadlessDialogPortal/SetSubscriptionsForMedia?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (subscribe === undefined || subscribe === null)
            throw new Error("The parameter 'subscribe' must be defined and cannot be null.");
        else
            url_ += "subscribe=" + encodeURIComponent("" + subscribe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionsForMedia2(_response);
        });
    }

    protected processSetSubscriptionsForMedia2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOldCrmUserName2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HeadlessDialogPortal/GetOldCrmUserName";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOldCrmUserName2(_response);
        });
    }

    protected processGetOldCrmUserName2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the "general permission" flags for email and sms from the logged-in User.
     * @param code (optional) 
     * @return OK
     */
    getGeneralPermissionsForUser2(code: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HeadlessDialogPortal/GetGeneralPermissionsForUser?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser2(_response);
        });
    }

    protected processGetGeneralPermissionsForUser2(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }

    /**
     * @return OK
     */
    setSubscriptionsForMedia3(subscribe: boolean , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/HeadlessDialogPortal/SetSubscriptionsForMedia?";
        if (subscribe === undefined || subscribe === null)
            throw new Error("The parameter 'subscribe' must be defined and cannot be null.");
        else
            url_ += "subscribe=" + encodeURIComponent("" + subscribe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionsForMedia3(_response);
        });
    }

    protected processSetSubscriptionsForMedia3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getOldCrmUserName3(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/HeadlessDialogPortal/GetOldCrmUserName";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOldCrmUserName3(_response);
        });
    }

    protected processGetOldCrmUserName3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the "general permission" flags for email and sms from the logged-in User.
     * @param code (optional) 
     * @return OK
     */
    getGeneralPermissionsForUser3(code: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<KeyValuePairOfStringAndBoolean[]> {
        let url_ = this.baseUrl + "/api/HeadlessDialogPortal/GetGeneralPermissionsForUser?";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralPermissionsForUser3(_response);
        });
    }

    protected processGetGeneralPermissionsForUser3(response: AxiosResponse): Promise<KeyValuePairOfStringAndBoolean[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KeyValuePairOfStringAndBoolean[]>(null as any);
    }
}

export class HeadlessGenericComponentsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getGenericBox(id: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/HeadlessGenericComponents/GetGenericBox/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenericBox(_response);
        });
    }

    protected processGetGenericBox(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGenericBox2(id: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/HeadlessGenericComponents/GetGenericBox/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenericBox2(_response);
        });
    }

    protected processGetGenericBox2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGenericBox3(id: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/HeadlessGenericComponents/{id}/GetGenericBox";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenericBox3(_response);
        });
    }

    protected processGetGenericBox3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGenericBox4(id: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/HeadlessGenericComponents/GetGenericBox/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenericBox4(_response);
        });
    }

    protected processGetGenericBox4(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class InvoicesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getItella(id: string, ip: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/GetItella/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (ip === undefined || ip === null)
            throw new Error("The parameter 'ip' must be defined and cannot be null.");
        else
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItella(_response);
        });
    }

    protected processGetItella(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    bulkDownloadInvoices(documentHitId: DocumentHitId2[], dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/BulkDownloadInvoices";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentHitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkDownloadInvoices(_response);
        });
    }

    protected processBulkDownloadInvoices(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    downloadzip(fName: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/Downloadzip?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fName === undefined || fName === null)
            throw new Error("The parameter 'fName' must be defined and cannot be null.");
        else
            url_ += "fName=" + encodeURIComponent("" + fName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadzip(_response);
        });
    }

    protected processDownloadzip(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoiceGET(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/SearchInvoice?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceGET(_response);
        });
    }

    protected processSearchInvoiceGET(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoicePOST(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/SearchInvoice?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoicePOST(_response);
        });
    }

    protected processSearchInvoicePOST(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    fetchInvoiceInfo(dlgnamespace: string, hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IDocumentFetchInfoResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/FetchInvoiceInfo?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFetchInvoiceInfo(_response);
        });
    }

    protected processFetchInvoiceInfo(response: AxiosResponse): Promise<IDocumentFetchInfoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentFetchInfoResult.fromJS(resultData200);
            return Promise.resolve<IDocumentFetchInfoResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentFetchInfoResult>(null as any);
    }

    /**
     * @param searchTimestamp (optional) 
     * @param hitToken (optional) 
     * @param origin (optional) 
     * @param reportName (optional) 
     * @param reportVersion (optional) 
     * @param fullLength (optional) 
     * @param compressedLength (optional) 
     * @param displacement (optional) 
     * @param postingDateTime (optional) 
     * @param dataTable (optional) 
     * @param documentId (optional) 
     * @return OK
     */
    downloadInvoice(searchTimestamp: string | null | undefined, hitToken: string | null | undefined, origin: number | null | undefined, reportName: string | null | undefined, reportVersion: string | null | undefined, fullLength: number | null | undefined, compressedLength: number | null | undefined, displacement: number | null | undefined, postingDateTime: string | null | undefined, dataTable: string | null | undefined, documentId: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/DownloadInvoice?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchTimestamp !== undefined && searchTimestamp !== null)
            url_ += "SearchTimestamp=" + encodeURIComponent("" + searchTimestamp) + "&";
        if (hitToken !== undefined && hitToken !== null)
            url_ += "HitToken=" + encodeURIComponent("" + hitToken) + "&";
        if (origin !== undefined && origin !== null)
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (reportName !== undefined && reportName !== null)
            url_ += "ReportName=" + encodeURIComponent("" + reportName) + "&";
        if (reportVersion !== undefined && reportVersion !== null)
            url_ += "ReportVersion=" + encodeURIComponent("" + reportVersion) + "&";
        if (fullLength !== undefined && fullLength !== null)
            url_ += "FullLength=" + encodeURIComponent("" + fullLength) + "&";
        if (compressedLength !== undefined && compressedLength !== null)
            url_ += "CompressedLength=" + encodeURIComponent("" + compressedLength) + "&";
        if (displacement !== undefined && displacement !== null)
            url_ += "Displacement=" + encodeURIComponent("" + displacement) + "&";
        if (postingDateTime !== undefined && postingDateTime !== null)
            url_ += "PostingDateTime=" + encodeURIComponent("" + postingDateTime) + "&";
        if (dataTable !== undefined && dataTable !== null)
            url_ += "DataTable=" + encodeURIComponent("" + dataTable) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoice(_response);
        });
    }

    protected processDownloadInvoice(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    downloadInvoiceLocal(hitId: DocumentHitId2, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/DownloadInvoiceLocal";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoiceLocal(_response);
        });
    }

    protected processDownloadInvoiceLocal(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryOverview(fromDate: Date, toDate: Date, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDeliveryOverview[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/GetDeliveryOverview?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryOverview(_response);
        });
    }

    protected processGetDeliveryOverview(response: AxiosResponse): Promise<IDeliveryOverview[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IDeliveryOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IDeliveryOverview[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryOverview[]>(null as any);
    }

    /**
     * @return OK
     */
    hasDeliveryPdf(sku: string, date: Date, deliveryNumber: string, documentType: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDeliveryPdfResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/HasDeliveryPdf?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasDeliveryPdf(_response);
        });
    }

    protected processHasDeliveryPdf(response: AxiosResponse): Promise<IDeliveryPdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDeliveryPdfResult.fromJS(resultData200);
            return Promise.resolve<IDeliveryPdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryPdfResult>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryPdf(sku: string, date: Date, deliveryNumber: string, documentType: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/invoices/GetDeliveryPdf?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPdf(_response);
        });
    }

    protected processGetDeliveryPdf(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getItella2(id: string, ip: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/GetItella/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (ip === undefined || ip === null)
            throw new Error("The parameter 'ip' must be defined and cannot be null.");
        else
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItella2(_response);
        });
    }

    protected processGetItella2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    bulkDownloadInvoices2(documentHitId: DocumentHitId2[], virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/BulkDownloadInvoices";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentHitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkDownloadInvoices2(_response);
        });
    }

    protected processBulkDownloadInvoices2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    downloadzip2(fName: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/Downloadzip?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fName === undefined || fName === null)
            throw new Error("The parameter 'fName' must be defined and cannot be null.");
        else
            url_ += "fName=" + encodeURIComponent("" + fName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadzip2(_response);
        });
    }

    protected processDownloadzip2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoiceGET2(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/SearchInvoice?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceGET2(_response);
        });
    }

    protected processSearchInvoiceGET2(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoicePOST2(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/SearchInvoice?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoicePOST2(_response);
        });
    }

    protected processSearchInvoicePOST2(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    fetchInvoiceInfo2(virtualFolder: string, dlgnamespace: string, hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IDocumentFetchInfoResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/FetchInvoiceInfo?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFetchInvoiceInfo2(_response);
        });
    }

    protected processFetchInvoiceInfo2(response: AxiosResponse): Promise<IDocumentFetchInfoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentFetchInfoResult.fromJS(resultData200);
            return Promise.resolve<IDocumentFetchInfoResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentFetchInfoResult>(null as any);
    }

    /**
     * @param searchTimestamp (optional) 
     * @param hitToken (optional) 
     * @param origin (optional) 
     * @param reportName (optional) 
     * @param reportVersion (optional) 
     * @param fullLength (optional) 
     * @param compressedLength (optional) 
     * @param displacement (optional) 
     * @param postingDateTime (optional) 
     * @param dataTable (optional) 
     * @param documentId (optional) 
     * @return OK
     */
    downloadInvoice2(searchTimestamp: string | null | undefined, hitToken: string | null | undefined, origin: number | null | undefined, reportName: string | null | undefined, reportVersion: string | null | undefined, fullLength: number | null | undefined, compressedLength: number | null | undefined, displacement: number | null | undefined, postingDateTime: string | null | undefined, dataTable: string | null | undefined, documentId: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/DownloadInvoice?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchTimestamp !== undefined && searchTimestamp !== null)
            url_ += "SearchTimestamp=" + encodeURIComponent("" + searchTimestamp) + "&";
        if (hitToken !== undefined && hitToken !== null)
            url_ += "HitToken=" + encodeURIComponent("" + hitToken) + "&";
        if (origin !== undefined && origin !== null)
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (reportName !== undefined && reportName !== null)
            url_ += "ReportName=" + encodeURIComponent("" + reportName) + "&";
        if (reportVersion !== undefined && reportVersion !== null)
            url_ += "ReportVersion=" + encodeURIComponent("" + reportVersion) + "&";
        if (fullLength !== undefined && fullLength !== null)
            url_ += "FullLength=" + encodeURIComponent("" + fullLength) + "&";
        if (compressedLength !== undefined && compressedLength !== null)
            url_ += "CompressedLength=" + encodeURIComponent("" + compressedLength) + "&";
        if (displacement !== undefined && displacement !== null)
            url_ += "Displacement=" + encodeURIComponent("" + displacement) + "&";
        if (postingDateTime !== undefined && postingDateTime !== null)
            url_ += "PostingDateTime=" + encodeURIComponent("" + postingDateTime) + "&";
        if (dataTable !== undefined && dataTable !== null)
            url_ += "DataTable=" + encodeURIComponent("" + dataTable) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoice2(_response);
        });
    }

    protected processDownloadInvoice2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    downloadInvoiceLocal2(hitId: DocumentHitId2, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/DownloadInvoiceLocal";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoiceLocal2(_response);
        });
    }

    protected processDownloadInvoiceLocal2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryOverview2(fromDate: Date, toDate: Date, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDeliveryOverview[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/GetDeliveryOverview?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryOverview2(_response);
        });
    }

    protected processGetDeliveryOverview2(response: AxiosResponse): Promise<IDeliveryOverview[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IDeliveryOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IDeliveryOverview[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryOverview[]>(null as any);
    }

    /**
     * @return OK
     */
    hasDeliveryPdf2(sku: string, date: Date, deliveryNumber: string, documentType: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IDeliveryPdfResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/HasDeliveryPdf?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasDeliveryPdf2(_response);
        });
    }

    protected processHasDeliveryPdf2(response: AxiosResponse): Promise<IDeliveryPdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDeliveryPdfResult.fromJS(resultData200);
            return Promise.resolve<IDeliveryPdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryPdfResult>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryPdf2(sku: string, date: Date, deliveryNumber: string, documentType: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/invoices/GetDeliveryPdf?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPdf2(_response);
        });
    }

    protected processGetDeliveryPdf2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getItella3(id: string, ip: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/invoices/{id}/GetItella?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        if (ip === undefined || ip === null)
            throw new Error("The parameter 'ip' must be defined and cannot be null.");
        else
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItella3(_response);
        });
    }

    protected processGetItella3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getItella4(id: string, ip: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/invoices/GetItella/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (ip === undefined || ip === null)
            throw new Error("The parameter 'ip' must be defined and cannot be null.");
        else
            url_ += "ip=" + encodeURIComponent("" + ip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItella4(_response);
        });
    }

    protected processGetItella4(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    bulkDownloadInvoices3(documentHitId: DocumentHitId2[] , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/invoices/BulkDownloadInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(documentHitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkDownloadInvoices3(_response);
        });
    }

    protected processBulkDownloadInvoices3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    downloadzip3(fName: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/invoices/Downloadzip?";
        if (fName === undefined || fName === null)
            throw new Error("The parameter 'fName' must be defined and cannot be null.");
        else
            url_ += "fName=" + encodeURIComponent("" + fName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadzip3(_response);
        });
    }

    protected processDownloadzip3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoiceGET3(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/api/invoices/SearchInvoice?";
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoiceGET3(_response);
        });
    }

    protected processSearchInvoiceGET3(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param customerNumber (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param maxResults (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return OK
     */
    searchInvoicePOST3(customerNumber: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, maxResults: number | null | undefined, documentId: string | null | undefined, documentType: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IDocumentSearchResult> {
        let url_ = this.baseUrl + "/api/invoices/SearchInvoice?";
        if (customerNumber !== undefined && customerNumber !== null)
            url_ += "CustomerNumber=" + encodeURIComponent("" + customerNumber) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "MaxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        if (documentType !== undefined && documentType !== null)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoicePOST3(_response);
        });
    }

    protected processSearchInvoicePOST3(response: AxiosResponse): Promise<IDocumentSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentSearchResult.fromJS(resultData200);
            return Promise.resolve<IDocumentSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentSearchResult>(null as any);
    }

    /**
     * @param hitId_searchTimestamp (optional) 
     * @param hitId_hitToken (optional) 
     * @param hitId_origin (optional) 
     * @param hitId_reportName (optional) 
     * @param hitId_reportVersion (optional) 
     * @param hitId_fullLength (optional) 
     * @param hitId_compressedLength (optional) 
     * @param hitId_displacement (optional) 
     * @param hitId_postingDateTime (optional) 
     * @param hitId_dataTable (optional) 
     * @param hitId_documentId (optional) 
     * @param hitId_type (optional) 
     * @param hitId_documentNumber (optional) 
     * @return OK
     */
    fetchInvoiceInfo3(hitId_searchTimestamp: string | null | undefined, hitId_hitToken: string | null | undefined, hitId_origin: number | null | undefined, hitId_reportName: string | null | undefined, hitId_reportVersion: string | null | undefined, hitId_fullLength: number | null | undefined, hitId_compressedLength: number | null | undefined, hitId_displacement: number | null | undefined, hitId_postingDateTime: string | null | undefined, hitId_dataTable: string | null | undefined, hitId_documentId: string | null | undefined, hitId_type: string | null | undefined, hitId_documentNumber: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IDocumentFetchInfoResult> {
        let url_ = this.baseUrl + "/api/invoices/FetchInvoiceInfo?";
        if (hitId_searchTimestamp !== undefined && hitId_searchTimestamp !== null)
            url_ += "hitId.searchTimestamp=" + encodeURIComponent("" + hitId_searchTimestamp) + "&";
        if (hitId_hitToken !== undefined && hitId_hitToken !== null)
            url_ += "hitId.hitToken=" + encodeURIComponent("" + hitId_hitToken) + "&";
        if (hitId_origin !== undefined && hitId_origin !== null)
            url_ += "hitId.origin=" + encodeURIComponent("" + hitId_origin) + "&";
        if (hitId_reportName !== undefined && hitId_reportName !== null)
            url_ += "hitId.reportName=" + encodeURIComponent("" + hitId_reportName) + "&";
        if (hitId_reportVersion !== undefined && hitId_reportVersion !== null)
            url_ += "hitId.reportVersion=" + encodeURIComponent("" + hitId_reportVersion) + "&";
        if (hitId_fullLength !== undefined && hitId_fullLength !== null)
            url_ += "hitId.fullLength=" + encodeURIComponent("" + hitId_fullLength) + "&";
        if (hitId_compressedLength !== undefined && hitId_compressedLength !== null)
            url_ += "hitId.compressedLength=" + encodeURIComponent("" + hitId_compressedLength) + "&";
        if (hitId_displacement !== undefined && hitId_displacement !== null)
            url_ += "hitId.displacement=" + encodeURIComponent("" + hitId_displacement) + "&";
        if (hitId_postingDateTime !== undefined && hitId_postingDateTime !== null)
            url_ += "hitId.postingDateTime=" + encodeURIComponent("" + hitId_postingDateTime) + "&";
        if (hitId_dataTable !== undefined && hitId_dataTable !== null)
            url_ += "hitId.dataTable=" + encodeURIComponent("" + hitId_dataTable) + "&";
        if (hitId_documentId !== undefined && hitId_documentId !== null)
            url_ += "hitId.documentId=" + encodeURIComponent("" + hitId_documentId) + "&";
        if (hitId_type !== undefined && hitId_type !== null)
            url_ += "hitId.type=" + encodeURIComponent("" + hitId_type) + "&";
        if (hitId_documentNumber !== undefined && hitId_documentNumber !== null)
            url_ += "hitId.documentNumber=" + encodeURIComponent("" + hitId_documentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFetchInvoiceInfo3(_response);
        });
    }

    protected processFetchInvoiceInfo3(response: AxiosResponse): Promise<IDocumentFetchInfoResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDocumentFetchInfoResult.fromJS(resultData200);
            return Promise.resolve<IDocumentFetchInfoResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDocumentFetchInfoResult>(null as any);
    }

    /**
     * @param searchTimestamp (optional) 
     * @param hitToken (optional) 
     * @param origin (optional) 
     * @param reportName (optional) 
     * @param reportVersion (optional) 
     * @param fullLength (optional) 
     * @param compressedLength (optional) 
     * @param displacement (optional) 
     * @param postingDateTime (optional) 
     * @param dataTable (optional) 
     * @param documentId (optional) 
     * @return OK
     */
    downloadInvoice3(searchTimestamp: string | null | undefined, hitToken: string | null | undefined, origin: number | null | undefined, reportName: string | null | undefined, reportVersion: string | null | undefined, fullLength: number | null | undefined, compressedLength: number | null | undefined, displacement: number | null | undefined, postingDateTime: string | null | undefined, dataTable: string | null | undefined, documentId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/invoices/DownloadInvoice?";
        if (searchTimestamp !== undefined && searchTimestamp !== null)
            url_ += "SearchTimestamp=" + encodeURIComponent("" + searchTimestamp) + "&";
        if (hitToken !== undefined && hitToken !== null)
            url_ += "HitToken=" + encodeURIComponent("" + hitToken) + "&";
        if (origin !== undefined && origin !== null)
            url_ += "Origin=" + encodeURIComponent("" + origin) + "&";
        if (reportName !== undefined && reportName !== null)
            url_ += "ReportName=" + encodeURIComponent("" + reportName) + "&";
        if (reportVersion !== undefined && reportVersion !== null)
            url_ += "ReportVersion=" + encodeURIComponent("" + reportVersion) + "&";
        if (fullLength !== undefined && fullLength !== null)
            url_ += "FullLength=" + encodeURIComponent("" + fullLength) + "&";
        if (compressedLength !== undefined && compressedLength !== null)
            url_ += "CompressedLength=" + encodeURIComponent("" + compressedLength) + "&";
        if (displacement !== undefined && displacement !== null)
            url_ += "Displacement=" + encodeURIComponent("" + displacement) + "&";
        if (postingDateTime !== undefined && postingDateTime !== null)
            url_ += "PostingDateTime=" + encodeURIComponent("" + postingDateTime) + "&";
        if (dataTable !== undefined && dataTable !== null)
            url_ += "DataTable=" + encodeURIComponent("" + dataTable) + "&";
        if (documentId !== undefined && documentId !== null)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoice3(_response);
        });
    }

    protected processDownloadInvoice3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    downloadInvoiceLocal3(hitId: DocumentHitId2 , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/invoices/DownloadInvoiceLocal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hitId);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadInvoiceLocal3(_response);
        });
    }

    protected processDownloadInvoiceLocal3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryOverview3(fromDate: Date, toDate: Date , cancelToken?: CancelToken | undefined): Promise<IDeliveryOverview[]> {
        let url_ = this.baseUrl + "/api/invoices/GetDeliveryOverview?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryOverview3(_response);
        });
    }

    protected processGetDeliveryOverview3(response: AxiosResponse): Promise<IDeliveryOverview[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IDeliveryOverview.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IDeliveryOverview[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryOverview[]>(null as any);
    }

    /**
     * @return OK
     */
    hasDeliveryPdf3(sku: string, date: Date, deliveryNumber: string, documentType: string , cancelToken?: CancelToken | undefined): Promise<IDeliveryPdfResult> {
        let url_ = this.baseUrl + "/api/invoices/HasDeliveryPdf?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasDeliveryPdf3(_response);
        });
    }

    protected processHasDeliveryPdf3(response: AxiosResponse): Promise<IDeliveryPdfResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDeliveryPdfResult.fromJS(resultData200);
            return Promise.resolve<IDeliveryPdfResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDeliveryPdfResult>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryPdf3(sku: string, date: Date, deliveryNumber: string, documentType: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/invoices/GetDeliveryPdf?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (deliveryNumber === undefined || deliveryNumber === null)
            throw new Error("The parameter 'deliveryNumber' must be defined and cannot be null.");
        else
            url_ += "deliveryNumber=" + encodeURIComponent("" + deliveryNumber) + "&";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined and cannot be null.");
        else
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPdf3(_response);
        });
    }

    protected processGetDeliveryPdf3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class LinksClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getEnergyContractUrl(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Links/GetEnergyContractUrl";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnergyContractUrl(_response);
        });
    }

    protected processGetEnergyContractUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getEnergyContractUrl2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Links/GetEnergyContractUrl";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnergyContractUrl2(_response);
        });
    }

    protected processGetEnergyContractUrl2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getEnergyContractUrl3(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Links/GetEnergyContractUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnergyContractUrl3(_response);
        });
    }

    protected processGetEnergyContractUrl3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LoginClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getRefreshToken(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Login/GetRefreshToken";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRefreshToken(_response);
        });
    }

    protected processGetRefreshToken(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param authID (optional) 
     * @return OK
     */
    logout(authID: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Login/Logout?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (authID !== undefined && authID !== null)
            url_ += "authID=" + encodeURIComponent("" + authID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getRefreshToken2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Login/GetRefreshToken";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRefreshToken2(_response);
        });
    }

    protected processGetRefreshToken2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param authID (optional) 
     * @return OK
     */
    logout2(authID: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Login/Logout?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (authID !== undefined && authID !== null)
            url_ += "authID=" + encodeURIComponent("" + authID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout2(_response);
        });
    }

    protected processLogout2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    getRefreshToken3(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/Login/GetRefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRefreshToken3(_response);
        });
    }

    protected processGetRefreshToken3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param authID (optional) 
     * @return OK
     */
    logout3(authID: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Login/Logout?";
        if (authID !== undefined && authID !== null)
            url_ += "authID=" + encodeURIComponent("" + authID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout3(_response);
        });
    }

    protected processLogout3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MerxCornUniverseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    merxGetDLGPrices(crop: string, termId: string, months: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropTermPrices[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/MerxCornUniverse/MerxGetDLGPrices?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        if (termId === undefined || termId === null)
            throw new Error("The parameter 'termId' must be defined and cannot be null.");
        else
            url_ += "termId=" + encodeURIComponent("" + termId) + "&";
        if (months === undefined || months === null)
            throw new Error("The parameter 'months' must be defined and cannot be null.");
        else
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerxGetDLGPrices(_response);
        });
    }

    protected processMerxGetDLGPrices(response: AxiosResponse): Promise<CropTermPrices[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CropTermPrices.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CropTermPrices[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropTermPrices[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllDLGPrices(crop: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DLGTermTable> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/MerxCornUniverse/GetAllDLGPrices?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDLGPrices(_response);
        });
    }

    protected processGetAllDLGPrices(response: AxiosResponse): Promise<DLGTermTable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DLGTermTable.fromJS(resultData200);
            return Promise.resolve<DLGTermTable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DLGTermTable>(null as any);
    }

    /**
     * @return OK
     */
    merxGetDLGPrices2(crop: string, termId: string, months: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CropTermPrices[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/MerxCornUniverse/MerxGetDLGPrices?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        if (termId === undefined || termId === null)
            throw new Error("The parameter 'termId' must be defined and cannot be null.");
        else
            url_ += "termId=" + encodeURIComponent("" + termId) + "&";
        if (months === undefined || months === null)
            throw new Error("The parameter 'months' must be defined and cannot be null.");
        else
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerxGetDLGPrices2(_response);
        });
    }

    protected processMerxGetDLGPrices2(response: AxiosResponse): Promise<CropTermPrices[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CropTermPrices.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CropTermPrices[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropTermPrices[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllDLGPrices2(crop: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<DLGTermTable> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/MerxCornUniverse/GetAllDLGPrices?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDLGPrices2(_response);
        });
    }

    protected processGetAllDLGPrices2(response: AxiosResponse): Promise<DLGTermTable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DLGTermTable.fromJS(resultData200);
            return Promise.resolve<DLGTermTable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DLGTermTable>(null as any);
    }

    /**
     * @return OK
     */
    merxGetDLGPrices3(crop: string, termId: string, months: number , cancelToken?: CancelToken | undefined): Promise<CropTermPrices[]> {
        let url_ = this.baseUrl + "/api/MerxCornUniverse/MerxGetDLGPrices?";
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        if (termId === undefined || termId === null)
            throw new Error("The parameter 'termId' must be defined and cannot be null.");
        else
            url_ += "termId=" + encodeURIComponent("" + termId) + "&";
        if (months === undefined || months === null)
            throw new Error("The parameter 'months' must be defined and cannot be null.");
        else
            url_ += "months=" + encodeURIComponent("" + months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerxGetDLGPrices3(_response);
        });
    }

    protected processMerxGetDLGPrices3(response: AxiosResponse): Promise<CropTermPrices[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CropTermPrices.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CropTermPrices[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropTermPrices[]>(null as any);
    }

    /**
     * @return OK
     */
    getAllDLGPrices3(crop: string , cancelToken?: CancelToken | undefined): Promise<DLGTermTable> {
        let url_ = this.baseUrl + "/api/MerxCornUniverse/GetAllDLGPrices?";
        if (crop === undefined || crop === null)
            throw new Error("The parameter 'crop' must be defined and cannot be null.");
        else
            url_ += "crop=" + encodeURIComponent("" + crop) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDLGPrices3(_response);
        });
    }

    protected processGetAllDLGPrices3(response: AxiosResponse): Promise<DLGTermTable> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DLGTermTable.fromJS(resultData200);
            return Promise.resolve<DLGTermTable>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DLGTermTable>(null as any);
    }
}

export class OrdersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getOrderHistory(startDate: Date, endDate: Date, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/orders/GetOrderHistory?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderHistory(_response);
        });
    }

    protected processGetOrderHistory(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }

    /**
     * @return OK
     */
    getLatest(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/orders/GetLatest";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatest(_response);
        });
    }

    protected processGetLatest(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }

    /**
     * @return OK
     */
    getOrderHistory2(startDate: Date, endDate: Date, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/orders/GetOrderHistory?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderHistory2(_response);
        });
    }

    protected processGetOrderHistory2(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }

    /**
     * @return OK
     */
    getLatest2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/orders/GetLatest";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatest2(_response);
        });
    }

    protected processGetLatest2(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }

    /**
     * @return OK
     */
    getOrderHistory3(startDate: Date, endDate: Date , cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/api/orders/GetOrderHistory?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrderHistory3(_response);
        });
    }

    protected processGetOrderHistory3(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }

    /**
     * @return OK
     */
    getLatest3(  cancelToken?: CancelToken | undefined): Promise<IOrderHistory> {
        let url_ = this.baseUrl + "/api/orders/GetLatest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatest3(_response);
        });
    }

    protected processGetLatest3(response: AxiosResponse): Promise<IOrderHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IOrderHistory.fromJS(resultData200);
            return Promise.resolve<IOrderHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IOrderHistory>(null as any);
    }
}

export class PartnershipDataClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    uploadPartnershipPriceData(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/PartnershipData/UploadPartnershipPriceData";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPartnershipPriceData(_response);
        });
    }

    protected processUploadPartnershipPriceData(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    uploadPartnershipPriceData2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/PartnershipData/UploadPartnershipPriceData";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPartnershipPriceData2(_response);
        });
    }

    protected processUploadPartnershipPriceData2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    uploadPartnershipPriceData3(  cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PartnershipData/UploadPartnershipPriceData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPartnershipPriceData3(_response);
        });
    }

    protected processUploadPartnershipPriceData3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getSeedMaterialData(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SeedMaterial> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/Product/GetSeedMaterialData?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeedMaterialData(_response);
        });
    }

    protected processGetSeedMaterialData(response: AxiosResponse): Promise<SeedMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SeedMaterial.fromJS(resultData200);
            return Promise.resolve<SeedMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SeedMaterial>(null as any);
    }

    /**
     * @return OK
     */
    getSeedMaterialData2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SeedMaterial> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/Product/GetSeedMaterialData?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeedMaterialData2(_response);
        });
    }

    protected processGetSeedMaterialData2(response: AxiosResponse): Promise<SeedMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SeedMaterial.fromJS(resultData200);
            return Promise.resolve<SeedMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SeedMaterial>(null as any);
    }

    /**
     * @return OK
     */
    getSeedMaterialData3(sku: string , cancelToken?: CancelToken | undefined): Promise<SeedMaterial> {
        let url_ = this.baseUrl + "/api/Product/GetSeedMaterialData?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSeedMaterialData3(_response);
        });
    }

    protected processGetSeedMaterialData3(response: AxiosResponse): Promise<SeedMaterial> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SeedMaterial.fromJS(resultData200);
            return Promise.resolve<SeedMaterial>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SeedMaterial>(null as any);
    }
}

export class ProductFeedClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getGoogleProductFeed(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Channel> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeed";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeed(_response);
        });
    }

    protected processGetGoogleProductFeed(response: AxiosResponse): Promise<Channel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Channel.fromJS(resultData200);
            return Promise.resolve<Channel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Channel>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv2(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeedv2";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv2(_response);
        });
    }

    protected processGetGoogleProductFeedv2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv3(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeedv3";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv3(_response);
        });
    }

    protected processGetGoogleProductFeedv3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getLiaFeed(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetLiaFeed";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaFeed(_response);
        });
    }

    protected processGetLiaFeed(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getProductPriceFeed(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetProductPriceFeed";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductPriceFeed(_response);
        });
    }

    protected processGetProductPriceFeed(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getFeedStockData(minStock: number | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetFeedStockData?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedStockData(_response);
        });
    }

    protected processGetFeedStockData(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getLiaStockData(minStock: number | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/ProductFeed/GetLiaStockData?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaStockData(_response);
        });
    }

    protected processGetLiaStockData(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeed2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Channel> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeed";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeed2(_response);
        });
    }

    protected processGetGoogleProductFeed2(response: AxiosResponse): Promise<Channel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Channel.fromJS(resultData200);
            return Promise.resolve<Channel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Channel>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv22(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeedv2";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv22(_response);
        });
    }

    protected processGetGoogleProductFeedv22(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv32(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetGoogleProductFeedv3";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv32(_response);
        });
    }

    protected processGetGoogleProductFeedv32(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getLiaFeed2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetLiaFeed";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaFeed2(_response);
        });
    }

    protected processGetLiaFeed2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getProductPriceFeed2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetProductPriceFeed";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductPriceFeed2(_response);
        });
    }

    protected processGetProductPriceFeed2(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getFeedStockData2(minStock: number | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetFeedStockData?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedStockData2(_response);
        });
    }

    protected processGetFeedStockData2(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getLiaStockData2(minStock: number | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/ProductFeed/GetLiaStockData?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaStockData2(_response);
        });
    }

    protected processGetLiaStockData2(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeed3(  cancelToken?: CancelToken | undefined): Promise<Channel> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetGoogleProductFeed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeed3(_response);
        });
    }

    protected processGetGoogleProductFeed3(response: AxiosResponse): Promise<Channel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Channel.fromJS(resultData200);
            return Promise.resolve<Channel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Channel>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv23(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetGoogleProductFeedv2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv23(_response);
        });
    }

    protected processGetGoogleProductFeedv23(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getGoogleProductFeedv33(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetGoogleProductFeedv3";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGoogleProductFeedv33(_response);
        });
    }

    protected processGetGoogleProductFeedv33(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getLiaFeed3(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetLiaFeed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaFeed3(_response);
        });
    }

    protected processGetLiaFeed3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return OK
     */
    getProductPriceFeed3(  cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetProductPriceFeed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductPriceFeed3(_response);
        });
    }

    protected processGetProductPriceFeed3(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getFeedStockData3(minStock: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetFeedStockData?";
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedStockData3(_response);
        });
    }

    protected processGetFeedStockData3(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }

    /**
     * @param minStock (optional) 
     * @return OK
     */
    getLiaStockData3(minStock: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/ProductFeed/GetLiaStockData?";
        if (minStock !== undefined && minStock !== null)
            url_ += "minStock=" + encodeURIComponent("" + minStock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLiaStockData3(_response);
        });
    }

    protected processGetLiaStockData3(response: AxiosResponse): Promise<{ [key: string]: number; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: number; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: number; }>(null as any);
    }
}

export class RothCatalogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search(q: string, searchContext: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/Search?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/GetProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET(_response);
        });
    }

    protected processGetProductsGET(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST(query: SearchQuery, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/GetProducts";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST(_response);
        });
    }

    protected processGetProductsPOST(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts(lastVersion: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/GetPowerBiProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts(_response);
        });
    }

    protected processGetPowerBiProducts(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult(q: string, hits: number | null | undefined, searchContext: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/GetAutoSuggestSearchResult?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult(_response);
        });
    }

    protected processGetAutoSuggestSearchResult(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts(lastVersion: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/RothCatalog/BaseGetPowerBiProducts?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts(_response);
        });
    }

    protected processBaseGetPowerBiProducts(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search2(q: string, searchContext: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/Search?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch2(_response);
        });
    }

    protected processSearch2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET2(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/GetProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET2(_response);
        });
    }

    protected processGetProductsGET2(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST2(query: SearchQuery, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/GetProducts";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST2(_response);
        });
    }

    protected processGetProductsPOST2(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts2(lastVersion: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/GetPowerBiProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts2(_response);
        });
    }

    protected processGetPowerBiProducts2(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult2(q: string, hits: number | null | undefined, searchContext: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/GetAutoSuggestSearchResult?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult2(_response);
        });
    }

    protected processGetAutoSuggestSearchResult2(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts2(lastVersion: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/RothCatalog/BaseGetPowerBiProducts?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts2(_response);
        });
    }

    protected processBaseGetPowerBiProducts2(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @return OK
     */
    search3(q: string, searchContext: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/Search?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch3(_response);
        });
    }

    protected processSearch3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @param searchContext (optional) 
     * @param query (optional) 
     * @param page (optional) 
     * @param hits (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getProductsGET3(searchContext: string | null | undefined, query: string | null | undefined, page: number | null | undefined, hits: number | null | undefined, sort: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/GetProducts?";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsGET3(_response);
        });
    }

    protected processGetProductsGET3(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getProductsPOST3(query: SearchQuery , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/GetProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsPOST3(_response);
        });
    }

    protected processGetProductsPOST3(response: AxiosResponse): Promise<V2ControllerResultOfCatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfCatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfCatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiProducts3(lastVersion: number , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/GetPowerBiProducts?";
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiProducts3(_response);
        });
    }

    protected processGetPowerBiProducts3(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }

    /**
     * @param hits (optional) 
     * @param searchContext (optional) 
     * @return OK
     */
    getAutoSuggestSearchResult3(q: string, hits: number | null | undefined, searchContext: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<CatalogProductSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/GetAutoSuggestSearchResult?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (hits !== undefined && hits !== null)
            url_ += "hits=" + encodeURIComponent("" + hits) + "&";
        if (searchContext !== undefined && searchContext !== null)
            url_ += "searchContext=" + encodeURIComponent("" + searchContext) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoSuggestSearchResult3(_response);
        });
    }

    protected processGetAutoSuggestSearchResult3(response: AxiosResponse): Promise<CatalogProductSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CatalogProductSearchResult.fromJS(resultData200);
            return Promise.resolve<CatalogProductSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CatalogProductSearchResult>(null as any);
    }

    /**
     * @return OK
     */
    baseGetPowerBiProducts3(lastVersion: number , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfPowerBiSearchResult> {
        let url_ = this.baseUrl + "/api/RothCatalog/BaseGetPowerBiProducts?";
        if (lastVersion === undefined || lastVersion === null)
            throw new Error("The parameter 'lastVersion' must be defined and cannot be null.");
        else
            url_ += "lastVersion=" + encodeURIComponent("" + lastVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBaseGetPowerBiProducts3(_response);
        });
    }

    protected processBaseGetPowerBiProducts3(response: AxiosResponse): Promise<V2ControllerResultOfPowerBiSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfPowerBiSearchResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfPowerBiSearchResult>(null as any);
    }
}

export class SalesOfficesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    get(id: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/SalesOffices/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOfficeItems(salesOfficeId: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/SalesOffices/GetPhysicalSalesOfficeItems?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOfficeItems(_response);
        });
    }

    protected processGetPhysicalSalesOfficeItems(response: AxiosResponse): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Item[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOffices(salesOfficeId: string | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/SalesOffices/GetPhysicalSalesOffices?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOffices(_response);
        });
    }

    protected processGetPhysicalSalesOffices(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    getHolidays(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Holiday[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/SalesOffices/GetHolidays";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidays(_response);
        });
    }

    protected processGetHolidays(response: AxiosResponse): Promise<Holiday[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Holiday.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Holiday[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Holiday[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlphabetically(id: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/SalesOffices/GetAlphabetically/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlphabetically(_response);
        });
    }

    protected processGetAlphabetically(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    get2(id: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/SalesOffices/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOfficeItems2(salesOfficeId: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Item[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/SalesOffices/GetPhysicalSalesOfficeItems?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOfficeItems2(_response);
        });
    }

    protected processGetPhysicalSalesOfficeItems2(response: AxiosResponse): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Item[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOffices2(salesOfficeId: string | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/SalesOffices/GetPhysicalSalesOffices?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOffices2(_response);
        });
    }

    protected processGetPhysicalSalesOffices2(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    getHolidays2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<Holiday[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/SalesOffices/GetHolidays";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidays2(_response);
        });
    }

    protected processGetHolidays2(response: AxiosResponse): Promise<Holiday[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Holiday.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Holiday[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Holiday[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlphabetically2(id: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/SalesOffices/GetAlphabetically/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlphabetically2(_response);
        });
    }

    protected processGetAlphabetically2(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    get3(id: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/SalesOffices/{id}/Get";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlphabetically3(id: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/SalesOffices/{id}/GetAlphabetically";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlphabetically3(_response);
        });
    }

    protected processGetAlphabetically3(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    get4(id: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/SalesOffices/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet4(_response);
        });
    }

    protected processGet4(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOfficeItems3(salesOfficeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<Item[]> {
        let url_ = this.baseUrl + "/api/SalesOffices/GetPhysicalSalesOfficeItems?";
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOfficeItems3(_response);
        });
    }

    protected processGetPhysicalSalesOfficeItems3(response: AxiosResponse): Promise<Item[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Item.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Item[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item[]>(null as any);
    }

    /**
     * @param salesOfficeId (optional) 
     * @return OK
     */
    getPhysicalSalesOffices3(salesOfficeId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/SalesOffices/GetPhysicalSalesOffices?";
        if (salesOfficeId !== undefined && salesOfficeId !== null)
            url_ += "salesOfficeId=" + encodeURIComponent("" + salesOfficeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPhysicalSalesOffices3(_response);
        });
    }

    protected processGetPhysicalSalesOffices3(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }

    /**
     * @return OK
     */
    getHolidays3(  cancelToken?: CancelToken | undefined): Promise<Holiday[]> {
        let url_ = this.baseUrl + "/api/SalesOffices/GetHolidays";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidays3(_response);
        });
    }

    protected processGetHolidays3(response: AxiosResponse): Promise<Holiday[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Holiday.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Holiday[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Holiday[]>(null as any);
    }

    /**
     * @return OK
     */
    getAlphabetically4(id: string , cancelToken?: CancelToken | undefined): Promise<SalesOffice[]> {
        let url_ = this.baseUrl + "/api/SalesOffices/GetAlphabetically/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlphabetically4(_response);
        });
    }

    protected processGetAlphabetically4(response: AxiosResponse): Promise<SalesOffice[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOffice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOffice[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOffice[]>(null as any);
    }
}

export class StockProcessingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * Gets information regarding the sales offices which hold the product specified by sku.
     * @return OK
     */
    getStock(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<StockInformation[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/GetStock?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStock(_response);
        });
    }

    protected processGetStock(response: AxiosResponse): Promise<StockInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockInformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockInformation[]>(null as any);
    }

    /**
     * @return OK
     */
    getEshopStockStatus(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<StockStatus> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/GetEshopStockStatus?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEshopStockStatus(_response);
        });
    }

    protected processGetEshopStockStatus(response: AxiosResponse): Promise<StockStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StockStatus.fromJS(resultData200);
            return Promise.resolve<StockStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockStatus>(null as any);
    }

    /**
     * @return OK
     */
    getATPStock(matnr: string, unit: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ATPStock> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/GetATPStock?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (matnr === undefined || matnr === null)
            throw new Error("The parameter 'matnr' must be defined and cannot be null.");
        else
            url_ += "matnr=" + encodeURIComponent("" + matnr) + "&";
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetATPStock(_response);
        });
    }

    protected processGetATPStock(response: AxiosResponse): Promise<ATPStock> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ATPStock.fromJS(resultData200);
            return Promise.resolve<ATPStock>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ATPStock>(null as any);
    }

    /**
     * Gets the number of shops which have the product specified by sku.
     * @return OK
     */
    getNumberOfShops(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/GetNumberOfShops?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfShops(_response);
        });
    }

    protected processGetNumberOfShops(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets a list of all sales-offices, each of which is enriched with information regarding the stock count of the 
    product specified by sku.
     * @return OK
     */
    getSalesOfficesAndStock(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeWithStock[]> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/GetSalesOfficesAndStock?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficesAndStock(_response);
        });
    }

    protected processGetSalesOfficesAndStock(response: AxiosResponse): Promise<SalesOfficeWithStock[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeWithStock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeWithStock[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeWithStock[]>(null as any);
    }

    /**
     * @return OK
     */
    inStock(sku: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/StockProcessing/inStock?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInStock(_response);
        });
    }

    protected processInStock(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets information regarding the sales offices which hold the product specified by sku.
     * @return OK
     */
    getStock2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<StockInformation[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/GetStock?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStock2(_response);
        });
    }

    protected processGetStock2(response: AxiosResponse): Promise<StockInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockInformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockInformation[]>(null as any);
    }

    /**
     * @return OK
     */
    getEshopStockStatus2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<StockStatus> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/GetEshopStockStatus?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEshopStockStatus2(_response);
        });
    }

    protected processGetEshopStockStatus2(response: AxiosResponse): Promise<StockStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StockStatus.fromJS(resultData200);
            return Promise.resolve<StockStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockStatus>(null as any);
    }

    /**
     * @return OK
     */
    getATPStock2(matnr: string, unit: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<ATPStock> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/GetATPStock?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (matnr === undefined || matnr === null)
            throw new Error("The parameter 'matnr' must be defined and cannot be null.");
        else
            url_ += "matnr=" + encodeURIComponent("" + matnr) + "&";
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetATPStock2(_response);
        });
    }

    protected processGetATPStock2(response: AxiosResponse): Promise<ATPStock> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ATPStock.fromJS(resultData200);
            return Promise.resolve<ATPStock>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ATPStock>(null as any);
    }

    /**
     * Gets the number of shops which have the product specified by sku.
     * @return OK
     */
    getNumberOfShops2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/GetNumberOfShops?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfShops2(_response);
        });
    }

    protected processGetNumberOfShops2(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets a list of all sales-offices, each of which is enriched with information regarding the stock count of the 
    product specified by sku.
     * @return OK
     */
    getSalesOfficesAndStock2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeWithStock[]> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/GetSalesOfficesAndStock?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficesAndStock2(_response);
        });
    }

    protected processGetSalesOfficesAndStock2(response: AxiosResponse): Promise<SalesOfficeWithStock[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeWithStock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeWithStock[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeWithStock[]>(null as any);
    }

    /**
     * @return OK
     */
    inStock2(sku: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/StockProcessing/inStock?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInStock2(_response);
        });
    }

    protected processInStock2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets information regarding the sales offices which hold the product specified by sku.
     * @return OK
     */
    getStock3(sku: string , cancelToken?: CancelToken | undefined): Promise<StockInformation[]> {
        let url_ = this.baseUrl + "/api/StockProcessing/GetStock?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStock3(_response);
        });
    }

    protected processGetStock3(response: AxiosResponse): Promise<StockInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StockInformation[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockInformation[]>(null as any);
    }

    /**
     * @return OK
     */
    getEshopStockStatus3(sku: string , cancelToken?: CancelToken | undefined): Promise<StockStatus> {
        let url_ = this.baseUrl + "/api/StockProcessing/GetEshopStockStatus?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEshopStockStatus3(_response);
        });
    }

    protected processGetEshopStockStatus3(response: AxiosResponse): Promise<StockStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StockStatus.fromJS(resultData200);
            return Promise.resolve<StockStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StockStatus>(null as any);
    }

    /**
     * @return OK
     */
    getATPStock3(matnr: string, unit: string , cancelToken?: CancelToken | undefined): Promise<ATPStock> {
        let url_ = this.baseUrl + "/api/StockProcessing/GetATPStock?";
        if (matnr === undefined || matnr === null)
            throw new Error("The parameter 'matnr' must be defined and cannot be null.");
        else
            url_ += "matnr=" + encodeURIComponent("" + matnr) + "&";
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetATPStock3(_response);
        });
    }

    protected processGetATPStock3(response: AxiosResponse): Promise<ATPStock> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ATPStock.fromJS(resultData200);
            return Promise.resolve<ATPStock>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ATPStock>(null as any);
    }

    /**
     * Gets the number of shops which have the product specified by sku.
     * @return OK
     */
    getNumberOfShops3(sku: string , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/StockProcessing/GetNumberOfShops?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNumberOfShops3(_response);
        });
    }

    protected processGetNumberOfShops3(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets a list of all sales-offices, each of which is enriched with information regarding the stock count of the 
    product specified by sku.
     * @return OK
     */
    getSalesOfficesAndStock3(sku: string , cancelToken?: CancelToken | undefined): Promise<SalesOfficeWithStock[]> {
        let url_ = this.baseUrl + "/api/StockProcessing/GetSalesOfficesAndStock?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSalesOfficesAndStock3(_response);
        });
    }

    protected processGetSalesOfficesAndStock3(response: AxiosResponse): Promise<SalesOfficeWithStock[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesOfficeWithStock.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SalesOfficeWithStock[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SalesOfficeWithStock[]>(null as any);
    }

    /**
     * @return OK
     */
    inStock3(sku: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/StockProcessing/inStock?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined and cannot be null.");
        else
            url_ += "sku=" + encodeURIComponent("" + sku) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInStock3(_response);
        });
    }

    protected processInStock3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SubscriptionManagerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    addSubscription(subscription: Subscription, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/AddSubscription?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSubscription(_response);
        });
    }

    protected processAddSubscription(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateSubscription(subscription: Subscription, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/UpdateSubscription?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscription(_response);
        });
    }

    protected processUpdateSubscription(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteSubscription(obj: SubscriptionIdObj, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/DeleteSubscription?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obj);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubscription(_response);
        });
    }

    protected processDeleteSubscription(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    setSubscriptionActiveState(activesub: ActiveSubscription, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/SetSubscriptionActiveState?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activesub);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionActiveState(_response);
        });
    }

    protected processSetSubscriptionActiveState(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateToken(token: UpdateToken, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/UpdateToken?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateToken(_response);
        });
    }

    protected processUpdateToken(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    getSubscriptions(data: GetSubscription, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/GetSubscriptions?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteToken(token: TokenObj, debug: boolean | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/subscriptionmanager/DeleteToken?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteToken(_response);
        });
    }

    protected processDeleteToken(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    addSubscription2(subscription: Subscription, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/AddSubscription?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSubscription2(_response);
        });
    }

    protected processAddSubscription2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateSubscription2(subscription: Subscription, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/UpdateSubscription?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscription2(_response);
        });
    }

    protected processUpdateSubscription2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteSubscription2(obj: SubscriptionIdObj, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/DeleteSubscription?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obj);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubscription2(_response);
        });
    }

    protected processDeleteSubscription2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    setSubscriptionActiveState2(activesub: ActiveSubscription, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/SetSubscriptionActiveState?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activesub);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionActiveState2(_response);
        });
    }

    protected processSetSubscriptionActiveState2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateToken2(token: UpdateToken, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/UpdateToken?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateToken2(_response);
        });
    }

    protected processUpdateToken2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    getSubscriptions2(data: GetSubscription, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/GetSubscriptions?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions2(_response);
        });
    }

    protected processGetSubscriptions2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteToken2(token: TokenObj, debug: boolean | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/subscriptionmanager/DeleteToken?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteToken2(_response);
        });
    }

    protected processDeleteToken2(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    addSubscription3(subscription: Subscription, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/AddSubscription?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSubscription3(_response);
        });
    }

    protected processAddSubscription3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateSubscription3(subscription: Subscription, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/UpdateSubscription?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscription);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubscription3(_response);
        });
    }

    protected processUpdateSubscription3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteSubscription3(obj: SubscriptionIdObj, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/DeleteSubscription?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obj);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubscription3(_response);
        });
    }

    protected processDeleteSubscription3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    setSubscriptionActiveState3(activesub: ActiveSubscription, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/SetSubscriptionActiveState?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activesub);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetSubscriptionActiveState3(_response);
        });
    }

    protected processSetSubscriptionActiveState3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    updateToken3(token: UpdateToken, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/UpdateToken?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateToken3(_response);
        });
    }

    protected processUpdateToken3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    getSubscriptions3(data: GetSubscription, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/GetSubscriptions?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubscriptions3(_response);
        });
    }

    protected processGetSubscriptions3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }

    /**
     * @param debug (optional) 
     * @return OK
     */
    deleteToken3(token: TokenObj, debug: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfObject> {
        let url_ = this.baseUrl + "/api/subscriptionmanager/DeleteToken?";
        if (debug !== undefined && debug !== null)
            url_ += "debug=" + encodeURIComponent("" + debug) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(token);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteToken3(_response);
        });
    }

    protected processDeleteToken3(response: AxiosResponse): Promise<V2ControllerResultOfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfObject.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfObject>(null as any);
    }
}

export class TrackAndTraceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getTrackAndTrace(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<TrackAndTrace> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/GetTrackAndTrace";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackAndTrace(_response);
        });
    }

    protected processGetTrackAndTrace(response: AxiosResponse): Promise<TrackAndTrace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackAndTrace.fromJS(resultData200);
            return Promise.resolve<TrackAndTrace>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackAndTrace>(null as any);
    }

    /**
     * @return OK
     */
    createContact(fname: string, lname: string, mail: string, phone: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/CreateContact?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact(_response);
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    activateContact(adminfname: string, adminlname: string, adminmail: string, adminphone: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/ActivateContact?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (adminfname === undefined || adminfname === null)
            throw new Error("The parameter 'adminfname' must be defined and cannot be null.");
        else
            url_ += "adminfname=" + encodeURIComponent("" + adminfname) + "&";
        if (adminlname === undefined || adminlname === null)
            throw new Error("The parameter 'adminlname' must be defined and cannot be null.");
        else
            url_ += "adminlname=" + encodeURIComponent("" + adminlname) + "&";
        if (adminmail === undefined || adminmail === null)
            throw new Error("The parameter 'adminmail' must be defined and cannot be null.");
        else
            url_ += "adminmail=" + encodeURIComponent("" + adminmail) + "&";
        if (adminphone === undefined || adminphone === null)
            throw new Error("The parameter 'adminphone' must be defined and cannot be null.");
        else
            url_ += "adminphone=" + encodeURIComponent("" + adminphone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateContact(_response);
        });
    }

    protected processActivateContact(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    subscribe(id: string, contactid: string, mail: boolean, sms: boolean, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/Subscribe/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contactid === undefined || contactid === null)
            throw new Error("The parameter 'contactid' must be defined and cannot be null.");
        else
            url_ += "contactid=" + encodeURIComponent("" + contactid) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (sms === undefined || sms === null)
            throw new Error("The parameter 'sms' must be defined and cannot be null.");
        else
            url_ += "sms=" + encodeURIComponent("" + sms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribe(_response);
        });
    }

    protected processSubscribe(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updateContactInfo(fname: string, lname: string, phone: string, mail: string, id: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/UpdateContactInfo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo(_response);
        });
    }

    protected processUpdateContactInfo(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    deleteContact(id: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/DeleteContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact(_response);
        });
    }

    protected processDeleteContact(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    trackAndTraceOrderFlow(pos: string, vbeln: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/trackandtrace/TrackAndTraceOrderFlow?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (pos === undefined || pos === null)
            throw new Error("The parameter 'pos' must be defined and cannot be null.");
        else
            url_ += "pos=" + encodeURIComponent("" + pos) + "&";
        if (vbeln === undefined || vbeln === null)
            throw new Error("The parameter 'vbeln' must be defined and cannot be null.");
        else
            url_ += "vbeln=" + encodeURIComponent("" + vbeln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackAndTraceOrderFlow(_response);
        });
    }

    protected processTrackAndTraceOrderFlow(response: AxiosResponse): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfTTDocumentFlowOf.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(null as any);
    }

    /**
     * @return OK
     */
    getTrackAndTrace2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<TrackAndTrace> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/GetTrackAndTrace";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackAndTrace2(_response);
        });
    }

    protected processGetTrackAndTrace2(response: AxiosResponse): Promise<TrackAndTrace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackAndTrace.fromJS(resultData200);
            return Promise.resolve<TrackAndTrace>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackAndTrace>(null as any);
    }

    /**
     * @return OK
     */
    createContact2(fname: string, lname: string, mail: string, phone: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/CreateContact?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact2(_response);
        });
    }

    protected processCreateContact2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    activateContact2(adminfname: string, adminlname: string, adminmail: string, adminphone: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/ActivateContact?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (adminfname === undefined || adminfname === null)
            throw new Error("The parameter 'adminfname' must be defined and cannot be null.");
        else
            url_ += "adminfname=" + encodeURIComponent("" + adminfname) + "&";
        if (adminlname === undefined || adminlname === null)
            throw new Error("The parameter 'adminlname' must be defined and cannot be null.");
        else
            url_ += "adminlname=" + encodeURIComponent("" + adminlname) + "&";
        if (adminmail === undefined || adminmail === null)
            throw new Error("The parameter 'adminmail' must be defined and cannot be null.");
        else
            url_ += "adminmail=" + encodeURIComponent("" + adminmail) + "&";
        if (adminphone === undefined || adminphone === null)
            throw new Error("The parameter 'adminphone' must be defined and cannot be null.");
        else
            url_ += "adminphone=" + encodeURIComponent("" + adminphone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateContact2(_response);
        });
    }

    protected processActivateContact2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    subscribe2(id: string, contactid: string, mail: boolean, sms: boolean, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/Subscribe/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (contactid === undefined || contactid === null)
            throw new Error("The parameter 'contactid' must be defined and cannot be null.");
        else
            url_ += "contactid=" + encodeURIComponent("" + contactid) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (sms === undefined || sms === null)
            throw new Error("The parameter 'sms' must be defined and cannot be null.");
        else
            url_ += "sms=" + encodeURIComponent("" + sms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribe2(_response);
        });
    }

    protected processSubscribe2(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updateContactInfo2(fname: string, lname: string, phone: string, mail: string, id: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/UpdateContactInfo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo2(_response);
        });
    }

    protected processUpdateContactInfo2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    deleteContact2(id: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/DeleteContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact2(_response);
        });
    }

    protected processDeleteContact2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    trackAndTraceOrderFlow2(pos: string, vbeln: string, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/trackandtrace/TrackAndTraceOrderFlow?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (pos === undefined || pos === null)
            throw new Error("The parameter 'pos' must be defined and cannot be null.");
        else
            url_ += "pos=" + encodeURIComponent("" + pos) + "&";
        if (vbeln === undefined || vbeln === null)
            throw new Error("The parameter 'vbeln' must be defined and cannot be null.");
        else
            url_ += "vbeln=" + encodeURIComponent("" + vbeln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackAndTraceOrderFlow2(_response);
        });
    }

    protected processTrackAndTraceOrderFlow2(response: AxiosResponse): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfTTDocumentFlowOf.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(null as any);
    }

    /**
     * @return OK
     */
    subscribe3(id: string, contactid: string, mail: boolean, sms: boolean, namespace: string , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/trackandtrace/{id}/Subscribe?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        if (contactid === undefined || contactid === null)
            throw new Error("The parameter 'contactid' must be defined and cannot be null.");
        else
            url_ += "contactid=" + encodeURIComponent("" + contactid) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (sms === undefined || sms === null)
            throw new Error("The parameter 'sms' must be defined and cannot be null.");
        else
            url_ += "sms=" + encodeURIComponent("" + sms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribe3(_response);
        });
    }

    protected processSubscribe3(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updateContactInfo3(fname: string, lname: string, phone: string, mail: string, id: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/trackandtrace/{id}/UpdateContactInfo?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo3(_response);
        });
    }

    protected processUpdateContactInfo3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    deleteContact3(id: string, namespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/sitecore/api/ssc/{namespace}/trackandtrace/{id}/DeleteContact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact3(_response);
        });
    }

    protected processDeleteContact3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getTrackAndTrace3(  cancelToken?: CancelToken | undefined): Promise<TrackAndTrace> {
        let url_ = this.baseUrl + "/api/trackandtrace/GetTrackAndTrace";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackAndTrace3(_response);
        });
    }

    protected processGetTrackAndTrace3(response: AxiosResponse): Promise<TrackAndTrace> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrackAndTrace.fromJS(resultData200);
            return Promise.resolve<TrackAndTrace>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackAndTrace>(null as any);
    }

    /**
     * @return OK
     */
    createContact3(fname: string, lname: string, mail: string, phone: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/trackandtrace/CreateContact?";
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact3(_response);
        });
    }

    protected processCreateContact3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    activateContact3(adminfname: string, adminlname: string, adminmail: string, adminphone: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/trackandtrace/ActivateContact?";
        if (adminfname === undefined || adminfname === null)
            throw new Error("The parameter 'adminfname' must be defined and cannot be null.");
        else
            url_ += "adminfname=" + encodeURIComponent("" + adminfname) + "&";
        if (adminlname === undefined || adminlname === null)
            throw new Error("The parameter 'adminlname' must be defined and cannot be null.");
        else
            url_ += "adminlname=" + encodeURIComponent("" + adminlname) + "&";
        if (adminmail === undefined || adminmail === null)
            throw new Error("The parameter 'adminmail' must be defined and cannot be null.");
        else
            url_ += "adminmail=" + encodeURIComponent("" + adminmail) + "&";
        if (adminphone === undefined || adminphone === null)
            throw new Error("The parameter 'adminphone' must be defined and cannot be null.");
        else
            url_ += "adminphone=" + encodeURIComponent("" + adminphone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateContact3(_response);
        });
    }

    protected processActivateContact3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    subscribe4(id: string, contactid: string, mail: boolean, sms: boolean , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/trackandtrace/Subscribe/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contactid === undefined || contactid === null)
            throw new Error("The parameter 'contactid' must be defined and cannot be null.");
        else
            url_ += "contactid=" + encodeURIComponent("" + contactid) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        if (sms === undefined || sms === null)
            throw new Error("The parameter 'sms' must be defined and cannot be null.");
        else
            url_ += "sms=" + encodeURIComponent("" + sms) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubscribe4(_response);
        });
    }

    protected processSubscribe4(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    updateContactInfo4(fname: string, lname: string, phone: string, mail: string, id: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/trackandtrace/UpdateContactInfo/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fname === undefined || fname === null)
            throw new Error("The parameter 'fname' must be defined and cannot be null.");
        else
            url_ += "fname=" + encodeURIComponent("" + fname) + "&";
        if (lname === undefined || lname === null)
            throw new Error("The parameter 'lname' must be defined and cannot be null.");
        else
            url_ += "lname=" + encodeURIComponent("" + lname) + "&";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined and cannot be null.");
        else
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        if (mail === undefined || mail === null)
            throw new Error("The parameter 'mail' must be defined and cannot be null.");
        else
            url_ += "mail=" + encodeURIComponent("" + mail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContactInfo4(_response);
        });
    }

    protected processUpdateContactInfo4(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    deleteContact4(id: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/trackandtrace/DeleteContact/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact4(_response);
        });
    }

    protected processDeleteContact4(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    trackAndTraceOrderFlow3(pos: string, vbeln: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        let url_ = this.baseUrl + "/api/trackandtrace/TrackAndTraceOrderFlow?";
        if (pos === undefined || pos === null)
            throw new Error("The parameter 'pos' must be defined and cannot be null.");
        else
            url_ += "pos=" + encodeURIComponent("" + pos) + "&";
        if (vbeln === undefined || vbeln === null)
            throw new Error("The parameter 'vbeln' must be defined and cannot be null.");
        else
            url_ += "vbeln=" + encodeURIComponent("" + vbeln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackAndTraceOrderFlow3(_response);
        });
    }

    protected processTrackAndTraceOrderFlow3(response: AxiosResponse): Promise<V2ControllerResultOfTTDocumentFlowOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfTTDocumentFlowOf.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfTTDocumentFlowOf>(null as any);
    }
}

export class UnitPluralisationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getUnitPluralisation(unit: string, amount: number, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/UnitPluralisation/GetUnitPluralisation?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnitPluralisation(_response);
        });
    }

    protected processGetUnitPluralisation(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getUnitPluralisation2(unit: string, amount: number, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/UnitPluralisation/GetUnitPluralisation?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnitPluralisation2(_response);
        });
    }

    protected processGetUnitPluralisation2(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    getUnitPluralisation3(unit: string, amount: number , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/UnitPluralisation/GetUnitPluralisation?";
        if (unit === undefined || unit === null)
            throw new Error("The parameter 'unit' must be defined and cannot be null.");
        else
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnitPluralisation3(_response);
        });
    }

    protected processGetUnitPluralisation3(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class WeatherClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @param days (optional) 
     * @return OK
     */
    getCustomWeatherByCoordinates(latitude: string, longitude: string, days: number | null | undefined, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfWeatherResult> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/weather/GetCustomWeatherByCoordinates?";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomWeatherByCoordinates(_response);
        });
    }

    protected processGetCustomWeatherByCoordinates(response: AxiosResponse): Promise<V2ControllerResultOfWeatherResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfWeatherResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfWeatherResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfWeatherResult>(null as any);
    }

    /**
     * @param days (optional) 
     * @return OK
     */
    getCustomWeatherByCoordinates2(latitude: string, longitude: string, days: number | null | undefined, virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfWeatherResult> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/weather/GetCustomWeatherByCoordinates?";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomWeatherByCoordinates2(_response);
        });
    }

    protected processGetCustomWeatherByCoordinates2(response: AxiosResponse): Promise<V2ControllerResultOfWeatherResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfWeatherResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfWeatherResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfWeatherResult>(null as any);
    }

    /**
     * @param days (optional) 
     * @return OK
     */
    getCustomWeatherByCoordinates3(latitude: string, longitude: string, days: number | null | undefined , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfWeatherResult> {
        let url_ = this.baseUrl + "/api/weather/GetCustomWeatherByCoordinates?";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "longitude=" + encodeURIComponent("" + longitude) + "&";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomWeatherByCoordinates3(_response);
        });
    }

    protected processGetCustomWeatherByCoordinates3(response: AxiosResponse): Promise<V2ControllerResultOfWeatherResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfWeatherResult.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfWeatherResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfWeatherResult>(null as any);
    }
}

export class WidgetClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://dlg9.localhost";

    }

    /**
     * @return OK
     */
    getDefaultFrontpageWidgets(dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpageWidget> {
        let url_ = this.baseUrl + "/api/{dlgnamespace}/widget/GetDefaultFrontpageWidgets";
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultFrontpageWidgets(_response);
        });
    }

    protected processGetDefaultFrontpageWidgets(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpageWidget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpageWidget.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(null as any);
    }

    /**
     * @return OK
     */
    getDefaultFrontpageWidgets2(virtualFolder: string, dlgnamespace: string , cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpageWidget> {
        let url_ = this.baseUrl + "/{virtualFolder}/api/{dlgnamespace}/widget/GetDefaultFrontpageWidgets";
        if (virtualFolder === undefined || virtualFolder === null)
            throw new Error("The parameter 'virtualFolder' must be defined.");
        url_ = url_.replace("{virtualFolder}", encodeURIComponent("" + virtualFolder));
        if (dlgnamespace === undefined || dlgnamespace === null)
            throw new Error("The parameter 'dlgnamespace' must be defined.");
        url_ = url_.replace("{dlgnamespace}", encodeURIComponent("" + dlgnamespace));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultFrontpageWidgets2(_response);
        });
    }

    protected processGetDefaultFrontpageWidgets2(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpageWidget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpageWidget.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(null as any);
    }

    /**
     * @return OK
     */
    getDefaultFrontpageWidgets3(  cancelToken?: CancelToken | undefined): Promise<V2ControllerResultOfAppFrontpageWidget> {
        let url_ = this.baseUrl + "/api/widget/GetDefaultFrontpageWidgets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultFrontpageWidgets3(_response);
        });
    }

    protected processGetDefaultFrontpageWidgets3(response: AxiosResponse): Promise<V2ControllerResultOfAppFrontpageWidget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = V2ControllerResultOfAppFrontpageWidget.fromJS(resultData200);
            return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<V2ControllerResultOfAppFrontpageWidget>(null as any);
    }
}

export class V2ControllerResultOfVersionUpdate implements IV2ControllerResultOfVersionUpdate {
    readonly result?: VersionUpdate | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfVersionUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? VersionUpdate.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfVersionUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfVersionUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfVersionUpdate {
    result?: VersionUpdate | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

/** Return value from "GetUpdateInfo" controller method. */
export class VersionUpdate implements IVersionUpdate {
    deviceType?: VersionUpdateDeviceType | undefined;
    currentAppVersion?: string | undefined;
    currentOSVersion?: string | undefined;
    isMandatoryUpdate?: boolean | undefined;
    updateToAppVersion?: string | undefined;

    constructor(data?: IVersionUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceType = _data["DeviceType"];
            this.currentAppVersion = _data["CurrentAppVersion"];
            this.currentOSVersion = _data["CurrentOSVersion"];
            this.isMandatoryUpdate = _data["IsMandatoryUpdate"];
            this.updateToAppVersion = _data["UpdateToAppVersion"];
        }
    }

    static fromJS(data: any): VersionUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new VersionUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeviceType"] = this.deviceType;
        data["CurrentAppVersion"] = this.currentAppVersion;
        data["CurrentOSVersion"] = this.currentOSVersion;
        data["IsMandatoryUpdate"] = this.isMandatoryUpdate;
        data["UpdateToAppVersion"] = this.updateToAppVersion;
        return data;
    }
}

/** Return value from "GetUpdateInfo" controller method. */
export interface IVersionUpdate {
    deviceType?: VersionUpdateDeviceType | undefined;
    currentAppVersion?: string | undefined;
    currentOSVersion?: string | undefined;
    isMandatoryUpdate?: boolean | undefined;
    updateToAppVersion?: string | undefined;
}

export class CatalogProductSearchResult implements ICatalogProductSearchResult {
    products?: CatalogProduct[] | undefined;
    readonly totalHits?: number | undefined;
    readonly facets?: SearchFacet[] | undefined;
    readonly count?: number | undefined;
    readonly pagingRows?: number | undefined;
    readonly pagingStart?: number | undefined;
    maxprice?: number | undefined;
    minprice?: number | undefined;

    constructor(data?: ICatalogProductSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CatalogProduct.fromJS(item));
            }
            (<any>this).totalHits = _data["TotalHits"];
            if (Array.isArray(_data["Facets"])) {
                (<any>this).facets = [] as any;
                for (let item of _data["Facets"])
                    (<any>this).facets!.push(SearchFacet.fromJS(item));
            }
            (<any>this).count = _data["Count"];
            (<any>this).pagingRows = _data["PagingRows"];
            (<any>this).pagingStart = _data["PagingStart"];
            this.maxprice = _data["Maxprice"];
            this.minprice = _data["Minprice"];
        }
    }

    static fromJS(data: any): CatalogProductSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogProductSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        data["TotalHits"] = this.totalHits;
        if (Array.isArray(this.facets)) {
            data["Facets"] = [];
            for (let item of this.facets)
                data["Facets"].push(item.toJSON());
        }
        data["Count"] = this.count;
        data["PagingRows"] = this.pagingRows;
        data["PagingStart"] = this.pagingStart;
        data["Maxprice"] = this.maxprice;
        data["Minprice"] = this.minprice;
        return data;
    }
}

export interface ICatalogProductSearchResult {
    products?: CatalogProduct[] | undefined;
    totalHits?: number | undefined;
    facets?: SearchFacet[] | undefined;
    count?: number | undefined;
    pagingRows?: number | undefined;
    pagingStart?: number | undefined;
    maxprice?: number | undefined;
    minprice?: number | undefined;
}

export class CatalogProduct implements ICatalogProduct {
    readonly notForSale?: boolean | undefined;
    readonly notForDisplay?: boolean | undefined;
    readonly salesCode?: string | undefined;
    readonly transportGroup?: string | undefined;
    readonly systemUnit?: string | undefined;
    readonly prettyUnit?: string | undefined;
    readonly hidePreciseStock?: boolean | undefined;
    readonly isEcological?: boolean | undefined;
    readonly name?: string | undefined;
    readonly sku?: string | undefined;
    readonly description?: string | undefined;
    readonly itemWebDescription?: string | undefined;
    readonly metaDescription?: string | undefined;
    readonly contents?: string | undefined;
    readonly dosage?: string | undefined;
    readonly eAN?: string | undefined;
    readonly brand?: string | undefined;
    readonly link?: string | undefined;
    readonly category?: string | undefined;
    readonly categoryGroup?: string | undefined;
    hasBusinessCustomerDiscount?: boolean | undefined;
    readonly minimumCount?: string | undefined;
    readonly maximumCount?: string | undefined;
    readonly hasVariants?: boolean | undefined;
    readonly variantGroupId?: string | undefined;
    readonly variantGroupTitle?: string | undefined;
    readonly variantDimension?: string | undefined;
    readonly variantValue?: string | undefined;
    readonly variantOrder?: number | undefined;
    readonly variants?: CatalogProductVariantReference[] | undefined;
    mainImageUrl?: string | undefined;
    mainImageUrlAndroid?: string | undefined;
    mainImageUrlIos?: string | undefined;
    readonly allImages?: MediaReference[] | undefined;
    allImagesAbsoluteUrlAndroid?: MediaReference[] | undefined;
    allImagesAbsoluteUrlIos?: MediaReference[] | undefined;
    readonly pdfs?: MediaReference[] | undefined;
    mainVariantGroupImageUrl?: string | undefined;
    mainVariantGroupImageAndroid?: string | undefined;
    mainVariantGroupImageIos?: string | undefined;
    mediaContent?: MediaContent[] | undefined;
    readonly productLinks?: ProductLink[] | undefined;
    readonly singlePrice?: ProductPrice | undefined;
    readonly cheapestMultiPrice?: ProductPrice | undefined;
    readonly cheapestPSName?: string | undefined;
    readonly cheapestPSLink?: string | undefined;
    readonly cheapestPSImage?: string | undefined;
    readonly cheapestPriceStepPrice?: number | undefined;
    cheapestPriceStepSalesCode?: string | undefined;
    readonly priceSteps?: ProductPrice[] | undefined;
    readonly clubPrice?: ProductPrice | undefined;
    readonly clubPriceSteps?: ProductPrice[] | undefined;
    readonly grossWeight?: string | undefined;
    readonly grossWeightUnit?: string | undefined;
    readonly conversionFactors?: ConversionFactor[] | undefined;
    readonly palletConversionUnitPrice?: number | undefined;
    readonly synonymes?: string[] | undefined;
    readonly relatedProducts?: string[] | undefined;
    readonly alternativeProducts?: string[] | undefined;
    readonly normallyMixedWith?: string[] | undefined;
    readonly notRecommendedMix?: string[] | undefined;
    readonly mixWithSpecialProcedure?: string[] | undefined;
    readonly mixWithRisk?: string[] | undefined;
    readonly bestMix1?: string | undefined;
    readonly bestMix2?: string | undefined;
    readonly bestMix3?: string | undefined;
    readonly shelfFront?: boolean | undefined;
    readonly shelfFrontDescription?: string | undefined;
    readonly shelfFrontTitle?: string | undefined;
    readonly signDescription?: string | undefined;
    readonly signTitle?: string | undefined;
    itemHideConversion?: boolean | undefined;
    atpMark?: boolean | undefined;
    readonly renderedFlag?: string | undefined;
    readonly flagType?: CatalogProductFlagType | undefined;
    readonly stockStatus?: StockStatus | undefined;
    aTPStock?: ATPStock | undefined;
    readonly deliveryDate?: ProductDeliveryDate | undefined;
    readonly tagList?: ProductTag[] | undefined;
    readonly tagGroups?: TagGroup[] | undefined;
    readonly recommendedAnimalTags?: Tag[] | undefined;
    readonly notRecommendedAnimalTags?: Tag[] | undefined;
    readonly hazardTags?: Tag[] | undefined;
    readonly ecoTags?: Tag[] | undefined;
    seedMaterial?: SeedMaterial | undefined;
    trustPilotReviewDisplayable?: boolean | undefined;
    preferredVariantSku?: string | undefined;
    preferredVariant?: number | undefined;
    isPallet?: boolean | undefined;

    constructor(data?: ICatalogProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).notForSale = _data["NotForSale"];
            (<any>this).notForDisplay = _data["NotForDisplay"];
            (<any>this).salesCode = _data["SalesCode"];
            (<any>this).transportGroup = _data["TransportGroup"];
            (<any>this).systemUnit = _data["SystemUnit"];
            (<any>this).prettyUnit = _data["PrettyUnit"];
            (<any>this).hidePreciseStock = _data["HidePreciseStock"];
            (<any>this).isEcological = _data["IsEcological"];
            (<any>this).name = _data["Name"];
            (<any>this).sku = _data["Sku"];
            (<any>this).description = _data["Description"];
            (<any>this).itemWebDescription = _data["ItemWebDescription"];
            (<any>this).metaDescription = _data["MetaDescription"];
            (<any>this).contents = _data["Contents"];
            (<any>this).dosage = _data["Dosage"];
            (<any>this).eAN = _data["EAN"];
            (<any>this).brand = _data["Brand"];
            (<any>this).link = _data["Link"];
            (<any>this).category = _data["Category"];
            (<any>this).categoryGroup = _data["CategoryGroup"];
            this.hasBusinessCustomerDiscount = _data["HasBusinessCustomerDiscount"];
            (<any>this).minimumCount = _data["MinimumCount"];
            (<any>this).maximumCount = _data["MaximumCount"];
            (<any>this).hasVariants = _data["HasVariants"];
            (<any>this).variantGroupId = _data["VariantGroupId"];
            (<any>this).variantGroupTitle = _data["VariantGroupTitle"];
            (<any>this).variantDimension = _data["VariantDimension"];
            (<any>this).variantValue = _data["VariantValue"];
            (<any>this).variantOrder = _data["VariantOrder"];
            if (Array.isArray(_data["Variants"])) {
                (<any>this).variants = [] as any;
                for (let item of _data["Variants"])
                    (<any>this).variants!.push(CatalogProductVariantReference.fromJS(item));
            }
            this.mainImageUrl = _data["MainImageUrl"];
            this.mainImageUrlAndroid = _data["MainImageUrlAndroid"];
            this.mainImageUrlIos = _data["MainImageUrlIos"];
            if (Array.isArray(_data["AllImages"])) {
                (<any>this).allImages = [] as any;
                for (let item of _data["AllImages"])
                    (<any>this).allImages!.push(MediaReference.fromJS(item));
            }
            if (Array.isArray(_data["AllImagesAbsoluteUrlAndroid"])) {
                this.allImagesAbsoluteUrlAndroid = [] as any;
                for (let item of _data["AllImagesAbsoluteUrlAndroid"])
                    this.allImagesAbsoluteUrlAndroid!.push(MediaReference.fromJS(item));
            }
            if (Array.isArray(_data["AllImagesAbsoluteUrlIos"])) {
                this.allImagesAbsoluteUrlIos = [] as any;
                for (let item of _data["AllImagesAbsoluteUrlIos"])
                    this.allImagesAbsoluteUrlIos!.push(MediaReference.fromJS(item));
            }
            if (Array.isArray(_data["Pdfs"])) {
                (<any>this).pdfs = [] as any;
                for (let item of _data["Pdfs"])
                    (<any>this).pdfs!.push(MediaReference.fromJS(item));
            }
            this.mainVariantGroupImageUrl = _data["MainVariantGroupImageUrl"];
            this.mainVariantGroupImageAndroid = _data["MainVariantGroupImageAndroid"];
            this.mainVariantGroupImageIos = _data["MainVariantGroupImageIos"];
            if (Array.isArray(_data["MediaContent"])) {
                this.mediaContent = [] as any;
                for (let item of _data["MediaContent"])
                    this.mediaContent!.push(MediaContent.fromJS(item));
            }
            if (Array.isArray(_data["ProductLinks"])) {
                (<any>this).productLinks = [] as any;
                for (let item of _data["ProductLinks"])
                    (<any>this).productLinks!.push(ProductLink.fromJS(item));
            }
            (<any>this).singlePrice = _data["SinglePrice"] ? ProductPrice.fromJS(_data["SinglePrice"]) : <any>undefined;
            (<any>this).cheapestMultiPrice = _data["CheapestMultiPrice"] ? ProductPrice.fromJS(_data["CheapestMultiPrice"]) : <any>undefined;
            (<any>this).cheapestPSName = _data["CheapestPSName"];
            (<any>this).cheapestPSLink = _data["CheapestPSLink"];
            (<any>this).cheapestPSImage = _data["CheapestPSImage"];
            (<any>this).cheapestPriceStepPrice = _data["CheapestPriceStepPrice"];
            this.cheapestPriceStepSalesCode = _data["CheapestPriceStepSalesCode"];
            if (Array.isArray(_data["PriceSteps"])) {
                (<any>this).priceSteps = [] as any;
                for (let item of _data["PriceSteps"])
                    (<any>this).priceSteps!.push(ProductPrice.fromJS(item));
            }
            (<any>this).clubPrice = _data["ClubPrice"] ? ProductPrice.fromJS(_data["ClubPrice"]) : <any>undefined;
            if (Array.isArray(_data["ClubPriceSteps"])) {
                (<any>this).clubPriceSteps = [] as any;
                for (let item of _data["ClubPriceSteps"])
                    (<any>this).clubPriceSteps!.push(ProductPrice.fromJS(item));
            }
            (<any>this).grossWeight = _data["GrossWeight"];
            (<any>this).grossWeightUnit = _data["GrossWeightUnit"];
            if (Array.isArray(_data["ConversionFactors"])) {
                (<any>this).conversionFactors = [] as any;
                for (let item of _data["ConversionFactors"])
                    (<any>this).conversionFactors!.push(ConversionFactor.fromJS(item));
            }
            (<any>this).palletConversionUnitPrice = _data["PalletConversionUnitPrice"];
            if (Array.isArray(_data["Synonymes"])) {
                (<any>this).synonymes = [] as any;
                for (let item of _data["Synonymes"])
                    (<any>this).synonymes!.push(item);
            }
            if (Array.isArray(_data["RelatedProducts"])) {
                (<any>this).relatedProducts = [] as any;
                for (let item of _data["RelatedProducts"])
                    (<any>this).relatedProducts!.push(item);
            }
            if (Array.isArray(_data["AlternativeProducts"])) {
                (<any>this).alternativeProducts = [] as any;
                for (let item of _data["AlternativeProducts"])
                    (<any>this).alternativeProducts!.push(item);
            }
            if (Array.isArray(_data["NormallyMixedWith"])) {
                (<any>this).normallyMixedWith = [] as any;
                for (let item of _data["NormallyMixedWith"])
                    (<any>this).normallyMixedWith!.push(item);
            }
            if (Array.isArray(_data["NotRecommendedMix"])) {
                (<any>this).notRecommendedMix = [] as any;
                for (let item of _data["NotRecommendedMix"])
                    (<any>this).notRecommendedMix!.push(item);
            }
            if (Array.isArray(_data["MixWithSpecialProcedure"])) {
                (<any>this).mixWithSpecialProcedure = [] as any;
                for (let item of _data["MixWithSpecialProcedure"])
                    (<any>this).mixWithSpecialProcedure!.push(item);
            }
            if (Array.isArray(_data["MixWithRisk"])) {
                (<any>this).mixWithRisk = [] as any;
                for (let item of _data["MixWithRisk"])
                    (<any>this).mixWithRisk!.push(item);
            }
            (<any>this).bestMix1 = _data["BestMix1"];
            (<any>this).bestMix2 = _data["BestMix2"];
            (<any>this).bestMix3 = _data["BestMix3"];
            (<any>this).shelfFront = _data["ShelfFront"];
            (<any>this).shelfFrontDescription = _data["ShelfFrontDescription"];
            (<any>this).shelfFrontTitle = _data["ShelfFrontTitle"];
            (<any>this).signDescription = _data["SignDescription"];
            (<any>this).signTitle = _data["SignTitle"];
            this.itemHideConversion = _data["ItemHideConversion"];
            this.atpMark = _data["AtpMark"];
            (<any>this).renderedFlag = _data["RenderedFlag"];
            (<any>this).flagType = _data["FlagType"];
            (<any>this).stockStatus = _data["StockStatus"] ? StockStatus.fromJS(_data["StockStatus"]) : <any>undefined;
            this.aTPStock = _data["ATPStock"] ? ATPStock.fromJS(_data["ATPStock"]) : <any>undefined;
            (<any>this).deliveryDate = _data["DeliveryDate"] ? ProductDeliveryDate.fromJS(_data["DeliveryDate"]) : <any>undefined;
            if (Array.isArray(_data["TagList"])) {
                (<any>this).tagList = [] as any;
                for (let item of _data["TagList"])
                    (<any>this).tagList!.push(ProductTag.fromJS(item));
            }
            if (Array.isArray(_data["TagGroups"])) {
                (<any>this).tagGroups = [] as any;
                for (let item of _data["TagGroups"])
                    (<any>this).tagGroups!.push(TagGroup.fromJS(item));
            }
            if (Array.isArray(_data["RecommendedAnimalTags"])) {
                (<any>this).recommendedAnimalTags = [] as any;
                for (let item of _data["RecommendedAnimalTags"])
                    (<any>this).recommendedAnimalTags!.push(Tag.fromJS(item));
            }
            if (Array.isArray(_data["NotRecommendedAnimalTags"])) {
                (<any>this).notRecommendedAnimalTags = [] as any;
                for (let item of _data["NotRecommendedAnimalTags"])
                    (<any>this).notRecommendedAnimalTags!.push(Tag.fromJS(item));
            }
            if (Array.isArray(_data["HazardTags"])) {
                (<any>this).hazardTags = [] as any;
                for (let item of _data["HazardTags"])
                    (<any>this).hazardTags!.push(Tag.fromJS(item));
            }
            if (Array.isArray(_data["EcoTags"])) {
                (<any>this).ecoTags = [] as any;
                for (let item of _data["EcoTags"])
                    (<any>this).ecoTags!.push(Tag.fromJS(item));
            }
            this.seedMaterial = _data["SeedMaterial"] ? SeedMaterial.fromJS(_data["SeedMaterial"]) : <any>undefined;
            this.trustPilotReviewDisplayable = _data["TrustPilotReviewDisplayable"];
            this.preferredVariantSku = _data["PreferredVariantSku"];
            this.preferredVariant = _data["PreferredVariant"];
            this.isPallet = _data["IsPallet"];
        }
    }

    static fromJS(data: any): CatalogProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NotForSale"] = this.notForSale;
        data["NotForDisplay"] = this.notForDisplay;
        data["SalesCode"] = this.salesCode;
        data["TransportGroup"] = this.transportGroup;
        data["SystemUnit"] = this.systemUnit;
        data["PrettyUnit"] = this.prettyUnit;
        data["HidePreciseStock"] = this.hidePreciseStock;
        data["IsEcological"] = this.isEcological;
        data["Name"] = this.name;
        data["Sku"] = this.sku;
        data["Description"] = this.description;
        data["ItemWebDescription"] = this.itemWebDescription;
        data["MetaDescription"] = this.metaDescription;
        data["Contents"] = this.contents;
        data["Dosage"] = this.dosage;
        data["EAN"] = this.eAN;
        data["Brand"] = this.brand;
        data["Link"] = this.link;
        data["Category"] = this.category;
        data["CategoryGroup"] = this.categoryGroup;
        data["HasBusinessCustomerDiscount"] = this.hasBusinessCustomerDiscount;
        data["MinimumCount"] = this.minimumCount;
        data["MaximumCount"] = this.maximumCount;
        data["HasVariants"] = this.hasVariants;
        data["VariantGroupId"] = this.variantGroupId;
        data["VariantGroupTitle"] = this.variantGroupTitle;
        data["VariantDimension"] = this.variantDimension;
        data["VariantValue"] = this.variantValue;
        data["VariantOrder"] = this.variantOrder;
        if (Array.isArray(this.variants)) {
            data["Variants"] = [];
            for (let item of this.variants)
                data["Variants"].push(item.toJSON());
        }
        data["MainImageUrl"] = this.mainImageUrl;
        data["MainImageUrlAndroid"] = this.mainImageUrlAndroid;
        data["MainImageUrlIos"] = this.mainImageUrlIos;
        if (Array.isArray(this.allImages)) {
            data["AllImages"] = [];
            for (let item of this.allImages)
                data["AllImages"].push(item.toJSON());
        }
        if (Array.isArray(this.allImagesAbsoluteUrlAndroid)) {
            data["AllImagesAbsoluteUrlAndroid"] = [];
            for (let item of this.allImagesAbsoluteUrlAndroid)
                data["AllImagesAbsoluteUrlAndroid"].push(item.toJSON());
        }
        if (Array.isArray(this.allImagesAbsoluteUrlIos)) {
            data["AllImagesAbsoluteUrlIos"] = [];
            for (let item of this.allImagesAbsoluteUrlIos)
                data["AllImagesAbsoluteUrlIos"].push(item.toJSON());
        }
        if (Array.isArray(this.pdfs)) {
            data["Pdfs"] = [];
            for (let item of this.pdfs)
                data["Pdfs"].push(item.toJSON());
        }
        data["MainVariantGroupImageUrl"] = this.mainVariantGroupImageUrl;
        data["MainVariantGroupImageAndroid"] = this.mainVariantGroupImageAndroid;
        data["MainVariantGroupImageIos"] = this.mainVariantGroupImageIos;
        if (Array.isArray(this.mediaContent)) {
            data["MediaContent"] = [];
            for (let item of this.mediaContent)
                data["MediaContent"].push(item.toJSON());
        }
        if (Array.isArray(this.productLinks)) {
            data["ProductLinks"] = [];
            for (let item of this.productLinks)
                data["ProductLinks"].push(item.toJSON());
        }
        data["SinglePrice"] = this.singlePrice ? this.singlePrice.toJSON() : <any>undefined;
        data["CheapestMultiPrice"] = this.cheapestMultiPrice ? this.cheapestMultiPrice.toJSON() : <any>undefined;
        data["CheapestPSName"] = this.cheapestPSName;
        data["CheapestPSLink"] = this.cheapestPSLink;
        data["CheapestPSImage"] = this.cheapestPSImage;
        data["CheapestPriceStepPrice"] = this.cheapestPriceStepPrice;
        data["CheapestPriceStepSalesCode"] = this.cheapestPriceStepSalesCode;
        if (Array.isArray(this.priceSteps)) {
            data["PriceSteps"] = [];
            for (let item of this.priceSteps)
                data["PriceSteps"].push(item.toJSON());
        }
        data["ClubPrice"] = this.clubPrice ? this.clubPrice.toJSON() : <any>undefined;
        if (Array.isArray(this.clubPriceSteps)) {
            data["ClubPriceSteps"] = [];
            for (let item of this.clubPriceSteps)
                data["ClubPriceSteps"].push(item.toJSON());
        }
        data["GrossWeight"] = this.grossWeight;
        data["GrossWeightUnit"] = this.grossWeightUnit;
        if (Array.isArray(this.conversionFactors)) {
            data["ConversionFactors"] = [];
            for (let item of this.conversionFactors)
                data["ConversionFactors"].push(item.toJSON());
        }
        data["PalletConversionUnitPrice"] = this.palletConversionUnitPrice;
        if (Array.isArray(this.synonymes)) {
            data["Synonymes"] = [];
            for (let item of this.synonymes)
                data["Synonymes"].push(item);
        }
        if (Array.isArray(this.relatedProducts)) {
            data["RelatedProducts"] = [];
            for (let item of this.relatedProducts)
                data["RelatedProducts"].push(item);
        }
        if (Array.isArray(this.alternativeProducts)) {
            data["AlternativeProducts"] = [];
            for (let item of this.alternativeProducts)
                data["AlternativeProducts"].push(item);
        }
        if (Array.isArray(this.normallyMixedWith)) {
            data["NormallyMixedWith"] = [];
            for (let item of this.normallyMixedWith)
                data["NormallyMixedWith"].push(item);
        }
        if (Array.isArray(this.notRecommendedMix)) {
            data["NotRecommendedMix"] = [];
            for (let item of this.notRecommendedMix)
                data["NotRecommendedMix"].push(item);
        }
        if (Array.isArray(this.mixWithSpecialProcedure)) {
            data["MixWithSpecialProcedure"] = [];
            for (let item of this.mixWithSpecialProcedure)
                data["MixWithSpecialProcedure"].push(item);
        }
        if (Array.isArray(this.mixWithRisk)) {
            data["MixWithRisk"] = [];
            for (let item of this.mixWithRisk)
                data["MixWithRisk"].push(item);
        }
        data["BestMix1"] = this.bestMix1;
        data["BestMix2"] = this.bestMix2;
        data["BestMix3"] = this.bestMix3;
        data["ShelfFront"] = this.shelfFront;
        data["ShelfFrontDescription"] = this.shelfFrontDescription;
        data["ShelfFrontTitle"] = this.shelfFrontTitle;
        data["SignDescription"] = this.signDescription;
        data["SignTitle"] = this.signTitle;
        data["ItemHideConversion"] = this.itemHideConversion;
        data["AtpMark"] = this.atpMark;
        data["RenderedFlag"] = this.renderedFlag;
        data["FlagType"] = this.flagType;
        data["StockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : <any>undefined;
        data["ATPStock"] = this.aTPStock ? this.aTPStock.toJSON() : <any>undefined;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : <any>undefined;
        if (Array.isArray(this.tagList)) {
            data["TagList"] = [];
            for (let item of this.tagList)
                data["TagList"].push(item.toJSON());
        }
        if (Array.isArray(this.tagGroups)) {
            data["TagGroups"] = [];
            for (let item of this.tagGroups)
                data["TagGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.recommendedAnimalTags)) {
            data["RecommendedAnimalTags"] = [];
            for (let item of this.recommendedAnimalTags)
                data["RecommendedAnimalTags"].push(item.toJSON());
        }
        if (Array.isArray(this.notRecommendedAnimalTags)) {
            data["NotRecommendedAnimalTags"] = [];
            for (let item of this.notRecommendedAnimalTags)
                data["NotRecommendedAnimalTags"].push(item.toJSON());
        }
        if (Array.isArray(this.hazardTags)) {
            data["HazardTags"] = [];
            for (let item of this.hazardTags)
                data["HazardTags"].push(item.toJSON());
        }
        if (Array.isArray(this.ecoTags)) {
            data["EcoTags"] = [];
            for (let item of this.ecoTags)
                data["EcoTags"].push(item.toJSON());
        }
        data["SeedMaterial"] = this.seedMaterial ? this.seedMaterial.toJSON() : <any>undefined;
        data["TrustPilotReviewDisplayable"] = this.trustPilotReviewDisplayable;
        data["PreferredVariantSku"] = this.preferredVariantSku;
        data["PreferredVariant"] = this.preferredVariant;
        data["IsPallet"] = this.isPallet;
        return data;
    }
}

export interface ICatalogProduct {
    notForSale?: boolean | undefined;
    notForDisplay?: boolean | undefined;
    salesCode?: string | undefined;
    transportGroup?: string | undefined;
    systemUnit?: string | undefined;
    prettyUnit?: string | undefined;
    hidePreciseStock?: boolean | undefined;
    isEcological?: boolean | undefined;
    name?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    itemWebDescription?: string | undefined;
    metaDescription?: string | undefined;
    contents?: string | undefined;
    dosage?: string | undefined;
    eAN?: string | undefined;
    brand?: string | undefined;
    link?: string | undefined;
    category?: string | undefined;
    categoryGroup?: string | undefined;
    hasBusinessCustomerDiscount?: boolean | undefined;
    minimumCount?: string | undefined;
    maximumCount?: string | undefined;
    hasVariants?: boolean | undefined;
    variantGroupId?: string | undefined;
    variantGroupTitle?: string | undefined;
    variantDimension?: string | undefined;
    variantValue?: string | undefined;
    variantOrder?: number | undefined;
    variants?: CatalogProductVariantReference[] | undefined;
    mainImageUrl?: string | undefined;
    mainImageUrlAndroid?: string | undefined;
    mainImageUrlIos?: string | undefined;
    allImages?: MediaReference[] | undefined;
    allImagesAbsoluteUrlAndroid?: MediaReference[] | undefined;
    allImagesAbsoluteUrlIos?: MediaReference[] | undefined;
    pdfs?: MediaReference[] | undefined;
    mainVariantGroupImageUrl?: string | undefined;
    mainVariantGroupImageAndroid?: string | undefined;
    mainVariantGroupImageIos?: string | undefined;
    mediaContent?: MediaContent[] | undefined;
    productLinks?: ProductLink[] | undefined;
    singlePrice?: ProductPrice | undefined;
    cheapestMultiPrice?: ProductPrice | undefined;
    cheapestPSName?: string | undefined;
    cheapestPSLink?: string | undefined;
    cheapestPSImage?: string | undefined;
    cheapestPriceStepPrice?: number | undefined;
    cheapestPriceStepSalesCode?: string | undefined;
    priceSteps?: ProductPrice[] | undefined;
    clubPrice?: ProductPrice | undefined;
    clubPriceSteps?: ProductPrice[] | undefined;
    grossWeight?: string | undefined;
    grossWeightUnit?: string | undefined;
    conversionFactors?: ConversionFactor[] | undefined;
    palletConversionUnitPrice?: number | undefined;
    synonymes?: string[] | undefined;
    relatedProducts?: string[] | undefined;
    alternativeProducts?: string[] | undefined;
    normallyMixedWith?: string[] | undefined;
    notRecommendedMix?: string[] | undefined;
    mixWithSpecialProcedure?: string[] | undefined;
    mixWithRisk?: string[] | undefined;
    bestMix1?: string | undefined;
    bestMix2?: string | undefined;
    bestMix3?: string | undefined;
    shelfFront?: boolean | undefined;
    shelfFrontDescription?: string | undefined;
    shelfFrontTitle?: string | undefined;
    signDescription?: string | undefined;
    signTitle?: string | undefined;
    itemHideConversion?: boolean | undefined;
    atpMark?: boolean | undefined;
    renderedFlag?: string | undefined;
    flagType?: CatalogProductFlagType | undefined;
    stockStatus?: StockStatus | undefined;
    aTPStock?: ATPStock | undefined;
    deliveryDate?: ProductDeliveryDate | undefined;
    tagList?: ProductTag[] | undefined;
    tagGroups?: TagGroup[] | undefined;
    recommendedAnimalTags?: Tag[] | undefined;
    notRecommendedAnimalTags?: Tag[] | undefined;
    hazardTags?: Tag[] | undefined;
    ecoTags?: Tag[] | undefined;
    seedMaterial?: SeedMaterial | undefined;
    trustPilotReviewDisplayable?: boolean | undefined;
    preferredVariantSku?: string | undefined;
    preferredVariant?: number | undefined;
    isPallet?: boolean | undefined;
}

export class SearchFacet implements ISearchFacet {
    fieldName?: string | undefined;
    displayName?: string | undefined;
    toggle?: boolean | undefined;
    top?: boolean | undefined;
    childrenTagNiveau?: { [key: string]: string; } | undefined;
    showOnlyChildrenValue?: boolean | undefined;
    selectedValues?: string[] | undefined;
    results?: SearchFacetValue[] | undefined;
    sortType?: SearchFacetSortType | undefined;
    sortOrder?: string[] | undefined;

    constructor(data?: ISearchFacet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["FieldName"];
            this.displayName = _data["DisplayName"];
            this.toggle = _data["Toggle"];
            this.top = _data["Top"];
            if (_data["ChildrenTagNiveau"]) {
                this.childrenTagNiveau = {} as any;
                for (let key in _data["ChildrenTagNiveau"]) {
                    if (_data["ChildrenTagNiveau"].hasOwnProperty(key))
                        (<any>this.childrenTagNiveau)![key] = _data["ChildrenTagNiveau"][key];
                }
            }
            this.showOnlyChildrenValue = _data["ShowOnlyChildrenValue"];
            if (Array.isArray(_data["SelectedValues"])) {
                this.selectedValues = [] as any;
                for (let item of _data["SelectedValues"])
                    this.selectedValues!.push(item);
            }
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(SearchFacetValue.fromJS(item));
            }
            this.sortType = _data["SortType"];
            if (Array.isArray(_data["SortOrder"])) {
                this.sortOrder = [] as any;
                for (let item of _data["SortOrder"])
                    this.sortOrder!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchFacet {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFacet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FieldName"] = this.fieldName;
        data["DisplayName"] = this.displayName;
        data["Toggle"] = this.toggle;
        data["Top"] = this.top;
        if (this.childrenTagNiveau) {
            data["ChildrenTagNiveau"] = {};
            for (let key in this.childrenTagNiveau) {
                if (this.childrenTagNiveau.hasOwnProperty(key))
                    (<any>data["ChildrenTagNiveau"])[key] = (<any>this.childrenTagNiveau)[key];
            }
        }
        data["ShowOnlyChildrenValue"] = this.showOnlyChildrenValue;
        if (Array.isArray(this.selectedValues)) {
            data["SelectedValues"] = [];
            for (let item of this.selectedValues)
                data["SelectedValues"].push(item);
        }
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item.toJSON());
        }
        data["SortType"] = this.sortType;
        if (Array.isArray(this.sortOrder)) {
            data["SortOrder"] = [];
            for (let item of this.sortOrder)
                data["SortOrder"].push(item);
        }
        return data;
    }
}

export interface ISearchFacet {
    fieldName?: string | undefined;
    displayName?: string | undefined;
    toggle?: boolean | undefined;
    top?: boolean | undefined;
    childrenTagNiveau?: { [key: string]: string; } | undefined;
    showOnlyChildrenValue?: boolean | undefined;
    selectedValues?: string[] | undefined;
    results?: SearchFacetValue[] | undefined;
    sortType?: SearchFacetSortType | undefined;
    sortOrder?: string[] | undefined;
}

export class CatalogProductVariantReference implements ICatalogProductVariantReference {
    readonly name?: string | undefined;
    readonly price?: number | undefined;
    readonly value?: string | undefined;
    readonly link?: string | undefined;
    readonly sku?: string | undefined;
    readonly image?: string | undefined;
    readonly variantImageAndroid?: string | undefined;
    readonly variantImageIos?: string | undefined;
    readonly order?: number | undefined;
    readonly notForDisplay?: boolean | undefined;
    readonly salesCode?: string | undefined;
    readonly priceSteps?: ProductPrice[] | undefined;

    constructor(data?: ICatalogProductVariantReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["Name"];
            (<any>this).price = _data["Price"];
            (<any>this).value = _data["Value"];
            (<any>this).link = _data["Link"];
            (<any>this).sku = _data["Sku"];
            (<any>this).image = _data["Image"];
            (<any>this).variantImageAndroid = _data["VariantImageAndroid"];
            (<any>this).variantImageIos = _data["VariantImageIos"];
            (<any>this).order = _data["Order"];
            (<any>this).notForDisplay = _data["NotForDisplay"];
            (<any>this).salesCode = _data["SalesCode"];
            if (Array.isArray(_data["PriceSteps"])) {
                (<any>this).priceSteps = [] as any;
                for (let item of _data["PriceSteps"])
                    (<any>this).priceSteps!.push(ProductPrice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CatalogProductVariantReference {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogProductVariantReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["Value"] = this.value;
        data["Link"] = this.link;
        data["Sku"] = this.sku;
        data["Image"] = this.image;
        data["VariantImageAndroid"] = this.variantImageAndroid;
        data["VariantImageIos"] = this.variantImageIos;
        data["Order"] = this.order;
        data["NotForDisplay"] = this.notForDisplay;
        data["SalesCode"] = this.salesCode;
        if (Array.isArray(this.priceSteps)) {
            data["PriceSteps"] = [];
            for (let item of this.priceSteps)
                data["PriceSteps"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICatalogProductVariantReference {
    name?: string | undefined;
    price?: number | undefined;
    value?: string | undefined;
    link?: string | undefined;
    sku?: string | undefined;
    image?: string | undefined;
    variantImageAndroid?: string | undefined;
    variantImageIos?: string | undefined;
    order?: number | undefined;
    notForDisplay?: boolean | undefined;
    salesCode?: string | undefined;
    priceSteps?: ProductPrice[] | undefined;
}

export class MediaReference implements IMediaReference {
    url?: string | undefined;
    urlAndroid?: string | undefined;
    urlIos?: string | undefined;
    name?: string | undefined;
    readonly alt?: string | undefined;

    constructor(data?: IMediaReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["Url"];
            this.urlAndroid = _data["UrlAndroid"];
            this.urlIos = _data["UrlIos"];
            this.name = _data["Name"];
            (<any>this).alt = _data["Alt"];
        }
    }

    static fromJS(data: any): MediaReference {
        data = typeof data === 'object' ? data : {};
        let result = new MediaReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Url"] = this.url;
        data["UrlAndroid"] = this.urlAndroid;
        data["UrlIos"] = this.urlIos;
        data["Name"] = this.name;
        data["Alt"] = this.alt;
        return data;
    }
}

export interface IMediaReference {
    url?: string | undefined;
    urlAndroid?: string | undefined;
    urlIos?: string | undefined;
    name?: string | undefined;
    alt?: string | undefined;
}

export class MediaContent implements IMediaContent {
    type?: string | undefined;
    text?: string | undefined;
    mediaLink?: string | undefined;

    constructor(data?: IMediaContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.text = _data["Text"];
            this.mediaLink = _data["MediaLink"];
        }
    }

    static fromJS(data: any): MediaContent {
        data = typeof data === 'object' ? data : {};
        let result = new MediaContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Text"] = this.text;
        data["MediaLink"] = this.mediaLink;
        return data;
    }
}

export interface IMediaContent {
    type?: string | undefined;
    text?: string | undefined;
    mediaLink?: string | undefined;
}

export class ProductLink implements IProductLink {
    text?: string | undefined;
    link?: string | undefined;

    constructor(data?: IProductLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
            this.link = _data["Link"];
        }
    }

    static fromJS(data: any): ProductLink {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Link"] = this.link;
        return data;
    }
}

export interface IProductLink {
    text?: string | undefined;
    link?: string | undefined;
}

export class ProductPrice implements IProductPrice {
    readonly price?: number | undefined;
    readonly save?: number | undefined;
    readonly requiredQuantity?: number | undefined;
    readonly priceType?: ProductPricePriceType | undefined;
    readonly salesOfficeId?: string | undefined;
    readonly priceGroup?: string | undefined;
    contractNumber?: string | undefined;
    pos?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IProductPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).price = _data["Price"];
            (<any>this).save = _data["Save"];
            (<any>this).requiredQuantity = _data["RequiredQuantity"];
            (<any>this).priceType = _data["PriceType"];
            (<any>this).salesOfficeId = _data["SalesOfficeId"];
            (<any>this).priceGroup = _data["PriceGroup"];
            this.contractNumber = _data["ContractNumber"];
            this.pos = _data["Pos"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : <any>undefined;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Price"] = this.price;
        data["Save"] = this.save;
        data["RequiredQuantity"] = this.requiredQuantity;
        data["PriceType"] = this.priceType;
        data["SalesOfficeId"] = this.salesOfficeId;
        data["PriceGroup"] = this.priceGroup;
        data["ContractNumber"] = this.contractNumber;
        data["Pos"] = this.pos;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductPrice {
    price?: number | undefined;
    save?: number | undefined;
    requiredQuantity?: number | undefined;
    priceType?: ProductPricePriceType | undefined;
    salesOfficeId?: string | undefined;
    priceGroup?: string | undefined;
    contractNumber?: string | undefined;
    pos?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class ConversionFactor implements IConversionFactor {
    readonly numeratorUnit?: string | undefined;
    readonly numerator?: number | undefined;
    readonly denominatorUnit?: string | undefined;
    readonly denominator?: number | undefined;
    readonly showConversion?: boolean | undefined;

    constructor(data?: IConversionFactor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).numeratorUnit = _data["NumeratorUnit"];
            (<any>this).numerator = _data["Numerator"];
            (<any>this).denominatorUnit = _data["DenominatorUnit"];
            (<any>this).denominator = _data["Denominator"];
            (<any>this).showConversion = _data["ShowConversion"];
        }
    }

    static fromJS(data: any): ConversionFactor {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionFactor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NumeratorUnit"] = this.numeratorUnit;
        data["Numerator"] = this.numerator;
        data["DenominatorUnit"] = this.denominatorUnit;
        data["Denominator"] = this.denominator;
        data["ShowConversion"] = this.showConversion;
        return data;
    }
}

export interface IConversionFactor {
    numeratorUnit?: string | undefined;
    numerator?: number | undefined;
    denominatorUnit?: string | undefined;
    denominator?: number | undefined;
    showConversion?: boolean | undefined;
}

export class StockStatus implements IStockStatus {
    readonly text?: string | undefined;
    readonly type?: StockStatusType | undefined;
    currentStock?: number | undefined;

    constructor(data?: IStockStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).text = _data["Text"];
            (<any>this).type = _data["Type"];
            this.currentStock = _data["CurrentStock"];
        }
    }

    static fromJS(data: any): StockStatus {
        data = typeof data === 'object' ? data : {};
        let result = new StockStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        data["Type"] = this.type;
        data["CurrentStock"] = this.currentStock;
        return data;
    }
}

export interface IStockStatus {
    text?: string | undefined;
    type?: StockStatusType | undefined;
    currentStock?: number | undefined;
}

export class ATPStock implements IATPStock {
    stockStatus?: ATPStockStockStatus | undefined;
    quantity?: number | undefined;
    dates?: ATPDates | undefined;
    futureStock?: FutureStock[] | undefined;

    constructor(data?: IATPStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockStatus = _data["StockStatus"];
            this.quantity = _data["Quantity"];
            this.dates = _data["Dates"] ? ATPDates.fromJS(_data["Dates"]) : <any>undefined;
            if (Array.isArray(_data["FutureStock"])) {
                this.futureStock = [] as any;
                for (let item of _data["FutureStock"])
                    this.futureStock!.push(FutureStock.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ATPStock {
        data = typeof data === 'object' ? data : {};
        let result = new ATPStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StockStatus"] = this.stockStatus;
        data["Quantity"] = this.quantity;
        data["Dates"] = this.dates ? this.dates.toJSON() : <any>undefined;
        if (Array.isArray(this.futureStock)) {
            data["FutureStock"] = [];
            for (let item of this.futureStock)
                data["FutureStock"].push(item.toJSON());
        }
        return data;
    }
}

export interface IATPStock {
    stockStatus?: ATPStockStockStatus | undefined;
    quantity?: number | undefined;
    dates?: ATPDates | undefined;
    futureStock?: FutureStock[] | undefined;
}

export class ProductDeliveryDate implements IProductDeliveryDate {
    isSuggestedLastDeliveryDateSet?: boolean | undefined;
    sku?: string | undefined;
    firstDeliveryDate?: Date | undefined;
    suggestedLastDeliveryDate?: Date | undefined;
    minDeliveryDays?: number | undefined;
    validDeliveryDates?: Date[] | undefined;
    routeDelivery?: boolean | undefined;
    optionalDeliveryDates?: Date[] | undefined;
    optionalRouteDelivery?: boolean | undefined;
    expressDeliveryPossible?: boolean | undefined;

    constructor(data?: IProductDeliveryDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuggestedLastDeliveryDateSet = _data["IsSuggestedLastDeliveryDateSet"];
            this.sku = _data["Sku"];
            this.firstDeliveryDate = _data["FirstDeliveryDate"] ? new Date(_data["FirstDeliveryDate"].toString()) : <any>undefined;
            this.suggestedLastDeliveryDate = _data["SuggestedLastDeliveryDate"] ? new Date(_data["SuggestedLastDeliveryDate"].toString()) : <any>undefined;
            this.minDeliveryDays = _data["MinDeliveryDays"];
            if (Array.isArray(_data["ValidDeliveryDates"])) {
                this.validDeliveryDates = [] as any;
                for (let item of _data["ValidDeliveryDates"])
                    this.validDeliveryDates!.push(new Date(item));
            }
            this.routeDelivery = _data["RouteDelivery"];
            if (Array.isArray(_data["OptionalDeliveryDates"])) {
                this.optionalDeliveryDates = [] as any;
                for (let item of _data["OptionalDeliveryDates"])
                    this.optionalDeliveryDates!.push(new Date(item));
            }
            this.optionalRouteDelivery = _data["OptionalRouteDelivery"];
            this.expressDeliveryPossible = _data["ExpressDeliveryPossible"];
        }
    }

    static fromJS(data: any): ProductDeliveryDate {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDeliveryDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSuggestedLastDeliveryDateSet"] = this.isSuggestedLastDeliveryDateSet;
        data["Sku"] = this.sku;
        data["FirstDeliveryDate"] = this.firstDeliveryDate ? this.firstDeliveryDate.toISOString() : <any>undefined;
        data["SuggestedLastDeliveryDate"] = this.suggestedLastDeliveryDate ? this.suggestedLastDeliveryDate.toISOString() : <any>undefined;
        data["MinDeliveryDays"] = this.minDeliveryDays;
        if (Array.isArray(this.validDeliveryDates)) {
            data["ValidDeliveryDates"] = [];
            for (let item of this.validDeliveryDates)
                data["ValidDeliveryDates"].push(item.toISOString());
        }
        data["RouteDelivery"] = this.routeDelivery;
        if (Array.isArray(this.optionalDeliveryDates)) {
            data["OptionalDeliveryDates"] = [];
            for (let item of this.optionalDeliveryDates)
                data["OptionalDeliveryDates"].push(item.toISOString());
        }
        data["OptionalRouteDelivery"] = this.optionalRouteDelivery;
        data["ExpressDeliveryPossible"] = this.expressDeliveryPossible;
        return data;
    }
}

export interface IProductDeliveryDate {
    isSuggestedLastDeliveryDateSet?: boolean | undefined;
    sku?: string | undefined;
    firstDeliveryDate?: Date | undefined;
    suggestedLastDeliveryDate?: Date | undefined;
    minDeliveryDays?: number | undefined;
    validDeliveryDates?: Date[] | undefined;
    routeDelivery?: boolean | undefined;
    optionalDeliveryDates?: Date[] | undefined;
    optionalRouteDelivery?: boolean | undefined;
    expressDeliveryPossible?: boolean | undefined;
}

export class ProductTag implements IProductTag {
    readonly tag?: string | undefined;
    readonly type?: string | undefined;
    readonly values?: string[] | undefined;

    constructor(data?: IProductTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).tag = _data["Tag"];
            (<any>this).type = _data["Type"];
            if (Array.isArray(_data["Values"])) {
                (<any>this).values = [] as any;
                for (let item of _data["Values"])
                    (<any>this).values!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductTag {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Tag"] = this.tag;
        data["Type"] = this.type;
        if (Array.isArray(this.values)) {
            data["Values"] = [];
            for (let item of this.values)
                data["Values"].push(item);
        }
        return data;
    }
}

export interface IProductTag {
    tag?: string | undefined;
    type?: string | undefined;
    values?: string[] | undefined;
}

export class TagGroup implements ITagGroup {
    title?: string | undefined;
    iconUrl?: string | undefined;
    iconUrlAndroid?: string | undefined;
    iconUrlIos?: string | undefined;
    tags?: Tag[] | undefined;
    hasBackground?: boolean | undefined;
    smallIconUrl?: string | undefined;
    smallIconUrlAndroid?: string | undefined;
    smallIconUrlIos?: string | undefined;

    constructor(data?: ITagGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.iconUrl = _data["IconUrl"];
            this.iconUrlAndroid = _data["IconUrlAndroid"];
            this.iconUrlIos = _data["IconUrlIos"];
            if (Array.isArray(_data["Tags"])) {
                this.tags = [] as any;
                for (let item of _data["Tags"])
                    this.tags!.push(Tag.fromJS(item));
            }
            this.hasBackground = _data["HasBackground"];
            this.smallIconUrl = _data["SmallIconUrl"];
            this.smallIconUrlAndroid = _data["SmallIconUrlAndroid"];
            this.smallIconUrlIos = _data["SmallIconUrlIos"];
        }
    }

    static fromJS(data: any): TagGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TagGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["IconUrl"] = this.iconUrl;
        data["IconUrlAndroid"] = this.iconUrlAndroid;
        data["IconUrlIos"] = this.iconUrlIos;
        if (Array.isArray(this.tags)) {
            data["Tags"] = [];
            for (let item of this.tags)
                data["Tags"].push(item.toJSON());
        }
        data["HasBackground"] = this.hasBackground;
        data["SmallIconUrl"] = this.smallIconUrl;
        data["SmallIconUrlAndroid"] = this.smallIconUrlAndroid;
        data["SmallIconUrlIos"] = this.smallIconUrlIos;
        return data;
    }
}

export interface ITagGroup {
    title?: string | undefined;
    iconUrl?: string | undefined;
    iconUrlAndroid?: string | undefined;
    iconUrlIos?: string | undefined;
    tags?: Tag[] | undefined;
    hasBackground?: boolean | undefined;
    smallIconUrl?: string | undefined;
    smallIconUrlAndroid?: string | undefined;
    smallIconUrlIos?: string | undefined;
}

export class Tag implements ITag {
    key?: string | undefined;
    readonly name?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlAndroid?: string | undefined;
    imageUrlIos?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["Key"];
            (<any>this).name = _data["Name"];
            this.imageUrl = _data["ImageUrl"];
            this.imageUrlAndroid = _data["ImageUrlAndroid"];
            this.imageUrlIos = _data["ImageUrlIos"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        data["Name"] = this.name;
        data["ImageUrl"] = this.imageUrl;
        data["ImageUrlAndroid"] = this.imageUrlAndroid;
        data["ImageUrlIos"] = this.imageUrlIos;
        data["Description"] = this.description;
        return data;
    }
}

export interface ITag {
    key?: string | undefined;
    name?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlAndroid?: string | undefined;
    imageUrlIos?: string | undefined;
    description?: string | undefined;
}

export class SeedMaterial implements ISeedMaterial {
    type?: string | undefined;
    readonly isBulk?: boolean | undefined;
    picklings1?: Pickling[] | undefined;
    picklings2?: Pickling[] | undefined;
    containerVolume?: string[] | undefined;
    pickling1Locked?: boolean | undefined;
    pickling2Locked?: boolean | undefined;
    pickling1?: Pickling | undefined;
    pickling2?: Pickling | undefined;
    kF?: number | undefined;
    kFSpecified?: boolean | undefined;
    tKG?: number | undefined;
    tKGSpecified?: boolean | undefined;

    constructor(data?: ISeedMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            (<any>this).isBulk = _data["IsBulk"];
            if (Array.isArray(_data["Picklings1"])) {
                this.picklings1 = [] as any;
                for (let item of _data["Picklings1"])
                    this.picklings1!.push(Pickling.fromJS(item));
            }
            if (Array.isArray(_data["Picklings2"])) {
                this.picklings2 = [] as any;
                for (let item of _data["Picklings2"])
                    this.picklings2!.push(Pickling.fromJS(item));
            }
            if (Array.isArray(_data["ContainerVolume"])) {
                this.containerVolume = [] as any;
                for (let item of _data["ContainerVolume"])
                    this.containerVolume!.push(item);
            }
            this.pickling1Locked = _data["Pickling1Locked"];
            this.pickling2Locked = _data["Pickling2Locked"];
            this.pickling1 = _data["Pickling1"] ? Pickling.fromJS(_data["Pickling1"]) : <any>undefined;
            this.pickling2 = _data["Pickling2"] ? Pickling.fromJS(_data["Pickling2"]) : <any>undefined;
            this.kF = _data["KF"];
            this.kFSpecified = _data["KFSpecified"];
            this.tKG = _data["TKG"];
            this.tKGSpecified = _data["TKGSpecified"];
        }
    }

    static fromJS(data: any): SeedMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new SeedMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["IsBulk"] = this.isBulk;
        if (Array.isArray(this.picklings1)) {
            data["Picklings1"] = [];
            for (let item of this.picklings1)
                data["Picklings1"].push(item.toJSON());
        }
        if (Array.isArray(this.picklings2)) {
            data["Picklings2"] = [];
            for (let item of this.picklings2)
                data["Picklings2"].push(item.toJSON());
        }
        if (Array.isArray(this.containerVolume)) {
            data["ContainerVolume"] = [];
            for (let item of this.containerVolume)
                data["ContainerVolume"].push(item);
        }
        data["Pickling1Locked"] = this.pickling1Locked;
        data["Pickling2Locked"] = this.pickling2Locked;
        data["Pickling1"] = this.pickling1 ? this.pickling1.toJSON() : <any>undefined;
        data["Pickling2"] = this.pickling2 ? this.pickling2.toJSON() : <any>undefined;
        data["KF"] = this.kF;
        data["KFSpecified"] = this.kFSpecified;
        data["TKG"] = this.tKG;
        data["TKGSpecified"] = this.tKGSpecified;
        return data;
    }
}

export interface ISeedMaterial {
    type?: string | undefined;
    isBulk?: boolean | undefined;
    picklings1?: Pickling[] | undefined;
    picklings2?: Pickling[] | undefined;
    containerVolume?: string[] | undefined;
    pickling1Locked?: boolean | undefined;
    pickling2Locked?: boolean | undefined;
    pickling1?: Pickling | undefined;
    pickling2?: Pickling | undefined;
    kF?: number | undefined;
    kFSpecified?: boolean | undefined;
    tKG?: number | undefined;
    tKGSpecified?: boolean | undefined;
}

export class SearchFacetValue implements ISearchFacetValue {
    name?: string | undefined;
    displayName?: string | undefined;
    count?: number | undefined;
    selected?: boolean | undefined;

    constructor(data?: ISearchFacetValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.displayName = _data["DisplayName"];
            this.count = _data["Count"];
            this.selected = _data["Selected"];
        }
    }

    static fromJS(data: any): SearchFacetValue {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFacetValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["DisplayName"] = this.displayName;
        data["Count"] = this.count;
        data["Selected"] = this.selected;
        return data;
    }
}

export interface ISearchFacetValue {
    name?: string | undefined;
    displayName?: string | undefined;
    count?: number | undefined;
    selected?: boolean | undefined;
}

export class ATPDates implements IATPDates {
    stockDate?: Date | undefined;
    latestDeliveryDate?: Date | undefined;

    constructor(data?: IATPDates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockDate = _data["StockDate"] ? new Date(_data["StockDate"].toString()) : <any>undefined;
            this.latestDeliveryDate = _data["LatestDeliveryDate"] ? new Date(_data["LatestDeliveryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ATPDates {
        data = typeof data === 'object' ? data : {};
        let result = new ATPDates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StockDate"] = this.stockDate ? this.stockDate.toISOString() : <any>undefined;
        data["LatestDeliveryDate"] = this.latestDeliveryDate ? this.latestDeliveryDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IATPDates {
    stockDate?: Date | undefined;
    latestDeliveryDate?: Date | undefined;
}

export class FutureStock implements IFutureStock {
    quantity?: number | undefined;
    dates?: ATPDates | undefined;

    constructor(data?: IFutureStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["Quantity"];
            this.dates = _data["Dates"] ? ATPDates.fromJS(_data["Dates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FutureStock {
        data = typeof data === 'object' ? data : {};
        let result = new FutureStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Quantity"] = this.quantity;
        data["Dates"] = this.dates ? this.dates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFutureStock {
    quantity?: number | undefined;
    dates?: ATPDates | undefined;
}

export class Pickling implements IPickling {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IPickling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): Pickling {
        data = typeof data === 'object' ? data : {};
        let result = new Pickling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Text"] = this.text;
        return data;
    }
}

export interface IPickling {
    code?: string | undefined;
    text?: string | undefined;
}

export class HaGeControllerResultOfHaGeBasketOfHaGeBasketLine implements IHaGeControllerResultOfHaGeBasketOfHaGeBasketLine {
    readonly result?: HaGeBasketOfHaGeBasketLine | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IHaGeControllerResultOfHaGeBasketOfHaGeBasketLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? HaGeBasketOfHaGeBasketLine.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): HaGeControllerResultOfHaGeBasketOfHaGeBasketLine {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeControllerResultOfHaGeBasketOfHaGeBasketLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IHaGeControllerResultOfHaGeBasketOfHaGeBasketLine {
    result?: HaGeBasketOfHaGeBasketLine | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class HaGeBasketOfHaGeBasketLine implements IHaGeBasketOfHaGeBasketLine {
    expiredLinesWithoutMAB?: HaGeBasketLine[] | undefined;
    readonly lines?: HaGeBasketLine[] | undefined;
    subTotal?: number | undefined;
    freight?: number | undefined;
    voucherDiscount?: number | undefined;
    total?: number | undefined;
    totalSave?: number | undefined;
    simulationResult?: SimulationResult | undefined;
    voucherCode?: string | undefined;
    userIdentification?: string | undefined;
    orderNumber?: string | undefined;
    sAPOrderNumber?: string | undefined;
    expiredLines?: HaGeBasketLine[] | undefined;
    serviceCodeList?: ProductService[] | undefined;

    constructor(data?: IHaGeBasketOfHaGeBasketLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ExpiredLinesWithoutMAB"])) {
                this.expiredLinesWithoutMAB = [] as any;
                for (let item of _data["ExpiredLinesWithoutMAB"])
                    this.expiredLinesWithoutMAB!.push(HaGeBasketLine.fromJS(item));
            }
            if (Array.isArray(_data["Lines"])) {
                (<any>this).lines = [] as any;
                for (let item of _data["Lines"])
                    (<any>this).lines!.push(HaGeBasketLine.fromJS(item));
            }
            this.subTotal = _data["SubTotal"];
            this.freight = _data["Freight"];
            this.voucherDiscount = _data["VoucherDiscount"];
            this.total = _data["Total"];
            this.totalSave = _data["TotalSave"];
            this.simulationResult = _data["SimulationResult"] ? SimulationResult.fromJS(_data["SimulationResult"]) : <any>undefined;
            this.voucherCode = _data["VoucherCode"];
            this.userIdentification = _data["UserIdentification"];
            this.orderNumber = _data["OrderNumber"];
            this.sAPOrderNumber = _data["SAPOrderNumber"];
            if (Array.isArray(_data["ExpiredLines"])) {
                this.expiredLines = [] as any;
                for (let item of _data["ExpiredLines"])
                    this.expiredLines!.push(HaGeBasketLine.fromJS(item));
            }
            if (Array.isArray(_data["ServiceCodeList"])) {
                this.serviceCodeList = [] as any;
                for (let item of _data["ServiceCodeList"])
                    this.serviceCodeList!.push(ProductService.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HaGeBasketOfHaGeBasketLine {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeBasketOfHaGeBasketLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiredLinesWithoutMAB)) {
            data["ExpiredLinesWithoutMAB"] = [];
            for (let item of this.expiredLinesWithoutMAB)
                data["ExpiredLinesWithoutMAB"].push(item.toJSON());
        }
        if (Array.isArray(this.lines)) {
            data["Lines"] = [];
            for (let item of this.lines)
                data["Lines"].push(item.toJSON());
        }
        data["SubTotal"] = this.subTotal;
        data["Freight"] = this.freight;
        data["VoucherDiscount"] = this.voucherDiscount;
        data["Total"] = this.total;
        data["TotalSave"] = this.totalSave;
        data["SimulationResult"] = this.simulationResult ? this.simulationResult.toJSON() : <any>undefined;
        data["VoucherCode"] = this.voucherCode;
        data["UserIdentification"] = this.userIdentification;
        data["OrderNumber"] = this.orderNumber;
        data["SAPOrderNumber"] = this.sAPOrderNumber;
        if (Array.isArray(this.expiredLines)) {
            data["ExpiredLines"] = [];
            for (let item of this.expiredLines)
                data["ExpiredLines"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceCodeList)) {
            data["ServiceCodeList"] = [];
            for (let item of this.serviceCodeList)
                data["ServiceCodeList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHaGeBasketOfHaGeBasketLine {
    expiredLinesWithoutMAB?: HaGeBasketLine[] | undefined;
    lines?: HaGeBasketLine[] | undefined;
    subTotal?: number | undefined;
    freight?: number | undefined;
    voucherDiscount?: number | undefined;
    total?: number | undefined;
    totalSave?: number | undefined;
    simulationResult?: SimulationResult | undefined;
    voucherCode?: string | undefined;
    userIdentification?: string | undefined;
    orderNumber?: string | undefined;
    sAPOrderNumber?: string | undefined;
    expiredLines?: HaGeBasketLine[] | undefined;
    serviceCodeList?: ProductService[] | undefined;
}

export class HaGeBasketLine implements IHaGeBasketLine {
    type?: HaGeBasketLineType | undefined;
    accountId?: number | undefined;
    accountName?: string | undefined;
    positionNumber?: string | undefined;
    contractId?: string | undefined;
    truckType?: string | undefined;
    transportationType?: string | undefined;
    delivery?: HaGeBasketLineDelivery | undefined;
    readonly unitAmount?: number | undefined;
    contractExpired?: boolean | undefined;
    posType?: string | undefined;
    contractType?: string | undefined;
    grain?: number | undefined;
    surface?: number | undefined;
    picklings?: Pickling2[] | undefined;
    containerVolume?: string | undefined;
    hasFreightSurcharge?: boolean | undefined;
    readonly lineId?: string | undefined;
    quantity?: number | undefined;
    maxValue?: string | undefined;
    minValue?: string | undefined;
    skuId?: string | undefined;
    salesCode?: string | undefined;
    brand?: string | undefined;
    systemUnit?: string | undefined;
    priceSteps?: ProductPrice[] | undefined;
    subTotal?: number | undefined;
    subTotalSave?: number | undefined;
    simulationResult?: SimulationResult | undefined;
    display?: BasketLineDisplay | undefined;
    productPriceType?: HaGeBasketLineProductPriceType | undefined;

    constructor(data?: IHaGeBasketLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.accountId = _data["AccountId"];
            this.accountName = _data["AccountName"];
            this.positionNumber = _data["PositionNumber"];
            this.contractId = _data["ContractId"];
            this.truckType = _data["TruckType"];
            this.transportationType = _data["TransportationType"];
            this.delivery = _data["Delivery"] ? HaGeBasketLineDelivery.fromJS(_data["Delivery"]) : <any>undefined;
            (<any>this).unitAmount = _data["UnitAmount"];
            this.contractExpired = _data["ContractExpired"];
            this.posType = _data["PosType"];
            this.contractType = _data["ContractType"];
            this.grain = _data["Grain"];
            this.surface = _data["Surface"];
            if (Array.isArray(_data["Picklings"])) {
                this.picklings = [] as any;
                for (let item of _data["Picklings"])
                    this.picklings!.push(Pickling2.fromJS(item));
            }
            this.containerVolume = _data["ContainerVolume"];
            this.hasFreightSurcharge = _data["HasFreightSurcharge"];
            (<any>this).lineId = _data["LineId"];
            this.quantity = _data["Quantity"];
            this.maxValue = _data["MaxValue"];
            this.minValue = _data["MinValue"];
            this.skuId = _data["SkuId"];
            this.salesCode = _data["SalesCode"];
            this.brand = _data["Brand"];
            this.systemUnit = _data["SystemUnit"];
            if (Array.isArray(_data["PriceSteps"])) {
                this.priceSteps = [] as any;
                for (let item of _data["PriceSteps"])
                    this.priceSteps!.push(ProductPrice.fromJS(item));
            }
            this.subTotal = _data["SubTotal"];
            this.subTotalSave = _data["SubTotalSave"];
            this.simulationResult = _data["SimulationResult"] ? SimulationResult.fromJS(_data["SimulationResult"]) : <any>undefined;
            this.display = _data["Display"] ? BasketLineDisplay.fromJS(_data["Display"]) : <any>undefined;
            this.productPriceType = _data["ProductPriceType"];
        }
    }

    static fromJS(data: any): HaGeBasketLine {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeBasketLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["AccountId"] = this.accountId;
        data["AccountName"] = this.accountName;
        data["PositionNumber"] = this.positionNumber;
        data["ContractId"] = this.contractId;
        data["TruckType"] = this.truckType;
        data["TransportationType"] = this.transportationType;
        data["Delivery"] = this.delivery ? this.delivery.toJSON() : <any>undefined;
        data["UnitAmount"] = this.unitAmount;
        data["ContractExpired"] = this.contractExpired;
        data["PosType"] = this.posType;
        data["ContractType"] = this.contractType;
        data["Grain"] = this.grain;
        data["Surface"] = this.surface;
        if (Array.isArray(this.picklings)) {
            data["Picklings"] = [];
            for (let item of this.picklings)
                data["Picklings"].push(item.toJSON());
        }
        data["ContainerVolume"] = this.containerVolume;
        data["HasFreightSurcharge"] = this.hasFreightSurcharge;
        data["LineId"] = this.lineId;
        data["Quantity"] = this.quantity;
        data["MaxValue"] = this.maxValue;
        data["MinValue"] = this.minValue;
        data["SkuId"] = this.skuId;
        data["SalesCode"] = this.salesCode;
        data["Brand"] = this.brand;
        data["SystemUnit"] = this.systemUnit;
        if (Array.isArray(this.priceSteps)) {
            data["PriceSteps"] = [];
            for (let item of this.priceSteps)
                data["PriceSteps"].push(item.toJSON());
        }
        data["SubTotal"] = this.subTotal;
        data["SubTotalSave"] = this.subTotalSave;
        data["SimulationResult"] = this.simulationResult ? this.simulationResult.toJSON() : <any>undefined;
        data["Display"] = this.display ? this.display.toJSON() : <any>undefined;
        data["ProductPriceType"] = this.productPriceType;
        return data;
    }
}

export interface IHaGeBasketLine {
    type?: HaGeBasketLineType | undefined;
    accountId?: number | undefined;
    accountName?: string | undefined;
    positionNumber?: string | undefined;
    contractId?: string | undefined;
    truckType?: string | undefined;
    transportationType?: string | undefined;
    delivery?: HaGeBasketLineDelivery | undefined;
    unitAmount?: number | undefined;
    contractExpired?: boolean | undefined;
    posType?: string | undefined;
    contractType?: string | undefined;
    grain?: number | undefined;
    surface?: number | undefined;
    picklings?: Pickling2[] | undefined;
    containerVolume?: string | undefined;
    hasFreightSurcharge?: boolean | undefined;
    lineId?: string | undefined;
    quantity?: number | undefined;
    maxValue?: string | undefined;
    minValue?: string | undefined;
    skuId?: string | undefined;
    salesCode?: string | undefined;
    brand?: string | undefined;
    systemUnit?: string | undefined;
    priceSteps?: ProductPrice[] | undefined;
    subTotal?: number | undefined;
    subTotalSave?: number | undefined;
    simulationResult?: SimulationResult | undefined;
    display?: BasketLineDisplay | undefined;
    productPriceType?: HaGeBasketLineProductPriceType | undefined;
}

export class SimulationResult implements ISimulationResult {
    priceModifiers?: PriceModifier[] | undefined;
    total?: number | undefined;
    sitecoreDiscount?: number | undefined;
    latestdeliveryOverride?: Date | undefined;
    readonly status?: SimulationResultStatus | undefined;

    constructor(data?: ISimulationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["PriceModifiers"])) {
                this.priceModifiers = [] as any;
                for (let item of _data["PriceModifiers"])
                    this.priceModifiers!.push(PriceModifier.fromJS(item));
            }
            this.total = _data["Total"];
            this.sitecoreDiscount = _data["SitecoreDiscount"];
            this.latestdeliveryOverride = _data["LatestdeliveryOverride"] ? new Date(_data["LatestdeliveryOverride"].toString()) : <any>undefined;
            (<any>this).status = _data["Status"];
        }
    }

    static fromJS(data: any): SimulationResult {
        data = typeof data === 'object' ? data : {};
        let result = new SimulationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priceModifiers)) {
            data["PriceModifiers"] = [];
            for (let item of this.priceModifiers)
                data["PriceModifiers"].push(item.toJSON());
        }
        data["Total"] = this.total;
        data["SitecoreDiscount"] = this.sitecoreDiscount;
        data["LatestdeliveryOverride"] = this.latestdeliveryOverride ? this.latestdeliveryOverride.toISOString() : <any>undefined;
        data["Status"] = this.status;
        return data;
    }
}

export interface ISimulationResult {
    priceModifiers?: PriceModifier[] | undefined;
    total?: number | undefined;
    sitecoreDiscount?: number | undefined;
    latestdeliveryOverride?: Date | undefined;
    status?: SimulationResultStatus | undefined;
}

export class ProductService implements IProductService {
    mat?: string | undefined;
    pos?: string | undefined;
    serviceCode?: string | undefined;
    accountId?: number | undefined;

    constructor(data?: IProductService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mat = _data["Mat"];
            this.pos = _data["Pos"];
            this.serviceCode = _data["ServiceCode"];
            this.accountId = _data["AccountId"];
        }
    }

    static fromJS(data: any): ProductService {
        data = typeof data === 'object' ? data : {};
        let result = new ProductService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Mat"] = this.mat;
        data["Pos"] = this.pos;
        data["ServiceCode"] = this.serviceCode;
        data["AccountId"] = this.accountId;
        return data;
    }
}

export interface IProductService {
    mat?: string | undefined;
    pos?: string | undefined;
    serviceCode?: string | undefined;
    accountId?: number | undefined;
}

export class HaGeBasketLineDelivery implements IHaGeBasketLineDelivery {
    deliveryAddressId?: string | undefined;
    deliveryAddressPretty?: string | undefined;
    unloadingPoint?: string | undefined;
    deliveryPlaceDescription?: string | undefined;
    deliveryLocationId?: string | undefined;
    deliveryLocationPretty?: string | undefined;
    deliveryDate?: DeliveryDate | undefined;
    messageToDriver?: string | undefined;
    wagonTypePretty?: string | undefined;
    unloadingMethodPretty?: string | undefined;

    constructor(data?: IHaGeBasketLineDelivery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAddressId = _data["DeliveryAddressId"];
            this.deliveryAddressPretty = _data["DeliveryAddressPretty"];
            this.unloadingPoint = _data["UnloadingPoint"];
            this.deliveryPlaceDescription = _data["DeliveryPlaceDescription"];
            this.deliveryLocationId = _data["DeliveryLocationId"];
            this.deliveryLocationPretty = _data["DeliveryLocationPretty"];
            this.deliveryDate = _data["DeliveryDate"] ? DeliveryDate.fromJS(_data["DeliveryDate"]) : <any>undefined;
            this.messageToDriver = _data["MessageToDriver"];
            this.wagonTypePretty = _data["WagonTypePretty"];
            this.unloadingMethodPretty = _data["UnloadingMethodPretty"];
        }
    }

    static fromJS(data: any): HaGeBasketLineDelivery {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeBasketLineDelivery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeliveryAddressId"] = this.deliveryAddressId;
        data["DeliveryAddressPretty"] = this.deliveryAddressPretty;
        data["UnloadingPoint"] = this.unloadingPoint;
        data["DeliveryPlaceDescription"] = this.deliveryPlaceDescription;
        data["DeliveryLocationId"] = this.deliveryLocationId;
        data["DeliveryLocationPretty"] = this.deliveryLocationPretty;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : <any>undefined;
        data["MessageToDriver"] = this.messageToDriver;
        data["WagonTypePretty"] = this.wagonTypePretty;
        data["UnloadingMethodPretty"] = this.unloadingMethodPretty;
        return data;
    }
}

export interface IHaGeBasketLineDelivery {
    deliveryAddressId?: string | undefined;
    deliveryAddressPretty?: string | undefined;
    unloadingPoint?: string | undefined;
    deliveryPlaceDescription?: string | undefined;
    deliveryLocationId?: string | undefined;
    deliveryLocationPretty?: string | undefined;
    deliveryDate?: DeliveryDate | undefined;
    messageToDriver?: string | undefined;
    wagonTypePretty?: string | undefined;
    unloadingMethodPretty?: string | undefined;
}

export class Pickling2 implements IPickling2 {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IPickling2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): Pickling2 {
        data = typeof data === 'object' ? data : {};
        let result = new Pickling2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Text"] = this.text;
        return data;
    }
}

export interface IPickling2 {
    code?: string | undefined;
    text?: string | undefined;
}

export class BasketLineDisplay implements IBasketLineDisplay {
    name?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlAndroid?: string | undefined;
    imageUrlIos?: string | undefined;
    prettyUnit?: string | undefined;
    link?: string | undefined;
    variantValue?: string | undefined;

    constructor(data?: IBasketLineDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.imageUrl = _data["ImageUrl"];
            this.imageUrlAndroid = _data["ImageUrlAndroid"];
            this.imageUrlIos = _data["ImageUrlIos"];
            this.prettyUnit = _data["PrettyUnit"];
            this.link = _data["Link"];
            this.variantValue = _data["VariantValue"];
        }
    }

    static fromJS(data: any): BasketLineDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new BasketLineDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["ImageUrl"] = this.imageUrl;
        data["ImageUrlAndroid"] = this.imageUrlAndroid;
        data["ImageUrlIos"] = this.imageUrlIos;
        data["PrettyUnit"] = this.prettyUnit;
        data["Link"] = this.link;
        data["VariantValue"] = this.variantValue;
        return data;
    }
}

export interface IBasketLineDisplay {
    name?: string | undefined;
    imageUrl?: string | undefined;
    imageUrlAndroid?: string | undefined;
    imageUrlIos?: string | undefined;
    prettyUnit?: string | undefined;
    link?: string | undefined;
    variantValue?: string | undefined;
}

export class PriceModifier implements IPriceModifier {
    readonly key?: PriceModifierKey | undefined;
    readonly value?: number | undefined;

    constructor(data?: IPriceModifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).key = _data["Key"];
            (<any>this).value = _data["Value"];
        }
    }

    static fromJS(data: any): PriceModifier {
        data = typeof data === 'object' ? data : {};
        let result = new PriceModifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        data["Value"] = this.value;
        return data;
    }
}

export interface IPriceModifier {
    key?: PriceModifierKey | undefined;
    value?: number | undefined;
}

export class DeliveryDate implements IDeliveryDate {
    readonly earliestDate?: Date | undefined;
    readonly latestDate?: Date | undefined;
    readonly isPreviousDayOk?: boolean | undefined;
    readonly isExpressDeliveryDate?: boolean | undefined;

    constructor(data?: IDeliveryDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).earliestDate = _data["EarliestDate"] ? new Date(_data["EarliestDate"].toString()) : <any>undefined;
            (<any>this).latestDate = _data["LatestDate"] ? new Date(_data["LatestDate"].toString()) : <any>undefined;
            (<any>this).isPreviousDayOk = _data["IsPreviousDayOk"];
            (<any>this).isExpressDeliveryDate = _data["IsExpressDeliveryDate"];
        }
    }

    static fromJS(data: any): DeliveryDate {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EarliestDate"] = this.earliestDate ? this.earliestDate.toISOString() : <any>undefined;
        data["LatestDate"] = this.latestDate ? this.latestDate.toISOString() : <any>undefined;
        data["IsPreviousDayOk"] = this.isPreviousDayOk;
        data["IsExpressDeliveryDate"] = this.isExpressDeliveryDate;
        return data;
    }
}

export interface IDeliveryDate {
    earliestDate?: Date | undefined;
    latestDate?: Date | undefined;
    isPreviousDayOk?: boolean | undefined;
    isExpressDeliveryDate?: boolean | undefined;
}

export class AddContractProductModel implements IAddContractProductModel {
    lineId?: string | undefined;
    contractId?: string | undefined;
    positionId?: string | undefined;
    addressId?: string | undefined;
    locations?: AddProductModelDeliveryLocation[] | undefined;
    deliveryDate?: AddProductModelDeliveryDate | undefined;
    message?: string | undefined;

    constructor(data?: IAddContractProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["LineId"];
            this.contractId = _data["ContractId"];
            this.positionId = _data["PositionId"];
            this.addressId = _data["AddressId"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(AddProductModelDeliveryLocation.fromJS(item));
            }
            this.deliveryDate = _data["DeliveryDate"] ? AddProductModelDeliveryDate.fromJS(_data["DeliveryDate"]) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): AddContractProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddContractProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineId"] = this.lineId;
        data["ContractId"] = this.contractId;
        data["PositionId"] = this.positionId;
        data["AddressId"] = this.addressId;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : <any>undefined;
        data["Message"] = this.message;
        return data;
    }
}

export interface IAddContractProductModel {
    lineId?: string | undefined;
    contractId?: string | undefined;
    positionId?: string | undefined;
    addressId?: string | undefined;
    locations?: AddProductModelDeliveryLocation[] | undefined;
    deliveryDate?: AddProductModelDeliveryDate | undefined;
    message?: string | undefined;
}

export class AddProductModelDeliveryLocation implements IAddProductModelDeliveryLocation {
    locationId?: string | undefined;
    unloadingMethodId?: string | undefined;
    wagonTypeId?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IAddProductModelDeliveryLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationId = _data["LocationId"];
            this.unloadingMethodId = _data["UnloadingMethodId"];
            this.wagonTypeId = _data["WagonTypeId"];
            this.quantity = _data["Quantity"];
        }
    }

    static fromJS(data: any): AddProductModelDeliveryLocation {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductModelDeliveryLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LocationId"] = this.locationId;
        data["UnloadingMethodId"] = this.unloadingMethodId;
        data["WagonTypeId"] = this.wagonTypeId;
        data["Quantity"] = this.quantity;
        return data;
    }
}

export interface IAddProductModelDeliveryLocation {
    locationId?: string | undefined;
    unloadingMethodId?: string | undefined;
    wagonTypeId?: string | undefined;
    quantity?: number | undefined;
}

export class AddProductModelDeliveryDate implements IAddProductModelDeliveryDate {
    earliestDate?: Date | undefined;
    latestDate?: Date | undefined;
    isPreviousDayOk?: boolean | undefined;
    /** DCC Express Fee 
If this is not used on app "IsExpressDeliveryDate" shouldbe renamed to something like isExpressFee or isDCCExpress */
    isExpressDeliveryDate?: boolean | undefined;

    constructor(data?: IAddProductModelDeliveryDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.earliestDate = _data["EarliestDate"] ? new Date(_data["EarliestDate"].toString()) : <any>undefined;
            this.latestDate = _data["LatestDate"] ? new Date(_data["LatestDate"].toString()) : <any>undefined;
            this.isPreviousDayOk = _data["IsPreviousDayOk"];
            this.isExpressDeliveryDate = _data["IsExpressDeliveryDate"];
        }
    }

    static fromJS(data: any): AddProductModelDeliveryDate {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductModelDeliveryDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EarliestDate"] = this.earliestDate ? this.earliestDate.toISOString() : <any>undefined;
        data["LatestDate"] = this.latestDate ? this.latestDate.toISOString() : <any>undefined;
        data["IsPreviousDayOk"] = this.isPreviousDayOk;
        data["IsExpressDeliveryDate"] = this.isExpressDeliveryDate;
        return data;
    }
}

export interface IAddProductModelDeliveryDate {
    earliestDate?: Date | undefined;
    latestDate?: Date | undefined;
    isPreviousDayOk?: boolean | undefined;
    /** DCC Express Fee 
If this is not used on app "IsExpressDeliveryDate" shouldbe renamed to something like isExpressFee or isDCCExpress */
    isExpressDeliveryDate?: boolean | undefined;
}

export class AddCatalogProductModel implements IAddCatalogProductModel {
    lineId?: string | undefined;
    sku?: string | undefined;
    addressId?: string | undefined;
    locations?: AddProductModelDeliveryLocation[] | undefined;
    deliveryDate?: AddProductModelDeliveryDate | undefined;
    message?: string | undefined;
    picklings?: Pickling3[] | undefined;
    containerVolume?: string | undefined;
    grain?: number | undefined;
    surface?: number | undefined;

    constructor(data?: IAddCatalogProductModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["LineId"];
            this.sku = _data["Sku"];
            this.addressId = _data["AddressId"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(AddProductModelDeliveryLocation.fromJS(item));
            }
            this.deliveryDate = _data["DeliveryDate"] ? AddProductModelDeliveryDate.fromJS(_data["DeliveryDate"]) : <any>undefined;
            this.message = _data["Message"];
            if (Array.isArray(_data["Picklings"])) {
                this.picklings = [] as any;
                for (let item of _data["Picklings"])
                    this.picklings!.push(Pickling3.fromJS(item));
            }
            this.containerVolume = _data["ContainerVolume"];
            this.grain = _data["Grain"];
            this.surface = _data["Surface"];
        }
    }

    static fromJS(data: any): AddCatalogProductModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCatalogProductModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LineId"] = this.lineId;
        data["Sku"] = this.sku;
        data["AddressId"] = this.addressId;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : <any>undefined;
        data["Message"] = this.message;
        if (Array.isArray(this.picklings)) {
            data["Picklings"] = [];
            for (let item of this.picklings)
                data["Picklings"].push(item.toJSON());
        }
        data["ContainerVolume"] = this.containerVolume;
        data["Grain"] = this.grain;
        data["Surface"] = this.surface;
        return data;
    }
}

export interface IAddCatalogProductModel {
    lineId?: string | undefined;
    sku?: string | undefined;
    addressId?: string | undefined;
    locations?: AddProductModelDeliveryLocation[] | undefined;
    deliveryDate?: AddProductModelDeliveryDate | undefined;
    message?: string | undefined;
    picklings?: Pickling3[] | undefined;
    containerVolume?: string | undefined;
    grain?: number | undefined;
    surface?: number | undefined;
}

export class Pickling3 implements IPickling3 {
    code?: string | undefined;
    text?: string | undefined;

    constructor(data?: IPickling3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["Code"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): Pickling3 {
        data = typeof data === 'object' ? data : {};
        let result = new Pickling3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.code;
        data["Text"] = this.text;
        return data;
    }
}

export interface IPickling3 {
    code?: string | undefined;
    text?: string | undefined;
}

export class HaGeControllerResultOfKPSentResult implements IHaGeControllerResultOfKPSentResult {
    readonly result?: KPSentResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IHaGeControllerResultOfKPSentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? KPSentResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): HaGeControllerResultOfKPSentResult {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeControllerResultOfKPSentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IHaGeControllerResultOfKPSentResult {
    result?: KPSentResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class KPSentResult implements IKPSentResult {
    kpOrderResult?: KPOrderResult[] | undefined;
    sitecoreOrderNr?: string | undefined;

    constructor(data?: IKPSentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["KpOrderResult"])) {
                this.kpOrderResult = [] as any;
                for (let item of _data["KpOrderResult"])
                    this.kpOrderResult!.push(KPOrderResult.fromJS(item));
            }
            this.sitecoreOrderNr = _data["SitecoreOrderNr"];
        }
    }

    static fromJS(data: any): KPSentResult {
        data = typeof data === 'object' ? data : {};
        let result = new KPSentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpOrderResult)) {
            data["KpOrderResult"] = [];
            for (let item of this.kpOrderResult)
                data["KpOrderResult"].push(item.toJSON());
        }
        data["SitecoreOrderNr"] = this.sitecoreOrderNr;
        return data;
    }
}

export interface IKPSentResult {
    kpOrderResult?: KPOrderResult[] | undefined;
    sitecoreOrderNr?: string | undefined;
}

export class KPOrderResult implements IKPOrderResult {
    orderNumber?: string | undefined;
    accountId?: string | undefined;
    skuList?: string[] | undefined;
    splitOrder?: boolean | undefined;

    constructor(data?: IKPOrderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["OrderNumber"];
            this.accountId = _data["AccountId"];
            if (Array.isArray(_data["SkuList"])) {
                this.skuList = [] as any;
                for (let item of _data["SkuList"])
                    this.skuList!.push(item);
            }
            this.splitOrder = _data["splitOrder"];
        }
    }

    static fromJS(data: any): KPOrderResult {
        data = typeof data === 'object' ? data : {};
        let result = new KPOrderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OrderNumber"] = this.orderNumber;
        data["AccountId"] = this.accountId;
        if (Array.isArray(this.skuList)) {
            data["SkuList"] = [];
            for (let item of this.skuList)
                data["SkuList"].push(item);
        }
        data["splitOrder"] = this.splitOrder;
        return data;
    }
}

export interface IKPOrderResult {
    orderNumber?: string | undefined;
    accountId?: string | undefined;
    skuList?: string[] | undefined;
    splitOrder?: boolean | undefined;
}

export class HaGeControllerResultOfBoolean implements IHaGeControllerResultOfBoolean {
    readonly result?: boolean | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IHaGeControllerResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"];
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): HaGeControllerResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeControllerResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IHaGeControllerResultOfBoolean {
    result?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class V2ControllerResultOfBoolean implements IV2ControllerResultOfBoolean {
    readonly result?: boolean | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"];
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfBoolean {
    result?: boolean | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class ReutersQuoteItem implements IReutersQuoteItem {
    quoteName?: string | undefined;
    quoteNameType?: string | undefined;
    closeMonthNumber?: number | undefined;
    closeYear?: number | undefined;
    expireDate?: Date | undefined;
    currentCloseValue?: number | undefined;
    lastCloseValue?: number | undefined;
    percentChange?: number | undefined;
    change?: number | undefined;
    currencyCode?: string | undefined;

    constructor(data?: IReutersQuoteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteName = _data["QuoteName"];
            this.quoteNameType = _data["QuoteNameType"];
            this.closeMonthNumber = _data["CloseMonthNumber"];
            this.closeYear = _data["CloseYear"];
            this.expireDate = _data["ExpireDate"] ? new Date(_data["ExpireDate"].toString()) : <any>undefined;
            this.currentCloseValue = _data["CurrentCloseValue"];
            this.lastCloseValue = _data["LastCloseValue"];
            this.percentChange = _data["PercentChange"];
            this.change = _data["Change"];
            this.currencyCode = _data["CurrencyCode"];
        }
    }

    static fromJS(data: any): ReutersQuoteItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReutersQuoteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuoteName"] = this.quoteName;
        data["QuoteNameType"] = this.quoteNameType;
        data["CloseMonthNumber"] = this.closeMonthNumber;
        data["CloseYear"] = this.closeYear;
        data["ExpireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["CurrentCloseValue"] = this.currentCloseValue;
        data["LastCloseValue"] = this.lastCloseValue;
        data["PercentChange"] = this.percentChange;
        data["Change"] = this.change;
        data["CurrencyCode"] = this.currencyCode;
        return data;
    }
}

export interface IReutersQuoteItem {
    quoteName?: string | undefined;
    quoteNameType?: string | undefined;
    closeMonthNumber?: number | undefined;
    closeYear?: number | undefined;
    expireDate?: Date | undefined;
    currentCloseValue?: number | undefined;
    lastCloseValue?: number | undefined;
    percentChange?: number | undefined;
    change?: number | undefined;
    currencyCode?: string | undefined;
}

export class ReutersTimeSeriesData implements IReutersTimeSeriesData {
    symbol?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    dataPoints?: ReutersTimeSeriesDataPoint[] | undefined;

    constructor(data?: IReutersTimeSeriesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["Symbol"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["DataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["DataPoints"])
                    this.dataPoints!.push(ReutersTimeSeriesDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReutersTimeSeriesData {
        data = typeof data === 'object' ? data : {};
        let result = new ReutersTimeSeriesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Symbol"] = this.symbol;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.dataPoints)) {
            data["DataPoints"] = [];
            for (let item of this.dataPoints)
                data["DataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReutersTimeSeriesData {
    symbol?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    dataPoints?: ReutersTimeSeriesDataPoint[] | undefined;
}

export class ReutersTimeSeriesDataPoint implements IReutersTimeSeriesDataPoint {
    date?: Date | undefined;
    open?: number | undefined;
    close?: number | undefined;
    low?: number | undefined;
    high?: number | undefined;

    constructor(data?: IReutersTimeSeriesDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.open = _data["Open"];
            this.close = _data["Close"];
            this.low = _data["Low"];
            this.high = _data["High"];
        }
    }

    static fromJS(data: any): ReutersTimeSeriesDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ReutersTimeSeriesDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Open"] = this.open;
        data["Close"] = this.close;
        data["Low"] = this.low;
        data["High"] = this.high;
        return data;
    }
}

export interface IReutersTimeSeriesDataPoint {
    date?: Date | undefined;
    open?: number | undefined;
    close?: number | undefined;
    low?: number | undefined;
    high?: number | undefined;
}

export class SearchQuery implements ISearchQuery {
    contextId?: string | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sort?: string | undefined;
    text?: string | undefined;
    facets?: SearchFacet[] | undefined;
    priceFrom?: number | undefined;
    priceTo?: number | undefined;

    constructor(data?: ISearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contextId = _data["ContextId"];
            this.pageNumber = _data["PageNumber"];
            this.pageSize = _data["PageSize"];
            this.sort = _data["Sort"];
            this.text = _data["Text"];
            if (Array.isArray(_data["Facets"])) {
                this.facets = [] as any;
                for (let item of _data["Facets"])
                    this.facets!.push(SearchFacet.fromJS(item));
            }
            this.priceFrom = _data["PriceFrom"];
            this.priceTo = _data["PriceTo"];
        }
    }

    static fromJS(data: any): SearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContextId"] = this.contextId;
        data["PageNumber"] = this.pageNumber;
        data["PageSize"] = this.pageSize;
        data["Sort"] = this.sort;
        data["Text"] = this.text;
        if (Array.isArray(this.facets)) {
            data["Facets"] = [];
            for (let item of this.facets)
                data["Facets"].push(item.toJSON());
        }
        data["PriceFrom"] = this.priceFrom;
        data["PriceTo"] = this.priceTo;
        return data;
    }
}

export interface ISearchQuery {
    contextId?: string | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    sort?: string | undefined;
    text?: string | undefined;
    facets?: SearchFacet[] | undefined;
    priceFrom?: number | undefined;
    priceTo?: number | undefined;
}

export class DocumentHitId implements IDocumentHitId {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;

    constructor(data?: IDocumentHitId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTimestamp = _data["SearchTimestamp"];
            this.hitToken = _data["HitToken"];
            this.origin = _data["Origin"];
            this.reportName = _data["ReportName"];
            this.reportVersion = _data["ReportVersion"];
            this.fullLength = _data["FullLength"];
            this.compressedLength = _data["CompressedLength"];
            this.displacement = _data["Displacement"];
            this.postingDateTime = _data["PostingDateTime"];
            this.dataTable = _data["DataTable"];
            this.documentId = _data["DocumentId"];
            this.type = _data["Type"];
            this.documentNumber = _data["DocumentNumber"];
        }
    }

    static fromJS(data: any): DocumentHitId {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentHitId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SearchTimestamp"] = this.searchTimestamp;
        data["HitToken"] = this.hitToken;
        data["Origin"] = this.origin;
        data["ReportName"] = this.reportName;
        data["ReportVersion"] = this.reportVersion;
        data["FullLength"] = this.fullLength;
        data["CompressedLength"] = this.compressedLength;
        data["Displacement"] = this.displacement;
        data["PostingDateTime"] = this.postingDateTime;
        data["DataTable"] = this.dataTable;
        data["DocumentId"] = this.documentId;
        data["Type"] = this.type;
        data["DocumentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IDocumentHitId {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;
}

export class CropPreanalysis implements ICropPreanalysis {
    materialName?: string | undefined;
    materialNumber?: string | undefined;
    contractNumber?: string | undefined;
    positionsNumber?: string | undefined;
    batches?: CropPreanalysisBatch[] | undefined;

    constructor(data?: ICropPreanalysis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialName = _data["MaterialName"];
            this.materialNumber = _data["MaterialNumber"];
            this.contractNumber = _data["ContractNumber"];
            this.positionsNumber = _data["PositionsNumber"];
            if (Array.isArray(_data["Batches"])) {
                this.batches = [] as any;
                for (let item of _data["Batches"])
                    this.batches!.push(CropPreanalysisBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropPreanalysis {
        data = typeof data === 'object' ? data : {};
        let result = new CropPreanalysis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MaterialName"] = this.materialName;
        data["MaterialNumber"] = this.materialNumber;
        data["ContractNumber"] = this.contractNumber;
        data["PositionsNumber"] = this.positionsNumber;
        if (Array.isArray(this.batches)) {
            data["Batches"] = [];
            for (let item of this.batches)
                data["Batches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropPreanalysis {
    materialName?: string | undefined;
    materialNumber?: string | undefined;
    contractNumber?: string | undefined;
    positionsNumber?: string | undefined;
    batches?: CropPreanalysisBatch[] | undefined;
}

export class CropPreanalysisBatch implements ICropPreanalysisBatch {
    batchId?: string | undefined;
    inspectionLot?: CropPreanalysisInspectionLot[] | undefined;

    constructor(data?: ICropPreanalysisBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchId = _data["BatchId"];
            if (Array.isArray(_data["InspectionLot"])) {
                this.inspectionLot = [] as any;
                for (let item of _data["InspectionLot"])
                    this.inspectionLot!.push(CropPreanalysisInspectionLot.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropPreanalysisBatch {
        data = typeof data === 'object' ? data : {};
        let result = new CropPreanalysisBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BatchId"] = this.batchId;
        if (Array.isArray(this.inspectionLot)) {
            data["InspectionLot"] = [];
            for (let item of this.inspectionLot)
                data["InspectionLot"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropPreanalysisBatch {
    batchId?: string | undefined;
    inspectionLot?: CropPreanalysisInspectionLot[] | undefined;
}

export class CropPreanalysisInspectionLot implements ICropPreanalysisInspectionLot {
    number?: string | undefined;
    date?: Date | undefined;
    quantity?: string | undefined;
    decimalQuantity?: number | undefined;
    shortText?: string | undefined;
    characteristics?: CropPreanalysisCharacteristic[] | undefined;

    constructor(data?: ICropPreanalysisInspectionLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.quantity = _data["Quantity"];
            this.decimalQuantity = _data["DecimalQuantity"];
            this.shortText = _data["ShortText"];
            if (Array.isArray(_data["Characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["Characteristics"])
                    this.characteristics!.push(CropPreanalysisCharacteristic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropPreanalysisInspectionLot {
        data = typeof data === 'object' ? data : {};
        let result = new CropPreanalysisInspectionLot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Quantity"] = this.quantity;
        data["DecimalQuantity"] = this.decimalQuantity;
        data["ShortText"] = this.shortText;
        if (Array.isArray(this.characteristics)) {
            data["Characteristics"] = [];
            for (let item of this.characteristics)
                data["Characteristics"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropPreanalysisInspectionLot {
    number?: string | undefined;
    date?: Date | undefined;
    quantity?: string | undefined;
    decimalQuantity?: number | undefined;
    shortText?: string | undefined;
    characteristics?: CropPreanalysisCharacteristic[] | undefined;
}

export class CropPreanalysisCharacteristic implements ICropPreanalysisCharacteristic {
    characteristicNumber?: string | undefined;
    characteristicName?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;

    constructor(data?: ICropPreanalysisCharacteristic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicNumber = _data["CharacteristicNumber"];
            this.characteristicName = _data["CharacteristicName"];
            this.value = _data["Value"];
            this.unit = _data["Unit"];
        }
    }

    static fromJS(data: any): CropPreanalysisCharacteristic {
        data = typeof data === 'object' ? data : {};
        let result = new CropPreanalysisCharacteristic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CharacteristicNumber"] = this.characteristicNumber;
        data["CharacteristicName"] = this.characteristicName;
        data["Value"] = this.value;
        data["Unit"] = this.unit;
        return data;
    }
}

export interface ICropPreanalysisCharacteristic {
    characteristicNumber?: string | undefined;
    characteristicName?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;
}

export class CropGraph implements ICropGraph {
    graphdata?: CropGraphItem[] | undefined;
    minFutureYAxes?: number | undefined;
    maxFutureYAxes?: number | undefined;
    minMarketYAxes?: number | undefined;
    maxMarketYAxes?: number | undefined;

    constructor(data?: ICropGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Graphdata"])) {
                this.graphdata = [] as any;
                for (let item of _data["Graphdata"])
                    this.graphdata!.push(CropGraphItem.fromJS(item));
            }
            this.minFutureYAxes = _data["MinFutureYAxes"];
            this.maxFutureYAxes = _data["MaxFutureYAxes"];
            this.minMarketYAxes = _data["MinMarketYAxes"];
            this.maxMarketYAxes = _data["MaxMarketYAxes"];
        }
    }

    static fromJS(data: any): CropGraph {
        data = typeof data === 'object' ? data : {};
        let result = new CropGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.graphdata)) {
            data["Graphdata"] = [];
            for (let item of this.graphdata)
                data["Graphdata"].push(item.toJSON());
        }
        data["MinFutureYAxes"] = this.minFutureYAxes;
        data["MaxFutureYAxes"] = this.maxFutureYAxes;
        data["MinMarketYAxes"] = this.minMarketYAxes;
        data["MaxMarketYAxes"] = this.maxMarketYAxes;
        return data;
    }
}

export interface ICropGraph {
    graphdata?: CropGraphItem[] | undefined;
    minFutureYAxes?: number | undefined;
    maxFutureYAxes?: number | undefined;
    minMarketYAxes?: number | undefined;
    maxMarketYAxes?: number | undefined;
}

export class CropGraphItem implements ICropGraphItem {
    material?: string | undefined;
    calday?: string | undefined;
    future?: string | undefined;
    market?: string | undefined;

    constructor(data?: ICropGraphItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.material = _data["Material"];
            this.calday = _data["Calday"];
            this.future = _data["Future"];
            this.market = _data["Market"];
        }
    }

    static fromJS(data: any): CropGraphItem {
        data = typeof data === 'object' ? data : {};
        let result = new CropGraphItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Material"] = this.material;
        data["Calday"] = this.calday;
        data["Future"] = this.future;
        data["Market"] = this.market;
        return data;
    }
}

export interface ICropGraphItem {
    material?: string | undefined;
    calday?: string | undefined;
    future?: string | undefined;
    market?: string | undefined;
}

export class CropOverviewOld implements ICropOverviewOld {
    contracts?: CropOverviewContract[] | undefined;

    constructor(data?: ICropOverviewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["Contracts"])
                    this.contracts!.push(CropOverviewContract.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewOld {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contracts)) {
            data["Contracts"] = [];
            for (let item of this.contracts)
                data["Contracts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewOld {
    contracts?: CropOverviewContract[] | undefined;
}

export class CropOverviewContract implements ICropOverviewContract {
    contractId?: string | undefined;
    contractType?: string | undefined;
    positions?: CropOverviewPosition[] | undefined;

    constructor(data?: ICropOverviewContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["ContractId"];
            this.contractType = _data["ContractType"];
            if (Array.isArray(_data["Positions"])) {
                this.positions = [] as any;
                for (let item of _data["Positions"])
                    this.positions!.push(CropOverviewPosition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewContract {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContractId"] = this.contractId;
        data["ContractType"] = this.contractType;
        if (Array.isArray(this.positions)) {
            data["Positions"] = [];
            for (let item of this.positions)
                data["Positions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewContract {
    contractId?: string | undefined;
    contractType?: string | undefined;
    positions?: CropOverviewPosition[] | undefined;
}

export class CropOverviewPosition implements ICropOverviewPosition {
    positionNumber?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    amount?: string | undefined;
    residualQuantity?: string | undefined;
    endDate?: string | undefined;
    pricedLines?: CropOverViewDataLine[] | undefined;
    unpriced?: CropOverViewDataLine | undefined;
    depositedCommodityLines?: CropOverViewDataLine[] | undefined;
    depositedForLaterLines?: CropOverViewDataLine[] | undefined;
    preCreditedLines?: CropOverViewDataLine[] | undefined;
    freightRates?: FreightRate[] | undefined;

    constructor(data?: ICropOverviewPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionNumber = _data["PositionNumber"];
            this.productId = _data["ProductId"];
            this.productName = _data["ProductName"];
            this.amount = _data["Amount"];
            this.residualQuantity = _data["ResidualQuantity"];
            this.endDate = _data["EndDate"];
            if (Array.isArray(_data["PricedLines"])) {
                this.pricedLines = [] as any;
                for (let item of _data["PricedLines"])
                    this.pricedLines!.push(CropOverViewDataLine.fromJS(item));
            }
            this.unpriced = _data["Unpriced"] ? CropOverViewDataLine.fromJS(_data["Unpriced"]) : <any>undefined;
            if (Array.isArray(_data["DepositedCommodityLines"])) {
                this.depositedCommodityLines = [] as any;
                for (let item of _data["DepositedCommodityLines"])
                    this.depositedCommodityLines!.push(CropOverViewDataLine.fromJS(item));
            }
            if (Array.isArray(_data["DepositedForLaterLines"])) {
                this.depositedForLaterLines = [] as any;
                for (let item of _data["DepositedForLaterLines"])
                    this.depositedForLaterLines!.push(CropOverViewDataLine.fromJS(item));
            }
            if (Array.isArray(_data["PreCreditedLines"])) {
                this.preCreditedLines = [] as any;
                for (let item of _data["PreCreditedLines"])
                    this.preCreditedLines!.push(CropOverViewDataLine.fromJS(item));
            }
            if (Array.isArray(_data["FreightRates"])) {
                this.freightRates = [] as any;
                for (let item of _data["FreightRates"])
                    this.freightRates!.push(FreightRate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewPosition {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PositionNumber"] = this.positionNumber;
        data["ProductId"] = this.productId;
        data["ProductName"] = this.productName;
        data["Amount"] = this.amount;
        data["ResidualQuantity"] = this.residualQuantity;
        data["EndDate"] = this.endDate;
        if (Array.isArray(this.pricedLines)) {
            data["PricedLines"] = [];
            for (let item of this.pricedLines)
                data["PricedLines"].push(item.toJSON());
        }
        data["Unpriced"] = this.unpriced ? this.unpriced.toJSON() : <any>undefined;
        if (Array.isArray(this.depositedCommodityLines)) {
            data["DepositedCommodityLines"] = [];
            for (let item of this.depositedCommodityLines)
                data["DepositedCommodityLines"].push(item.toJSON());
        }
        if (Array.isArray(this.depositedForLaterLines)) {
            data["DepositedForLaterLines"] = [];
            for (let item of this.depositedForLaterLines)
                data["DepositedForLaterLines"].push(item.toJSON());
        }
        if (Array.isArray(this.preCreditedLines)) {
            data["PreCreditedLines"] = [];
            for (let item of this.preCreditedLines)
                data["PreCreditedLines"].push(item.toJSON());
        }
        if (Array.isArray(this.freightRates)) {
            data["FreightRates"] = [];
            for (let item of this.freightRates)
                data["FreightRates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewPosition {
    positionNumber?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    amount?: string | undefined;
    residualQuantity?: string | undefined;
    endDate?: string | undefined;
    pricedLines?: CropOverViewDataLine[] | undefined;
    unpriced?: CropOverViewDataLine | undefined;
    depositedCommodityLines?: CropOverViewDataLine[] | undefined;
    depositedForLaterLines?: CropOverViewDataLine[] | undefined;
    preCreditedLines?: CropOverViewDataLine[] | undefined;
    freightRates?: FreightRate[] | undefined;
}

export class CropOverViewDataLine implements ICropOverViewDataLine {
    title?: string | undefined;
    amount?: string | undefined;
    netPrice?: string | undefined;
    typeSupplement?: string | undefined;
    consumerSupplement?: string | undefined;
    matif?: string | undefined;
    settlementDate?: string | undefined;
    totalPrice?: string | undefined;
    alternatePrice?: string | undefined;
    future?: string | undefined;

    constructor(data?: ICropOverViewDataLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.amount = _data["Amount"];
            this.netPrice = _data["NetPrice"];
            this.typeSupplement = _data["TypeSupplement"];
            this.consumerSupplement = _data["ConsumerSupplement"];
            this.matif = _data["Matif"];
            this.settlementDate = _data["SettlementDate"];
            this.totalPrice = _data["TotalPrice"];
            this.alternatePrice = _data["AlternatePrice"];
            this.future = _data["Future"];
        }
    }

    static fromJS(data: any): CropOverViewDataLine {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverViewDataLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Amount"] = this.amount;
        data["NetPrice"] = this.netPrice;
        data["TypeSupplement"] = this.typeSupplement;
        data["ConsumerSupplement"] = this.consumerSupplement;
        data["Matif"] = this.matif;
        data["SettlementDate"] = this.settlementDate;
        data["TotalPrice"] = this.totalPrice;
        data["AlternatePrice"] = this.alternatePrice;
        data["Future"] = this.future;
        return data;
    }
}

export interface ICropOverViewDataLine {
    title?: string | undefined;
    amount?: string | undefined;
    netPrice?: string | undefined;
    typeSupplement?: string | undefined;
    consumerSupplement?: string | undefined;
    matif?: string | undefined;
    settlementDate?: string | undefined;
    totalPrice?: string | undefined;
    alternatePrice?: string | undefined;
    future?: string | undefined;
}

export class FreightRate implements IFreightRate {
    title?: string | undefined;
    value?: string | undefined;

    constructor(data?: IFreightRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): FreightRate {
        data = typeof data === 'object' ? data : {};
        let result = new FreightRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Value"] = this.value;
        return data;
    }
}

export interface IFreightRate {
    title?: string | undefined;
    value?: string | undefined;
}

export class CropOverview implements ICropOverview {
    accountnumber?: number | undefined;
    years?: CropOverviewYear[] | undefined;
    farmGoods?: CropOverviewFarmGoods | undefined;
    weighedIn?: WeighedIn[] | undefined;
    phone?: string | undefined;

    constructor(data?: ICropOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountnumber = _data["accountnumber"];
            if (Array.isArray(_data["Years"])) {
                this.years = [] as any;
                for (let item of _data["Years"])
                    this.years!.push(CropOverviewYear.fromJS(item));
            }
            this.farmGoods = _data["FarmGoods"] ? CropOverviewFarmGoods.fromJS(_data["FarmGoods"]) : <any>undefined;
            if (Array.isArray(_data["WeighedIn"])) {
                this.weighedIn = [] as any;
                for (let item of _data["WeighedIn"])
                    this.weighedIn!.push(WeighedIn.fromJS(item));
            }
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): CropOverview {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountnumber"] = this.accountnumber;
        if (Array.isArray(this.years)) {
            data["Years"] = [];
            for (let item of this.years)
                data["Years"].push(item.toJSON());
        }
        data["FarmGoods"] = this.farmGoods ? this.farmGoods.toJSON() : <any>undefined;
        if (Array.isArray(this.weighedIn)) {
            data["WeighedIn"] = [];
            for (let item of this.weighedIn)
                data["WeighedIn"].push(item.toJSON());
        }
        data["Phone"] = this.phone;
        return data;
    }
}

export interface ICropOverview {
    accountnumber?: number | undefined;
    years?: CropOverviewYear[] | undefined;
    farmGoods?: CropOverviewFarmGoods | undefined;
    weighedIn?: WeighedIn[] | undefined;
    phone?: string | undefined;
}

export class CropOverviewYear implements ICropOverviewYear {
    year?: string | undefined;
    products?: CropOverviewProduct[] | undefined;

    constructor(data?: ICropOverviewYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["Year"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CropOverviewProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewYear {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Year"] = this.year;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewYear {
    year?: string | undefined;
    products?: CropOverviewProduct[] | undefined;
}

export class CropOverviewFarmGoods implements ICropOverviewFarmGoods {
    accountNumber?: number | undefined;
    farmGoodsProductsList?: FarmGoodsProduct[] | undefined;

    constructor(data?: ICropOverviewFarmGoods) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["AccountNumber"];
            if (Array.isArray(_data["FarmGoodsProductsList"])) {
                this.farmGoodsProductsList = [] as any;
                for (let item of _data["FarmGoodsProductsList"])
                    this.farmGoodsProductsList!.push(FarmGoodsProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewFarmGoods {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewFarmGoods();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountNumber"] = this.accountNumber;
        if (Array.isArray(this.farmGoodsProductsList)) {
            data["FarmGoodsProductsList"] = [];
            for (let item of this.farmGoodsProductsList)
                data["FarmGoodsProductsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewFarmGoods {
    accountNumber?: number | undefined;
    farmGoodsProductsList?: FarmGoodsProduct[] | undefined;
}

export class WeighedIn implements IWeighedIn {
    date?: string | undefined;
    position?: string | undefined;
    deliveryPlace?: string | undefined;
    deliveryBrutto?: string | undefined;
    deliveryTara?: string | undefined;
    deliveryNetto?: string | undefined;
    contract?: string | undefined;
    cropName?: string | undefined;

    constructor(data?: IWeighedIn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.position = _data["Position"];
            this.deliveryPlace = _data["DeliveryPlace"];
            this.deliveryBrutto = _data["DeliveryBrutto"];
            this.deliveryTara = _data["DeliveryTara"];
            this.deliveryNetto = _data["DeliveryNetto"];
            this.contract = _data["Contract"];
            this.cropName = _data["CropName"];
        }
    }

    static fromJS(data: any): WeighedIn {
        data = typeof data === 'object' ? data : {};
        let result = new WeighedIn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["Position"] = this.position;
        data["DeliveryPlace"] = this.deliveryPlace;
        data["DeliveryBrutto"] = this.deliveryBrutto;
        data["DeliveryTara"] = this.deliveryTara;
        data["DeliveryNetto"] = this.deliveryNetto;
        data["Contract"] = this.contract;
        data["CropName"] = this.cropName;
        return data;
    }
}

export interface IWeighedIn {
    date?: string | undefined;
    position?: string | undefined;
    deliveryPlace?: string | undefined;
    deliveryBrutto?: string | undefined;
    deliveryTara?: string | undefined;
    deliveryNetto?: string | undefined;
    contract?: string | undefined;
    cropName?: string | undefined;
}

export class CropOverviewProduct implements ICropOverviewProduct {
    productId?: string | undefined;
    productName?: string | undefined;
    positions?: CropOverviewContractPosition[] | undefined;
    productWithoutContract?: ProductWithoutContract | undefined;

    constructor(data?: ICropOverviewProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["ProductId"];
            this.productName = _data["ProductName"];
            if (Array.isArray(_data["Positions"])) {
                this.positions = [] as any;
                for (let item of _data["Positions"])
                    this.positions!.push(CropOverviewContractPosition.fromJS(item));
            }
            this.productWithoutContract = _data["ProductWithoutContract"] ? ProductWithoutContract.fromJS(_data["ProductWithoutContract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CropOverviewProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductId"] = this.productId;
        data["ProductName"] = this.productName;
        if (Array.isArray(this.positions)) {
            data["Positions"] = [];
            for (let item of this.positions)
                data["Positions"].push(item.toJSON());
        }
        data["ProductWithoutContract"] = this.productWithoutContract ? this.productWithoutContract.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICropOverviewProduct {
    productId?: string | undefined;
    productName?: string | undefined;
    positions?: CropOverviewContractPosition[] | undefined;
    productWithoutContract?: ProductWithoutContract | undefined;
}

export class FarmGoodsProduct implements IFarmGoodsProduct {
    accountNumber?: number | undefined;
    productSku?: string | undefined;
    productName?: string | undefined;
    farmGoodsBatchList?: FarmGoodsBatch[] | undefined;

    constructor(data?: IFarmGoodsProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNumber = _data["AccountNumber"];
            this.productSku = _data["ProductSku"];
            this.productName = _data["ProductName"];
            if (Array.isArray(_data["FarmGoodsBatchList"])) {
                this.farmGoodsBatchList = [] as any;
                for (let item of _data["FarmGoodsBatchList"])
                    this.farmGoodsBatchList!.push(FarmGoodsBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FarmGoodsProduct {
        data = typeof data === 'object' ? data : {};
        let result = new FarmGoodsProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AccountNumber"] = this.accountNumber;
        data["ProductSku"] = this.productSku;
        data["ProductName"] = this.productName;
        if (Array.isArray(this.farmGoodsBatchList)) {
            data["FarmGoodsBatchList"] = [];
            for (let item of this.farmGoodsBatchList)
                data["FarmGoodsBatchList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFarmGoodsProduct {
    accountNumber?: number | undefined;
    productSku?: string | undefined;
    productName?: string | undefined;
    farmGoodsBatchList?: FarmGoodsBatch[] | undefined;
}

export class CropOverviewContractPosition implements ICropOverviewContractPosition {
    alternateMaterial?: string | undefined;
    isAlternateMaterial?: boolean | undefined;
    year?: string | undefined;
    place?: string | undefined;
    salesOfficeId?: string | undefined;
    salesOfficeIsSubscribed?: boolean | undefined;
    contractId?: string | undefined;
    amount?: number | undefined;
    endDate?: string | undefined;
    startDate?: string | undefined;
    positionNumber?: string | undefined;
    pricedline?: PricedLine[] | undefined;
    freightRates?: FreightRate2[] | undefined;
    preCreditedLine?: PreCreditLine[] | undefined;
    summedRawMaterial?: number | undefined;
    summedCleanMaterial?: number | undefined;
    summedSettled?: number | undefined;
    summedResidualQuantity?: number | undefined;
    downloadLink?: string | undefined;
    maltBarleyMaterial?: string | undefined;
    maltBarleyAmount?: number | undefined;
    maltBarleyMatNumber?: string | undefined;
    isPartnerContract?: boolean | undefined;

    constructor(data?: ICropOverviewContractPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alternateMaterial = _data["AlternateMaterial"];
            this.isAlternateMaterial = _data["IsAlternateMaterial"];
            this.year = _data["Year"];
            this.place = _data["Place"];
            this.salesOfficeId = _data["SalesOfficeId"];
            this.salesOfficeIsSubscribed = _data["SalesOfficeIsSubscribed"];
            this.contractId = _data["ContractId"];
            this.amount = _data["Amount"];
            this.endDate = _data["EndDate"];
            this.startDate = _data["StartDate"];
            this.positionNumber = _data["PositionNumber"];
            if (Array.isArray(_data["Pricedline"])) {
                this.pricedline = [] as any;
                for (let item of _data["Pricedline"])
                    this.pricedline!.push(PricedLine.fromJS(item));
            }
            if (Array.isArray(_data["FreightRates"])) {
                this.freightRates = [] as any;
                for (let item of _data["FreightRates"])
                    this.freightRates!.push(FreightRate2.fromJS(item));
            }
            if (Array.isArray(_data["PreCreditedLine"])) {
                this.preCreditedLine = [] as any;
                for (let item of _data["PreCreditedLine"])
                    this.preCreditedLine!.push(PreCreditLine.fromJS(item));
            }
            this.summedRawMaterial = _data["SummedRawMaterial"];
            this.summedCleanMaterial = _data["SummedCleanMaterial"];
            this.summedSettled = _data["SummedSettled"];
            this.summedResidualQuantity = _data["SummedResidualQuantity"];
            this.downloadLink = _data["DownloadLink"];
            this.maltBarleyMaterial = _data["MaltBarleyMaterial"];
            this.maltBarleyAmount = _data["MaltBarleyAmount"];
            this.maltBarleyMatNumber = _data["MaltBarleyMatNumber"];
            this.isPartnerContract = _data["IsPartnerContract"];
        }
    }

    static fromJS(data: any): CropOverviewContractPosition {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewContractPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AlternateMaterial"] = this.alternateMaterial;
        data["IsAlternateMaterial"] = this.isAlternateMaterial;
        data["Year"] = this.year;
        data["Place"] = this.place;
        data["SalesOfficeId"] = this.salesOfficeId;
        data["SalesOfficeIsSubscribed"] = this.salesOfficeIsSubscribed;
        data["ContractId"] = this.contractId;
        data["Amount"] = this.amount;
        data["EndDate"] = this.endDate;
        data["StartDate"] = this.startDate;
        data["PositionNumber"] = this.positionNumber;
        if (Array.isArray(this.pricedline)) {
            data["Pricedline"] = [];
            for (let item of this.pricedline)
                data["Pricedline"].push(item.toJSON());
        }
        if (Array.isArray(this.freightRates)) {
            data["FreightRates"] = [];
            for (let item of this.freightRates)
                data["FreightRates"].push(item.toJSON());
        }
        if (Array.isArray(this.preCreditedLine)) {
            data["PreCreditedLine"] = [];
            for (let item of this.preCreditedLine)
                data["PreCreditedLine"].push(item.toJSON());
        }
        data["SummedRawMaterial"] = this.summedRawMaterial;
        data["SummedCleanMaterial"] = this.summedCleanMaterial;
        data["SummedSettled"] = this.summedSettled;
        data["SummedResidualQuantity"] = this.summedResidualQuantity;
        data["DownloadLink"] = this.downloadLink;
        data["MaltBarleyMaterial"] = this.maltBarleyMaterial;
        data["MaltBarleyAmount"] = this.maltBarleyAmount;
        data["MaltBarleyMatNumber"] = this.maltBarleyMatNumber;
        data["IsPartnerContract"] = this.isPartnerContract;
        return data;
    }
}

export interface ICropOverviewContractPosition {
    alternateMaterial?: string | undefined;
    isAlternateMaterial?: boolean | undefined;
    year?: string | undefined;
    place?: string | undefined;
    salesOfficeId?: string | undefined;
    salesOfficeIsSubscribed?: boolean | undefined;
    contractId?: string | undefined;
    amount?: number | undefined;
    endDate?: string | undefined;
    startDate?: string | undefined;
    positionNumber?: string | undefined;
    pricedline?: PricedLine[] | undefined;
    freightRates?: FreightRate2[] | undefined;
    preCreditedLine?: PreCreditLine[] | undefined;
    summedRawMaterial?: number | undefined;
    summedCleanMaterial?: number | undefined;
    summedSettled?: number | undefined;
    summedResidualQuantity?: number | undefined;
    downloadLink?: string | undefined;
    maltBarleyMaterial?: string | undefined;
    maltBarleyAmount?: number | undefined;
    maltBarleyMatNumber?: string | undefined;
    isPartnerContract?: boolean | undefined;
}

export class ProductWithoutContract implements IProductWithoutContract {
    productName?: string | undefined;
    productId?: string | undefined;
    year?: number | undefined;
    productDocumentRows?: ProductDocumentRow[] | undefined;
    totalRaw?: number | undefined;
    totalClean?: number | undefined;
    total?: number | undefined;

    constructor(data?: IProductWithoutContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productName = _data["ProductName"];
            this.productId = _data["ProductId"];
            this.year = _data["Year"];
            if (Array.isArray(_data["ProductDocumentRows"])) {
                this.productDocumentRows = [] as any;
                for (let item of _data["ProductDocumentRows"])
                    this.productDocumentRows!.push(ProductDocumentRow.fromJS(item));
            }
            this.totalRaw = _data["TotalRaw"];
            this.totalClean = _data["TotalClean"];
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): ProductWithoutContract {
        data = typeof data === 'object' ? data : {};
        let result = new ProductWithoutContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ProductName"] = this.productName;
        data["ProductId"] = this.productId;
        data["Year"] = this.year;
        if (Array.isArray(this.productDocumentRows)) {
            data["ProductDocumentRows"] = [];
            for (let item of this.productDocumentRows)
                data["ProductDocumentRows"].push(item.toJSON());
        }
        data["TotalRaw"] = this.totalRaw;
        data["TotalClean"] = this.totalClean;
        data["Total"] = this.total;
        return data;
    }
}

export interface IProductWithoutContract {
    productName?: string | undefined;
    productId?: string | undefined;
    year?: number | undefined;
    productDocumentRows?: ProductDocumentRow[] | undefined;
    totalRaw?: number | undefined;
    totalClean?: number | undefined;
    total?: number | undefined;
}

export class FarmGoodsBatch implements IFarmGoodsBatch {
    batchNumber?: string | undefined;
    batchCreatedDate?: Date | undefined;
    sku?: string | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    productClass?: string | undefined;
    wGBEZ?: string | undefined;
    farmGoodsAnalysisList?: FarmGoodsAnalysis[] | undefined;

    constructor(data?: IFarmGoodsBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchNumber = _data["BatchNumber"];
            this.batchCreatedDate = _data["BatchCreatedDate"] ? new Date(_data["BatchCreatedDate"].toString()) : <any>undefined;
            this.sku = _data["Sku"];
            this.productName = _data["ProductName"];
            this.quantity = _data["Quantity"];
            this.productClass = _data["ProductClass"];
            this.wGBEZ = _data["WGBEZ"];
            if (Array.isArray(_data["FarmGoodsAnalysisList"])) {
                this.farmGoodsAnalysisList = [] as any;
                for (let item of _data["FarmGoodsAnalysisList"])
                    this.farmGoodsAnalysisList!.push(FarmGoodsAnalysis.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FarmGoodsBatch {
        data = typeof data === 'object' ? data : {};
        let result = new FarmGoodsBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BatchNumber"] = this.batchNumber;
        data["BatchCreatedDate"] = this.batchCreatedDate ? this.batchCreatedDate.toISOString() : <any>undefined;
        data["Sku"] = this.sku;
        data["ProductName"] = this.productName;
        data["Quantity"] = this.quantity;
        data["ProductClass"] = this.productClass;
        data["WGBEZ"] = this.wGBEZ;
        if (Array.isArray(this.farmGoodsAnalysisList)) {
            data["FarmGoodsAnalysisList"] = [];
            for (let item of this.farmGoodsAnalysisList)
                data["FarmGoodsAnalysisList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFarmGoodsBatch {
    batchNumber?: string | undefined;
    batchCreatedDate?: Date | undefined;
    sku?: string | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    productClass?: string | undefined;
    wGBEZ?: string | undefined;
    farmGoodsAnalysisList?: FarmGoodsAnalysis[] | undefined;
}

export class PricedLine implements IPricedLine {
    amount?: number | undefined;
    netPrice?: number | undefined;
    typeSupplement?: number | undefined;
    consumerSupplement?: number | undefined;
    matif?: number | undefined;
    settlementDate?: string | undefined;
    totalPrice?: number | undefined;
    alternatePrice?: number | undefined;
    premium?: number | undefined;
    contractType?: string | undefined;
    canCalculate?: boolean | undefined;

    constructor(data?: IPricedLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["Amount"];
            this.netPrice = _data["NetPrice"];
            this.typeSupplement = _data["TypeSupplement"];
            this.consumerSupplement = _data["ConsumerSupplement"];
            this.matif = _data["Matif"];
            this.settlementDate = _data["SettlementDate"];
            this.totalPrice = _data["TotalPrice"];
            this.alternatePrice = _data["AlternatePrice"];
            this.premium = _data["Premium"];
            this.contractType = _data["ContractType"];
            this.canCalculate = _data["CanCalculate"];
        }
    }

    static fromJS(data: any): PricedLine {
        data = typeof data === 'object' ? data : {};
        let result = new PricedLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Amount"] = this.amount;
        data["NetPrice"] = this.netPrice;
        data["TypeSupplement"] = this.typeSupplement;
        data["ConsumerSupplement"] = this.consumerSupplement;
        data["Matif"] = this.matif;
        data["SettlementDate"] = this.settlementDate;
        data["TotalPrice"] = this.totalPrice;
        data["AlternatePrice"] = this.alternatePrice;
        data["Premium"] = this.premium;
        data["ContractType"] = this.contractType;
        data["CanCalculate"] = this.canCalculate;
        return data;
    }
}

export interface IPricedLine {
    amount?: number | undefined;
    netPrice?: number | undefined;
    typeSupplement?: number | undefined;
    consumerSupplement?: number | undefined;
    matif?: number | undefined;
    settlementDate?: string | undefined;
    totalPrice?: number | undefined;
    alternatePrice?: number | undefined;
    premium?: number | undefined;
    contractType?: string | undefined;
    canCalculate?: boolean | undefined;
}

export class FreightRate2 implements IFreightRate2 {
    title?: string | undefined;
    value?: number | undefined;

    constructor(data?: IFreightRate2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): FreightRate2 {
        data = typeof data === 'object' ? data : {};
        let result = new FreightRate2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Value"] = this.value;
        return data;
    }
}

export interface IFreightRate2 {
    title?: string | undefined;
    value?: number | undefined;
}

export class PreCreditLine implements IPreCreditLine {
    amount?: number | undefined;
    netPrice?: number | undefined;
    totalPrice?: number | undefined;

    constructor(data?: IPreCreditLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["Amount"];
            this.netPrice = _data["NetPrice"];
            this.totalPrice = _data["TotalPrice"];
        }
    }

    static fromJS(data: any): PreCreditLine {
        data = typeof data === 'object' ? data : {};
        let result = new PreCreditLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Amount"] = this.amount;
        data["NetPrice"] = this.netPrice;
        data["TotalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IPreCreditLine {
    amount?: number | undefined;
    netPrice?: number | undefined;
    totalPrice?: number | undefined;
}

export class ProductDocumentRow implements IProductDocumentRow {
    documentId?: string | undefined;
    positionNumber?: string | undefined;
    rawProduct?: number | undefined;
    cleanedProduct?: number | undefined;
    documentDownloadIdentifierList?: string[] | undefined;
    total?: number | undefined;

    constructor(data?: IProductDocumentRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["DocumentId"];
            this.positionNumber = _data["PositionNumber"];
            this.rawProduct = _data["RawProduct"];
            this.cleanedProduct = _data["CleanedProduct"];
            if (Array.isArray(_data["DocumentDownloadIdentifierList"])) {
                this.documentDownloadIdentifierList = [] as any;
                for (let item of _data["DocumentDownloadIdentifierList"])
                    this.documentDownloadIdentifierList!.push(item);
            }
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): ProductDocumentRow {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDocumentRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentId"] = this.documentId;
        data["PositionNumber"] = this.positionNumber;
        data["RawProduct"] = this.rawProduct;
        data["CleanedProduct"] = this.cleanedProduct;
        if (Array.isArray(this.documentDownloadIdentifierList)) {
            data["DocumentDownloadIdentifierList"] = [];
            for (let item of this.documentDownloadIdentifierList)
                data["DocumentDownloadIdentifierList"].push(item);
        }
        data["Total"] = this.total;
        return data;
    }
}

export interface IProductDocumentRow {
    documentId?: string | undefined;
    positionNumber?: string | undefined;
    rawProduct?: number | undefined;
    cleanedProduct?: number | undefined;
    documentDownloadIdentifierList?: string[] | undefined;
    total?: number | undefined;
}

export class FarmGoodsAnalysis implements IFarmGoodsAnalysis {
    analysisNumber?: string | undefined;
    date?: Date | undefined;
    quantity?: number | undefined;
    shortText?: string | undefined;
    farmGoodsCharacteristicsList?: FarmGoodsCharacteristics[] | undefined;

    constructor(data?: IFarmGoodsAnalysis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.analysisNumber = _data["AnalysisNumber"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.quantity = _data["Quantity"];
            this.shortText = _data["ShortText"];
            if (Array.isArray(_data["FarmGoodsCharacteristicsList"])) {
                this.farmGoodsCharacteristicsList = [] as any;
                for (let item of _data["FarmGoodsCharacteristicsList"])
                    this.farmGoodsCharacteristicsList!.push(FarmGoodsCharacteristics.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FarmGoodsAnalysis {
        data = typeof data === 'object' ? data : {};
        let result = new FarmGoodsAnalysis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AnalysisNumber"] = this.analysisNumber;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Quantity"] = this.quantity;
        data["ShortText"] = this.shortText;
        if (Array.isArray(this.farmGoodsCharacteristicsList)) {
            data["FarmGoodsCharacteristicsList"] = [];
            for (let item of this.farmGoodsCharacteristicsList)
                data["FarmGoodsCharacteristicsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFarmGoodsAnalysis {
    analysisNumber?: string | undefined;
    date?: Date | undefined;
    quantity?: number | undefined;
    shortText?: string | undefined;
    farmGoodsCharacteristicsList?: FarmGoodsCharacteristics[] | undefined;
}

export class FarmGoodsCharacteristics implements IFarmGoodsCharacteristics {
    characteristicNumber?: string | undefined;
    characteristicText?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;

    constructor(data?: IFarmGoodsCharacteristics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicNumber = _data["CharacteristicNumber"];
            this.characteristicText = _data["CharacteristicText"];
            this.value = _data["Value"];
            this.unit = _data["Unit"];
        }
    }

    static fromJS(data: any): FarmGoodsCharacteristics {
        data = typeof data === 'object' ? data : {};
        let result = new FarmGoodsCharacteristics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CharacteristicNumber"] = this.characteristicNumber;
        data["CharacteristicText"] = this.characteristicText;
        data["Value"] = this.value;
        data["Unit"] = this.unit;
        return data;
    }
}

export interface IFarmGoodsCharacteristics {
    characteristicNumber?: string | undefined;
    characteristicText?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;
}

export class CropFutures implements ICropFutures {
    status?: string | undefined;
    contractNumber?: string | undefined;
    posNumber?: string | undefined;
    future?: number | undefined;
    premium?: number | undefined;
    closingPrice?: number | undefined;
    matifPriceDate?: string | undefined;
    mDate?: string | undefined;
    cropName?: string | undefined;
    cropSku?: string | undefined;
    salesContactPhone?: string | undefined;
    salesContactName?: string | undefined;
    errorText?: string | undefined;
    tradeClosed?: boolean | undefined;
    tradeClosing?: string | undefined;
    tradeOpen?: string | undefined;

    constructor(data?: ICropFutures) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.contractNumber = _data["contractNumber"];
            this.posNumber = _data["posNumber"];
            this.future = _data["future"];
            this.premium = _data["premium"];
            this.closingPrice = _data["closingPrice"];
            this.matifPriceDate = _data["matifPriceDate"];
            this.mDate = _data["MDate"];
            this.cropName = _data["CropName"];
            this.cropSku = _data["CropSku"];
            this.salesContactPhone = _data["SalesContactPhone"];
            this.salesContactName = _data["SalesContactName"];
            this.errorText = _data["ErrorText"];
            this.tradeClosed = _data["TradeClosed"];
            this.tradeClosing = _data["TradeClosing"];
            this.tradeOpen = _data["TradeOpen"];
        }
    }

    static fromJS(data: any): CropFutures {
        data = typeof data === 'object' ? data : {};
        let result = new CropFutures();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["contractNumber"] = this.contractNumber;
        data["posNumber"] = this.posNumber;
        data["future"] = this.future;
        data["premium"] = this.premium;
        data["closingPrice"] = this.closingPrice;
        data["matifPriceDate"] = this.matifPriceDate;
        data["MDate"] = this.mDate;
        data["CropName"] = this.cropName;
        data["CropSku"] = this.cropSku;
        data["SalesContactPhone"] = this.salesContactPhone;
        data["SalesContactName"] = this.salesContactName;
        data["ErrorText"] = this.errorText;
        data["TradeClosed"] = this.tradeClosed;
        data["TradeClosing"] = this.tradeClosing;
        data["TradeOpen"] = this.tradeOpen;
        return data;
    }
}

export interface ICropFutures {
    status?: string | undefined;
    contractNumber?: string | undefined;
    posNumber?: string | undefined;
    future?: number | undefined;
    premium?: number | undefined;
    closingPrice?: number | undefined;
    matifPriceDate?: string | undefined;
    mDate?: string | undefined;
    cropName?: string | undefined;
    cropSku?: string | undefined;
    salesContactPhone?: string | undefined;
    salesContactName?: string | undefined;
    errorText?: string | undefined;
    tradeClosed?: boolean | undefined;
    tradeClosing?: string | undefined;
    tradeOpen?: string | undefined;
}

export class CropOverviewOverlay implements ICropOverviewOverlay {
    positions?: CropOverviewContractPosition[] | undefined;
    preAnalysis?: CropPreanalysis | undefined;
    documentIdentifiers?: string[] | undefined;
    downloadLink?: string | undefined;
    phone?: string | undefined;
    weighedIns?: WeighedIn[] | undefined;

    constructor(data?: ICropOverviewOverlay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Positions"])) {
                this.positions = [] as any;
                for (let item of _data["Positions"])
                    this.positions!.push(CropOverviewContractPosition.fromJS(item));
            }
            this.preAnalysis = _data["PreAnalysis"] ? CropPreanalysis.fromJS(_data["PreAnalysis"]) : <any>undefined;
            if (Array.isArray(_data["DocumentIdentifiers"])) {
                this.documentIdentifiers = [] as any;
                for (let item of _data["DocumentIdentifiers"])
                    this.documentIdentifiers!.push(item);
            }
            this.downloadLink = _data["DownloadLink"];
            this.phone = _data["Phone"];
            if (Array.isArray(_data["WeighedIns"])) {
                this.weighedIns = [] as any;
                for (let item of _data["WeighedIns"])
                    this.weighedIns!.push(WeighedIn.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CropOverviewOverlay {
        data = typeof data === 'object' ? data : {};
        let result = new CropOverviewOverlay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.positions)) {
            data["Positions"] = [];
            for (let item of this.positions)
                data["Positions"].push(item.toJSON());
        }
        data["PreAnalysis"] = this.preAnalysis ? this.preAnalysis.toJSON() : <any>undefined;
        if (Array.isArray(this.documentIdentifiers)) {
            data["DocumentIdentifiers"] = [];
            for (let item of this.documentIdentifiers)
                data["DocumentIdentifiers"].push(item);
        }
        data["DownloadLink"] = this.downloadLink;
        data["Phone"] = this.phone;
        if (Array.isArray(this.weighedIns)) {
            data["WeighedIns"] = [];
            for (let item of this.weighedIns)
                data["WeighedIns"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICropOverviewOverlay {
    positions?: CropOverviewContractPosition[] | undefined;
    preAnalysis?: CropPreanalysis | undefined;
    documentIdentifiers?: string[] | undefined;
    downloadLink?: string | undefined;
    phone?: string | undefined;
    weighedIns?: WeighedIn[] | undefined;
}

export class DigifarmDefaultResponseOfListOfDigiAddress implements IDigifarmDefaultResponseOfListOfDigiAddress {
    result?: DigiAddress[] | undefined;
    message?: string | undefined;
    success?: boolean | undefined;
    statusCode?: DigifarmDefaultResponseOfListOfDigiAddressStatusCode | undefined;

    constructor(data?: IDigifarmDefaultResponseOfListOfDigiAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(DigiAddress.fromJS(item));
            }
            this.message = _data["Message"];
            this.success = _data["Success"];
            this.statusCode = _data["StatusCode"];
        }
    }

    static fromJS(data: any): DigifarmDefaultResponseOfListOfDigiAddress {
        data = typeof data === 'object' ? data : {};
        let result = new DigifarmDefaultResponseOfListOfDigiAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Message"] = this.message;
        data["Success"] = this.success;
        data["StatusCode"] = this.statusCode;
        return data;
    }
}

export interface IDigifarmDefaultResponseOfListOfDigiAddress {
    result?: DigiAddress[] | undefined;
    message?: string | undefined;
    success?: boolean | undefined;
    statusCode?: DigifarmDefaultResponseOfListOfDigiAddressStatusCode | undefined;
}

export class DigiAddress implements IDigiAddress {
    addressId?: string | undefined;
    dCCAddressId?: string | undefined;
    addressName?: string | undefined;
    addressName2?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    locations?: Location[] | undefined;
    primary?: boolean | undefined;
    fullAddress?: string | undefined;

    constructor(data?: IDigiAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["AddressId"];
            this.dCCAddressId = _data["DCCAddressId"];
            this.addressName = _data["AddressName"];
            this.addressName2 = _data["AddressName2"];
            this.street = _data["Street"];
            this.zipCode = _data["ZipCode"];
            this.city = _data["City"];
            if (Array.isArray(_data["Locations"])) {
                this.locations = [] as any;
                for (let item of _data["Locations"])
                    this.locations!.push(Location.fromJS(item));
            }
            this.primary = _data["Primary"];
            this.fullAddress = _data["FullAddress"];
        }
    }

    static fromJS(data: any): DigiAddress {
        data = typeof data === 'object' ? data : {};
        let result = new DigiAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AddressId"] = this.addressId;
        data["DCCAddressId"] = this.dCCAddressId;
        data["AddressName"] = this.addressName;
        data["AddressName2"] = this.addressName2;
        data["Street"] = this.street;
        data["ZipCode"] = this.zipCode;
        data["City"] = this.city;
        if (Array.isArray(this.locations)) {
            data["Locations"] = [];
            for (let item of this.locations)
                data["Locations"].push(item.toJSON());
        }
        data["Primary"] = this.primary;
        data["FullAddress"] = this.fullAddress;
        return data;
    }
}

export interface IDigiAddress {
    addressId?: string | undefined;
    dCCAddressId?: string | undefined;
    addressName?: string | undefined;
    addressName2?: string | undefined;
    street?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    locations?: Location[] | undefined;
    primary?: boolean | undefined;
    fullAddress?: string | undefined;
}

export class Location implements ILocation {
    locationName?: string | undefined;
    locationId?: string | undefined;
    locusPoiGuid?: string | undefined;
    addressId?: string | undefined;
    customerId?: string | undefined;
    geoData?: GeoData | undefined;
    source?: LocationSource | undefined;
    materialGroupNumber?: string | undefined;
    materialGroupName?: string | undefined;
    locationType?: LocType | undefined;
    capacity?: number | undefined;
    characteristic?: string | undefined;
    isDCC?: boolean | undefined;
    isTrap?: boolean | undefined;
    lastUpdatedBy?: string | undefined;
    quickMaterial?: string | undefined;
    quickMaterialId?: string | undefined;
    additionalText?: string | undefined;
    additionalInfo?: AdditionalInfo | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["LocationName"];
            this.locationId = _data["LocationId"];
            this.locusPoiGuid = _data["LocusPoiGuid"];
            this.addressId = _data["AddressId"];
            this.customerId = _data["CustomerId"];
            this.geoData = _data["GeoData"] ? GeoData.fromJS(_data["GeoData"]) : <any>undefined;
            this.source = _data["Source"];
            this.materialGroupNumber = _data["MaterialGroupNumber"];
            this.materialGroupName = _data["MaterialGroupName"];
            this.locationType = _data["LocationType"] ? LocType.fromJS(_data["LocationType"]) : <any>undefined;
            this.capacity = _data["Capacity"];
            this.characteristic = _data["Characteristic"];
            this.isDCC = _data["IsDCC"];
            this.isTrap = _data["IsTrap"];
            this.lastUpdatedBy = _data["LastUpdatedBy"];
            this.quickMaterial = _data["QuickMaterial"];
            this.quickMaterialId = _data["QuickMaterialId"];
            this.additionalText = _data["AdditionalText"];
            this.additionalInfo = _data["AdditionalInfo"] ? AdditionalInfo.fromJS(_data["AdditionalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LocationName"] = this.locationName;
        data["LocationId"] = this.locationId;
        data["LocusPoiGuid"] = this.locusPoiGuid;
        data["AddressId"] = this.addressId;
        data["CustomerId"] = this.customerId;
        data["GeoData"] = this.geoData ? this.geoData.toJSON() : <any>undefined;
        data["Source"] = this.source;
        data["MaterialGroupNumber"] = this.materialGroupNumber;
        data["MaterialGroupName"] = this.materialGroupName;
        data["LocationType"] = this.locationType ? this.locationType.toJSON() : <any>undefined;
        data["Capacity"] = this.capacity;
        data["Characteristic"] = this.characteristic;
        data["IsDCC"] = this.isDCC;
        data["IsTrap"] = this.isTrap;
        data["LastUpdatedBy"] = this.lastUpdatedBy;
        data["QuickMaterial"] = this.quickMaterial;
        data["QuickMaterialId"] = this.quickMaterialId;
        data["AdditionalText"] = this.additionalText;
        data["AdditionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILocation {
    locationName?: string | undefined;
    locationId?: string | undefined;
    locusPoiGuid?: string | undefined;
    addressId?: string | undefined;
    customerId?: string | undefined;
    geoData?: GeoData | undefined;
    source?: LocationSource | undefined;
    materialGroupNumber?: string | undefined;
    materialGroupName?: string | undefined;
    locationType?: LocType | undefined;
    capacity?: number | undefined;
    characteristic?: string | undefined;
    isDCC?: boolean | undefined;
    isTrap?: boolean | undefined;
    lastUpdatedBy?: string | undefined;
    quickMaterial?: string | undefined;
    quickMaterialId?: string | undefined;
    additionalText?: string | undefined;
    additionalInfo?: AdditionalInfo | undefined;
}

export class GeoData implements IGeoData {
    point?: Point | undefined;

    constructor(data?: IGeoData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.point = _data["point"] ? Point.fromJS(_data["point"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeoData {
        data = typeof data === 'object' ? data : {};
        let result = new GeoData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point"] = this.point ? this.point.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeoData {
    point?: Point | undefined;
}

export class LocType implements ILocType {
    locationType?: string | undefined;
    locationTypeId?: string | undefined;
    capacityUnit?: string | undefined;
    capacityAllowed?: boolean | undefined;
    deliveryOptions?: DeliveryOption[] | undefined;

    constructor(data?: ILocType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationType = _data["LocationType"];
            this.locationTypeId = _data["LocationTypeId"];
            this.capacityUnit = _data["CapacityUnit"];
            this.capacityAllowed = _data["CapacityAllowed"];
            if (Array.isArray(_data["DeliveryOptions"])) {
                this.deliveryOptions = [] as any;
                for (let item of _data["DeliveryOptions"])
                    this.deliveryOptions!.push(DeliveryOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocType {
        data = typeof data === 'object' ? data : {};
        let result = new LocType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["LocationType"] = this.locationType;
        data["LocationTypeId"] = this.locationTypeId;
        data["CapacityUnit"] = this.capacityUnit;
        data["CapacityAllowed"] = this.capacityAllowed;
        if (Array.isArray(this.deliveryOptions)) {
            data["DeliveryOptions"] = [];
            for (let item of this.deliveryOptions)
                data["DeliveryOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocType {
    locationType?: string | undefined;
    locationTypeId?: string | undefined;
    capacityUnit?: string | undefined;
    capacityAllowed?: boolean | undefined;
    deliveryOptions?: DeliveryOption[] | undefined;
}

export class AdditionalInfo implements IAdditionalInfo {
    currentStock?: number | undefined;
    harvestYear?: string | undefined;
    minimumOrderQuantity?: number | undefined;
    maximumOrderQuantity?: number | undefined;
    allowFillUp?: boolean | undefined;
    defaultMessageToDriver?: string | undefined;
    note?: string | undefined;
    products?: LocationProduct[] | undefined;
    validDeliveryDates?: LocationProductDeliveryDate[] | undefined;
    tankOverview?: TankOverview | undefined;

    constructor(data?: IAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStock = _data["CurrentStock"];
            this.harvestYear = _data["HarvestYear"];
            this.minimumOrderQuantity = _data["MinimumOrderQuantity"];
            this.maximumOrderQuantity = _data["MaximumOrderQuantity"];
            this.allowFillUp = _data["allowFillUp"];
            this.defaultMessageToDriver = _data["DefaultMessageToDriver"];
            this.note = _data["Note"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(LocationProduct.fromJS(item));
            }
            if (Array.isArray(_data["ValidDeliveryDates"])) {
                this.validDeliveryDates = [] as any;
                for (let item of _data["ValidDeliveryDates"])
                    this.validDeliveryDates!.push(LocationProductDeliveryDate.fromJS(item));
            }
            this.tankOverview = _data["TankOverview"] ? TankOverview.fromJS(_data["TankOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CurrentStock"] = this.currentStock;
        data["HarvestYear"] = this.harvestYear;
        data["MinimumOrderQuantity"] = this.minimumOrderQuantity;
        data["MaximumOrderQuantity"] = this.maximumOrderQuantity;
        data["allowFillUp"] = this.allowFillUp;
        data["DefaultMessageToDriver"] = this.defaultMessageToDriver;
        data["Note"] = this.note;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        if (Array.isArray(this.validDeliveryDates)) {
            data["ValidDeliveryDates"] = [];
            for (let item of this.validDeliveryDates)
                data["ValidDeliveryDates"].push(item.toJSON());
        }
        data["TankOverview"] = this.tankOverview ? this.tankOverview.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAdditionalInfo {
    currentStock?: number | undefined;
    harvestYear?: string | undefined;
    minimumOrderQuantity?: number | undefined;
    maximumOrderQuantity?: number | undefined;
    allowFillUp?: boolean | undefined;
    defaultMessageToDriver?: string | undefined;
    note?: string | undefined;
    products?: LocationProduct[] | undefined;
    validDeliveryDates?: LocationProductDeliveryDate[] | undefined;
    tankOverview?: TankOverview | undefined;
}

export class Point implements IPoint {
    latitude?: number | undefined;
    longitude?: number | undefined;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPoint {
    latitude?: number | undefined;
    longitude?: number | undefined;
}

export class DeliveryOption implements IDeliveryOption {
    unloadingMethodId?: string | undefined;
    unloadingMethod?: string | undefined;
    transportGroups?: string[] | undefined;
    wagonTypes?: Wagon[] | undefined;

    constructor(data?: IDeliveryOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unloadingMethodId = _data["UnloadingMethodId"];
            this.unloadingMethod = _data["UnloadingMethod"];
            if (Array.isArray(_data["TransportGroups"])) {
                this.transportGroups = [] as any;
                for (let item of _data["TransportGroups"])
                    this.transportGroups!.push(item);
            }
            if (Array.isArray(_data["WagonTypes"])) {
                this.wagonTypes = [] as any;
                for (let item of _data["WagonTypes"])
                    this.wagonTypes!.push(Wagon.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryOption {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UnloadingMethodId"] = this.unloadingMethodId;
        data["UnloadingMethod"] = this.unloadingMethod;
        if (Array.isArray(this.transportGroups)) {
            data["TransportGroups"] = [];
            for (let item of this.transportGroups)
                data["TransportGroups"].push(item);
        }
        if (Array.isArray(this.wagonTypes)) {
            data["WagonTypes"] = [];
            for (let item of this.wagonTypes)
                data["WagonTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeliveryOption {
    unloadingMethodId?: string | undefined;
    unloadingMethod?: string | undefined;
    transportGroups?: string[] | undefined;
    wagonTypes?: Wagon[] | undefined;
}

export class LocationProduct implements ILocationProduct {
    id?: string | undefined;
    productName?: string | undefined;

    constructor(data?: ILocationProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.productName = _data["ProductName"];
        }
    }

    static fromJS(data: any): LocationProduct {
        data = typeof data === 'object' ? data : {};
        let result = new LocationProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ProductName"] = this.productName;
        return data;
    }
}

export interface ILocationProduct {
    id?: string | undefined;
    productName?: string | undefined;
}

export class LocationProductDeliveryDate implements ILocationProductDeliveryDate {
    date?: string | undefined;
    expressFee?: boolean | undefined;
    defaultDate?: boolean | undefined;

    constructor(data?: ILocationProductDeliveryDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.expressFee = _data["ExpressFee"];
            this.defaultDate = _data["DefaultDate"];
        }
    }

    static fromJS(data: any): LocationProductDeliveryDate {
        data = typeof data === 'object' ? data : {};
        let result = new LocationProductDeliveryDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["ExpressFee"] = this.expressFee;
        data["DefaultDate"] = this.defaultDate;
        return data;
    }
}

export interface ILocationProductDeliveryDate {
    date?: string | undefined;
    expressFee?: boolean | undefined;
    defaultDate?: boolean | undefined;
}

export class TankOverview implements ITankOverview {
    id?: string | undefined;
    activeOrderNumber?: string | undefined;
    deliveryDate?: Date | undefined;
    surveillance?: string | undefined;
    externalId?: string | undefined;
    securePercent?: number | undefined;
    dryrunPercent?: number | undefined;
    lastReadDate?: Date | undefined;
    lastReadVolume?: number | undefined;
    selfOrder?: boolean | undefined;
    automaticRefillEnabled?: boolean | undefined;
    equipmentInstall?: string | undefined;
    mail?: string | undefined;
    sms?: string | undefined;

    constructor(data?: ITankOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.activeOrderNumber = _data["ActiveOrderNumber"];
            this.deliveryDate = _data["DeliveryDate"] ? new Date(_data["DeliveryDate"].toString()) : <any>undefined;
            this.surveillance = _data["Surveillance"];
            this.externalId = _data["ExternalId"];
            this.securePercent = _data["SecurePercent"];
            this.dryrunPercent = _data["DryrunPercent"];
            this.lastReadDate = _data["LastReadDate"] ? new Date(_data["LastReadDate"].toString()) : <any>undefined;
            this.lastReadVolume = _data["LastReadVolume"];
            this.selfOrder = _data["SelfOrder"];
            this.automaticRefillEnabled = _data["AutomaticRefillEnabled"];
            this.equipmentInstall = _data["EquipmentInstall"];
            this.mail = _data["Mail"];
            this.sms = _data["Sms"];
        }
    }

    static fromJS(data: any): TankOverview {
        data = typeof data === 'object' ? data : {};
        let result = new TankOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ActiveOrderNumber"] = this.activeOrderNumber;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["Surveillance"] = this.surveillance;
        data["ExternalId"] = this.externalId;
        data["SecurePercent"] = this.securePercent;
        data["DryrunPercent"] = this.dryrunPercent;
        data["LastReadDate"] = this.lastReadDate ? this.lastReadDate.toISOString() : <any>undefined;
        data["LastReadVolume"] = this.lastReadVolume;
        data["SelfOrder"] = this.selfOrder;
        data["AutomaticRefillEnabled"] = this.automaticRefillEnabled;
        data["EquipmentInstall"] = this.equipmentInstall;
        data["Mail"] = this.mail;
        data["Sms"] = this.sms;
        return data;
    }
}

export interface ITankOverview {
    id?: string | undefined;
    activeOrderNumber?: string | undefined;
    deliveryDate?: Date | undefined;
    surveillance?: string | undefined;
    externalId?: string | undefined;
    securePercent?: number | undefined;
    dryrunPercent?: number | undefined;
    lastReadDate?: Date | undefined;
    lastReadVolume?: number | undefined;
    selfOrder?: boolean | undefined;
    automaticRefillEnabled?: boolean | undefined;
    equipmentInstall?: string | undefined;
    mail?: string | undefined;
    sms?: string | undefined;
}

export class Wagon implements IWagon {
    wagonType?: string | undefined;
    wagonTypeId?: string | undefined;

    constructor(data?: IWagon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wagonType = _data["WagonType"];
            this.wagonTypeId = _data["WagonTypeId"];
        }
    }

    static fromJS(data: any): Wagon {
        data = typeof data === 'object' ? data : {};
        let result = new Wagon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WagonType"] = this.wagonType;
        data["WagonTypeId"] = this.wagonTypeId;
        return data;
    }
}

export interface IWagon {
    wagonType?: string | undefined;
    wagonTypeId?: string | undefined;
}

export class DigifarmDefaultResponseOfListOfLocType implements IDigifarmDefaultResponseOfListOfLocType {
    result?: LocType[] | undefined;
    message?: string | undefined;
    success?: boolean | undefined;
    statusCode?: DigifarmDefaultResponseOfListOfLocTypeStatusCode | undefined;

    constructor(data?: IDigifarmDefaultResponseOfListOfLocType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(LocType.fromJS(item));
            }
            this.message = _data["Message"];
            this.success = _data["Success"];
            this.statusCode = _data["StatusCode"];
        }
    }

    static fromJS(data: any): DigifarmDefaultResponseOfListOfLocType {
        data = typeof data === 'object' ? data : {};
        let result = new DigifarmDefaultResponseOfListOfLocType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Message"] = this.message;
        data["Success"] = this.success;
        data["StatusCode"] = this.statusCode;
        return data;
    }
}

export interface IDigifarmDefaultResponseOfListOfLocType {
    result?: LocType[] | undefined;
    message?: string | undefined;
    success?: boolean | undefined;
    statusCode?: DigifarmDefaultResponseOfListOfLocTypeStatusCode | undefined;
}

export class ICustomerData implements IICustomerData {
    customerNumber?: string | undefined;
    name1?: string | undefined;
    name2?: string | undefined;
    email?: string | undefined;
    purchaseEmail?: string | undefined;
    salesEmail?: string | undefined;
    confirmationEmail?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    street?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    plantProtectionAllowance?: string | undefined;
    salesRegion?: string | undefined;
    centralOrderBlock?: string | undefined;

    constructor(data?: IICustomerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["CustomerNumber"];
            this.name1 = _data["Name1"];
            this.name2 = _data["Name2"];
            this.email = _data["Email"];
            this.purchaseEmail = _data["PurchaseEmail"];
            this.salesEmail = _data["SalesEmail"];
            this.confirmationEmail = _data["ConfirmationEmail"];
            this.mobileNumber = _data["MobileNumber"];
            this.phoneNumber = _data["PhoneNumber"];
            this.faxNumber = _data["FaxNumber"];
            this.street = _data["Street"];
            this.postCode = _data["PostCode"];
            this.city = _data["City"];
            this.plantProtectionAllowance = _data["PlantProtectionAllowance"];
            this.salesRegion = _data["SalesRegion"];
            this.centralOrderBlock = _data["CentralOrderBlock"];
        }
    }

    static fromJS(data: any): ICustomerData {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerNumber"] = this.customerNumber;
        data["Name1"] = this.name1;
        data["Name2"] = this.name2;
        data["Email"] = this.email;
        data["PurchaseEmail"] = this.purchaseEmail;
        data["SalesEmail"] = this.salesEmail;
        data["ConfirmationEmail"] = this.confirmationEmail;
        data["MobileNumber"] = this.mobileNumber;
        data["PhoneNumber"] = this.phoneNumber;
        data["FaxNumber"] = this.faxNumber;
        data["Street"] = this.street;
        data["PostCode"] = this.postCode;
        data["City"] = this.city;
        data["PlantProtectionAllowance"] = this.plantProtectionAllowance;
        data["SalesRegion"] = this.salesRegion;
        data["CentralOrderBlock"] = this.centralOrderBlock;
        return data;
    }
}

export interface IICustomerData {
    customerNumber?: string | undefined;
    name1?: string | undefined;
    name2?: string | undefined;
    email?: string | undefined;
    purchaseEmail?: string | undefined;
    salesEmail?: string | undefined;
    confirmationEmail?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
    faxNumber?: string | undefined;
    street?: string | undefined;
    postCode?: string | undefined;
    city?: string | undefined;
    plantProtectionAllowance?: string | undefined;
    salesRegion?: string | undefined;
    centralOrderBlock?: string | undefined;
}

export class CustomerSettings implements ICustomerSettings {
    accounts?: Accounts | undefined;
    issupport?: boolean | undefined;
    accountinfoSettings?: AccountInfoSettings | undefined;
    addresses?: DigiAddress[] | undefined;
    accesskeys?: string[] | undefined;
    ssoinfo?: SsoInfo | undefined;

    constructor(data?: ICustomerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accounts = _data["accounts"] ? Accounts.fromJS(_data["accounts"]) : <any>undefined;
            this.issupport = _data["issupport"];
            this.accountinfoSettings = _data["accountinfoSettings"] ? AccountInfoSettings.fromJS(_data["accountinfoSettings"]) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(DigiAddress.fromJS(item));
            }
            if (Array.isArray(_data["Accesskeys"])) {
                this.accesskeys = [] as any;
                for (let item of _data["Accesskeys"])
                    this.accesskeys!.push(item);
            }
            this.ssoinfo = _data["ssoinfo"] ? SsoInfo.fromJS(_data["ssoinfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accounts"] = this.accounts ? this.accounts.toJSON() : <any>undefined;
        data["issupport"] = this.issupport;
        data["accountinfoSettings"] = this.accountinfoSettings ? this.accountinfoSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.accesskeys)) {
            data["Accesskeys"] = [];
            for (let item of this.accesskeys)
                data["Accesskeys"].push(item);
        }
        data["ssoinfo"] = this.ssoinfo ? this.ssoinfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerSettings {
    accounts?: Accounts | undefined;
    issupport?: boolean | undefined;
    accountinfoSettings?: AccountInfoSettings | undefined;
    addresses?: DigiAddress[] | undefined;
    accesskeys?: string[] | undefined;
    ssoinfo?: SsoInfo | undefined;
}

export class Accounts implements IAccounts {
    available?: AvailableAccount[] | undefined;
    active?: Account | undefined;

    constructor(data?: IAccounts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["available"])) {
                this.available = [] as any;
                for (let item of _data["available"])
                    this.available!.push(AvailableAccount.fromJS(item));
            }
            this.active = _data["active"] ? Account.fromJS(_data["active"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Accounts {
        data = typeof data === 'object' ? data : {};
        let result = new Accounts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.available)) {
            data["available"] = [];
            for (let item of this.available)
                data["available"].push(item.toJSON());
        }
        data["active"] = this.active ? this.active.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAccounts {
    available?: AvailableAccount[] | undefined;
    active?: Account | undefined;
}

export class AccountInfoSettings implements IAccountInfoSettings {
    email?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;

    constructor(data?: IAccountInfoSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
        }
    }

    static fromJS(data: any): AccountInfoSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInfoSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        return data;
    }
}

export interface IAccountInfoSettings {
    email?: string | undefined;
    mobile?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
}

export class SsoInfo implements ISsoInfo {
    ssoMobil?: string | undefined;

    constructor(data?: ISsoInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssoMobil = _data["ssoMobil"];
        }
    }

    static fromJS(data: any): SsoInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SsoInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssoMobil"] = this.ssoMobil;
        return data;
    }
}

export interface ISsoInfo {
    ssoMobil?: string | undefined;
}

export class AvailableAccount implements IAvailableAccount {
    number?: number | undefined;
    name?: string | undefined;

    constructor(data?: IAvailableAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AvailableAccount {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["name"] = this.name;
        return data;
    }
}

export interface IAvailableAccount {
    number?: number | undefined;
    name?: string | undefined;
}

export class Account implements IAccount {
    number?: number | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    readonly fullname?: string | undefined;
    salesofficeid?: string | undefined;
    pricegroup?: string | undefined;
    readonly hasPriceGroup?: boolean | undefined;
    customergroup?: string | undefined;
    customergroupdescription?: string | undefined;
    hasPlantProtection?: boolean | undefined;
    hasBusinessCustomerDiscount?: boolean | undefined;
    salesRegion?: string | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            (<any>this).fullname = _data["fullname"];
            this.salesofficeid = _data["salesofficeid"];
            this.pricegroup = _data["pricegroup"];
            (<any>this).hasPriceGroup = _data["hasPriceGroup"];
            this.customergroup = _data["customergroup"];
            this.customergroupdescription = _data["customergroupdescription"];
            this.hasPlantProtection = _data["hasPlantProtection"];
            this.hasBusinessCustomerDiscount = _data["hasBusinessCustomerDiscount"];
            this.salesRegion = _data["SalesRegion"];
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["fullname"] = this.fullname;
        data["salesofficeid"] = this.salesofficeid;
        data["pricegroup"] = this.pricegroup;
        data["hasPriceGroup"] = this.hasPriceGroup;
        data["customergroup"] = this.customergroup;
        data["customergroupdescription"] = this.customergroupdescription;
        data["hasPlantProtection"] = this.hasPlantProtection;
        data["hasBusinessCustomerDiscount"] = this.hasBusinessCustomerDiscount;
        data["SalesRegion"] = this.salesRegion;
        return data;
    }
}

export interface IAccount {
    number?: number | undefined;
    name?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    fullname?: string | undefined;
    salesofficeid?: string | undefined;
    pricegroup?: string | undefined;
    hasPriceGroup?: boolean | undefined;
    customergroup?: string | undefined;
    customergroupdescription?: string | undefined;
    hasPlantProtection?: boolean | undefined;
    hasBusinessCustomerDiscount?: boolean | undefined;
    salesRegion?: string | undefined;
}

export class V2ControllerResultOfCustomerSettings implements IV2ControllerResultOfCustomerSettings {
    readonly result?: CustomerSettings | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfCustomerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? CustomerSettings.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfCustomerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfCustomerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfCustomerSettings {
    result?: CustomerSettings | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class UpdatePassword implements IUpdatePassword {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;

    constructor(data?: IUpdatePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["OldPassword"];
            this.newPassword = _data["NewPassword"];
            this.newPasswordConfirm = _data["NewPasswordConfirm"];
        }
    }

    static fromJS(data: any): UpdatePassword {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OldPassword"] = this.oldPassword;
        data["NewPassword"] = this.newPassword;
        data["NewPasswordConfirm"] = this.newPasswordConfirm;
        return data;
    }
}

export interface IUpdatePassword {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
}

export class V2ControllerResultOfDeleteAccountTextModel implements IV2ControllerResultOfDeleteAccountTextModel {
    readonly result?: DeleteAccountTextModel | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfDeleteAccountTextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? DeleteAccountTextModel.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfDeleteAccountTextModel {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfDeleteAccountTextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfDeleteAccountTextModel {
    result?: DeleteAccountTextModel | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class DeleteAccountTextModel implements IDeleteAccountTextModel {
    deleteAccountTitle?: string | undefined;
    deleteAccountDescription?: string | undefined;

    constructor(data?: IDeleteAccountTextModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deleteAccountTitle = _data["DeleteAccountTitle"];
            this.deleteAccountDescription = _data["DeleteAccountDescription"];
        }
    }

    static fromJS(data: any): DeleteAccountTextModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountTextModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DeleteAccountTitle"] = this.deleteAccountTitle;
        data["DeleteAccountDescription"] = this.deleteAccountDescription;
        return data;
    }
}

export interface IDeleteAccountTextModel {
    deleteAccountTitle?: string | undefined;
    deleteAccountDescription?: string | undefined;
}

export class V2ControllerResultOfString implements IV2ControllerResultOfString {
    readonly result?: string | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"];
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfString {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfString {
    result?: string | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class KeyValuePairOfStringAndBoolean implements IKeyValuePairOfStringAndBoolean {
    readonly key?: string | undefined;
    readonly value?: boolean | undefined;

    constructor(data?: IKeyValuePairOfStringAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).key = _data["Key"];
            (<any>this).value = _data["Value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        data["Value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndBoolean {
    key?: string | undefined;
    value?: boolean | undefined;
}

export class SubscriberList implements ISubscriberList {
    readonly text?: string | undefined;
    readonly title?: string | undefined;
    readonly listId?: string | undefined;
    readonly harvestsubscription?: boolean | undefined;
    readonly salesofficeid?: string | undefined;
    readonly extranumbers?: string[] | undefined;

    constructor(data?: ISubscriberList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).text = _data["text"];
            (<any>this).title = _data["title"];
            (<any>this).listId = _data["listId"];
            (<any>this).harvestsubscription = _data["harvestsubscription"];
            (<any>this).salesofficeid = _data["salesofficeid"];
            if (Array.isArray(_data["extranumbers"])) {
                (<any>this).extranumbers = [] as any;
                for (let item of _data["extranumbers"])
                    (<any>this).extranumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscriberList {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["title"] = this.title;
        data["listId"] = this.listId;
        data["harvestsubscription"] = this.harvestsubscription;
        data["salesofficeid"] = this.salesofficeid;
        if (Array.isArray(this.extranumbers)) {
            data["extranumbers"] = [];
            for (let item of this.extranumbers)
                data["extranumbers"].push(item);
        }
        return data;
    }
}

export interface ISubscriberList {
    text?: string | undefined;
    title?: string | undefined;
    listId?: string | undefined;
    harvestsubscription?: boolean | undefined;
    salesofficeid?: string | undefined;
    extranumbers?: string[] | undefined;
}

export class SubscribeHarvestSMSAdditionalNumbersParameters implements ISubscribeHarvestSMSAdditionalNumbersParameters {
    salesOffice?: string | undefined;
    phoneNumbers?: string[] | undefined;

    constructor(data?: ISubscribeHarvestSMSAdditionalNumbersParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesOffice = _data["salesOffice"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscribeHarvestSMSAdditionalNumbersParameters {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribeHarvestSMSAdditionalNumbersParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesOffice"] = this.salesOffice;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface ISubscribeHarvestSMSAdditionalNumbersParameters {
    salesOffice?: string | undefined;
    phoneNumbers?: string[] | undefined;
}

export class SubscribeHarvestSMSAnonParameters implements ISubscribeHarvestSMSAnonParameters {
    salesOffices?: string[] | undefined;
    phoneNumbers?: string[] | undefined;

    constructor(data?: ISubscribeHarvestSMSAnonParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesOffices"])) {
                this.salesOffices = [] as any;
                for (let item of _data["salesOffices"])
                    this.salesOffices!.push(item);
            }
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscribeHarvestSMSAnonParameters {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribeHarvestSMSAnonParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesOffices)) {
            data["salesOffices"] = [];
            for (let item of this.salesOffices)
                data["salesOffices"].push(item);
        }
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }
}

export interface ISubscribeHarvestSMSAnonParameters {
    salesOffices?: string[] | undefined;
    phoneNumbers?: string[] | undefined;
}

export class SubscriptionData implements ISubscriptionData {
    subscription?: string | undefined;
    subscribe?: boolean | undefined;

    constructor(data?: ISubscriptionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscription = _data["Subscription"];
            this.subscribe = _data["Subscribe"];
        }
    }

    static fromJS(data: any): SubscriptionData {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Subscription"] = this.subscription;
        data["Subscribe"] = this.subscribe;
        return data;
    }
}

export interface ISubscriptionData {
    subscription?: string | undefined;
    subscribe?: boolean | undefined;
}

export class V2ControllerResultOfInt32 implements IV2ControllerResultOfInt32 {
    readonly result?: number | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfInt32) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"];
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfInt32 {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfInt32();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfInt32 {
    result?: number | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class V2ControllerResultOfAppFrontpage implements IV2ControllerResultOfAppFrontpage {
    readonly result?: AppFrontpage | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfAppFrontpage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? AppFrontpage.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfAppFrontpage {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfAppFrontpage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfAppFrontpage {
    result?: AppFrontpage | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class AppFrontpage implements IAppFrontpage {
    appItems?: AppItem[] | undefined;

    constructor(data?: IAppFrontpage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["AppItems"])) {
                this.appItems = [] as any;
                for (let item of _data["AppItems"])
                    this.appItems!.push(AppItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppFrontpage {
        data = typeof data === 'object' ? data : {};
        let result = new AppFrontpage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appItems)) {
            data["AppItems"] = [];
            for (let item of this.appItems)
                data["AppItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppFrontpage {
    appItems?: AppItem[] | undefined;
}

export class AppItem implements IAppItem {

    constructor(data?: IAppItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AppItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAppItem {
}

export class V2ControllerResultOfCatalogProductSearchResult implements IV2ControllerResultOfCatalogProductSearchResult {
    readonly result?: CatalogProductSearchResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfCatalogProductSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? CatalogProductSearchResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfCatalogProductSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfCatalogProductSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfCatalogProductSearchResult {
    result?: CatalogProductSearchResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class V2ControllerResultOfPowerBiSearchResult implements IV2ControllerResultOfPowerBiSearchResult {
    readonly result?: PowerBiSearchResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfPowerBiSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? PowerBiSearchResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfPowerBiSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfPowerBiSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfPowerBiSearchResult {
    result?: PowerBiSearchResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class PowerBiSearchResult implements IPowerBiSearchResult {
    products?: CatalogProduct[] | undefined;
    lastVersion?: number | undefined;

    constructor(data?: IPowerBiSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(CatalogProduct.fromJS(item));
            }
            this.lastVersion = _data["LastVersion"];
        }
    }

    static fromJS(data: any): PowerBiSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new PowerBiSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        data["LastVersion"] = this.lastVersion;
        return data;
    }
}

export interface IPowerBiSearchResult {
    products?: CatalogProduct[] | undefined;
    lastVersion?: number | undefined;
}

export class SalesOfficeMapping implements ISalesOfficeMapping {
    title?: string | undefined;
    salesOfficeId?: string | undefined;
    region?: string | undefined;
    numbers?: number | undefined;
    plant?: string[] | undefined;
    location?: string[] | undefined;

    constructor(data?: ISalesOfficeMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.salesOfficeId = _data["salesOfficeId"];
            this.region = _data["region"];
            this.numbers = _data["numbers"];
            if (Array.isArray(_data["plant"])) {
                this.plant = [] as any;
                for (let item of _data["plant"])
                    this.plant!.push(item);
            }
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(item);
            }
        }
    }

    static fromJS(data: any): SalesOfficeMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOfficeMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["salesOfficeId"] = this.salesOfficeId;
        data["region"] = this.region;
        data["numbers"] = this.numbers;
        if (Array.isArray(this.plant)) {
            data["plant"] = [];
            for (let item of this.plant)
                data["plant"].push(item);
        }
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item);
        }
        return data;
    }
}

export interface ISalesOfficeMapping {
    title?: string | undefined;
    salesOfficeId?: string | undefined;
    region?: string | undefined;
    numbers?: number | undefined;
    plant?: string[] | undefined;
    location?: string[] | undefined;
}

export class HarvestSMSSubscriber implements IHarvestSMSSubscriber {
    iD?: string | undefined;
    domainUser?: string | undefined;
    salesOfficeID?: string | undefined;
    phoneNumber?: string | undefined;
    active?: boolean | undefined;
    subscriptionLog?: string | undefined;
    isHaGe?: boolean | undefined;
    iPAddress?: string | undefined;

    constructor(data?: IHarvestSMSSubscriber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iD = _data["ID"];
            this.domainUser = _data["DomainUser"];
            this.salesOfficeID = _data["SalesOfficeID"];
            this.phoneNumber = _data["PhoneNumber"];
            this.active = _data["Active"];
            this.subscriptionLog = _data["SubscriptionLog"];
            this.isHaGe = _data["isHaGe"];
            this.iPAddress = _data["IPAddress"];
        }
    }

    static fromJS(data: any): HarvestSMSSubscriber {
        data = typeof data === 'object' ? data : {};
        let result = new HarvestSMSSubscriber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD;
        data["DomainUser"] = this.domainUser;
        data["SalesOfficeID"] = this.salesOfficeID;
        data["PhoneNumber"] = this.phoneNumber;
        data["Active"] = this.active;
        data["SubscriptionLog"] = this.subscriptionLog;
        data["isHaGe"] = this.isHaGe;
        data["IPAddress"] = this.iPAddress;
        return data;
    }
}

export interface IHarvestSMSSubscriber {
    iD?: string | undefined;
    domainUser?: string | undefined;
    salesOfficeID?: string | undefined;
    phoneNumber?: string | undefined;
    active?: boolean | undefined;
    subscriptionLog?: string | undefined;
    isHaGe?: boolean | undefined;
    iPAddress?: string | undefined;
}

export class HaGeControllerResultOfIHarvestOverviewResult implements IHaGeControllerResultOfIHarvestOverviewResult {
    readonly result?: IHarvestOverviewResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IHaGeControllerResultOfIHarvestOverviewResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? IHarvestOverviewResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): HaGeControllerResultOfIHarvestOverviewResult {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeControllerResultOfIHarvestOverviewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IHaGeControllerResultOfIHarvestOverviewResult {
    result?: IHarvestOverviewResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class IHarvestOverviewResult implements IIHarvestOverviewResult {
    harvestOverviewList?: IHarvestOverview[] | undefined;

    constructor(data?: IIHarvestOverviewResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["HarvestOverviewList"])) {
                this.harvestOverviewList = [] as any;
                for (let item of _data["HarvestOverviewList"])
                    this.harvestOverviewList!.push(IHarvestOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IHarvestOverviewResult {
        data = typeof data === 'object' ? data : {};
        let result = new IHarvestOverviewResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.harvestOverviewList)) {
            data["HarvestOverviewList"] = [];
            for (let item of this.harvestOverviewList)
                data["HarvestOverviewList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIHarvestOverviewResult {
    harvestOverviewList?: IHarvestOverview[] | undefined;
}

export class IHarvestOverview implements IIHarvestOverview {
    cropType?: string | undefined;
    deliveryNumber?: string | undefined;
    productDescription?: string | undefined;
    deliveryDate?: Date | undefined;
    licensePlateNumber?: string | undefined;
    name?: string | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    sensorTest?: string | undefined;
    classDescription?: string | undefined;
    cropQualityList?: IHarvestCropQuality[] | undefined;
    invoiceNumber?: string | undefined;
    purchaseNumber?: string | undefined;

    constructor(data?: IIHarvestOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cropType = _data["CropType"];
            this.deliveryNumber = _data["DeliveryNumber"];
            this.productDescription = _data["ProductDescription"];
            this.deliveryDate = _data["DeliveryDate"] ? new Date(_data["DeliveryDate"].toString()) : <any>undefined;
            this.licensePlateNumber = _data["LicensePlateNumber"];
            this.name = _data["Name"];
            this.quantity = _data["Quantity"];
            this.unit = _data["Unit"];
            this.sensorTest = _data["SensorTest"];
            this.classDescription = _data["ClassDescription"];
            if (Array.isArray(_data["CropQualityList"])) {
                this.cropQualityList = [] as any;
                for (let item of _data["CropQualityList"])
                    this.cropQualityList!.push(IHarvestCropQuality.fromJS(item));
            }
            this.invoiceNumber = _data["InvoiceNumber"];
            this.purchaseNumber = _data["PurchaseNumber"];
        }
    }

    static fromJS(data: any): IHarvestOverview {
        data = typeof data === 'object' ? data : {};
        let result = new IHarvestOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CropType"] = this.cropType;
        data["DeliveryNumber"] = this.deliveryNumber;
        data["ProductDescription"] = this.productDescription;
        data["DeliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["LicensePlateNumber"] = this.licensePlateNumber;
        data["Name"] = this.name;
        data["Quantity"] = this.quantity;
        data["Unit"] = this.unit;
        data["SensorTest"] = this.sensorTest;
        data["ClassDescription"] = this.classDescription;
        if (Array.isArray(this.cropQualityList)) {
            data["CropQualityList"] = [];
            for (let item of this.cropQualityList)
                data["CropQualityList"].push(item.toJSON());
        }
        data["InvoiceNumber"] = this.invoiceNumber;
        data["PurchaseNumber"] = this.purchaseNumber;
        return data;
    }
}

export interface IIHarvestOverview {
    cropType?: string | undefined;
    deliveryNumber?: string | undefined;
    productDescription?: string | undefined;
    deliveryDate?: Date | undefined;
    licensePlateNumber?: string | undefined;
    name?: string | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    sensorTest?: string | undefined;
    classDescription?: string | undefined;
    cropQualityList?: IHarvestCropQuality[] | undefined;
    invoiceNumber?: string | undefined;
    purchaseNumber?: string | undefined;
}

export class IHarvestCropQuality implements IIHarvestCropQuality {
    characteristicDescription?: string | undefined;
    characteristicValue?: string | undefined;

    constructor(data?: IIHarvestCropQuality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicDescription = _data["CharacteristicDescription"];
            this.characteristicValue = _data["CharacteristicValue"];
        }
    }

    static fromJS(data: any): IHarvestCropQuality {
        data = typeof data === 'object' ? data : {};
        let result = new IHarvestCropQuality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CharacteristicDescription"] = this.characteristicDescription;
        data["CharacteristicValue"] = this.characteristicValue;
        return data;
    }
}

export interface IIHarvestCropQuality {
    characteristicDescription?: string | undefined;
    characteristicValue?: string | undefined;
}

export class HaGeControllerResultOfIHarvestOverviewByCropTypeResult implements IHaGeControllerResultOfIHarvestOverviewByCropTypeResult {
    readonly result?: IHarvestOverviewByCropTypeResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IHaGeControllerResultOfIHarvestOverviewByCropTypeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? IHarvestOverviewByCropTypeResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): HaGeControllerResultOfIHarvestOverviewByCropTypeResult {
        data = typeof data === 'object' ? data : {};
        let result = new HaGeControllerResultOfIHarvestOverviewByCropTypeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IHaGeControllerResultOfIHarvestOverviewByCropTypeResult {
    result?: IHarvestOverviewByCropTypeResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class IHarvestOverviewByCropTypeResult implements IIHarvestOverviewByCropTypeResult {
    groupedHarvestOverview?: { [key: string]: IHarvestOverview[]; } | undefined;

    constructor(data?: IIHarvestOverviewByCropTypeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["GroupedHarvestOverview"]) {
                this.groupedHarvestOverview = {} as any;
                for (let key in _data["GroupedHarvestOverview"]) {
                    if (_data["GroupedHarvestOverview"].hasOwnProperty(key))
                        (<any>this.groupedHarvestOverview)![key] = _data["GroupedHarvestOverview"][key] ? _data["GroupedHarvestOverview"][key].map((i: any) => IHarvestOverview.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): IHarvestOverviewByCropTypeResult {
        data = typeof data === 'object' ? data : {};
        let result = new IHarvestOverviewByCropTypeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.groupedHarvestOverview) {
            data["GroupedHarvestOverview"] = {};
            for (let key in this.groupedHarvestOverview) {
                if (this.groupedHarvestOverview.hasOwnProperty(key))
                    (<any>data["GroupedHarvestOverview"])[key] = (<any>this.groupedHarvestOverview)[key];
            }
        }
        return data;
    }
}

export interface IIHarvestOverviewByCropTypeResult {
    groupedHarvestOverview?: { [key: string]: IHarvestOverview[]; } | undefined;
}

export class DocumentHitId2 implements IDocumentHitId2 {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;

    constructor(data?: IDocumentHitId2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTimestamp = _data["SearchTimestamp"];
            this.hitToken = _data["HitToken"];
            this.origin = _data["Origin"];
            this.reportName = _data["ReportName"];
            this.reportVersion = _data["ReportVersion"];
            this.fullLength = _data["FullLength"];
            this.compressedLength = _data["CompressedLength"];
            this.displacement = _data["Displacement"];
            this.postingDateTime = _data["PostingDateTime"];
            this.dataTable = _data["DataTable"];
            this.documentId = _data["DocumentId"];
            this.type = _data["Type"];
            this.documentNumber = _data["DocumentNumber"];
        }
    }

    static fromJS(data: any): DocumentHitId2 {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentHitId2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SearchTimestamp"] = this.searchTimestamp;
        data["HitToken"] = this.hitToken;
        data["Origin"] = this.origin;
        data["ReportName"] = this.reportName;
        data["ReportVersion"] = this.reportVersion;
        data["FullLength"] = this.fullLength;
        data["CompressedLength"] = this.compressedLength;
        data["Displacement"] = this.displacement;
        data["PostingDateTime"] = this.postingDateTime;
        data["DataTable"] = this.dataTable;
        data["DocumentId"] = this.documentId;
        data["Type"] = this.type;
        data["DocumentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IDocumentHitId2 {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;
}

export class IDocumentSearchResult implements IIDocumentSearchResult {
    hitCount?: number | undefined;
    hitList?: IDocumentSearchHit[] | undefined;
    searchTimestamp?: string | undefined;
    isResultTruncated?: boolean | undefined;

    constructor(data?: IIDocumentSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hitCount = _data["HitCount"];
            if (Array.isArray(_data["HitList"])) {
                this.hitList = [] as any;
                for (let item of _data["HitList"])
                    this.hitList!.push(IDocumentSearchHit.fromJS(item));
            }
            this.searchTimestamp = _data["SearchTimestamp"];
            this.isResultTruncated = _data["IsResultTruncated"];
        }
    }

    static fromJS(data: any): IDocumentSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HitCount"] = this.hitCount;
        if (Array.isArray(this.hitList)) {
            data["HitList"] = [];
            for (let item of this.hitList)
                data["HitList"].push(item.toJSON());
        }
        data["SearchTimestamp"] = this.searchTimestamp;
        data["IsResultTruncated"] = this.isResultTruncated;
        return data;
    }
}

export interface IIDocumentSearchResult {
    hitCount?: number | undefined;
    hitList?: IDocumentSearchHit[] | undefined;
    searchTimestamp?: string | undefined;
    isResultTruncated?: boolean | undefined;
}

export class IDocumentSearchHit implements IIDocumentSearchHit {
    documentId?: string | undefined;
    customerNumber?: string | undefined;
    documentType?: string | undefined;
    date?: string | undefined;
    hitId?: IDocumentHitId | undefined;
    orgId?: string | undefined;
    sENumber?: string | undefined;
    salesOrg?: string | undefined;
    salesOffice?: string | undefined;
    sellerGroup?: string | undefined;

    constructor(data?: IIDocumentSearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["DocumentId"];
            this.customerNumber = _data["CustomerNumber"];
            this.documentType = _data["DocumentType"];
            this.date = _data["Date"];
            this.hitId = _data["HitId"] ? IDocumentHitId.fromJS(_data["HitId"]) : <any>undefined;
            this.orgId = _data["OrgId"];
            this.sENumber = _data["SENumber"];
            this.salesOrg = _data["SalesOrg"];
            this.salesOffice = _data["SalesOffice"];
            this.sellerGroup = _data["SellerGroup"];
        }
    }

    static fromJS(data: any): IDocumentSearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentSearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocumentId"] = this.documentId;
        data["CustomerNumber"] = this.customerNumber;
        data["DocumentType"] = this.documentType;
        data["Date"] = this.date;
        data["HitId"] = this.hitId ? this.hitId.toJSON() : <any>undefined;
        data["OrgId"] = this.orgId;
        data["SENumber"] = this.sENumber;
        data["SalesOrg"] = this.salesOrg;
        data["SalesOffice"] = this.salesOffice;
        data["SellerGroup"] = this.sellerGroup;
        return data;
    }
}

export interface IIDocumentSearchHit {
    documentId?: string | undefined;
    customerNumber?: string | undefined;
    documentType?: string | undefined;
    date?: string | undefined;
    hitId?: IDocumentHitId | undefined;
    orgId?: string | undefined;
    sENumber?: string | undefined;
    salesOrg?: string | undefined;
    salesOffice?: string | undefined;
    sellerGroup?: string | undefined;
}

export class IDocumentHitId implements IIDocumentHitId {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;

    constructor(data?: IIDocumentHitId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTimestamp = _data["SearchTimestamp"];
            this.hitToken = _data["HitToken"];
            this.origin = _data["Origin"];
            this.reportName = _data["ReportName"];
            this.reportVersion = _data["ReportVersion"];
            this.fullLength = _data["FullLength"];
            this.compressedLength = _data["CompressedLength"];
            this.displacement = _data["Displacement"];
            this.postingDateTime = _data["PostingDateTime"];
            this.dataTable = _data["DataTable"];
            this.documentId = _data["DocumentId"];
            this.type = _data["Type"];
            this.documentNumber = _data["DocumentNumber"];
        }
    }

    static fromJS(data: any): IDocumentHitId {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentHitId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SearchTimestamp"] = this.searchTimestamp;
        data["HitToken"] = this.hitToken;
        data["Origin"] = this.origin;
        data["ReportName"] = this.reportName;
        data["ReportVersion"] = this.reportVersion;
        data["FullLength"] = this.fullLength;
        data["CompressedLength"] = this.compressedLength;
        data["Displacement"] = this.displacement;
        data["PostingDateTime"] = this.postingDateTime;
        data["DataTable"] = this.dataTable;
        data["DocumentId"] = this.documentId;
        data["Type"] = this.type;
        data["DocumentNumber"] = this.documentNumber;
        return data;
    }
}

export interface IIDocumentHitId {
    searchTimestamp?: string | undefined;
    hitToken?: string | undefined;
    origin?: number | undefined;
    reportName?: string | undefined;
    reportVersion?: string | undefined;
    fullLength?: number | undefined;
    compressedLength?: number | undefined;
    displacement?: number | undefined;
    postingDateTime?: string | undefined;
    dataTable?: string | undefined;
    documentId?: string | undefined;
    type?: string | undefined;
    documentNumber?: string | undefined;
}

export class IDocumentFetchInfoResult implements IIDocumentFetchInfoResult {
    docSize?: number | undefined;
    docType?: string | undefined;
    message?: string | undefined;
    mimeType?: string | undefined;
    reasonCode?: number | undefined;
    returnCode?: number | undefined;
    version?: number | undefined;
    downloadId?: IDocumentDownloadId | undefined;

    constructor(data?: IIDocumentFetchInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.docSize = _data["DocSize"];
            this.docType = _data["DocType"];
            this.message = _data["Message"];
            this.mimeType = _data["MimeType"];
            this.reasonCode = _data["ReasonCode"];
            this.returnCode = _data["ReturnCode"];
            this.version = _data["Version"];
            this.downloadId = _data["DownloadId"] ? IDocumentDownloadId.fromJS(_data["DownloadId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IDocumentFetchInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentFetchInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DocSize"] = this.docSize;
        data["DocType"] = this.docType;
        data["Message"] = this.message;
        data["MimeType"] = this.mimeType;
        data["ReasonCode"] = this.reasonCode;
        data["ReturnCode"] = this.returnCode;
        data["Version"] = this.version;
        data["DownloadId"] = this.downloadId ? this.downloadId.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIDocumentFetchInfoResult {
    docSize?: number | undefined;
    docType?: string | undefined;
    message?: string | undefined;
    mimeType?: string | undefined;
    reasonCode?: number | undefined;
    returnCode?: number | undefined;
    version?: number | undefined;
    downloadId?: IDocumentDownloadId | undefined;
}

export class IDocumentDownloadId implements IIDocumentDownloadId {
    cICSSysId?: string | undefined;
    tSQname?: string | undefined;

    constructor(data?: IIDocumentDownloadId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cICSSysId = _data["CICSSysId"];
            this.tSQname = _data["TSQname"];
        }
    }

    static fromJS(data: any): IDocumentDownloadId {
        data = typeof data === 'object' ? data : {};
        let result = new IDocumentDownloadId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CICSSysId"] = this.cICSSysId;
        data["TSQname"] = this.tSQname;
        return data;
    }
}

export interface IIDocumentDownloadId {
    cICSSysId?: string | undefined;
    tSQname?: string | undefined;
}

export class IDeliveryOverview implements IIDeliveryOverview {
    customerNumber?: string | undefined;
    sku?: string | undefined;
    customerOrderPositionText?: string | undefined;
    date?: Date | undefined;
    deliveryNumber?: string | undefined;
    deliveryAmount?: string | undefined;
    unit?: string | undefined;
    documentType?: string | undefined;

    constructor(data?: IIDeliveryOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNumber = _data["CustomerNumber"];
            this.sku = _data["Sku"];
            this.customerOrderPositionText = _data["CustomerOrderPositionText"];
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.deliveryNumber = _data["DeliveryNumber"];
            this.deliveryAmount = _data["DeliveryAmount"];
            this.unit = _data["Unit"];
            this.documentType = _data["DocumentType"];
        }
    }

    static fromJS(data: any): IDeliveryOverview {
        data = typeof data === 'object' ? data : {};
        let result = new IDeliveryOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerNumber"] = this.customerNumber;
        data["Sku"] = this.sku;
        data["CustomerOrderPositionText"] = this.customerOrderPositionText;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["DeliveryNumber"] = this.deliveryNumber;
        data["DeliveryAmount"] = this.deliveryAmount;
        data["Unit"] = this.unit;
        data["DocumentType"] = this.documentType;
        return data;
    }
}

export interface IIDeliveryOverview {
    customerNumber?: string | undefined;
    sku?: string | undefined;
    customerOrderPositionText?: string | undefined;
    date?: Date | undefined;
    deliveryNumber?: string | undefined;
    deliveryAmount?: string | undefined;
    unit?: string | undefined;
    documentType?: string | undefined;
}

export class IDeliveryPdfResult implements IIDeliveryPdfResult {
    dataBytes?: string | undefined;
    deliveryPdfError?: IDeliveryPdfError | undefined;

    constructor(data?: IIDeliveryPdfResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataBytes = _data["DataBytes"];
            this.deliveryPdfError = _data["DeliveryPdfError"] ? IDeliveryPdfError.fromJS(_data["DeliveryPdfError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IDeliveryPdfResult {
        data = typeof data === 'object' ? data : {};
        let result = new IDeliveryPdfResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataBytes"] = this.dataBytes;
        data["DeliveryPdfError"] = this.deliveryPdfError ? this.deliveryPdfError.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIDeliveryPdfResult {
    dataBytes?: string | undefined;
    deliveryPdfError?: IDeliveryPdfError | undefined;
}

export class IDeliveryPdfError implements IIDeliveryPdfError {
    name?: string | undefined;
    text?: string | undefined;

    constructor(data?: IIDeliveryPdfError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): IDeliveryPdfError {
        data = typeof data === 'object' ? data : {};
        let result = new IDeliveryPdfError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Text"] = this.text;
        return data;
    }
}

export interface IIDeliveryPdfError {
    name?: string | undefined;
    text?: string | undefined;
}

export class CropTermPrices implements ICropTermPrices {
    date?: Date | undefined;
    prices?: CropTermPrice[] | undefined;
    inactive?: Date | undefined;
    created?: Date | undefined;
    isOpen?: boolean | undefined;

    constructor(data?: ICropTermPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            if (Array.isArray(_data["Prices"])) {
                this.prices = [] as any;
                for (let item of _data["Prices"])
                    this.prices!.push(CropTermPrice.fromJS(item));
            }
            this.inactive = _data["Inactive"] ? new Date(_data["Inactive"].toString()) : <any>undefined;
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            this.isOpen = _data["IsOpen"];
        }
    }

    static fromJS(data: any): CropTermPrices {
        data = typeof data === 'object' ? data : {};
        let result = new CropTermPrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.prices)) {
            data["Prices"] = [];
            for (let item of this.prices)
                data["Prices"].push(item.toJSON());
        }
        data["Inactive"] = this.inactive ? this.inactive.toISOString() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["IsOpen"] = this.isOpen;
        return data;
    }
}

export interface ICropTermPrices {
    date?: Date | undefined;
    prices?: CropTermPrice[] | undefined;
    inactive?: Date | undefined;
    created?: Date | undefined;
    isOpen?: boolean | undefined;
}

export class CropTermPrice implements ICropTermPrice {
    termId?: string | undefined;
    dateId?: string | undefined;
    price?: number | undefined;

    constructor(data?: ICropTermPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termId = _data["TermId"];
            this.dateId = _data["DateId"];
            this.price = _data["Price"];
        }
    }

    static fromJS(data: any): CropTermPrice {
        data = typeof data === 'object' ? data : {};
        let result = new CropTermPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TermId"] = this.termId;
        data["DateId"] = this.dateId;
        data["Price"] = this.price;
        return data;
    }
}

export interface ICropTermPrice {
    termId?: string | undefined;
    dateId?: string | undefined;
    price?: number | undefined;
}

export class DLGTermTable implements IDLGTermTable {
    headers?: string[] | undefined;
    rows?: DLGTermRow[] | undefined;

    constructor(data?: IDLGTermTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Headers"])) {
                this.headers = [] as any;
                for (let item of _data["Headers"])
                    this.headers!.push(item);
            }
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(DLGTermRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DLGTermTable {
        data = typeof data === 'object' ? data : {};
        let result = new DLGTermTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["Headers"] = [];
            for (let item of this.headers)
                data["Headers"].push(item);
        }
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDLGTermTable {
    headers?: string[] | undefined;
    rows?: DLGTermRow[] | undefined;
}

export class DLGTermRow implements IDLGTermRow {
    date?: Date | undefined;
    isOpen?: boolean | undefined;
    prices?: { [key: string]: number; } | undefined;

    constructor(data?: IDLGTermRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            this.isOpen = _data["IsOpen"];
            if (_data["Prices"]) {
                this.prices = {} as any;
                for (let key in _data["Prices"]) {
                    if (_data["Prices"].hasOwnProperty(key))
                        (<any>this.prices)![key] = _data["Prices"][key];
                }
            }
        }
    }

    static fromJS(data: any): DLGTermRow {
        data = typeof data === 'object' ? data : {};
        let result = new DLGTermRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["IsOpen"] = this.isOpen;
        if (this.prices) {
            data["Prices"] = {};
            for (let key in this.prices) {
                if (this.prices.hasOwnProperty(key))
                    (<any>data["Prices"])[key] = (<any>this.prices)[key];
            }
        }
        return data;
    }
}

export interface IDLGTermRow {
    date?: Date | undefined;
    isOpen?: boolean | undefined;
    prices?: { [key: string]: number; } | undefined;
}

export class IOrderHistory implements IIOrderHistory {
    orders?: IOrderHistoryOrder[] | undefined;

    constructor(data?: IIOrderHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Orders"])) {
                this.orders = [] as any;
                for (let item of _data["Orders"])
                    this.orders!.push(IOrderHistoryOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IOrderHistory {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["Orders"] = [];
            for (let item of this.orders)
                data["Orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIOrderHistory {
    orders?: IOrderHistoryOrder[] | undefined;
}

export class IOrderHistoryOrder implements IIOrderHistoryOrder {
    number?: string | undefined;
    orderDate?: Date | undefined;
    rows?: IOrderHistoryRow[] | undefined;
    readonly orderRowsTotalPrice?: number | undefined;

    constructor(data?: IIOrderHistoryOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.orderDate = _data["OrderDate"] ? new Date(_data["OrderDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["Rows"])) {
                this.rows = [] as any;
                for (let item of _data["Rows"])
                    this.rows!.push(IOrderHistoryRow.fromJS(item));
            }
            (<any>this).orderRowsTotalPrice = _data["OrderRowsTotalPrice"];
        }
    }

    static fromJS(data: any): IOrderHistoryOrder {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderHistoryOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["OrderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        if (Array.isArray(this.rows)) {
            data["Rows"] = [];
            for (let item of this.rows)
                data["Rows"].push(item.toJSON());
        }
        data["OrderRowsTotalPrice"] = this.orderRowsTotalPrice;
        return data;
    }
}

export interface IIOrderHistoryOrder {
    number?: string | undefined;
    orderDate?: Date | undefined;
    rows?: IOrderHistoryRow[] | undefined;
    orderRowsTotalPrice?: number | undefined;
}

export class IOrderHistoryRow implements IIOrderHistoryRow {
    number?: string | undefined;
    productName?: string | undefined;
    productSku?: string | undefined;
    orderDate?: Date | undefined;
    orderType?: string | undefined;
    unit?: string | undefined;
    currencyName?: string | undefined;
    position?: string | undefined;
    positionType?: string | undefined;
    quantity?: number | undefined;
    price?: string | undefined;
    priceDecimal?: number | undefined;
    deliveredQuantity?: number | undefined;
    deliveryName1?: string | undefined;
    deliveryName2?: string | undefined;
    deliveryStreet?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryDateString?: string | undefined;
    status?: string | undefined;

    constructor(data?: IIOrderHistoryRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.productName = _data["ProductName"];
            this.productSku = _data["ProductSku"];
            this.orderDate = _data["OrderDate"] ? new Date(_data["OrderDate"].toString()) : <any>undefined;
            this.orderType = _data["OrderType"];
            this.unit = _data["Unit"];
            this.currencyName = _data["CurrencyName"];
            this.position = _data["Position"];
            this.positionType = _data["PositionType"];
            this.quantity = _data["Quantity"];
            this.price = _data["Price"];
            this.priceDecimal = _data["PriceDecimal"];
            this.deliveredQuantity = _data["DeliveredQuantity"];
            this.deliveryName1 = _data["DeliveryName1"];
            this.deliveryName2 = _data["DeliveryName2"];
            this.deliveryStreet = _data["DeliveryStreet"];
            this.deliveryPostCode = _data["DeliveryPostCode"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryDateString = _data["DeliveryDateString"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): IOrderHistoryRow {
        data = typeof data === 'object' ? data : {};
        let result = new IOrderHistoryRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["ProductName"] = this.productName;
        data["ProductSku"] = this.productSku;
        data["OrderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["OrderType"] = this.orderType;
        data["Unit"] = this.unit;
        data["CurrencyName"] = this.currencyName;
        data["Position"] = this.position;
        data["PositionType"] = this.positionType;
        data["Quantity"] = this.quantity;
        data["Price"] = this.price;
        data["PriceDecimal"] = this.priceDecimal;
        data["DeliveredQuantity"] = this.deliveredQuantity;
        data["DeliveryName1"] = this.deliveryName1;
        data["DeliveryName2"] = this.deliveryName2;
        data["DeliveryStreet"] = this.deliveryStreet;
        data["DeliveryPostCode"] = this.deliveryPostCode;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryDateString"] = this.deliveryDateString;
        data["Status"] = this.status;
        return data;
    }
}

export interface IIOrderHistoryRow {
    number?: string | undefined;
    productName?: string | undefined;
    productSku?: string | undefined;
    orderDate?: Date | undefined;
    orderType?: string | undefined;
    unit?: string | undefined;
    currencyName?: string | undefined;
    position?: string | undefined;
    positionType?: string | undefined;
    quantity?: number | undefined;
    price?: string | undefined;
    priceDecimal?: number | undefined;
    deliveredQuantity?: number | undefined;
    deliveryName1?: string | undefined;
    deliveryName2?: string | undefined;
    deliveryStreet?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryDateString?: string | undefined;
    status?: string | undefined;
}

export class Channel implements IChannel {
    title?: string | undefined;
    link?: string | undefined;
    description?: string | undefined;
    products?: FeedProduct[] | undefined;

    constructor(data?: IChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.link = _data["Link"];
            this.description = _data["Description"];
            if (Array.isArray(_data["Products"])) {
                this.products = [] as any;
                for (let item of _data["Products"])
                    this.products!.push(FeedProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Channel {
        data = typeof data === 'object' ? data : {};
        let result = new Channel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Link"] = this.link;
        data["Description"] = this.description;
        if (Array.isArray(this.products)) {
            data["Products"] = [];
            for (let item of this.products)
                data["Products"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChannel {
    title?: string | undefined;
    link?: string | undefined;
    description?: string | undefined;
    products?: FeedProduct[] | undefined;
}

export class FeedProduct implements IFeedProduct {
    id?: string | undefined;
    title?: string | undefined;
    quantity?: number | undefined;
    titleCD?: any[] | undefined;
    description?: string | undefined;
    descriptionCD?: any[] | undefined;
    googleProductCategory?: string | undefined;
    googleProductCategoryCD?: any[] | undefined;
    productType?: string | undefined;
    productTypeCD?: any[] | undefined;
    link?: string | undefined;
    mobileLink?: string | undefined;
    imageLink?: string | undefined;
    additionalImageLink?: string[] | undefined;
    condition?: string | undefined;
    availability?: string | undefined;
    availabilityDate?: string | undefined;
    price?: string | undefined;
    salePrice?: string | undefined;
    salePriceEffectiveDate?: string | undefined;
    brand?: string | undefined;
    gTIN?: string | undefined;
    mPN?: string | undefined;
    identifierExists?: string | undefined;
    gender?: string | undefined;
    ageGroup?: string | undefined;
    color?: string | undefined;
    size?: string | undefined;
    sizeType?: string | undefined;
    sizeSystem?: string | undefined;
    itemGroupId?: string | undefined;
    material?: string | undefined;
    pattern?: string | undefined;
    shipping?: FeedShipping | undefined;
    shippingWeight?: string | undefined;
    shippingLabel?: string | undefined;
    multipack?: string | undefined;
    isBundle?: string | undefined;
    adult?: string | undefined;
    adwordsRedirect?: string | undefined;
    customLabel0?: string | undefined;
    customLabel1?: string | undefined;
    customLabel2?: string | undefined;
    customLabel3?: string | undefined;
    customLabel4?: string | undefined;
    excludedDestination?: string | undefined;
    expirationDate?: string | undefined;
    unitPricingMeasure?: string | undefined;
    unitPricingBaseMeasure?: string | undefined;
    energyEfficiencyClass?: string | undefined;

    constructor(data?: IFeedProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            this.quantity = _data["Quantity"];
            if (Array.isArray(_data["TitleCD"])) {
                this.titleCD = [] as any;
                for (let item of _data["TitleCD"])
                    this.titleCD!.push(item);
            }
            this.description = _data["Description"];
            if (Array.isArray(_data["DescriptionCD"])) {
                this.descriptionCD = [] as any;
                for (let item of _data["DescriptionCD"])
                    this.descriptionCD!.push(item);
            }
            this.googleProductCategory = _data["GoogleProductCategory"];
            if (Array.isArray(_data["GoogleProductCategoryCD"])) {
                this.googleProductCategoryCD = [] as any;
                for (let item of _data["GoogleProductCategoryCD"])
                    this.googleProductCategoryCD!.push(item);
            }
            this.productType = _data["ProductType"];
            if (Array.isArray(_data["ProductTypeCD"])) {
                this.productTypeCD = [] as any;
                for (let item of _data["ProductTypeCD"])
                    this.productTypeCD!.push(item);
            }
            this.link = _data["Link"];
            this.mobileLink = _data["MobileLink"];
            this.imageLink = _data["ImageLink"];
            if (Array.isArray(_data["AdditionalImageLink"])) {
                this.additionalImageLink = [] as any;
                for (let item of _data["AdditionalImageLink"])
                    this.additionalImageLink!.push(item);
            }
            this.condition = _data["Condition"];
            this.availability = _data["Availability"];
            this.availabilityDate = _data["AvailabilityDate"];
            this.price = _data["Price"];
            this.salePrice = _data["SalePrice"];
            this.salePriceEffectiveDate = _data["SalePriceEffectiveDate"];
            this.brand = _data["Brand"];
            this.gTIN = _data["GTIN"];
            this.mPN = _data["MPN"];
            this.identifierExists = _data["IdentifierExists"];
            this.gender = _data["Gender"];
            this.ageGroup = _data["AgeGroup"];
            this.color = _data["Color"];
            this.size = _data["Size"];
            this.sizeType = _data["SizeType"];
            this.sizeSystem = _data["SizeSystem"];
            this.itemGroupId = _data["ItemGroupId"];
            this.material = _data["Material"];
            this.pattern = _data["Pattern"];
            this.shipping = _data["Shipping"] ? FeedShipping.fromJS(_data["Shipping"]) : <any>undefined;
            this.shippingWeight = _data["ShippingWeight"];
            this.shippingLabel = _data["ShippingLabel"];
            this.multipack = _data["Multipack"];
            this.isBundle = _data["IsBundle"];
            this.adult = _data["Adult"];
            this.adwordsRedirect = _data["AdwordsRedirect"];
            this.customLabel0 = _data["CustomLabel0"];
            this.customLabel1 = _data["CustomLabel1"];
            this.customLabel2 = _data["CustomLabel2"];
            this.customLabel3 = _data["CustomLabel3"];
            this.customLabel4 = _data["CustomLabel4"];
            this.excludedDestination = _data["ExcludedDestination"];
            this.expirationDate = _data["ExpirationDate"];
            this.unitPricingMeasure = _data["UnitPricingMeasure"];
            this.unitPricingBaseMeasure = _data["UnitPricingBaseMeasure"];
            this.energyEfficiencyClass = _data["EnergyEfficiencyClass"];
        }
    }

    static fromJS(data: any): FeedProduct {
        data = typeof data === 'object' ? data : {};
        let result = new FeedProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["Quantity"] = this.quantity;
        if (Array.isArray(this.titleCD)) {
            data["TitleCD"] = [];
            for (let item of this.titleCD)
                data["TitleCD"].push(item);
        }
        data["Description"] = this.description;
        if (Array.isArray(this.descriptionCD)) {
            data["DescriptionCD"] = [];
            for (let item of this.descriptionCD)
                data["DescriptionCD"].push(item);
        }
        data["GoogleProductCategory"] = this.googleProductCategory;
        if (Array.isArray(this.googleProductCategoryCD)) {
            data["GoogleProductCategoryCD"] = [];
            for (let item of this.googleProductCategoryCD)
                data["GoogleProductCategoryCD"].push(item);
        }
        data["ProductType"] = this.productType;
        if (Array.isArray(this.productTypeCD)) {
            data["ProductTypeCD"] = [];
            for (let item of this.productTypeCD)
                data["ProductTypeCD"].push(item);
        }
        data["Link"] = this.link;
        data["MobileLink"] = this.mobileLink;
        data["ImageLink"] = this.imageLink;
        if (Array.isArray(this.additionalImageLink)) {
            data["AdditionalImageLink"] = [];
            for (let item of this.additionalImageLink)
                data["AdditionalImageLink"].push(item);
        }
        data["Condition"] = this.condition;
        data["Availability"] = this.availability;
        data["AvailabilityDate"] = this.availabilityDate;
        data["Price"] = this.price;
        data["SalePrice"] = this.salePrice;
        data["SalePriceEffectiveDate"] = this.salePriceEffectiveDate;
        data["Brand"] = this.brand;
        data["GTIN"] = this.gTIN;
        data["MPN"] = this.mPN;
        data["IdentifierExists"] = this.identifierExists;
        data["Gender"] = this.gender;
        data["AgeGroup"] = this.ageGroup;
        data["Color"] = this.color;
        data["Size"] = this.size;
        data["SizeType"] = this.sizeType;
        data["SizeSystem"] = this.sizeSystem;
        data["ItemGroupId"] = this.itemGroupId;
        data["Material"] = this.material;
        data["Pattern"] = this.pattern;
        data["Shipping"] = this.shipping ? this.shipping.toJSON() : <any>undefined;
        data["ShippingWeight"] = this.shippingWeight;
        data["ShippingLabel"] = this.shippingLabel;
        data["Multipack"] = this.multipack;
        data["IsBundle"] = this.isBundle;
        data["Adult"] = this.adult;
        data["AdwordsRedirect"] = this.adwordsRedirect;
        data["CustomLabel0"] = this.customLabel0;
        data["CustomLabel1"] = this.customLabel1;
        data["CustomLabel2"] = this.customLabel2;
        data["CustomLabel3"] = this.customLabel3;
        data["CustomLabel4"] = this.customLabel4;
        data["ExcludedDestination"] = this.excludedDestination;
        data["ExpirationDate"] = this.expirationDate;
        data["UnitPricingMeasure"] = this.unitPricingMeasure;
        data["UnitPricingBaseMeasure"] = this.unitPricingBaseMeasure;
        data["EnergyEfficiencyClass"] = this.energyEfficiencyClass;
        return data;
    }
}

export interface IFeedProduct {
    id?: string | undefined;
    title?: string | undefined;
    quantity?: number | undefined;
    titleCD?: any[] | undefined;
    description?: string | undefined;
    descriptionCD?: any[] | undefined;
    googleProductCategory?: string | undefined;
    googleProductCategoryCD?: any[] | undefined;
    productType?: string | undefined;
    productTypeCD?: any[] | undefined;
    link?: string | undefined;
    mobileLink?: string | undefined;
    imageLink?: string | undefined;
    additionalImageLink?: string[] | undefined;
    condition?: string | undefined;
    availability?: string | undefined;
    availabilityDate?: string | undefined;
    price?: string | undefined;
    salePrice?: string | undefined;
    salePriceEffectiveDate?: string | undefined;
    brand?: string | undefined;
    gTIN?: string | undefined;
    mPN?: string | undefined;
    identifierExists?: string | undefined;
    gender?: string | undefined;
    ageGroup?: string | undefined;
    color?: string | undefined;
    size?: string | undefined;
    sizeType?: string | undefined;
    sizeSystem?: string | undefined;
    itemGroupId?: string | undefined;
    material?: string | undefined;
    pattern?: string | undefined;
    shipping?: FeedShipping | undefined;
    shippingWeight?: string | undefined;
    shippingLabel?: string | undefined;
    multipack?: string | undefined;
    isBundle?: string | undefined;
    adult?: string | undefined;
    adwordsRedirect?: string | undefined;
    customLabel0?: string | undefined;
    customLabel1?: string | undefined;
    customLabel2?: string | undefined;
    customLabel3?: string | undefined;
    customLabel4?: string | undefined;
    excludedDestination?: string | undefined;
    expirationDate?: string | undefined;
    unitPricingMeasure?: string | undefined;
    unitPricingBaseMeasure?: string | undefined;
    energyEfficiencyClass?: string | undefined;
}

export class FeedShipping implements IFeedShipping {
    country?: string | undefined;
    service?: string | undefined;
    price?: string | undefined;

    constructor(data?: IFeedShipping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["Country"];
            this.service = _data["Service"];
            this.price = _data["Price"];
        }
    }

    static fromJS(data: any): FeedShipping {
        data = typeof data === 'object' ? data : {};
        let result = new FeedShipping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Country"] = this.country;
        data["Service"] = this.service;
        data["Price"] = this.price;
        return data;
    }
}

export interface IFeedShipping {
    country?: string | undefined;
    service?: string | undefined;
    price?: string | undefined;
}

export class SalesOffice implements ISalesOffice {
    id?: string | undefined;
    title?: string | undefined;
    readonly sortTitle?: string | undefined;
    address?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    telephone?: string | undefined;
    emails?: string | undefined;
    openingHours?: string[] | undefined;
    mondayOpen?: string | undefined;
    tuesdayOpen?: string | undefined;
    wednesdayOpen?: string | undefined;
    thursdayOpen?: string | undefined;
    fridayOpen?: string | undefined;
    saturdayOpen?: string | undefined;
    sundayOpen?: string | undefined;
    mondayClose?: string | undefined;
    tuesdayClose?: string | undefined;
    wednesdayClose?: string | undefined;
    thursdayClose?: string | undefined;
    fridayClose?: string | undefined;
    saturdayClose?: string | undefined;
    sundayClose?: string | undefined;
    note?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    smallCountryShop?: string | undefined;
    franchiseShop?: boolean | undefined;
    shopType?: string | undefined;
    disableClickAndCollect?: string | undefined;
    plants?: string[] | undefined;
    storageLocation?: string | undefined;
    facebookLink?: string | undefined;

    constructor(data?: ISalesOffice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.title = _data["Title"];
            (<any>this).sortTitle = _data["SortTitle"];
            this.address = _data["Address"];
            this.zipcode = _data["Zipcode"];
            this.city = _data["City"];
            this.region = _data["Region"];
            this.telephone = _data["Telephone"];
            this.emails = _data["Emails"];
            if (Array.isArray(_data["OpeningHours"])) {
                this.openingHours = [] as any;
                for (let item of _data["OpeningHours"])
                    this.openingHours!.push(item);
            }
            this.mondayOpen = _data["MondayOpen"];
            this.tuesdayOpen = _data["TuesdayOpen"];
            this.wednesdayOpen = _data["WednesdayOpen"];
            this.thursdayOpen = _data["ThursdayOpen"];
            this.fridayOpen = _data["FridayOpen"];
            this.saturdayOpen = _data["SaturdayOpen"];
            this.sundayOpen = _data["SundayOpen"];
            this.mondayClose = _data["MondayClose"];
            this.tuesdayClose = _data["TuesdayClose"];
            this.wednesdayClose = _data["WednesdayClose"];
            this.thursdayClose = _data["ThursdayClose"];
            this.fridayClose = _data["FridayClose"];
            this.saturdayClose = _data["SaturdayClose"];
            this.sundayClose = _data["SundayClose"];
            this.note = _data["Note"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.smallCountryShop = _data["SmallCountryShop"];
            this.franchiseShop = _data["FranchiseShop"];
            this.shopType = _data["ShopType"];
            this.disableClickAndCollect = _data["DisableClickAndCollect"];
            if (Array.isArray(_data["Plants"])) {
                this.plants = [] as any;
                for (let item of _data["Plants"])
                    this.plants!.push(item);
            }
            this.storageLocation = _data["StorageLocation"];
            this.facebookLink = _data["FacebookLink"];
        }
    }

    static fromJS(data: any): SalesOffice {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Title"] = this.title;
        data["SortTitle"] = this.sortTitle;
        data["Address"] = this.address;
        data["Zipcode"] = this.zipcode;
        data["City"] = this.city;
        data["Region"] = this.region;
        data["Telephone"] = this.telephone;
        data["Emails"] = this.emails;
        if (Array.isArray(this.openingHours)) {
            data["OpeningHours"] = [];
            for (let item of this.openingHours)
                data["OpeningHours"].push(item);
        }
        data["MondayOpen"] = this.mondayOpen;
        data["TuesdayOpen"] = this.tuesdayOpen;
        data["WednesdayOpen"] = this.wednesdayOpen;
        data["ThursdayOpen"] = this.thursdayOpen;
        data["FridayOpen"] = this.fridayOpen;
        data["SaturdayOpen"] = this.saturdayOpen;
        data["SundayOpen"] = this.sundayOpen;
        data["MondayClose"] = this.mondayClose;
        data["TuesdayClose"] = this.tuesdayClose;
        data["WednesdayClose"] = this.wednesdayClose;
        data["ThursdayClose"] = this.thursdayClose;
        data["FridayClose"] = this.fridayClose;
        data["SaturdayClose"] = this.saturdayClose;
        data["SundayClose"] = this.sundayClose;
        data["Note"] = this.note;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["SmallCountryShop"] = this.smallCountryShop;
        data["FranchiseShop"] = this.franchiseShop;
        data["ShopType"] = this.shopType;
        data["DisableClickAndCollect"] = this.disableClickAndCollect;
        if (Array.isArray(this.plants)) {
            data["Plants"] = [];
            for (let item of this.plants)
                data["Plants"].push(item);
        }
        data["StorageLocation"] = this.storageLocation;
        data["FacebookLink"] = this.facebookLink;
        return data;
    }
}

export interface ISalesOffice {
    id?: string | undefined;
    title?: string | undefined;
    sortTitle?: string | undefined;
    address?: string | undefined;
    zipcode?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    telephone?: string | undefined;
    emails?: string | undefined;
    openingHours?: string[] | undefined;
    mondayOpen?: string | undefined;
    tuesdayOpen?: string | undefined;
    wednesdayOpen?: string | undefined;
    thursdayOpen?: string | undefined;
    fridayOpen?: string | undefined;
    saturdayOpen?: string | undefined;
    sundayOpen?: string | undefined;
    mondayClose?: string | undefined;
    tuesdayClose?: string | undefined;
    wednesdayClose?: string | undefined;
    thursdayClose?: string | undefined;
    fridayClose?: string | undefined;
    saturdayClose?: string | undefined;
    sundayClose?: string | undefined;
    note?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    smallCountryShop?: string | undefined;
    franchiseShop?: boolean | undefined;
    shopType?: string | undefined;
    disableClickAndCollect?: string | undefined;
    plants?: string[] | undefined;
    storageLocation?: string | undefined;
    facebookLink?: string | undefined;
}

export class Item implements IItem {
    readonly access?: ItemAccess | undefined;
    readonly appearance?: ItemAppearance | undefined;
    readonly axes?: ItemAxes | undefined;
    readonly branch?: BranchItem | undefined;
    branchId?: ID | undefined;
    readonly branches?: BranchItem[] | undefined;
    readonly children?: Item[] | undefined;
    readonly created?: Date | undefined;
    readonly database?: Database | undefined;
    readonly displayName?: string | undefined;
    readonly editing?: ItemEditing | undefined;
    readonly empty?: boolean | undefined;
    readonly fields?: Field[] | undefined;
    readonly hasChildren?: boolean | undefined;
    readonly hasClones?: boolean | undefined;
    readonly help?: ItemHelp | undefined;
    readonly iD?: ID | undefined;
    readonly innerData?: ItemData | undefined;
    readonly isClone?: boolean | undefined;
    readonly isFallback?: boolean | undefined;
    readonly key?: string | undefined;
    readonly language?: Language | undefined;
    readonly languages?: Language[] | undefined;
    readonly links?: ItemLinks | undefined;
    readonly locking?: ItemLocking | undefined;
    readonly master?: BranchItem | undefined;
    readonly modified?: boolean | undefined;
    name?: string | undefined;
    readonly originatorId?: ID | undefined;
    originalLanguage?: Language | undefined;
    readonly parent?: Item | undefined;
    readonly parentID?: ID | undefined;
    readonly paths?: ItemPath | undefined;
    readonly publishing?: ItemPublishing | undefined;
    readonly runtimeSettings?: ItemRuntimeSettings | undefined;
    security?: ItemSecurity | undefined;
    readonly source?: Item | undefined;
    readonly sourceUri?: ItemUri | undefined;
    readonly state?: ItemState | undefined;
    readonly statistics?: ItemStatistics | undefined;
    readonly syncRoot?: any | undefined;
    readonly template?: TemplateItem | undefined;
    templateID?: ID | undefined;
    readonly templateName?: string | undefined;
    readonly uri?: ItemUri | undefined;
    readonly version?: Version | undefined;
    readonly versions?: ItemVersions | undefined;
    readonly visualization?: ItemVisualization | undefined;
    readonly isItemClone?: boolean | undefined;
    readonly sharedFieldsSource?: Item | undefined;
    readonly languageFallbackEnabled?: boolean | undefined;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).access = _data["Access"] ? ItemAccess.fromJS(_data["Access"]) : <any>undefined;
            (<any>this).appearance = _data["Appearance"] ? ItemAppearance.fromJS(_data["Appearance"]) : <any>undefined;
            (<any>this).axes = _data["Axes"] ? ItemAxes.fromJS(_data["Axes"]) : <any>undefined;
            (<any>this).branch = _data["Branch"] ? BranchItem.fromJS(_data["Branch"]) : <any>undefined;
            this.branchId = _data["BranchId"] ? ID.fromJS(_data["BranchId"]) : <any>undefined;
            if (Array.isArray(_data["Branches"])) {
                (<any>this).branches = [] as any;
                for (let item of _data["Branches"])
                    (<any>this).branches!.push(BranchItem.fromJS(item));
            }
            if (Array.isArray(_data["Children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["Children"])
                    (<any>this).children!.push(Item.fromJS(item));
            }
            (<any>this).created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).editing = _data["Editing"] ? ItemEditing.fromJS(_data["Editing"]) : <any>undefined;
            (<any>this).empty = _data["Empty"];
            if (Array.isArray(_data["Fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["Fields"])
                    (<any>this).fields!.push(Field.fromJS(item));
            }
            (<any>this).hasChildren = _data["HasChildren"];
            (<any>this).hasClones = _data["HasClones"];
            (<any>this).help = _data["Help"] ? ItemHelp.fromJS(_data["Help"]) : <any>undefined;
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerData = _data["InnerData"] ? ItemData.fromJS(_data["InnerData"]) : <any>undefined;
            (<any>this).isClone = _data["IsClone"];
            (<any>this).isFallback = _data["IsFallback"];
            (<any>this).key = _data["Key"];
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            if (Array.isArray(_data["Languages"])) {
                (<any>this).languages = [] as any;
                for (let item of _data["Languages"])
                    (<any>this).languages!.push(Language.fromJS(item));
            }
            (<any>this).links = _data["Links"] ? ItemLinks.fromJS(_data["Links"]) : <any>undefined;
            (<any>this).locking = _data["Locking"] ? ItemLocking.fromJS(_data["Locking"]) : <any>undefined;
            (<any>this).master = _data["Master"] ? BranchItem.fromJS(_data["Master"]) : <any>undefined;
            (<any>this).modified = _data["Modified"];
            this.name = _data["Name"];
            (<any>this).originatorId = _data["OriginatorId"] ? ID.fromJS(_data["OriginatorId"]) : <any>undefined;
            this.originalLanguage = _data["OriginalLanguage"] ? Language.fromJS(_data["OriginalLanguage"]) : <any>undefined;
            (<any>this).parent = _data["Parent"] ? Item.fromJS(_data["Parent"]) : <any>undefined;
            (<any>this).parentID = _data["ParentID"] ? ID.fromJS(_data["ParentID"]) : <any>undefined;
            (<any>this).paths = _data["Paths"] ? ItemPath.fromJS(_data["Paths"]) : <any>undefined;
            (<any>this).publishing = _data["Publishing"] ? ItemPublishing.fromJS(_data["Publishing"]) : <any>undefined;
            (<any>this).runtimeSettings = _data["RuntimeSettings"] ? ItemRuntimeSettings.fromJS(_data["RuntimeSettings"]) : <any>undefined;
            this.security = _data["Security"] ? ItemSecurity.fromJS(_data["Security"]) : <any>undefined;
            (<any>this).source = _data["Source"] ? Item.fromJS(_data["Source"]) : <any>undefined;
            (<any>this).sourceUri = _data["SourceUri"] ? ItemUri.fromJS(_data["SourceUri"]) : <any>undefined;
            (<any>this).state = _data["State"] ? ItemState.fromJS(_data["State"]) : <any>undefined;
            (<any>this).statistics = _data["Statistics"] ? ItemStatistics.fromJS(_data["Statistics"]) : <any>undefined;
            (<any>this).syncRoot = _data["SyncRoot"];
            (<any>this).template = _data["Template"] ? TemplateItem.fromJS(_data["Template"]) : <any>undefined;
            this.templateID = _data["TemplateID"] ? ID.fromJS(_data["TemplateID"]) : <any>undefined;
            (<any>this).templateName = _data["TemplateName"];
            (<any>this).uri = _data["Uri"] ? ItemUri.fromJS(_data["Uri"]) : <any>undefined;
            (<any>this).version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
            (<any>this).versions = _data["Versions"] ? ItemVersions.fromJS(_data["Versions"]) : <any>undefined;
            (<any>this).visualization = _data["Visualization"] ? ItemVisualization.fromJS(_data["Visualization"]) : <any>undefined;
            (<any>this).isItemClone = _data["IsItemClone"];
            (<any>this).sharedFieldsSource = _data["SharedFieldsSource"] ? Item.fromJS(_data["SharedFieldsSource"]) : <any>undefined;
            (<any>this).languageFallbackEnabled = _data["LanguageFallbackEnabled"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Access"] = this.access ? this.access.toJSON() : <any>undefined;
        data["Appearance"] = this.appearance ? this.appearance.toJSON() : <any>undefined;
        data["Axes"] = this.axes ? this.axes.toJSON() : <any>undefined;
        data["Branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["BranchId"] = this.branchId ? this.branchId.toJSON() : <any>undefined;
        if (Array.isArray(this.branches)) {
            data["Branches"] = [];
            for (let item of this.branches)
                data["Branches"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["Children"] = [];
            for (let item of this.children)
                data["Children"].push(item.toJSON());
        }
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Editing"] = this.editing ? this.editing.toJSON() : <any>undefined;
        data["Empty"] = this.empty;
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        data["HasChildren"] = this.hasChildren;
        data["HasClones"] = this.hasClones;
        data["Help"] = this.help ? this.help.toJSON() : <any>undefined;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerData"] = this.innerData ? this.innerData.toJSON() : <any>undefined;
        data["IsClone"] = this.isClone;
        data["IsFallback"] = this.isFallback;
        data["Key"] = this.key;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item.toJSON());
        }
        data["Links"] = this.links ? this.links.toJSON() : <any>undefined;
        data["Locking"] = this.locking ? this.locking.toJSON() : <any>undefined;
        data["Master"] = this.master ? this.master.toJSON() : <any>undefined;
        data["Modified"] = this.modified;
        data["Name"] = this.name;
        data["OriginatorId"] = this.originatorId ? this.originatorId.toJSON() : <any>undefined;
        data["OriginalLanguage"] = this.originalLanguage ? this.originalLanguage.toJSON() : <any>undefined;
        data["Parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        data["ParentID"] = this.parentID ? this.parentID.toJSON() : <any>undefined;
        data["Paths"] = this.paths ? this.paths.toJSON() : <any>undefined;
        data["Publishing"] = this.publishing ? this.publishing.toJSON() : <any>undefined;
        data["RuntimeSettings"] = this.runtimeSettings ? this.runtimeSettings.toJSON() : <any>undefined;
        data["Security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["SourceUri"] = this.sourceUri ? this.sourceUri.toJSON() : <any>undefined;
        data["State"] = this.state ? this.state.toJSON() : <any>undefined;
        data["Statistics"] = this.statistics ? this.statistics.toJSON() : <any>undefined;
        data["SyncRoot"] = this.syncRoot;
        data["Template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["TemplateID"] = this.templateID ? this.templateID.toJSON() : <any>undefined;
        data["TemplateName"] = this.templateName;
        data["Uri"] = this.uri ? this.uri.toJSON() : <any>undefined;
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["Versions"] = this.versions ? this.versions.toJSON() : <any>undefined;
        data["Visualization"] = this.visualization ? this.visualization.toJSON() : <any>undefined;
        data["IsItemClone"] = this.isItemClone;
        data["SharedFieldsSource"] = this.sharedFieldsSource ? this.sharedFieldsSource.toJSON() : <any>undefined;
        data["LanguageFallbackEnabled"] = this.languageFallbackEnabled;
        return data;
    }
}

export interface IItem {
    access?: ItemAccess | undefined;
    appearance?: ItemAppearance | undefined;
    axes?: ItemAxes | undefined;
    branch?: BranchItem | undefined;
    branchId?: ID | undefined;
    branches?: BranchItem[] | undefined;
    children?: Item[] | undefined;
    created?: Date | undefined;
    database?: Database | undefined;
    displayName?: string | undefined;
    editing?: ItemEditing | undefined;
    empty?: boolean | undefined;
    fields?: Field[] | undefined;
    hasChildren?: boolean | undefined;
    hasClones?: boolean | undefined;
    help?: ItemHelp | undefined;
    iD?: ID | undefined;
    innerData?: ItemData | undefined;
    isClone?: boolean | undefined;
    isFallback?: boolean | undefined;
    key?: string | undefined;
    language?: Language | undefined;
    languages?: Language[] | undefined;
    links?: ItemLinks | undefined;
    locking?: ItemLocking | undefined;
    master?: BranchItem | undefined;
    modified?: boolean | undefined;
    name?: string | undefined;
    originatorId?: ID | undefined;
    originalLanguage?: Language | undefined;
    parent?: Item | undefined;
    parentID?: ID | undefined;
    paths?: ItemPath | undefined;
    publishing?: ItemPublishing | undefined;
    runtimeSettings?: ItemRuntimeSettings | undefined;
    security?: ItemSecurity | undefined;
    source?: Item | undefined;
    sourceUri?: ItemUri | undefined;
    state?: ItemState | undefined;
    statistics?: ItemStatistics | undefined;
    syncRoot?: any | undefined;
    template?: TemplateItem | undefined;
    templateID?: ID | undefined;
    templateName?: string | undefined;
    uri?: ItemUri | undefined;
    version?: Version | undefined;
    versions?: ItemVersions | undefined;
    visualization?: ItemVisualization | undefined;
    isItemClone?: boolean | undefined;
    sharedFieldsSource?: Item | undefined;
    languageFallbackEnabled?: boolean | undefined;
}

export class ItemAccess implements IItemAccess {

    constructor(data?: IItemAccess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ItemAccess {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAccess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IItemAccess {
}

export class ItemAppearance implements IItemAppearance {
    contextMenu?: string | undefined;
    customEditor?: string | undefined;
    displayName?: string | undefined;
    helpLink?: string | undefined;
    hidden?: boolean | undefined;
    icon?: string | undefined;
    longDescription?: string | undefined;
    readOnly?: boolean | undefined;
    ribbon?: string | undefined;
    shortDescription?: string | undefined;
    readonly skin?: string | undefined;
    sortorder?: number | undefined;
    style?: string | undefined;
    thumbnail?: string | undefined;

    constructor(data?: IItemAppearance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contextMenu = _data["ContextMenu"];
            this.customEditor = _data["CustomEditor"];
            this.displayName = _data["DisplayName"];
            this.helpLink = _data["HelpLink"];
            this.hidden = _data["Hidden"];
            this.icon = _data["Icon"];
            this.longDescription = _data["LongDescription"];
            this.readOnly = _data["ReadOnly"];
            this.ribbon = _data["Ribbon"];
            this.shortDescription = _data["ShortDescription"];
            (<any>this).skin = _data["Skin"];
            this.sortorder = _data["Sortorder"];
            this.style = _data["Style"];
            this.thumbnail = _data["Thumbnail"];
        }
    }

    static fromJS(data: any): ItemAppearance {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAppearance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContextMenu"] = this.contextMenu;
        data["CustomEditor"] = this.customEditor;
        data["DisplayName"] = this.displayName;
        data["HelpLink"] = this.helpLink;
        data["Hidden"] = this.hidden;
        data["Icon"] = this.icon;
        data["LongDescription"] = this.longDescription;
        data["ReadOnly"] = this.readOnly;
        data["Ribbon"] = this.ribbon;
        data["ShortDescription"] = this.shortDescription;
        data["Skin"] = this.skin;
        data["Sortorder"] = this.sortorder;
        data["Style"] = this.style;
        data["Thumbnail"] = this.thumbnail;
        return data;
    }
}

export interface IItemAppearance {
    contextMenu?: string | undefined;
    customEditor?: string | undefined;
    displayName?: string | undefined;
    helpLink?: string | undefined;
    hidden?: boolean | undefined;
    icon?: string | undefined;
    longDescription?: string | undefined;
    readOnly?: boolean | undefined;
    ribbon?: string | undefined;
    shortDescription?: string | undefined;
    skin?: string | undefined;
    sortorder?: number | undefined;
    style?: string | undefined;
    thumbnail?: string | undefined;
}

export class ItemAxes implements IItemAxes {
    readonly level?: number | undefined;
    readonly root?: Item | undefined;

    constructor(data?: IItemAxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).level = _data["Level"];
            (<any>this).root = _data["Root"] ? Item.fromJS(_data["Root"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemAxes {
        data = typeof data === 'object' ? data : {};
        let result = new ItemAxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Level"] = this.level;
        data["Root"] = this.root ? this.root.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemAxes {
    level?: number | undefined;
    root?: Item | undefined;
}

export class BranchItem implements IBranchItem {
    readonly key?: string | undefined;
    readonly standardValues?: Item | undefined;
    readonly database?: Database | undefined;
    readonly displayName?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly innerItem?: Item | undefined;
    readonly name?: string | undefined;

    constructor(data?: IBranchItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).key = _data["Key"];
            (<any>this).standardValues = _data["StandardValues"] ? Item.fromJS(_data["StandardValues"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): BranchItem {
        data = typeof data === 'object' ? data : {};
        let result = new BranchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key;
        data["StandardValues"] = this.standardValues ? this.standardValues.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface IBranchItem {
    key?: string | undefined;
    standardValues?: Item | undefined;
    database?: Database | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    innerItem?: Item | undefined;
    name?: string | undefined;
}

export class ID implements IID {
    readonly guid?: string | undefined;
    readonly isGlobalNullId?: boolean | undefined;
    readonly isNull?: boolean | undefined;

    constructor(data?: IID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).guid = _data["Guid"];
            (<any>this).isGlobalNullId = _data["IsGlobalNullId"];
            (<any>this).isNull = _data["IsNull"];
        }
    }

    static fromJS(data: any): ID {
        data = typeof data === 'object' ? data : {};
        let result = new ID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Guid"] = this.guid;
        data["IsGlobalNullId"] = this.isGlobalNullId;
        data["IsNull"] = this.isNull;
        return data;
    }
}

export interface IID {
    guid?: string | undefined;
    isGlobalNullId?: boolean | undefined;
    isNull?: boolean | undefined;
}

export class Database implements IDatabase {
    readonly aliases?: AliasResolver | undefined;
    readonly archiveNames?: string[] | undefined;
    readonly archives?: DataArchives | undefined;
    readonly caches?: DatabaseCaches | undefined;
    connectionStringName?: string | undefined;
    readonly dataManager?: DataManager | undefined;
    readonly engines?: DatabaseEngines | undefined;
    readonly hasContentItem?: boolean | undefined;
    icon?: string | undefined;
    readonly items?: ItemRecords | undefined;
    readonly languages?: Language[] | undefined;
    readonly branches?: BranchRecords | undefined;
    readonly name?: string | undefined;
    readonly properties?: DatabaseProperties | undefined;
    propertyStore?: IPropertyStore | undefined;
    protected?: boolean | undefined;
    publishVirtualItems?: boolean | undefined;
    readOnly?: boolean | undefined;
    readonly remoteEvents?: DatabaseRemoteEvents | undefined;
    readonly resources?: ResourceItems | undefined;
    securityEnabled?: boolean | undefined;
    readonly sitecoreItem?: Item | undefined;
    readonly templates?: TemplateRecords | undefined;
    workflowProvider?: IWorkflowProvider | undefined;
    notificationProvider?: NotificationProvider | undefined;

    constructor(data?: IDatabase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).aliases = _data["Aliases"] ? AliasResolver.fromJS(_data["Aliases"]) : <any>undefined;
            if (Array.isArray(_data["ArchiveNames"])) {
                (<any>this).archiveNames = [] as any;
                for (let item of _data["ArchiveNames"])
                    (<any>this).archiveNames!.push(item);
            }
            (<any>this).archives = _data["Archives"] ? DataArchives.fromJS(_data["Archives"]) : <any>undefined;
            (<any>this).caches = _data["Caches"] ? DatabaseCaches.fromJS(_data["Caches"]) : <any>undefined;
            this.connectionStringName = _data["ConnectionStringName"];
            (<any>this).dataManager = _data["DataManager"] ? DataManager.fromJS(_data["DataManager"]) : <any>undefined;
            (<any>this).engines = _data["Engines"] ? DatabaseEngines.fromJS(_data["Engines"]) : <any>undefined;
            (<any>this).hasContentItem = _data["HasContentItem"];
            this.icon = _data["Icon"];
            (<any>this).items = _data["Items"] ? ItemRecords.fromJS(_data["Items"]) : <any>undefined;
            if (Array.isArray(_data["Languages"])) {
                (<any>this).languages = [] as any;
                for (let item of _data["Languages"])
                    (<any>this).languages!.push(Language.fromJS(item));
            }
            (<any>this).branches = _data["Branches"] ? BranchRecords.fromJS(_data["Branches"]) : <any>undefined;
            (<any>this).name = _data["Name"];
            (<any>this).properties = _data["Properties"] ? DatabaseProperties.fromJS(_data["Properties"]) : <any>undefined;
            this.propertyStore = _data["PropertyStore"] ? IPropertyStore.fromJS(_data["PropertyStore"]) : <any>undefined;
            this.protected = _data["Protected"];
            this.publishVirtualItems = _data["PublishVirtualItems"];
            this.readOnly = _data["ReadOnly"];
            (<any>this).remoteEvents = _data["RemoteEvents"] ? DatabaseRemoteEvents.fromJS(_data["RemoteEvents"]) : <any>undefined;
            (<any>this).resources = _data["Resources"] ? ResourceItems.fromJS(_data["Resources"]) : <any>undefined;
            this.securityEnabled = _data["SecurityEnabled"];
            (<any>this).sitecoreItem = _data["SitecoreItem"] ? Item.fromJS(_data["SitecoreItem"]) : <any>undefined;
            (<any>this).templates = _data["Templates"] ? TemplateRecords.fromJS(_data["Templates"]) : <any>undefined;
            this.workflowProvider = _data["WorkflowProvider"] ? IWorkflowProvider.fromJS(_data["WorkflowProvider"]) : <any>undefined;
            this.notificationProvider = _data["NotificationProvider"] ? NotificationProvider.fromJS(_data["NotificationProvider"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Database {
        data = typeof data === 'object' ? data : {};
        let result = new Database();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Aliases"] = this.aliases ? this.aliases.toJSON() : <any>undefined;
        if (Array.isArray(this.archiveNames)) {
            data["ArchiveNames"] = [];
            for (let item of this.archiveNames)
                data["ArchiveNames"].push(item);
        }
        data["Archives"] = this.archives ? this.archives.toJSON() : <any>undefined;
        data["Caches"] = this.caches ? this.caches.toJSON() : <any>undefined;
        data["ConnectionStringName"] = this.connectionStringName;
        data["DataManager"] = this.dataManager ? this.dataManager.toJSON() : <any>undefined;
        data["Engines"] = this.engines ? this.engines.toJSON() : <any>undefined;
        data["HasContentItem"] = this.hasContentItem;
        data["Icon"] = this.icon;
        data["Items"] = this.items ? this.items.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item.toJSON());
        }
        data["Branches"] = this.branches ? this.branches.toJSON() : <any>undefined;
        data["Name"] = this.name;
        data["Properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["PropertyStore"] = this.propertyStore ? this.propertyStore.toJSON() : <any>undefined;
        data["Protected"] = this.protected;
        data["PublishVirtualItems"] = this.publishVirtualItems;
        data["ReadOnly"] = this.readOnly;
        data["RemoteEvents"] = this.remoteEvents ? this.remoteEvents.toJSON() : <any>undefined;
        data["Resources"] = this.resources ? this.resources.toJSON() : <any>undefined;
        data["SecurityEnabled"] = this.securityEnabled;
        data["SitecoreItem"] = this.sitecoreItem ? this.sitecoreItem.toJSON() : <any>undefined;
        data["Templates"] = this.templates ? this.templates.toJSON() : <any>undefined;
        data["WorkflowProvider"] = this.workflowProvider ? this.workflowProvider.toJSON() : <any>undefined;
        data["NotificationProvider"] = this.notificationProvider ? this.notificationProvider.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatabase {
    aliases?: AliasResolver | undefined;
    archiveNames?: string[] | undefined;
    archives?: DataArchives | undefined;
    caches?: DatabaseCaches | undefined;
    connectionStringName?: string | undefined;
    dataManager?: DataManager | undefined;
    engines?: DatabaseEngines | undefined;
    hasContentItem?: boolean | undefined;
    icon?: string | undefined;
    items?: ItemRecords | undefined;
    languages?: Language[] | undefined;
    branches?: BranchRecords | undefined;
    name?: string | undefined;
    properties?: DatabaseProperties | undefined;
    propertyStore?: IPropertyStore | undefined;
    protected?: boolean | undefined;
    publishVirtualItems?: boolean | undefined;
    readOnly?: boolean | undefined;
    remoteEvents?: DatabaseRemoteEvents | undefined;
    resources?: ResourceItems | undefined;
    securityEnabled?: boolean | undefined;
    sitecoreItem?: Item | undefined;
    templates?: TemplateRecords | undefined;
    workflowProvider?: IWorkflowProvider | undefined;
    notificationProvider?: NotificationProvider | undefined;
}

export class ItemEditing implements IItemEditing {
    readonly isEditing?: boolean | undefined;

    constructor(data?: IItemEditing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isEditing = _data["IsEditing"];
        }
    }

    static fromJS(data: any): ItemEditing {
        data = typeof data === 'object' ? data : {};
        let result = new ItemEditing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsEditing"] = this.isEditing;
        return data;
    }
}

export interface IItemEditing {
    isEditing?: boolean | undefined;
}

export class Field implements IField {
    readonly canRead?: boolean | undefined;
    readonly canWrite?: boolean | undefined;
    readonly containsStandardValue?: boolean | undefined;
    readonly containsFallbackValue?: boolean | undefined;
    readonly isValidForLanguageFallback?: boolean | undefined;
    readonly inheritsValueFromOtherItem?: boolean | undefined;
    readonly fallbackValueSource?: string | undefined;
    readonly innerItem?: Item | undefined;
    readonly database?: Database | undefined;
    readonly definition?: TemplateField | undefined;
    readonly description?: string | undefined;
    readonly displayName?: string | undefined;
    readonly sectionDisplayName?: string | undefined;
    readonly hasBlobStream?: boolean | undefined;
    readonly hasValue?: boolean | undefined;
    readonly helpLink?: string | undefined;
    readonly iD?: ID | undefined;
    readonly inheritedValue?: string | undefined;
    readonly isBlobField?: boolean | undefined;
    readonly isModified?: boolean | undefined;
    readonly item?: Item | undefined;
    readonly key?: string | undefined;
    readonly language?: Language | undefined;
    readonly sharedLanguageFallbackEnabled?: boolean | undefined;
    readonly name?: string | undefined;
    readonly resetBlank?: boolean | undefined;
    readonly section?: string | undefined;
    readonly sectionNameByUILocale?: string | undefined;
    readonly sectionSortorder?: number | undefined;
    readonly shared?: boolean | undefined;
    readonly shouldBeTranslated?: boolean | undefined;
    readonly sortorder?: number | undefined;
    readonly source?: string | undefined;
    readonly style?: string | undefined;
    readonly title?: string | undefined;
    readonly toolTip?: string | undefined;
    readonly translatable?: boolean | undefined;
    readonly type?: string | undefined;
    readonly typeKey?: string | undefined;
    readonly unversioned?: boolean | undefined;
    readonly validation?: string | undefined;
    readonly validationText?: string | undefined;
    value?: string | undefined;

    constructor(data?: IField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["CanRead"];
            (<any>this).canWrite = _data["CanWrite"];
            (<any>this).containsStandardValue = _data["ContainsStandardValue"];
            (<any>this).containsFallbackValue = _data["ContainsFallbackValue"];
            (<any>this).isValidForLanguageFallback = _data["IsValidForLanguageFallback"];
            (<any>this).inheritsValueFromOtherItem = _data["InheritsValueFromOtherItem"];
            (<any>this).fallbackValueSource = _data["FallbackValueSource"];
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).definition = _data["Definition"] ? TemplateField.fromJS(_data["Definition"]) : <any>undefined;
            (<any>this).description = _data["Description"];
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).sectionDisplayName = _data["SectionDisplayName"];
            (<any>this).hasBlobStream = _data["HasBlobStream"];
            (<any>this).hasValue = _data["HasValue"];
            (<any>this).helpLink = _data["HelpLink"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).inheritedValue = _data["InheritedValue"];
            (<any>this).isBlobField = _data["IsBlobField"];
            (<any>this).isModified = _data["IsModified"];
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).key = _data["Key"];
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).sharedLanguageFallbackEnabled = _data["SharedLanguageFallbackEnabled"];
            (<any>this).name = _data["Name"];
            (<any>this).resetBlank = _data["ResetBlank"];
            (<any>this).section = _data["Section"];
            (<any>this).sectionNameByUILocale = _data["SectionNameByUILocale"];
            (<any>this).sectionSortorder = _data["SectionSortorder"];
            (<any>this).shared = _data["Shared"];
            (<any>this).shouldBeTranslated = _data["ShouldBeTranslated"];
            (<any>this).sortorder = _data["Sortorder"];
            (<any>this).source = _data["Source"];
            (<any>this).style = _data["Style"];
            (<any>this).title = _data["Title"];
            (<any>this).toolTip = _data["ToolTip"];
            (<any>this).translatable = _data["Translatable"];
            (<any>this).type = _data["Type"];
            (<any>this).typeKey = _data["TypeKey"];
            (<any>this).unversioned = _data["Unversioned"];
            (<any>this).validation = _data["Validation"];
            (<any>this).validationText = _data["ValidationText"];
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): Field {
        data = typeof data === 'object' ? data : {};
        let result = new Field();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanRead"] = this.canRead;
        data["CanWrite"] = this.canWrite;
        data["ContainsStandardValue"] = this.containsStandardValue;
        data["ContainsFallbackValue"] = this.containsFallbackValue;
        data["IsValidForLanguageFallback"] = this.isValidForLanguageFallback;
        data["InheritsValueFromOtherItem"] = this.inheritsValueFromOtherItem;
        data["FallbackValueSource"] = this.fallbackValueSource;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["Definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        data["Description"] = this.description;
        data["DisplayName"] = this.displayName;
        data["SectionDisplayName"] = this.sectionDisplayName;
        data["HasBlobStream"] = this.hasBlobStream;
        data["HasValue"] = this.hasValue;
        data["HelpLink"] = this.helpLink;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InheritedValue"] = this.inheritedValue;
        data["IsBlobField"] = this.isBlobField;
        data["IsModified"] = this.isModified;
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Key"] = this.key;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["SharedLanguageFallbackEnabled"] = this.sharedLanguageFallbackEnabled;
        data["Name"] = this.name;
        data["ResetBlank"] = this.resetBlank;
        data["Section"] = this.section;
        data["SectionNameByUILocale"] = this.sectionNameByUILocale;
        data["SectionSortorder"] = this.sectionSortorder;
        data["Shared"] = this.shared;
        data["ShouldBeTranslated"] = this.shouldBeTranslated;
        data["Sortorder"] = this.sortorder;
        data["Source"] = this.source;
        data["Style"] = this.style;
        data["Title"] = this.title;
        data["ToolTip"] = this.toolTip;
        data["Translatable"] = this.translatable;
        data["Type"] = this.type;
        data["TypeKey"] = this.typeKey;
        data["Unversioned"] = this.unversioned;
        data["Validation"] = this.validation;
        data["ValidationText"] = this.validationText;
        data["Value"] = this.value;
        return data;
    }
}

export interface IField {
    canRead?: boolean | undefined;
    canWrite?: boolean | undefined;
    containsStandardValue?: boolean | undefined;
    containsFallbackValue?: boolean | undefined;
    isValidForLanguageFallback?: boolean | undefined;
    inheritsValueFromOtherItem?: boolean | undefined;
    fallbackValueSource?: string | undefined;
    innerItem?: Item | undefined;
    database?: Database | undefined;
    definition?: TemplateField | undefined;
    description?: string | undefined;
    displayName?: string | undefined;
    sectionDisplayName?: string | undefined;
    hasBlobStream?: boolean | undefined;
    hasValue?: boolean | undefined;
    helpLink?: string | undefined;
    iD?: ID | undefined;
    inheritedValue?: string | undefined;
    isBlobField?: boolean | undefined;
    isModified?: boolean | undefined;
    item?: Item | undefined;
    key?: string | undefined;
    language?: Language | undefined;
    sharedLanguageFallbackEnabled?: boolean | undefined;
    name?: string | undefined;
    resetBlank?: boolean | undefined;
    section?: string | undefined;
    sectionNameByUILocale?: string | undefined;
    sectionSortorder?: number | undefined;
    shared?: boolean | undefined;
    shouldBeTranslated?: boolean | undefined;
    sortorder?: number | undefined;
    source?: string | undefined;
    style?: string | undefined;
    title?: string | undefined;
    toolTip?: string | undefined;
    translatable?: boolean | undefined;
    type?: string | undefined;
    typeKey?: string | undefined;
    unversioned?: boolean | undefined;
    validation?: string | undefined;
    validationText?: string | undefined;
    value?: string | undefined;
}

export class ItemHelp implements IItemHelp {
    toolTip?: string | undefined;
    text?: string | undefined;
    link?: string | undefined;

    constructor(data?: IItemHelp) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolTip = _data["ToolTip"];
            this.text = _data["Text"];
            this.link = _data["Link"];
        }
    }

    static fromJS(data: any): ItemHelp {
        data = typeof data === 'object' ? data : {};
        let result = new ItemHelp();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ToolTip"] = this.toolTip;
        data["Text"] = this.text;
        data["Link"] = this.link;
        return data;
    }
}

export interface IItemHelp {
    toolTip?: string | undefined;
    text?: string | undefined;
    link?: string | undefined;
}

export class ItemData implements IItemData {
    readonly definition?: ItemDefinition | undefined;
    readonly fields?: any[] | undefined;
    readonly language?: Language | undefined;
    readonly version?: Version | undefined;

    constructor(data?: IItemData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).definition = _data["Definition"] ? ItemDefinition.fromJS(_data["Definition"]) : <any>undefined;
            if (Array.isArray(_data["Fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["Fields"])
                    (<any>this).fields!.push(item);
            }
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemData {
        data = typeof data === 'object' ? data : {};
        let result = new ItemData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Definition"] = this.definition ? this.definition.toJSON() : <any>undefined;
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item);
        }
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemData {
    definition?: ItemDefinition | undefined;
    fields?: any[] | undefined;
    language?: Language | undefined;
    version?: Version | undefined;
}

export class Language implements ILanguage {
    readonly cultureInfo?: string | undefined;
    readonly origin?: LanguageOrigin | undefined;
    readonly name?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cultureInfo = _data["CultureInfo"];
            (<any>this).origin = _data["Origin"] ? LanguageOrigin.fromJS(_data["Origin"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CultureInfo"] = this.cultureInfo;
        data["Origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface ILanguage {
    cultureInfo?: string | undefined;
    origin?: LanguageOrigin | undefined;
    name?: string | undefined;
}

export class ItemLinks implements IItemLinks {
    readonly database?: Database | undefined;
    readonly item?: Item | undefined;

    constructor(data?: IItemLinks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemLinks {
        data = typeof data === 'object' ? data : {};
        let result = new ItemLinks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemLinks {
    database?: Database | undefined;
    item?: Item | undefined;
}

export class ItemLocking implements IItemLocking {

    constructor(data?: IItemLocking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ItemLocking {
        data = typeof data === 'object' ? data : {};
        let result = new ItemLocking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IItemLocking {
}

export class ItemPath implements IItemPath {
    readonly item?: Item | undefined;
    readonly contentPath?: string | undefined;
    readonly fullPath?: string | undefined;
    readonly isContentItem?: boolean | undefined;
    readonly isFullyQualified?: boolean | undefined;
    readonly isMasterPart?: boolean | undefined;
    readonly isMediaItem?: boolean | undefined;
    readonly longID?: string | undefined;
    readonly mediaPath?: string | undefined;
    readonly parentPath?: string | undefined;
    readonly path?: string | undefined;

    constructor(data?: IItemPath) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).contentPath = _data["ContentPath"];
            (<any>this).fullPath = _data["FullPath"];
            (<any>this).isContentItem = _data["IsContentItem"];
            (<any>this).isFullyQualified = _data["IsFullyQualified"];
            (<any>this).isMasterPart = _data["IsMasterPart"];
            (<any>this).isMediaItem = _data["IsMediaItem"];
            (<any>this).longID = _data["LongID"];
            (<any>this).mediaPath = _data["MediaPath"];
            (<any>this).parentPath = _data["ParentPath"];
            (<any>this).path = _data["Path"];
        }
    }

    static fromJS(data: any): ItemPath {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPath();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["ContentPath"] = this.contentPath;
        data["FullPath"] = this.fullPath;
        data["IsContentItem"] = this.isContentItem;
        data["IsFullyQualified"] = this.isFullyQualified;
        data["IsMasterPart"] = this.isMasterPart;
        data["IsMediaItem"] = this.isMediaItem;
        data["LongID"] = this.longID;
        data["MediaPath"] = this.mediaPath;
        data["ParentPath"] = this.parentPath;
        data["Path"] = this.path;
        return data;
    }
}

export interface IItemPath {
    item?: Item | undefined;
    contentPath?: string | undefined;
    fullPath?: string | undefined;
    isContentItem?: boolean | undefined;
    isFullyQualified?: boolean | undefined;
    isMasterPart?: boolean | undefined;
    isMediaItem?: boolean | undefined;
    longID?: string | undefined;
    mediaPath?: string | undefined;
    parentPath?: string | undefined;
    path?: string | undefined;
}

export class ItemPublishing implements IItemPublishing {
    hideVersion?: boolean | undefined;
    neverPublish?: boolean | undefined;
    publishDate?: Date | undefined;
    unpublishDate?: Date | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: IItemPublishing) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hideVersion = _data["HideVersion"];
            this.neverPublish = _data["NeverPublish"];
            this.publishDate = _data["PublishDate"] ? new Date(_data["PublishDate"].toString()) : <any>undefined;
            this.unpublishDate = _data["UnpublishDate"] ? new Date(_data["UnpublishDate"].toString()) : <any>undefined;
            this.validFrom = _data["ValidFrom"] ? new Date(_data["ValidFrom"].toString()) : <any>undefined;
            this.validTo = _data["ValidTo"] ? new Date(_data["ValidTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemPublishing {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPublishing();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HideVersion"] = this.hideVersion;
        data["NeverPublish"] = this.neverPublish;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["UnpublishDate"] = this.unpublishDate ? this.unpublishDate.toISOString() : <any>undefined;
        data["ValidFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["ValidTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IItemPublishing {
    hideVersion?: boolean | undefined;
    neverPublish?: boolean | undefined;
    publishDate?: Date | undefined;
    unpublishDate?: Date | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class ItemRuntimeSettings implements IItemRuntimeSettings {
    readonly browseOnly?: boolean | undefined;
    forceModified?: boolean | undefined;
    invalid?: boolean | undefined;
    readonly isExternal?: boolean | undefined;
    isVirtual?: boolean | undefined;
    ownerDatabase?: Database | undefined;
    readOnlyStatistics?: boolean | undefined;
    saveAll?: boolean | undefined;
    sortOrder?: string | undefined;
    templateDatabase?: Database | undefined;
    temporary?: boolean | undefined;
    readonly temporaryVersion?: boolean | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: IItemRuntimeSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).browseOnly = _data["BrowseOnly"];
            this.forceModified = _data["ForceModified"];
            this.invalid = _data["Invalid"];
            (<any>this).isExternal = _data["IsExternal"];
            this.isVirtual = _data["IsVirtual"];
            this.ownerDatabase = _data["OwnerDatabase"] ? Database.fromJS(_data["OwnerDatabase"]) : <any>undefined;
            this.readOnlyStatistics = _data["ReadOnlyStatistics"];
            this.saveAll = _data["SaveAll"];
            this.sortOrder = _data["SortOrder"];
            this.templateDatabase = _data["TemplateDatabase"] ? Database.fromJS(_data["TemplateDatabase"]) : <any>undefined;
            this.temporary = _data["Temporary"];
            (<any>this).temporaryVersion = _data["TemporaryVersion"];
            this.validFrom = _data["ValidFrom"] ? new Date(_data["ValidFrom"].toString()) : <any>undefined;
            this.validTo = _data["ValidTo"] ? new Date(_data["ValidTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemRuntimeSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRuntimeSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BrowseOnly"] = this.browseOnly;
        data["ForceModified"] = this.forceModified;
        data["Invalid"] = this.invalid;
        data["IsExternal"] = this.isExternal;
        data["IsVirtual"] = this.isVirtual;
        data["OwnerDatabase"] = this.ownerDatabase ? this.ownerDatabase.toJSON() : <any>undefined;
        data["ReadOnlyStatistics"] = this.readOnlyStatistics;
        data["SaveAll"] = this.saveAll;
        data["SortOrder"] = this.sortOrder;
        data["TemplateDatabase"] = this.templateDatabase ? this.templateDatabase.toJSON() : <any>undefined;
        data["Temporary"] = this.temporary;
        data["TemporaryVersion"] = this.temporaryVersion;
        data["ValidFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["ValidTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IItemRuntimeSettings {
    browseOnly?: boolean | undefined;
    forceModified?: boolean | undefined;
    invalid?: boolean | undefined;
    isExternal?: boolean | undefined;
    isVirtual?: boolean | undefined;
    ownerDatabase?: Database | undefined;
    readOnlyStatistics?: boolean | undefined;
    saveAll?: boolean | undefined;
    sortOrder?: string | undefined;
    templateDatabase?: Database | undefined;
    temporary?: boolean | undefined;
    temporaryVersion?: boolean | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class ItemSecurity implements IItemSecurity {

    constructor(data?: IItemSecurity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ItemSecurity {
        data = typeof data === 'object' ? data : {};
        let result = new ItemSecurity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IItemSecurity {
}

export class ItemUri implements IItemUri {
    readonly databaseName?: string | undefined;
    readonly itemID?: ID | undefined;
    readonly isEmpty?: boolean | undefined;
    readonly language?: Language | undefined;
    readonly path?: string | undefined;
    readonly version?: Version | undefined;

    constructor(data?: IItemUri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).databaseName = _data["DatabaseName"];
            (<any>this).itemID = _data["ItemID"] ? ID.fromJS(_data["ItemID"]) : <any>undefined;
            (<any>this).isEmpty = _data["IsEmpty"];
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).path = _data["Path"];
            (<any>this).version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemUri {
        data = typeof data === 'object' ? data : {};
        let result = new ItemUri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DatabaseName"] = this.databaseName;
        data["ItemID"] = this.itemID ? this.itemID.toJSON() : <any>undefined;
        data["IsEmpty"] = this.isEmpty;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["Path"] = this.path;
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemUri {
    databaseName?: string | undefined;
    itemID?: ID | undefined;
    isEmpty?: boolean | undefined;
    language?: Language | undefined;
    path?: string | undefined;
    version?: Version | undefined;
}

export class ItemState implements IItemState {

    constructor(data?: IItemState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ItemState {
        data = typeof data === 'object' ? data : {};
        let result = new ItemState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IItemState {
}

export class ItemStatistics implements IItemStatistics {
    readonly created?: Date | undefined;
    readonly createdBy?: string | undefined;
    readonly revision?: string | undefined;
    readonly updated?: Date | undefined;
    readonly updatedBy?: string | undefined;

    constructor(data?: IItemStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            (<any>this).createdBy = _data["CreatedBy"];
            (<any>this).revision = _data["Revision"];
            (<any>this).updated = _data["Updated"] ? new Date(_data["Updated"].toString()) : <any>undefined;
            (<any>this).updatedBy = _data["UpdatedBy"];
        }
    }

    static fromJS(data: any): ItemStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new ItemStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["Revision"] = this.revision;
        data["Updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["UpdatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IItemStatistics {
    created?: Date | undefined;
    createdBy?: string | undefined;
    revision?: string | undefined;
    updated?: Date | undefined;
    updatedBy?: string | undefined;
}

export class TemplateItem implements ITemplateItem {
    readonly baseTemplates?: TemplateItem[] | undefined;
    readonly fields?: TemplateFieldItem[] | undefined;
    readonly fullName?: string | undefined;
    readonly key?: string | undefined;
    readonly ownFields?: TemplateFieldItem[] | undefined;
    readonly standardValues?: Item | undefined;
    readonly database?: Database | undefined;
    readonly displayName?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly innerItem?: Item | undefined;
    readonly name?: string | undefined;

    constructor(data?: ITemplateItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["BaseTemplates"])) {
                (<any>this).baseTemplates = [] as any;
                for (let item of _data["BaseTemplates"])
                    (<any>this).baseTemplates!.push(TemplateItem.fromJS(item));
            }
            if (Array.isArray(_data["Fields"])) {
                (<any>this).fields = [] as any;
                for (let item of _data["Fields"])
                    (<any>this).fields!.push(TemplateFieldItem.fromJS(item));
            }
            (<any>this).fullName = _data["FullName"];
            (<any>this).key = _data["Key"];
            if (Array.isArray(_data["OwnFields"])) {
                (<any>this).ownFields = [] as any;
                for (let item of _data["OwnFields"])
                    (<any>this).ownFields!.push(TemplateFieldItem.fromJS(item));
            }
            (<any>this).standardValues = _data["StandardValues"] ? Item.fromJS(_data["StandardValues"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): TemplateItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.baseTemplates)) {
            data["BaseTemplates"] = [];
            for (let item of this.baseTemplates)
                data["BaseTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.fields)) {
            data["Fields"] = [];
            for (let item of this.fields)
                data["Fields"].push(item.toJSON());
        }
        data["FullName"] = this.fullName;
        data["Key"] = this.key;
        if (Array.isArray(this.ownFields)) {
            data["OwnFields"] = [];
            for (let item of this.ownFields)
                data["OwnFields"].push(item.toJSON());
        }
        data["StandardValues"] = this.standardValues ? this.standardValues.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface ITemplateItem {
    baseTemplates?: TemplateItem[] | undefined;
    fields?: TemplateFieldItem[] | undefined;
    fullName?: string | undefined;
    key?: string | undefined;
    ownFields?: TemplateFieldItem[] | undefined;
    standardValues?: Item | undefined;
    database?: Database | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    innerItem?: Item | undefined;
    name?: string | undefined;
}

export class Version implements IVersion {
    readonly number?: number | undefined;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).number = _data["Number"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        return data;
    }
}

export interface IVersion {
    number?: number | undefined;
}

export class ItemVersions implements IItemVersions {
    readonly count?: number | undefined;

    constructor(data?: IItemVersions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).count = _data["Count"];
        }
    }

    static fromJS(data: any): ItemVersions {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVersions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        return data;
    }
}

export interface IItemVersions {
    count?: number | undefined;
}

export class ItemVisualization implements IItemVisualization {
    readonly layout?: LayoutItem | undefined;

    constructor(data?: IItemVisualization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).layout = _data["Layout"] ? LayoutItem.fromJS(_data["Layout"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemVisualization {
        data = typeof data === 'object' ? data : {};
        let result = new ItemVisualization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemVisualization {
    layout?: LayoutItem | undefined;
}

export class AliasResolver implements IAliasResolver {

    constructor(data?: IAliasResolver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AliasResolver {
        data = typeof data === 'object' ? data : {};
        let result = new AliasResolver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAliasResolver {
}

export class DataArchives implements IDataArchives {
    readonly count?: number | undefined;

    constructor(data?: IDataArchives) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).count = _data["Count"];
        }
    }

    static fromJS(data: any): DataArchives {
        data = typeof data === 'object' ? data : {};
        let result = new DataArchives();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Count"] = this.count;
        return data;
    }
}

export interface IDataArchives {
    count?: number | undefined;
}

export class DatabaseCaches implements IDatabaseCaches {
    readonly dataCache?: DataCache | undefined;
    readonly itemCache?: ItemCache | undefined;
    readonly isFallbackValidCache?: LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey | undefined;
    readonly pathCache?: PathCache | undefined;
    readonly itemPathsCache?: ItemPathsCache | undefined;
    readonly standardValuesCache?: StandardValuesCache | undefined;
    readonly fallbackFieldValuesCache?: ILanguageFallbackFieldValuesCache | undefined;

    constructor(data?: IDatabaseCaches) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dataCache = _data["DataCache"] ? DataCache.fromJS(_data["DataCache"]) : <any>undefined;
            (<any>this).itemCache = _data["ItemCache"] ? ItemCache.fromJS(_data["ItemCache"]) : <any>undefined;
            (<any>this).isFallbackValidCache = _data["IsFallbackValidCache"] ? LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey.fromJS(_data["IsFallbackValidCache"]) : <any>undefined;
            (<any>this).pathCache = _data["PathCache"] ? PathCache.fromJS(_data["PathCache"]) : <any>undefined;
            (<any>this).itemPathsCache = _data["ItemPathsCache"] ? ItemPathsCache.fromJS(_data["ItemPathsCache"]) : <any>undefined;
            (<any>this).standardValuesCache = _data["StandardValuesCache"] ? StandardValuesCache.fromJS(_data["StandardValuesCache"]) : <any>undefined;
            (<any>this).fallbackFieldValuesCache = _data["FallbackFieldValuesCache"] ? ILanguageFallbackFieldValuesCache.fromJS(_data["FallbackFieldValuesCache"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatabaseCaches {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseCaches();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataCache"] = this.dataCache ? this.dataCache.toJSON() : <any>undefined;
        data["ItemCache"] = this.itemCache ? this.itemCache.toJSON() : <any>undefined;
        data["IsFallbackValidCache"] = this.isFallbackValidCache ? this.isFallbackValidCache.toJSON() : <any>undefined;
        data["PathCache"] = this.pathCache ? this.pathCache.toJSON() : <any>undefined;
        data["ItemPathsCache"] = this.itemPathsCache ? this.itemPathsCache.toJSON() : <any>undefined;
        data["StandardValuesCache"] = this.standardValuesCache ? this.standardValuesCache.toJSON() : <any>undefined;
        data["FallbackFieldValuesCache"] = this.fallbackFieldValuesCache ? this.fallbackFieldValuesCache.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatabaseCaches {
    dataCache?: DataCache | undefined;
    itemCache?: ItemCache | undefined;
    isFallbackValidCache?: LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey | undefined;
    pathCache?: PathCache | undefined;
    itemPathsCache?: ItemPathsCache | undefined;
    standardValuesCache?: StandardValuesCache | undefined;
    fallbackFieldValuesCache?: ILanguageFallbackFieldValuesCache | undefined;
}

export class DataManager implements IDataManager {
    readonly database?: Database | undefined;
    readonly dataEngine?: DataEngine | undefined;
    readonly dataSource?: DataSource | undefined;

    constructor(data?: IDataManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataEngine = _data["DataEngine"] ? DataEngine.fromJS(_data["DataEngine"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataManager {
        data = typeof data === 'object' ? data : {};
        let result = new DataManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataEngine"] = this.dataEngine ? this.dataEngine.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataManager {
    database?: Database | undefined;
    dataEngine?: DataEngine | undefined;
    dataSource?: DataSource | undefined;
}

export class DatabaseEngines implements IDatabaseEngines {
    readonly dataEngine?: DataEngine | undefined;
    readonly historyEngine?: HistoryEngine | undefined;
    readonly templateEngine?: TemplateEngine | undefined;
    readonly workflowEngine?: WorkflowEngine | undefined;

    constructor(data?: IDatabaseEngines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dataEngine = _data["DataEngine"] ? DataEngine.fromJS(_data["DataEngine"]) : <any>undefined;
            (<any>this).historyEngine = _data["HistoryEngine"] ? HistoryEngine.fromJS(_data["HistoryEngine"]) : <any>undefined;
            (<any>this).templateEngine = _data["TemplateEngine"] ? TemplateEngine.fromJS(_data["TemplateEngine"]) : <any>undefined;
            (<any>this).workflowEngine = _data["WorkflowEngine"] ? WorkflowEngine.fromJS(_data["WorkflowEngine"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatabaseEngines {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseEngines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataEngine"] = this.dataEngine ? this.dataEngine.toJSON() : <any>undefined;
        data["HistoryEngine"] = this.historyEngine ? this.historyEngine.toJSON() : <any>undefined;
        data["TemplateEngine"] = this.templateEngine ? this.templateEngine.toJSON() : <any>undefined;
        data["WorkflowEngine"] = this.workflowEngine ? this.workflowEngine.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatabaseEngines {
    dataEngine?: DataEngine | undefined;
    historyEngine?: HistoryEngine | undefined;
    templateEngine?: TemplateEngine | undefined;
    workflowEngine?: WorkflowEngine | undefined;
}

export class ItemRecords implements IItemRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IItemRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemRecords {
        data = typeof data === 'object' ? data : {};
        let result = new ItemRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IItemRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class BranchRecords implements IBranchRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IBranchRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchRecords {
        data = typeof data === 'object' ? data : {};
        let result = new BranchRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBranchRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class DatabaseProperties implements IDatabaseProperties {
    readonly version?: number | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IDatabaseProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).version = _data["Version"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatabaseProperties {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Version"] = this.version;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatabaseProperties {
    version?: number | undefined;
    database?: Database | undefined;
}

export class IPropertyStore implements IIPropertyStore {
    readonly getValueWithoutPrefix?: boolean | undefined;
    readonly prefix?: string | undefined;
    readonly name?: string | undefined;

    constructor(data?: IIPropertyStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).getValueWithoutPrefix = _data["GetValueWithoutPrefix"];
            (<any>this).prefix = _data["Prefix"];
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): IPropertyStore {
        data = typeof data === 'object' ? data : {};
        let result = new IPropertyStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GetValueWithoutPrefix"] = this.getValueWithoutPrefix;
        data["Prefix"] = this.prefix;
        data["Name"] = this.name;
        return data;
    }
}

export interface IIPropertyStore {
    getValueWithoutPrefix?: boolean | undefined;
    prefix?: string | undefined;
    name?: string | undefined;
}

export class DatabaseRemoteEvents implements IDatabaseRemoteEvents {
    listenToEvents?: boolean | undefined;
    queue?: EventQueue | undefined;
    eventQueue?: IEventQueue | undefined;

    constructor(data?: IDatabaseRemoteEvents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listenToEvents = _data["ListenToEvents"];
            this.queue = _data["Queue"] ? EventQueue.fromJS(_data["Queue"]) : <any>undefined;
            this.eventQueue = _data["EventQueue"] ? IEventQueue.fromJS(_data["EventQueue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DatabaseRemoteEvents {
        data = typeof data === 'object' ? data : {};
        let result = new DatabaseRemoteEvents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListenToEvents"] = this.listenToEvents;
        data["Queue"] = this.queue ? this.queue.toJSON() : <any>undefined;
        data["EventQueue"] = this.eventQueue ? this.eventQueue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDatabaseRemoteEvents {
    listenToEvents?: boolean | undefined;
    queue?: EventQueue | undefined;
    eventQueue?: IEventQueue | undefined;
}

export class ResourceItems implements IResourceItems {
    readonly devices?: DeviceRecords | undefined;
    readonly layouts?: LayoutRecords | undefined;
    readonly renderings?: RenderingRecords | undefined;
    readonly sublayouts?: SublayoutRecords | undefined;

    constructor(data?: IResourceItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).devices = _data["Devices"] ? DeviceRecords.fromJS(_data["Devices"]) : <any>undefined;
            (<any>this).layouts = _data["Layouts"] ? LayoutRecords.fromJS(_data["Layouts"]) : <any>undefined;
            (<any>this).renderings = _data["Renderings"] ? RenderingRecords.fromJS(_data["Renderings"]) : <any>undefined;
            (<any>this).sublayouts = _data["Sublayouts"] ? SublayoutRecords.fromJS(_data["Sublayouts"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResourceItems {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Devices"] = this.devices ? this.devices.toJSON() : <any>undefined;
        data["Layouts"] = this.layouts ? this.layouts.toJSON() : <any>undefined;
        data["Renderings"] = this.renderings ? this.renderings.toJSON() : <any>undefined;
        data["Sublayouts"] = this.sublayouts ? this.sublayouts.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResourceItems {
    devices?: DeviceRecords | undefined;
    layouts?: LayoutRecords | undefined;
    renderings?: RenderingRecords | undefined;
    sublayouts?: SublayoutRecords | undefined;
}

export class TemplateRecords implements ITemplateRecords {

    constructor(data?: ITemplateRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TemplateRecords {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITemplateRecords {
}

export class IWorkflowProvider implements IIWorkflowProvider {

    constructor(data?: IIWorkflowProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IWorkflowProvider {
        data = typeof data === 'object' ? data : {};
        let result = new IWorkflowProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIWorkflowProvider {
}

export class NotificationProvider implements INotificationProvider {

    constructor(data?: INotificationProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): NotificationProvider {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface INotificationProvider {
}

export class TemplateField implements ITemplateField {
    readonly defaultValue?: string | undefined;
    readonly helpLink?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly isEmpty?: boolean | undefined;
    readonly isSharedLanguageFallbackEnabled?: boolean | undefined;
    readonly isShared?: boolean | undefined;
    readonly isUnversioned?: boolean | undefined;
    readonly isVersioned?: boolean | undefined;
    readonly key?: string | undefined;
    readonly isBlob?: boolean | undefined;
    readonly name?: string | undefined;
    readonly section?: TemplateSection | undefined;
    readonly resetBlank?: boolean | undefined;
    readonly sortorder?: number | undefined;
    readonly source?: string | undefined;
    readonly style?: string | undefined;
    readonly template?: Template | undefined;
    readonly type?: string | undefined;
    readonly typeKey?: string | undefined;
    readonly validation?: string | undefined;
    readonly excludeFromTextSearch?: boolean | undefined;
    readonly ignoreDictionaryTranslations?: boolean | undefined;

    constructor(data?: ITemplateField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).defaultValue = _data["DefaultValue"];
            (<any>this).helpLink = _data["HelpLink"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).isEmpty = _data["IsEmpty"];
            (<any>this).isSharedLanguageFallbackEnabled = _data["IsSharedLanguageFallbackEnabled"];
            (<any>this).isShared = _data["IsShared"];
            (<any>this).isUnversioned = _data["IsUnversioned"];
            (<any>this).isVersioned = _data["IsVersioned"];
            (<any>this).key = _data["Key"];
            (<any>this).isBlob = _data["IsBlob"];
            (<any>this).name = _data["Name"];
            (<any>this).section = _data["Section"] ? TemplateSection.fromJS(_data["Section"]) : <any>undefined;
            (<any>this).resetBlank = _data["ResetBlank"];
            (<any>this).sortorder = _data["Sortorder"];
            (<any>this).source = _data["Source"];
            (<any>this).style = _data["Style"];
            (<any>this).template = _data["Template"] ? Template.fromJS(_data["Template"]) : <any>undefined;
            (<any>this).type = _data["Type"];
            (<any>this).typeKey = _data["TypeKey"];
            (<any>this).validation = _data["Validation"];
            (<any>this).excludeFromTextSearch = _data["ExcludeFromTextSearch"];
            (<any>this).ignoreDictionaryTranslations = _data["IgnoreDictionaryTranslations"];
        }
    }

    static fromJS(data: any): TemplateField {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DefaultValue"] = this.defaultValue;
        data["HelpLink"] = this.helpLink;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["IsEmpty"] = this.isEmpty;
        data["IsSharedLanguageFallbackEnabled"] = this.isSharedLanguageFallbackEnabled;
        data["IsShared"] = this.isShared;
        data["IsUnversioned"] = this.isUnversioned;
        data["IsVersioned"] = this.isVersioned;
        data["Key"] = this.key;
        data["IsBlob"] = this.isBlob;
        data["Name"] = this.name;
        data["Section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["ResetBlank"] = this.resetBlank;
        data["Sortorder"] = this.sortorder;
        data["Source"] = this.source;
        data["Style"] = this.style;
        data["Template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["Type"] = this.type;
        data["TypeKey"] = this.typeKey;
        data["Validation"] = this.validation;
        data["ExcludeFromTextSearch"] = this.excludeFromTextSearch;
        data["IgnoreDictionaryTranslations"] = this.ignoreDictionaryTranslations;
        return data;
    }
}

export interface ITemplateField {
    defaultValue?: string | undefined;
    helpLink?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    isEmpty?: boolean | undefined;
    isSharedLanguageFallbackEnabled?: boolean | undefined;
    isShared?: boolean | undefined;
    isUnversioned?: boolean | undefined;
    isVersioned?: boolean | undefined;
    key?: string | undefined;
    isBlob?: boolean | undefined;
    name?: string | undefined;
    section?: TemplateSection | undefined;
    resetBlank?: boolean | undefined;
    sortorder?: number | undefined;
    source?: string | undefined;
    style?: string | undefined;
    template?: Template | undefined;
    type?: string | undefined;
    typeKey?: string | undefined;
    validation?: string | undefined;
    excludeFromTextSearch?: boolean | undefined;
    ignoreDictionaryTranslations?: boolean | undefined;
}

export class ItemDefinition implements IItemDefinition {
    readonly iD?: ID | undefined;
    readonly isEmpty?: boolean | undefined;
    readonly key?: string | undefined;
    readonly branchId?: ID | undefined;
    readonly name?: string | undefined;
    readonly templateID?: ID | undefined;
    readonly created?: Date | undefined;

    constructor(data?: IItemDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).isEmpty = _data["IsEmpty"];
            (<any>this).key = _data["Key"];
            (<any>this).branchId = _data["BranchId"] ? ID.fromJS(_data["BranchId"]) : <any>undefined;
            (<any>this).name = _data["Name"];
            (<any>this).templateID = _data["TemplateID"] ? ID.fromJS(_data["TemplateID"]) : <any>undefined;
            (<any>this).created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["IsEmpty"] = this.isEmpty;
        data["Key"] = this.key;
        data["BranchId"] = this.branchId ? this.branchId.toJSON() : <any>undefined;
        data["Name"] = this.name;
        data["TemplateID"] = this.templateID ? this.templateID.toJSON() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IItemDefinition {
    iD?: ID | undefined;
    isEmpty?: boolean | undefined;
    key?: string | undefined;
    branchId?: ID | undefined;
    name?: string | undefined;
    templateID?: ID | undefined;
    created?: Date | undefined;
}

export class LanguageOrigin implements ILanguageOrigin {
    itemId?: ID | undefined;

    constructor(data?: ILanguageOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["ItemId"] ? ID.fromJS(_data["ItemId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LanguageOrigin {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageOrigin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId ? this.itemId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILanguageOrigin {
    itemId?: ID | undefined;
}

export class TemplateFieldItem implements ITemplateFieldItem {
    readonly description?: string | undefined;
    readonly helpLink?: LinkField | undefined;
    readonly isShared?: boolean | undefined;
    readonly isUnversioned?: boolean | undefined;
    readonly key?: string | undefined;
    readonly resetBlank?: boolean | undefined;
    readonly section?: TemplateSectionItem | undefined;
    readonly shared?: boolean | undefined;
    sortorder?: number | undefined;
    source?: string | undefined;
    style?: string | undefined;
    readonly template?: TemplateItem | undefined;
    title?: string | undefined;
    readonly toolTip?: string | undefined;
    type?: string | undefined;
    readonly unversioned?: boolean | undefined;
    validation?: string | undefined;
    validationText?: string | undefined;
    readonly database?: Database | undefined;
    readonly displayName?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly innerItem?: Item | undefined;
    readonly name?: string | undefined;

    constructor(data?: ITemplateFieldItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).description = _data["Description"];
            (<any>this).helpLink = _data["HelpLink"] ? LinkField.fromJS(_data["HelpLink"]) : <any>undefined;
            (<any>this).isShared = _data["IsShared"];
            (<any>this).isUnversioned = _data["IsUnversioned"];
            (<any>this).key = _data["Key"];
            (<any>this).resetBlank = _data["ResetBlank"];
            (<any>this).section = _data["Section"] ? TemplateSectionItem.fromJS(_data["Section"]) : <any>undefined;
            (<any>this).shared = _data["Shared"];
            this.sortorder = _data["Sortorder"];
            this.source = _data["Source"];
            this.style = _data["Style"];
            (<any>this).template = _data["Template"] ? TemplateItem.fromJS(_data["Template"]) : <any>undefined;
            this.title = _data["Title"];
            (<any>this).toolTip = _data["ToolTip"];
            this.type = _data["Type"];
            (<any>this).unversioned = _data["Unversioned"];
            this.validation = _data["Validation"];
            this.validationText = _data["ValidationText"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): TemplateFieldItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateFieldItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Description"] = this.description;
        data["HelpLink"] = this.helpLink ? this.helpLink.toJSON() : <any>undefined;
        data["IsShared"] = this.isShared;
        data["IsUnversioned"] = this.isUnversioned;
        data["Key"] = this.key;
        data["ResetBlank"] = this.resetBlank;
        data["Section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["Shared"] = this.shared;
        data["Sortorder"] = this.sortorder;
        data["Source"] = this.source;
        data["Style"] = this.style;
        data["Template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["Title"] = this.title;
        data["ToolTip"] = this.toolTip;
        data["Type"] = this.type;
        data["Unversioned"] = this.unversioned;
        data["Validation"] = this.validation;
        data["ValidationText"] = this.validationText;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface ITemplateFieldItem {
    description?: string | undefined;
    helpLink?: LinkField | undefined;
    isShared?: boolean | undefined;
    isUnversioned?: boolean | undefined;
    key?: string | undefined;
    resetBlank?: boolean | undefined;
    section?: TemplateSectionItem | undefined;
    shared?: boolean | undefined;
    sortorder?: number | undefined;
    source?: string | undefined;
    style?: string | undefined;
    template?: TemplateItem | undefined;
    title?: string | undefined;
    toolTip?: string | undefined;
    type?: string | undefined;
    unversioned?: boolean | undefined;
    validation?: string | undefined;
    validationText?: string | undefined;
    database?: Database | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    innerItem?: Item | undefined;
    name?: string | undefined;
}

export class LayoutItem implements ILayoutItem {
    readonly control?: string | undefined;
    readonly filePath?: string | undefined;
    readonly database?: Database | undefined;
    readonly displayName?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly innerItem?: Item | undefined;
    readonly name?: string | undefined;

    constructor(data?: ILayoutItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).control = _data["Control"];
            (<any>this).filePath = _data["FilePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): LayoutItem {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Control"] = this.control;
        data["FilePath"] = this.filePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DisplayName"] = this.displayName;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface ILayoutItem {
    control?: string | undefined;
    filePath?: string | undefined;
    database?: Database | undefined;
    displayName?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    innerItem?: Item | undefined;
    name?: string | undefined;
}

export class DataCache implements IDataCache {
    readonly enabled?: boolean | undefined;
    readonly innerCache?: ICacheOfID | undefined;
    readonly name?: string | undefined;

    constructor(data?: IDataCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).enabled = _data["Enabled"];
            (<any>this).innerCache = _data["InnerCache"] ? ICacheOfID.fromJS(_data["InnerCache"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): DataCache {
        data = typeof data === 'object' ? data : {};
        let result = new DataCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enabled"] = this.enabled;
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface IDataCache {
    enabled?: boolean | undefined;
    innerCache?: ICacheOfID | undefined;
    name?: string | undefined;
}

export class ItemCache implements IItemCache {
    enabled?: boolean | undefined;
    readonly innerCache?: ICacheOfString | undefined;
    readonly name?: string | undefined;

    constructor(data?: IItemCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["Enabled"];
            (<any>this).innerCache = _data["InnerCache"] ? ICacheOfString.fromJS(_data["InnerCache"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): ItemCache {
        data = typeof data === 'object' ? data : {};
        let result = new ItemCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enabled"] = this.enabled;
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface IItemCache {
    enabled?: boolean | undefined;
    innerCache?: ICacheOfString | undefined;
    name?: string | undefined;
}

export class LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey implements ILanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey {
    readonly innerCache?: ICacheOfIsLanguageFallbackValidCacheKey | undefined;
    enabled?: boolean | undefined;
    readonly name?: string | undefined;

    constructor(data?: ILanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).innerCache = _data["InnerCache"] ? ICacheOfIsLanguageFallbackValidCacheKey.fromJS(_data["InnerCache"]) : <any>undefined;
            this.enabled = _data["Enabled"];
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Enabled"] = this.enabled;
        data["Name"] = this.name;
        return data;
    }
}

export interface ILanguageFallbackIndexedCacheBaseOfIsLanguageFallbackValidCacheKey {
    innerCache?: ICacheOfIsLanguageFallbackValidCacheKey | undefined;
    enabled?: boolean | undefined;
    name?: string | undefined;
}

export class PathCache implements IPathCache {
    readonly enabled?: boolean | undefined;
    readonly innerCache?: ICache | undefined;
    readonly name?: string | undefined;

    constructor(data?: IPathCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).enabled = _data["Enabled"];
            (<any>this).innerCache = _data["InnerCache"] ? ICache.fromJS(_data["InnerCache"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): PathCache {
        data = typeof data === 'object' ? data : {};
        let result = new PathCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enabled"] = this.enabled;
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface IPathCache {
    enabled?: boolean | undefined;
    innerCache?: ICache | undefined;
    name?: string | undefined;
}

export class ItemPathsCache implements IItemPathsCache {
    readonly innerCache?: ICacheOfItemPathCacheKey | undefined;
    enabled?: boolean | undefined;
    readonly name?: string | undefined;

    constructor(data?: IItemPathsCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).innerCache = _data["InnerCache"] ? ICacheOfItemPathCacheKey.fromJS(_data["InnerCache"]) : <any>undefined;
            this.enabled = _data["Enabled"];
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): ItemPathsCache {
        data = typeof data === 'object' ? data : {};
        let result = new ItemPathsCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Enabled"] = this.enabled;
        data["Name"] = this.name;
        return data;
    }
}

export interface IItemPathsCache {
    innerCache?: ICacheOfItemPathCacheKey | undefined;
    enabled?: boolean | undefined;
    name?: string | undefined;
}

export class StandardValuesCache implements IStandardValuesCache {
    readonly innerCache?: ICache | undefined;
    enabled?: boolean | undefined;
    readonly name?: string | undefined;

    constructor(data?: IStandardValuesCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).innerCache = _data["InnerCache"] ? ICache.fromJS(_data["InnerCache"]) : <any>undefined;
            this.enabled = _data["Enabled"];
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): StandardValuesCache {
        data = typeof data === 'object' ? data : {};
        let result = new StandardValuesCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InnerCache"] = this.innerCache ? this.innerCache.toJSON() : <any>undefined;
        data["Enabled"] = this.enabled;
        data["Name"] = this.name;
        return data;
    }
}

export interface IStandardValuesCache {
    innerCache?: ICache | undefined;
    enabled?: boolean | undefined;
    name?: string | undefined;
}

export class ILanguageFallbackFieldValuesCache implements IILanguageFallbackFieldValuesCache {

    constructor(data?: IILanguageFallbackFieldValuesCache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ILanguageFallbackFieldValuesCache {
        data = typeof data === 'object' ? data : {};
        let result = new ILanguageFallbackFieldValuesCache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IILanguageFallbackFieldValuesCache {
}

export class DataEngine implements IDataEngine {
    itemAccessLock?: ReaderWriterLock | undefined;
    readonly commands?: CommandCollection | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IDataEngine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemAccessLock = _data["ItemAccessLock"] ? ReaderWriterLock.fromJS(_data["ItemAccessLock"]) : <any>undefined;
            (<any>this).commands = _data["Commands"] ? CommandCollection.fromJS(_data["Commands"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataEngine {
        data = typeof data === 'object' ? data : {};
        let result = new DataEngine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemAccessLock"] = this.itemAccessLock ? this.itemAccessLock.toJSON() : <any>undefined;
        data["Commands"] = this.commands ? this.commands.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataEngine {
    itemAccessLock?: ReaderWriterLock | undefined;
    commands?: CommandCollection | undefined;
    database?: Database | undefined;
}

export class DataSource implements IDataSource {
    readonly dataManager?: DataManager | undefined;

    constructor(data?: IDataSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dataManager = _data["DataManager"] ? DataManager.fromJS(_data["DataManager"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DataSource {
        data = typeof data === 'object' ? data : {};
        let result = new DataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataManager"] = this.dataManager ? this.dataManager.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDataSource {
    dataManager?: DataManager | undefined;
}

export class HistoryEngine implements IHistoryEngine {
    readonly database?: Database | undefined;
    saveDotNetCallStack?: boolean | undefined;
    storage?: HistoryStorage | undefined;

    constructor(data?: IHistoryEngine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            this.saveDotNetCallStack = _data["SaveDotNetCallStack"];
            this.storage = _data["Storage"] ? HistoryStorage.fromJS(_data["Storage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoryEngine {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryEngine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["SaveDotNetCallStack"] = this.saveDotNetCallStack;
        data["Storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHistoryEngine {
    database?: Database | undefined;
    saveDotNetCallStack?: boolean | undefined;
    storage?: HistoryStorage | undefined;
}

export class TemplateEngine implements ITemplateEngine {
    readonly dataEngine?: DataEngine | undefined;
    readonly dataManager?: DataManager | undefined;
    readonly dataSource?: DataSource | undefined;

    constructor(data?: ITemplateEngine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).dataEngine = _data["DataEngine"] ? DataEngine.fromJS(_data["DataEngine"]) : <any>undefined;
            (<any>this).dataManager = _data["DataManager"] ? DataManager.fromJS(_data["DataManager"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateEngine {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateEngine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DataEngine"] = this.dataEngine ? this.dataEngine.toJSON() : <any>undefined;
        data["DataManager"] = this.dataManager ? this.dataManager.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateEngine {
    dataEngine?: DataEngine | undefined;
    dataManager?: DataManager | undefined;
    dataSource?: DataSource | undefined;
}

export class WorkflowEngine implements IWorkflowEngine {

    constructor(data?: IWorkflowEngine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): WorkflowEngine {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowEngine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IWorkflowEngine {
}

export class EventQueue implements IEventQueue {
    listenToRemoteEvents?: boolean | undefined;
    readonly databaseName?: string | undefined;
    readonly name?: string | undefined;
    readonly assignProperties?: boolean | undefined;

    constructor(data?: IEventQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listenToRemoteEvents = _data["ListenToRemoteEvents"];
            (<any>this).databaseName = _data["DatabaseName"];
            (<any>this).name = _data["Name"];
            (<any>this).assignProperties = _data["AssignProperties"];
        }
    }

    static fromJS(data: any): EventQueue {
        data = typeof data === 'object' ? data : {};
        let result = new EventQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListenToRemoteEvents"] = this.listenToRemoteEvents;
        data["DatabaseName"] = this.databaseName;
        data["Name"] = this.name;
        data["AssignProperties"] = this.assignProperties;
        return data;
    }
}

export interface IEventQueue {
    listenToRemoteEvents?: boolean | undefined;
    databaseName?: string | undefined;
    name?: string | undefined;
    assignProperties?: boolean | undefined;
}

export class IEventQueue implements IIEventQueue {
    listenToRemoteEvents?: boolean | undefined;
    name?: string | undefined;

    constructor(data?: IIEventQueue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listenToRemoteEvents = _data["ListenToRemoteEvents"];
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): IEventQueue {
        data = typeof data === 'object' ? data : {};
        let result = new IEventQueue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ListenToRemoteEvents"] = this.listenToRemoteEvents;
        data["Name"] = this.name;
        return data;
    }
}

export interface IIEventQueue {
    listenToRemoteEvents?: boolean | undefined;
    name?: string | undefined;
}

export class DeviceRecords implements IDeviceRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IDeviceRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceRecords {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeviceRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class LayoutRecords implements ILayoutRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: ILayoutRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LayoutRecords {
        data = typeof data === 'object' ? data : {};
        let result = new LayoutRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILayoutRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class RenderingRecords implements IRenderingRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: IRenderingRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RenderingRecords {
        data = typeof data === 'object' ? data : {};
        let result = new RenderingRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRenderingRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class SublayoutRecords implements ISublayoutRecords {
    readonly basePath?: string | undefined;
    readonly database?: Database | undefined;

    constructor(data?: ISublayoutRecords) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).basePath = _data["BasePath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SublayoutRecords {
        data = typeof data === 'object' ? data : {};
        let result = new SublayoutRecords();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BasePath"] = this.basePath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISublayoutRecords {
    basePath?: string | undefined;
    database?: Database | undefined;
}

export class TemplateSection implements ITemplateSection {
    readonly fields?: { [key: string]: any; } | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly name?: string | undefined;
    readonly key?: string | undefined;
    readonly sortorder?: number | undefined;
    readonly template?: Template | undefined;

    constructor(data?: ITemplateSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Fields"]) {
                (<any>this).fields = {} as any;
                for (let key in _data["Fields"]) {
                    if (_data["Fields"].hasOwnProperty(key))
                        (<any>(<any>this).fields)![key] = _data["Fields"][key];
                }
            }
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).name = _data["Name"];
            (<any>this).key = _data["Key"];
            (<any>this).sortorder = _data["Sortorder"];
            (<any>this).template = _data["Template"] ? Template.fromJS(_data["Template"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TemplateSection {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fields) {
            data["Fields"] = {};
            for (let key in this.fields) {
                if (this.fields.hasOwnProperty(key))
                    (<any>data["Fields"])[key] = (<any>this.fields)[key];
            }
        }
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["Name"] = this.name;
        data["Key"] = this.key;
        data["Sortorder"] = this.sortorder;
        data["Template"] = this.template ? this.template.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateSection {
    fields?: { [key: string]: any; } | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    name?: string | undefined;
    key?: string | undefined;
    sortorder?: number | undefined;
    template?: Template | undefined;
}

export class Template implements ITemplate {
    readonly baseIDs?: ID[] | undefined;
    readonly customValues?: any[] | undefined;
    readonly fullName?: string | undefined;
    readonly icon?: string | undefined;
    readonly iD?: ID | undefined;
    readonly name?: string | undefined;
    readonly standardValueHolderId?: ID | undefined;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["BaseIDs"])) {
                (<any>this).baseIDs = [] as any;
                for (let item of _data["BaseIDs"])
                    (<any>this).baseIDs!.push(ID.fromJS(item));
            }
            if (Array.isArray(_data["CustomValues"])) {
                (<any>this).customValues = [] as any;
                for (let item of _data["CustomValues"])
                    (<any>this).customValues!.push(item);
            }
            (<any>this).fullName = _data["FullName"];
            (<any>this).icon = _data["Icon"];
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).name = _data["Name"];
            (<any>this).standardValueHolderId = _data["StandardValueHolderId"] ? ID.fromJS(_data["StandardValueHolderId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.baseIDs)) {
            data["BaseIDs"] = [];
            for (let item of this.baseIDs)
                data["BaseIDs"].push(item.toJSON());
        }
        if (Array.isArray(this.customValues)) {
            data["CustomValues"] = [];
            for (let item of this.customValues)
                data["CustomValues"].push(item);
        }
        data["FullName"] = this.fullName;
        data["Icon"] = this.icon;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["Name"] = this.name;
        data["StandardValueHolderId"] = this.standardValueHolderId ? this.standardValueHolderId.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplate {
    baseIDs?: ID[] | undefined;
    customValues?: any[] | undefined;
    fullName?: string | undefined;
    icon?: string | undefined;
    iD?: ID | undefined;
    name?: string | undefined;
    standardValueHolderId?: ID | undefined;
}

export class LinkField implements ILinkField {
    anchor?: string | undefined;
    class?: string | undefined;
    readonly internalPath?: string | undefined;
    readonly isInternal?: boolean | undefined;
    readonly isMediaLink?: boolean | undefined;
    linkType?: string | undefined;
    readonly mediaPath?: string | undefined;
    queryString?: string | undefined;
    target?: string | undefined;
    targetID?: ID | undefined;
    readonly targetItem?: Item | undefined;
    text?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    root?: string | undefined;
    readonly xml?: any[] | undefined;
    readonly innerField?: Field | undefined;
    value?: string | undefined;

    constructor(data?: ILinkField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anchor = _data["Anchor"];
            this.class = _data["Class"];
            (<any>this).internalPath = _data["InternalPath"];
            (<any>this).isInternal = _data["IsInternal"];
            (<any>this).isMediaLink = _data["IsMediaLink"];
            this.linkType = _data["LinkType"];
            (<any>this).mediaPath = _data["MediaPath"];
            this.queryString = _data["QueryString"];
            this.target = _data["Target"];
            this.targetID = _data["TargetID"] ? ID.fromJS(_data["TargetID"]) : <any>undefined;
            (<any>this).targetItem = _data["TargetItem"] ? Item.fromJS(_data["TargetItem"]) : <any>undefined;
            this.text = _data["Text"];
            this.title = _data["Title"];
            this.url = _data["Url"];
            this.root = _data["Root"];
            if (Array.isArray(_data["Xml"])) {
                (<any>this).xml = [] as any;
                for (let item of _data["Xml"])
                    (<any>this).xml!.push(item);
            }
            (<any>this).innerField = _data["InnerField"] ? Field.fromJS(_data["InnerField"]) : <any>undefined;
            this.value = _data["Value"];
        }
    }

    static fromJS(data: any): LinkField {
        data = typeof data === 'object' ? data : {};
        let result = new LinkField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Anchor"] = this.anchor;
        data["Class"] = this.class;
        data["InternalPath"] = this.internalPath;
        data["IsInternal"] = this.isInternal;
        data["IsMediaLink"] = this.isMediaLink;
        data["LinkType"] = this.linkType;
        data["MediaPath"] = this.mediaPath;
        data["QueryString"] = this.queryString;
        data["Target"] = this.target;
        data["TargetID"] = this.targetID ? this.targetID.toJSON() : <any>undefined;
        data["TargetItem"] = this.targetItem ? this.targetItem.toJSON() : <any>undefined;
        data["Text"] = this.text;
        data["Title"] = this.title;
        data["Url"] = this.url;
        data["Root"] = this.root;
        if (Array.isArray(this.xml)) {
            data["Xml"] = [];
            for (let item of this.xml)
                data["Xml"].push(item);
        }
        data["InnerField"] = this.innerField ? this.innerField.toJSON() : <any>undefined;
        data["Value"] = this.value;
        return data;
    }
}

export interface ILinkField {
    anchor?: string | undefined;
    class?: string | undefined;
    internalPath?: string | undefined;
    isInternal?: boolean | undefined;
    isMediaLink?: boolean | undefined;
    linkType?: string | undefined;
    mediaPath?: string | undefined;
    queryString?: string | undefined;
    target?: string | undefined;
    targetID?: ID | undefined;
    targetItem?: Item | undefined;
    text?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    root?: string | undefined;
    xml?: any[] | undefined;
    innerField?: Field | undefined;
    value?: string | undefined;
}

export class TemplateSectionItem implements ITemplateSectionItem {
    readonly control?: string | undefined;
    readonly displayName?: string | undefined;
    readonly hideFields?: boolean | undefined;
    readonly icon?: string | undefined;
    readonly key?: string | undefined;
    readonly sortorder?: number | undefined;
    readonly template?: TemplateItem | undefined;
    readonly hiddenByDefault?: boolean | undefined;
    readonly database?: Database | undefined;
    readonly iD?: ID | undefined;
    readonly innerItem?: Item | undefined;
    readonly name?: string | undefined;

    constructor(data?: ITemplateSectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).control = _data["Control"];
            (<any>this).displayName = _data["DisplayName"];
            (<any>this).hideFields = _data["HideFields"];
            (<any>this).icon = _data["Icon"];
            (<any>this).key = _data["Key"];
            (<any>this).sortorder = _data["Sortorder"];
            (<any>this).template = _data["Template"] ? TemplateItem.fromJS(_data["Template"]) : <any>undefined;
            (<any>this).hiddenByDefault = _data["HiddenByDefault"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).iD = _data["ID"] ? ID.fromJS(_data["ID"]) : <any>undefined;
            (<any>this).innerItem = _data["InnerItem"] ? Item.fromJS(_data["InnerItem"]) : <any>undefined;
            (<any>this).name = _data["Name"];
        }
    }

    static fromJS(data: any): TemplateSectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Control"] = this.control;
        data["DisplayName"] = this.displayName;
        data["HideFields"] = this.hideFields;
        data["Icon"] = this.icon;
        data["Key"] = this.key;
        data["Sortorder"] = this.sortorder;
        data["Template"] = this.template ? this.template.toJSON() : <any>undefined;
        data["HiddenByDefault"] = this.hiddenByDefault;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["ID"] = this.iD ? this.iD.toJSON() : <any>undefined;
        data["InnerItem"] = this.innerItem ? this.innerItem.toJSON() : <any>undefined;
        data["Name"] = this.name;
        return data;
    }
}

export interface ITemplateSectionItem {
    control?: string | undefined;
    displayName?: string | undefined;
    hideFields?: boolean | undefined;
    icon?: string | undefined;
    key?: string | undefined;
    sortorder?: number | undefined;
    template?: TemplateItem | undefined;
    hiddenByDefault?: boolean | undefined;
    database?: Database | undefined;
    iD?: ID | undefined;
    innerItem?: Item | undefined;
    name?: string | undefined;
}

export class ICacheOfID implements IICacheOfID {
    readonly cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    readonly count?: number | undefined;
    enabled?: boolean | undefined;
    readonly id?: ID | undefined;
    maxSize?: number | undefined;
    readonly name?: string | undefined;
    readonly remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    readonly size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;

    constructor(data?: IICacheOfID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cacheSizeCalculationStrategy = _data["CacheSizeCalculationStrategy"] ? ICacheSizeCalculationStrategy.fromJS(_data["CacheSizeCalculationStrategy"]) : <any>undefined;
            (<any>this).count = _data["Count"];
            this.enabled = _data["Enabled"];
            (<any>this).id = _data["Id"] ? ID.fromJS(_data["Id"]) : <any>undefined;
            this.maxSize = _data["MaxSize"];
            (<any>this).name = _data["Name"];
            (<any>this).remainingSpace = _data["RemainingSpace"];
            this.scavengable = _data["Scavengable"];
            (<any>this).size = _data["Size"];
            this.externalCacheClearingsCounter = _data["ExternalCacheClearingsCounter"] ? AmountPerSecondCounter.fromJS(_data["ExternalCacheClearingsCounter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICacheOfID {
        data = typeof data === 'object' ? data : {};
        let result = new ICacheOfID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheSizeCalculationStrategy"] = this.cacheSizeCalculationStrategy ? this.cacheSizeCalculationStrategy.toJSON() : <any>undefined;
        data["Count"] = this.count;
        data["Enabled"] = this.enabled;
        data["Id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["MaxSize"] = this.maxSize;
        data["Name"] = this.name;
        data["RemainingSpace"] = this.remainingSpace;
        data["Scavengable"] = this.scavengable;
        data["Size"] = this.size;
        data["ExternalCacheClearingsCounter"] = this.externalCacheClearingsCounter ? this.externalCacheClearingsCounter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICacheOfID {
    cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    count?: number | undefined;
    enabled?: boolean | undefined;
    id?: ID | undefined;
    maxSize?: number | undefined;
    name?: string | undefined;
    remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;
}

export class ICacheOfString implements IICacheOfString {
    readonly cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    readonly count?: number | undefined;
    enabled?: boolean | undefined;
    readonly id?: ID | undefined;
    maxSize?: number | undefined;
    readonly name?: string | undefined;
    readonly remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    readonly size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;

    constructor(data?: IICacheOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cacheSizeCalculationStrategy = _data["CacheSizeCalculationStrategy"] ? ICacheSizeCalculationStrategy.fromJS(_data["CacheSizeCalculationStrategy"]) : <any>undefined;
            (<any>this).count = _data["Count"];
            this.enabled = _data["Enabled"];
            (<any>this).id = _data["Id"] ? ID.fromJS(_data["Id"]) : <any>undefined;
            this.maxSize = _data["MaxSize"];
            (<any>this).name = _data["Name"];
            (<any>this).remainingSpace = _data["RemainingSpace"];
            this.scavengable = _data["Scavengable"];
            (<any>this).size = _data["Size"];
            this.externalCacheClearingsCounter = _data["ExternalCacheClearingsCounter"] ? AmountPerSecondCounter.fromJS(_data["ExternalCacheClearingsCounter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICacheOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ICacheOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheSizeCalculationStrategy"] = this.cacheSizeCalculationStrategy ? this.cacheSizeCalculationStrategy.toJSON() : <any>undefined;
        data["Count"] = this.count;
        data["Enabled"] = this.enabled;
        data["Id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["MaxSize"] = this.maxSize;
        data["Name"] = this.name;
        data["RemainingSpace"] = this.remainingSpace;
        data["Scavengable"] = this.scavengable;
        data["Size"] = this.size;
        data["ExternalCacheClearingsCounter"] = this.externalCacheClearingsCounter ? this.externalCacheClearingsCounter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICacheOfString {
    cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    count?: number | undefined;
    enabled?: boolean | undefined;
    id?: ID | undefined;
    maxSize?: number | undefined;
    name?: string | undefined;
    remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;
}

export class ICacheOfIsLanguageFallbackValidCacheKey implements IICacheOfIsLanguageFallbackValidCacheKey {
    readonly cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    readonly count?: number | undefined;
    enabled?: boolean | undefined;
    readonly id?: ID | undefined;
    maxSize?: number | undefined;
    readonly name?: string | undefined;
    readonly remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    readonly size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;

    constructor(data?: IICacheOfIsLanguageFallbackValidCacheKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cacheSizeCalculationStrategy = _data["CacheSizeCalculationStrategy"] ? ICacheSizeCalculationStrategy.fromJS(_data["CacheSizeCalculationStrategy"]) : <any>undefined;
            (<any>this).count = _data["Count"];
            this.enabled = _data["Enabled"];
            (<any>this).id = _data["Id"] ? ID.fromJS(_data["Id"]) : <any>undefined;
            this.maxSize = _data["MaxSize"];
            (<any>this).name = _data["Name"];
            (<any>this).remainingSpace = _data["RemainingSpace"];
            this.scavengable = _data["Scavengable"];
            (<any>this).size = _data["Size"];
            this.externalCacheClearingsCounter = _data["ExternalCacheClearingsCounter"] ? AmountPerSecondCounter.fromJS(_data["ExternalCacheClearingsCounter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICacheOfIsLanguageFallbackValidCacheKey {
        data = typeof data === 'object' ? data : {};
        let result = new ICacheOfIsLanguageFallbackValidCacheKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheSizeCalculationStrategy"] = this.cacheSizeCalculationStrategy ? this.cacheSizeCalculationStrategy.toJSON() : <any>undefined;
        data["Count"] = this.count;
        data["Enabled"] = this.enabled;
        data["Id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["MaxSize"] = this.maxSize;
        data["Name"] = this.name;
        data["RemainingSpace"] = this.remainingSpace;
        data["Scavengable"] = this.scavengable;
        data["Size"] = this.size;
        data["ExternalCacheClearingsCounter"] = this.externalCacheClearingsCounter ? this.externalCacheClearingsCounter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICacheOfIsLanguageFallbackValidCacheKey {
    cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    count?: number | undefined;
    enabled?: boolean | undefined;
    id?: ID | undefined;
    maxSize?: number | undefined;
    name?: string | undefined;
    remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;
}

export class ICache implements IICache {
    readonly cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    readonly count?: number | undefined;
    enabled?: boolean | undefined;
    readonly id?: ID | undefined;
    maxSize?: number | undefined;
    readonly name?: string | undefined;
    readonly remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    readonly size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;

    constructor(data?: IICache) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cacheSizeCalculationStrategy = _data["CacheSizeCalculationStrategy"] ? ICacheSizeCalculationStrategy.fromJS(_data["CacheSizeCalculationStrategy"]) : <any>undefined;
            (<any>this).count = _data["Count"];
            this.enabled = _data["Enabled"];
            (<any>this).id = _data["Id"] ? ID.fromJS(_data["Id"]) : <any>undefined;
            this.maxSize = _data["MaxSize"];
            (<any>this).name = _data["Name"];
            (<any>this).remainingSpace = _data["RemainingSpace"];
            this.scavengable = _data["Scavengable"];
            (<any>this).size = _data["Size"];
            this.externalCacheClearingsCounter = _data["ExternalCacheClearingsCounter"] ? AmountPerSecondCounter.fromJS(_data["ExternalCacheClearingsCounter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICache {
        data = typeof data === 'object' ? data : {};
        let result = new ICache();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheSizeCalculationStrategy"] = this.cacheSizeCalculationStrategy ? this.cacheSizeCalculationStrategy.toJSON() : <any>undefined;
        data["Count"] = this.count;
        data["Enabled"] = this.enabled;
        data["Id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["MaxSize"] = this.maxSize;
        data["Name"] = this.name;
        data["RemainingSpace"] = this.remainingSpace;
        data["Scavengable"] = this.scavengable;
        data["Size"] = this.size;
        data["ExternalCacheClearingsCounter"] = this.externalCacheClearingsCounter ? this.externalCacheClearingsCounter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICache {
    cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    count?: number | undefined;
    enabled?: boolean | undefined;
    id?: ID | undefined;
    maxSize?: number | undefined;
    name?: string | undefined;
    remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;
}

export class ICacheOfItemPathCacheKey implements IICacheOfItemPathCacheKey {
    readonly cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    readonly count?: number | undefined;
    enabled?: boolean | undefined;
    readonly id?: ID | undefined;
    maxSize?: number | undefined;
    readonly name?: string | undefined;
    readonly remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    readonly size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;

    constructor(data?: IICacheOfItemPathCacheKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cacheSizeCalculationStrategy = _data["CacheSizeCalculationStrategy"] ? ICacheSizeCalculationStrategy.fromJS(_data["CacheSizeCalculationStrategy"]) : <any>undefined;
            (<any>this).count = _data["Count"];
            this.enabled = _data["Enabled"];
            (<any>this).id = _data["Id"] ? ID.fromJS(_data["Id"]) : <any>undefined;
            this.maxSize = _data["MaxSize"];
            (<any>this).name = _data["Name"];
            (<any>this).remainingSpace = _data["RemainingSpace"];
            this.scavengable = _data["Scavengable"];
            (<any>this).size = _data["Size"];
            this.externalCacheClearingsCounter = _data["ExternalCacheClearingsCounter"] ? AmountPerSecondCounter.fromJS(_data["ExternalCacheClearingsCounter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ICacheOfItemPathCacheKey {
        data = typeof data === 'object' ? data : {};
        let result = new ICacheOfItemPathCacheKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheSizeCalculationStrategy"] = this.cacheSizeCalculationStrategy ? this.cacheSizeCalculationStrategy.toJSON() : <any>undefined;
        data["Count"] = this.count;
        data["Enabled"] = this.enabled;
        data["Id"] = this.id ? this.id.toJSON() : <any>undefined;
        data["MaxSize"] = this.maxSize;
        data["Name"] = this.name;
        data["RemainingSpace"] = this.remainingSpace;
        data["Scavengable"] = this.scavengable;
        data["Size"] = this.size;
        data["ExternalCacheClearingsCounter"] = this.externalCacheClearingsCounter ? this.externalCacheClearingsCounter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IICacheOfItemPathCacheKey {
    cacheSizeCalculationStrategy?: ICacheSizeCalculationStrategy | undefined;
    count?: number | undefined;
    enabled?: boolean | undefined;
    id?: ID | undefined;
    maxSize?: number | undefined;
    name?: string | undefined;
    remainingSpace?: number | undefined;
    scavengable?: boolean | undefined;
    size?: number | undefined;
    externalCacheClearingsCounter?: AmountPerSecondCounter | undefined;
}

export class ReaderWriterLock implements IReaderWriterLock {
    readonly isReaderLockHeld?: boolean | undefined;
    readonly isWriterLockHeld?: boolean | undefined;
    readonly writerSeqNum?: number | undefined;

    constructor(data?: IReaderWriterLock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).isReaderLockHeld = _data["IsReaderLockHeld"];
            (<any>this).isWriterLockHeld = _data["IsWriterLockHeld"];
            (<any>this).writerSeqNum = _data["WriterSeqNum"];
        }
    }

    static fromJS(data: any): ReaderWriterLock {
        data = typeof data === 'object' ? data : {};
        let result = new ReaderWriterLock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsReaderLockHeld"] = this.isReaderLockHeld;
        data["IsWriterLockHeld"] = this.isWriterLockHeld;
        data["WriterSeqNum"] = this.writerSeqNum;
        return data;
    }
}

export interface IReaderWriterLock {
    isReaderLockHeld?: boolean | undefined;
    isWriterLockHeld?: boolean | undefined;
    writerSeqNum?: number | undefined;
}

export class CommandCollection implements ICommandCollection {
    addFromTemplatePrototype?: AddFromTemplateCommand | undefined;
    addVersionPrototype?: AddVersionCommand | undefined;
    blobStreamExistsPrototype?: BlobStreamExistsCommand | undefined;
    copyItemPrototype?: CopyItemCommand | undefined;
    createItemPrototype?: CreateItemCommand | undefined;
    deletePrototype?: DeleteItemCommand | undefined;
    getBlobStreamPrototype?: GetBlobStreamCommand | undefined;
    getChildrenPrototype?: GetChildrenCommand | undefined;
    getItemPrototype?: GetItemCommand | undefined;
    getParentPrototype?: GetParentCommand | undefined;
    getRootItemPrototype?: GetRootItemCommand | undefined;
    getVersionsPrototype?: GetVersionsCommand | undefined;
    hasChildrenPrototype?: HasChildrenCommand | undefined;
    moveItemPrototype?: MoveItemCommand | undefined;
    removeDataPrototype?: RemoveDataCommand | undefined;
    removeVersionPrototype?: RemoveVersionCommand | undefined;
    resolvePathPrototype?: ResolvePathCommand | undefined;
    saveItemPrototype?: SaveItemCommand | undefined;
    setBlobStreamPrototype?: SetBlobStreamCommand | undefined;

    constructor(data?: ICommandCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addFromTemplatePrototype = _data["AddFromTemplatePrototype"] ? AddFromTemplateCommand.fromJS(_data["AddFromTemplatePrototype"]) : <any>undefined;
            this.addVersionPrototype = _data["AddVersionPrototype"] ? AddVersionCommand.fromJS(_data["AddVersionPrototype"]) : <any>undefined;
            this.blobStreamExistsPrototype = _data["BlobStreamExistsPrototype"] ? BlobStreamExistsCommand.fromJS(_data["BlobStreamExistsPrototype"]) : <any>undefined;
            this.copyItemPrototype = _data["CopyItemPrototype"] ? CopyItemCommand.fromJS(_data["CopyItemPrototype"]) : <any>undefined;
            this.createItemPrototype = _data["CreateItemPrototype"] ? CreateItemCommand.fromJS(_data["CreateItemPrototype"]) : <any>undefined;
            this.deletePrototype = _data["DeletePrototype"] ? DeleteItemCommand.fromJS(_data["DeletePrototype"]) : <any>undefined;
            this.getBlobStreamPrototype = _data["GetBlobStreamPrototype"] ? GetBlobStreamCommand.fromJS(_data["GetBlobStreamPrototype"]) : <any>undefined;
            this.getChildrenPrototype = _data["GetChildrenPrototype"] ? GetChildrenCommand.fromJS(_data["GetChildrenPrototype"]) : <any>undefined;
            this.getItemPrototype = _data["GetItemPrototype"] ? GetItemCommand.fromJS(_data["GetItemPrototype"]) : <any>undefined;
            this.getParentPrototype = _data["GetParentPrototype"] ? GetParentCommand.fromJS(_data["GetParentPrototype"]) : <any>undefined;
            this.getRootItemPrototype = _data["GetRootItemPrototype"] ? GetRootItemCommand.fromJS(_data["GetRootItemPrototype"]) : <any>undefined;
            this.getVersionsPrototype = _data["GetVersionsPrototype"] ? GetVersionsCommand.fromJS(_data["GetVersionsPrototype"]) : <any>undefined;
            this.hasChildrenPrototype = _data["HasChildrenPrototype"] ? HasChildrenCommand.fromJS(_data["HasChildrenPrototype"]) : <any>undefined;
            this.moveItemPrototype = _data["MoveItemPrototype"] ? MoveItemCommand.fromJS(_data["MoveItemPrototype"]) : <any>undefined;
            this.removeDataPrototype = _data["RemoveDataPrototype"] ? RemoveDataCommand.fromJS(_data["RemoveDataPrototype"]) : <any>undefined;
            this.removeVersionPrototype = _data["RemoveVersionPrototype"] ? RemoveVersionCommand.fromJS(_data["RemoveVersionPrototype"]) : <any>undefined;
            this.resolvePathPrototype = _data["ResolvePathPrototype"] ? ResolvePathCommand.fromJS(_data["ResolvePathPrototype"]) : <any>undefined;
            this.saveItemPrototype = _data["SaveItemPrototype"] ? SaveItemCommand.fromJS(_data["SaveItemPrototype"]) : <any>undefined;
            this.setBlobStreamPrototype = _data["SetBlobStreamPrototype"] ? SetBlobStreamCommand.fromJS(_data["SetBlobStreamPrototype"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommandCollection {
        data = typeof data === 'object' ? data : {};
        let result = new CommandCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AddFromTemplatePrototype"] = this.addFromTemplatePrototype ? this.addFromTemplatePrototype.toJSON() : <any>undefined;
        data["AddVersionPrototype"] = this.addVersionPrototype ? this.addVersionPrototype.toJSON() : <any>undefined;
        data["BlobStreamExistsPrototype"] = this.blobStreamExistsPrototype ? this.blobStreamExistsPrototype.toJSON() : <any>undefined;
        data["CopyItemPrototype"] = this.copyItemPrototype ? this.copyItemPrototype.toJSON() : <any>undefined;
        data["CreateItemPrototype"] = this.createItemPrototype ? this.createItemPrototype.toJSON() : <any>undefined;
        data["DeletePrototype"] = this.deletePrototype ? this.deletePrototype.toJSON() : <any>undefined;
        data["GetBlobStreamPrototype"] = this.getBlobStreamPrototype ? this.getBlobStreamPrototype.toJSON() : <any>undefined;
        data["GetChildrenPrototype"] = this.getChildrenPrototype ? this.getChildrenPrototype.toJSON() : <any>undefined;
        data["GetItemPrototype"] = this.getItemPrototype ? this.getItemPrototype.toJSON() : <any>undefined;
        data["GetParentPrototype"] = this.getParentPrototype ? this.getParentPrototype.toJSON() : <any>undefined;
        data["GetRootItemPrototype"] = this.getRootItemPrototype ? this.getRootItemPrototype.toJSON() : <any>undefined;
        data["GetVersionsPrototype"] = this.getVersionsPrototype ? this.getVersionsPrototype.toJSON() : <any>undefined;
        data["HasChildrenPrototype"] = this.hasChildrenPrototype ? this.hasChildrenPrototype.toJSON() : <any>undefined;
        data["MoveItemPrototype"] = this.moveItemPrototype ? this.moveItemPrototype.toJSON() : <any>undefined;
        data["RemoveDataPrototype"] = this.removeDataPrototype ? this.removeDataPrototype.toJSON() : <any>undefined;
        data["RemoveVersionPrototype"] = this.removeVersionPrototype ? this.removeVersionPrototype.toJSON() : <any>undefined;
        data["ResolvePathPrototype"] = this.resolvePathPrototype ? this.resolvePathPrototype.toJSON() : <any>undefined;
        data["SaveItemPrototype"] = this.saveItemPrototype ? this.saveItemPrototype.toJSON() : <any>undefined;
        data["SetBlobStreamPrototype"] = this.setBlobStreamPrototype ? this.setBlobStreamPrototype.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommandCollection {
    addFromTemplatePrototype?: AddFromTemplateCommand | undefined;
    addVersionPrototype?: AddVersionCommand | undefined;
    blobStreamExistsPrototype?: BlobStreamExistsCommand | undefined;
    copyItemPrototype?: CopyItemCommand | undefined;
    createItemPrototype?: CreateItemCommand | undefined;
    deletePrototype?: DeleteItemCommand | undefined;
    getBlobStreamPrototype?: GetBlobStreamCommand | undefined;
    getChildrenPrototype?: GetChildrenCommand | undefined;
    getItemPrototype?: GetItemCommand | undefined;
    getParentPrototype?: GetParentCommand | undefined;
    getRootItemPrototype?: GetRootItemCommand | undefined;
    getVersionsPrototype?: GetVersionsCommand | undefined;
    hasChildrenPrototype?: HasChildrenCommand | undefined;
    moveItemPrototype?: MoveItemCommand | undefined;
    removeDataPrototype?: RemoveDataCommand | undefined;
    removeVersionPrototype?: RemoveVersionCommand | undefined;
    resolvePathPrototype?: ResolvePathCommand | undefined;
    saveItemPrototype?: SaveItemCommand | undefined;
    setBlobStreamPrototype?: SetBlobStreamCommand | undefined;
}

export class HistoryStorage implements IHistoryStorage {
    entryLifeTime?: string | undefined;

    constructor(data?: IHistoryStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryLifeTime = _data["EntryLifeTime"];
        }
    }

    static fromJS(data: any): HistoryStorage {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EntryLifeTime"] = this.entryLifeTime;
        return data;
    }
}

export interface IHistoryStorage {
    entryLifeTime?: string | undefined;
}

export class ICacheSizeCalculationStrategy implements IICacheSizeCalculationStrategy {

    constructor(data?: IICacheSizeCalculationStrategy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICacheSizeCalculationStrategy {
        data = typeof data === 'object' ? data : {};
        let result = new ICacheSizeCalculationStrategy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICacheSizeCalculationStrategy {
}

export class AmountPerSecondCounter implements IAmountPerSecondCounter {
    readonly value?: number | undefined;
    readonly carry?: AmountPerSecondCounter | undefined;
    readonly resetOnStartup?: boolean | undefined;
    allowConnect?: boolean | undefined;
    readonly hasCarry?: boolean | undefined;
    readonly category?: string | undefined;
    readonly name?: string | undefined;
    readonly fullName?: string | undefined;
    readonly readOnly?: boolean | undefined;
    readonly isConnected?: boolean | undefined;

    constructor(data?: IAmountPerSecondCounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["Value"];
            (<any>this).carry = _data["Carry"] ? AmountPerSecondCounter.fromJS(_data["Carry"]) : <any>undefined;
            (<any>this).resetOnStartup = _data["ResetOnStartup"];
            this.allowConnect = _data["AllowConnect"];
            (<any>this).hasCarry = _data["HasCarry"];
            (<any>this).category = _data["Category"];
            (<any>this).name = _data["Name"];
            (<any>this).fullName = _data["FullName"];
            (<any>this).readOnly = _data["ReadOnly"];
            (<any>this).isConnected = _data["IsConnected"];
        }
    }

    static fromJS(data: any): AmountPerSecondCounter {
        data = typeof data === 'object' ? data : {};
        let result = new AmountPerSecondCounter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["Carry"] = this.carry ? this.carry.toJSON() : <any>undefined;
        data["ResetOnStartup"] = this.resetOnStartup;
        data["AllowConnect"] = this.allowConnect;
        data["HasCarry"] = this.hasCarry;
        data["Category"] = this.category;
        data["Name"] = this.name;
        data["FullName"] = this.fullName;
        data["ReadOnly"] = this.readOnly;
        data["IsConnected"] = this.isConnected;
        return data;
    }
}

export interface IAmountPerSecondCounter {
    value?: number | undefined;
    carry?: AmountPerSecondCounter | undefined;
    resetOnStartup?: boolean | undefined;
    allowConnect?: boolean | undefined;
    hasCarry?: boolean | undefined;
    category?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    readOnly?: boolean | undefined;
    isConnected?: boolean | undefined;
}

export class AddFromTemplateCommand implements IAddFromTemplateCommand {
    readonly destination?: Item | undefined;
    readonly itemName?: string | undefined;
    readonly newId?: ID | undefined;
    readonly templateId?: ID | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: IAddFromTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).destination = _data["Destination"] ? Item.fromJS(_data["Destination"]) : <any>undefined;
            (<any>this).itemName = _data["ItemName"];
            (<any>this).newId = _data["NewId"] ? ID.fromJS(_data["NewId"]) : <any>undefined;
            (<any>this).templateId = _data["TemplateId"] ? ID.fromJS(_data["TemplateId"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddFromTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddFromTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["ItemName"] = this.itemName;
        data["NewId"] = this.newId ? this.newId.toJSON() : <any>undefined;
        data["TemplateId"] = this.templateId ? this.templateId.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddFromTemplateCommand {
    destination?: Item | undefined;
    itemName?: string | undefined;
    newId?: ID | undefined;
    templateId?: ID | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class AddVersionCommand implements IAddVersionCommand {
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: IAddVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddVersionCommand {
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class BlobStreamExistsCommand implements IBlobStreamExistsCommand {
    readonly blobId?: string | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IBlobStreamExistsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).blobId = _data["BlobId"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): BlobStreamExistsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BlobStreamExistsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BlobId"] = this.blobId;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IBlobStreamExistsCommand {
    blobId?: string | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class CopyItemCommand implements ICopyItemCommand {
    readonly copyName?: string | undefined;
    readonly copyId?: ID | undefined;
    readonly deep?: boolean | undefined;
    readonly destination?: Item | undefined;
    readonly source?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: ICopyItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).copyName = _data["CopyName"];
            (<any>this).copyId = _data["CopyId"] ? ID.fromJS(_data["CopyId"]) : <any>undefined;
            (<any>this).deep = _data["Deep"];
            (<any>this).destination = _data["Destination"] ? Item.fromJS(_data["Destination"]) : <any>undefined;
            (<any>this).source = _data["Source"] ? Item.fromJS(_data["Source"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CopyItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CopyItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CopyName"] = this.copyName;
        data["CopyId"] = this.copyId ? this.copyId.toJSON() : <any>undefined;
        data["Deep"] = this.deep;
        data["Destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["Source"] = this.source ? this.source.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICopyItemCommand {
    copyName?: string | undefined;
    copyId?: ID | undefined;
    deep?: boolean | undefined;
    destination?: Item | undefined;
    source?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class CreateItemCommand implements ICreateItemCommand {
    readonly destination?: Item | undefined;
    readonly itemId?: ID | undefined;
    readonly itemName?: string | undefined;
    readonly templateId?: ID | undefined;
    readonly created?: Date | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: ICreateItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).destination = _data["Destination"] ? Item.fromJS(_data["Destination"]) : <any>undefined;
            (<any>this).itemId = _data["ItemId"] ? ID.fromJS(_data["ItemId"]) : <any>undefined;
            (<any>this).itemName = _data["ItemName"];
            (<any>this).templateId = _data["TemplateId"] ? ID.fromJS(_data["TemplateId"]) : <any>undefined;
            (<any>this).created = _data["Created"] ? new Date(_data["Created"].toString()) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["ItemId"] = this.itemId ? this.itemId.toJSON() : <any>undefined;
        data["ItemName"] = this.itemName;
        data["TemplateId"] = this.templateId ? this.templateId.toJSON() : <any>undefined;
        data["Created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateItemCommand {
    destination?: Item | undefined;
    itemId?: ID | undefined;
    itemName?: string | undefined;
    templateId?: ID | undefined;
    created?: Date | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class DeleteItemCommand implements IDeleteItemCommand {
    readonly item?: Item | undefined;
    readonly parentId?: ID | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IDeleteItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).parentId = _data["ParentId"] ? ID.fromJS(_data["ParentId"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): DeleteItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["ParentId"] = this.parentId ? this.parentId.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IDeleteItemCommand {
    item?: Item | undefined;
    parentId?: ID | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class GetBlobStreamCommand implements IGetBlobStreamCommand {
    readonly blobId?: string | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Stream | undefined;

    constructor(data?: IGetBlobStreamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).blobId = _data["BlobId"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Stream.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBlobStreamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetBlobStreamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BlobId"] = this.blobId;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBlobStreamCommand {
    blobId?: string | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Stream | undefined;
}

export class GetChildrenCommand implements IGetChildrenCommand {
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item[] | undefined;

    constructor(data?: IGetChildrenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            if (Array.isArray(_data["Result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["Result"])
                    (<any>this).result!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetChildrenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetChildrenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetChildrenCommand {
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item[] | undefined;
}

export class GetItemCommand implements IGetItemCommand {
    readonly itemId?: ID | undefined;
    readonly language?: Language | undefined;
    readonly version?: Version | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: IGetItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).itemId = _data["ItemId"] ? ID.fromJS(_data["ItemId"]) : <any>undefined;
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId ? this.itemId.toJSON() : <any>undefined;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetItemCommand {
    itemId?: ID | undefined;
    language?: Language | undefined;
    version?: Version | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class GetParentCommand implements IGetParentCommand {
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: IGetParentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetParentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetParentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetParentCommand {
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class GetRootItemCommand implements IGetRootItemCommand {
    readonly language?: Language | undefined;
    readonly version?: Version | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Item | undefined;

    constructor(data?: IGetRootItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).version = _data["Version"] ? Version.fromJS(_data["Version"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? Item.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRootItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetRootItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["Version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRootItemCommand {
    language?: Language | undefined;
    version?: Version | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Item | undefined;
}

export class GetVersionsCommand implements IGetVersionsCommand {
    readonly item?: Item | undefined;
    readonly language?: Language | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: Version[] | undefined;

    constructor(data?: IGetVersionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            if (Array.isArray(_data["Result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["Result"])
                    (<any>this).result!.push(Version.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetVersionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GetVersionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetVersionsCommand {
    item?: Item | undefined;
    language?: Language | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: Version[] | undefined;
}

export class HasChildrenCommand implements IHasChildrenCommand {
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IHasChildrenCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): HasChildrenCommand {
        data = typeof data === 'object' ? data : {};
        let result = new HasChildrenCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IHasChildrenCommand {
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class MoveItemCommand implements IMoveItemCommand {
    readonly destination?: Item | undefined;
    readonly item?: Item | undefined;
    readonly oldParentId?: ID | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IMoveItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).destination = _data["Destination"] ? Item.fromJS(_data["Destination"]) : <any>undefined;
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).oldParentId = _data["OldParentId"] ? ID.fromJS(_data["OldParentId"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): MoveItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["OldParentId"] = this.oldParentId ? this.oldParentId.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IMoveItemCommand {
    destination?: Item | undefined;
    item?: Item | undefined;
    oldParentId?: ID | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class RemoveDataCommand implements IRemoveDataCommand {
    readonly itemId?: ID | undefined;
    readonly language?: Language | undefined;
    readonly removeAllLanguages?: boolean | undefined;
    readonly removeSharedData?: boolean | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IRemoveDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).itemId = _data["ItemId"] ? ID.fromJS(_data["ItemId"]) : <any>undefined;
            (<any>this).language = _data["Language"] ? Language.fromJS(_data["Language"]) : <any>undefined;
            (<any>this).removeAllLanguages = _data["RemoveAllLanguages"];
            (<any>this).removeSharedData = _data["RemoveSharedData"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): RemoveDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId ? this.itemId.toJSON() : <any>undefined;
        data["Language"] = this.language ? this.language.toJSON() : <any>undefined;
        data["RemoveAllLanguages"] = this.removeAllLanguages;
        data["RemoveSharedData"] = this.removeSharedData;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IRemoveDataCommand {
    itemId?: ID | undefined;
    language?: Language | undefined;
    removeAllLanguages?: boolean | undefined;
    removeSharedData?: boolean | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class RemoveVersionCommand implements IRemoveVersionCommand {
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: IRemoveVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): RemoveVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface IRemoveVersionCommand {
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class ResolvePathCommand implements IResolvePathCommand {
    readonly itemPath?: string | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: ID | undefined;

    constructor(data?: IResolvePathCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).itemPath = _data["ItemPath"];
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"] ? ID.fromJS(_data["Result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResolvePathCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvePathCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemPath"] = this.itemPath;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResolvePathCommand {
    itemPath?: string | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: ID | undefined;
}

export class SaveItemCommand implements ISaveItemCommand {
    readonly changes?: ItemChanges | undefined;
    readonly item?: Item | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: ISaveItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).changes = _data["Changes"] ? ItemChanges.fromJS(_data["Changes"]) : <any>undefined;
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): SaveItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Changes"] = this.changes ? this.changes.toJSON() : <any>undefined;
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface ISaveItemCommand {
    changes?: ItemChanges | undefined;
    item?: Item | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class SetBlobStreamCommand implements ISetBlobStreamCommand {
    readonly blobId?: string | undefined;
    readonly stream?: Stream | undefined;
    readonly database?: Database | undefined;
    readonly dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    readonly result?: boolean | undefined;

    constructor(data?: ISetBlobStreamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).blobId = _data["BlobId"];
            (<any>this).stream = _data["Stream"] ? Stream.fromJS(_data["Stream"]) : <any>undefined;
            (<any>this).database = _data["Database"] ? Database.fromJS(_data["Database"]) : <any>undefined;
            (<any>this).dataSource = _data["DataSource"] ? DataSource.fromJS(_data["DataSource"]) : <any>undefined;
            this.engine = _data["Engine"] ? DataEngine.fromJS(_data["Engine"]) : <any>undefined;
            (<any>this).result = _data["Result"];
        }
    }

    static fromJS(data: any): SetBlobStreamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetBlobStreamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["BlobId"] = this.blobId;
        data["Stream"] = this.stream ? this.stream.toJSON() : <any>undefined;
        data["Database"] = this.database ? this.database.toJSON() : <any>undefined;
        data["DataSource"] = this.dataSource ? this.dataSource.toJSON() : <any>undefined;
        data["Engine"] = this.engine ? this.engine.toJSON() : <any>undefined;
        data["Result"] = this.result;
        return data;
    }
}

export interface ISetBlobStreamCommand {
    blobId?: string | undefined;
    stream?: Stream | undefined;
    database?: Database | undefined;
    dataSource?: DataSource | undefined;
    engine?: DataEngine | undefined;
    result?: boolean | undefined;
}

export class Stream implements IStream {
    readonly canRead?: boolean | undefined;
    readonly canSeek?: boolean | undefined;
    readonly canTimeout?: boolean | undefined;
    readonly canWrite?: boolean | undefined;
    readonly length?: number | undefined;
    position?: number | undefined;
    readTimeout?: number | undefined;
    writeTimeout?: number | undefined;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["CanRead"];
            (<any>this).canSeek = _data["CanSeek"];
            (<any>this).canTimeout = _data["CanTimeout"];
            (<any>this).canWrite = _data["CanWrite"];
            (<any>this).length = _data["Length"];
            this.position = _data["Position"];
            this.readTimeout = _data["ReadTimeout"];
            this.writeTimeout = _data["WriteTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanRead"] = this.canRead;
        data["CanSeek"] = this.canSeek;
        data["CanTimeout"] = this.canTimeout;
        data["CanWrite"] = this.canWrite;
        data["Length"] = this.length;
        data["Position"] = this.position;
        data["ReadTimeout"] = this.readTimeout;
        data["WriteTimeout"] = this.writeTimeout;
        return data;
    }
}

export interface IStream {
    canRead?: boolean | undefined;
    canSeek?: boolean | undefined;
    canTimeout?: boolean | undefined;
    canWrite?: boolean | undefined;
    length?: number | undefined;
    position?: number | undefined;
    readTimeout?: number | undefined;
    writeTimeout?: number | undefined;
}

export class ItemChanges implements IItemChanges {
    readonly fieldChanges?: any[] | undefined;
    readonly hasFieldsChanged?: boolean | undefined;
    readonly hasPropertiesChanged?: boolean | undefined;
    readonly isEmpty?: boolean | undefined;
    readonly item?: Item | undefined;
    readonly properties?: { [key: string]: PropertyChange; } | undefined;
    readonly renamed?: boolean | undefined;

    constructor(data?: IItemChanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["FieldChanges"])) {
                (<any>this).fieldChanges = [] as any;
                for (let item of _data["FieldChanges"])
                    (<any>this).fieldChanges!.push(item);
            }
            (<any>this).hasFieldsChanged = _data["HasFieldsChanged"];
            (<any>this).hasPropertiesChanged = _data["HasPropertiesChanged"];
            (<any>this).isEmpty = _data["IsEmpty"];
            (<any>this).item = _data["Item"] ? Item.fromJS(_data["Item"]) : <any>undefined;
            if (_data["Properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["Properties"]) {
                    if (_data["Properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["Properties"][key] ? PropertyChange.fromJS(_data["Properties"][key]) : new PropertyChange();
                }
            }
            (<any>this).renamed = _data["Renamed"];
        }
    }

    static fromJS(data: any): ItemChanges {
        data = typeof data === 'object' ? data : {};
        let result = new ItemChanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldChanges)) {
            data["FieldChanges"] = [];
            for (let item of this.fieldChanges)
                data["FieldChanges"].push(item);
        }
        data["HasFieldsChanged"] = this.hasFieldsChanged;
        data["HasPropertiesChanged"] = this.hasPropertiesChanged;
        data["IsEmpty"] = this.isEmpty;
        data["Item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (this.properties) {
            data["Properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["Properties"])[key] = this.properties[key] ? this.properties[key].toJSON() : <any>undefined;
            }
        }
        data["Renamed"] = this.renamed;
        return data;
    }
}

export interface IItemChanges {
    fieldChanges?: any[] | undefined;
    hasFieldsChanged?: boolean | undefined;
    hasPropertiesChanged?: boolean | undefined;
    isEmpty?: boolean | undefined;
    item?: Item | undefined;
    properties?: { [key: string]: PropertyChange; } | undefined;
    renamed?: boolean | undefined;
}

export class PropertyChange implements IPropertyChange {
    readonly name?: string | undefined;
    readonly originalValue?: any | undefined;
    readonly value?: any | undefined;

    constructor(data?: IPropertyChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["Name"];
            (<any>this).originalValue = _data["OriginalValue"];
            (<any>this).value = _data["Value"];
        }
    }

    static fromJS(data: any): PropertyChange {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["OriginalValue"] = this.originalValue;
        data["Value"] = this.value;
        return data;
    }
}

export interface IPropertyChange {
    name?: string | undefined;
    originalValue?: any | undefined;
    value?: any | undefined;
}

export class Holiday implements IHoliday {
    date?: string | undefined;
    open?: string | undefined;
    close?: string | undefined;

    constructor(data?: IHoliday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["Date"];
            this.open = _data["Open"];
            this.close = _data["Close"];
        }
    }

    static fromJS(data: any): Holiday {
        data = typeof data === 'object' ? data : {};
        let result = new Holiday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Date"] = this.date;
        data["Open"] = this.open;
        data["Close"] = this.close;
        return data;
    }
}

export interface IHoliday {
    date?: string | undefined;
    open?: string | undefined;
    close?: string | undefined;
}

export class StockInformation implements IStockInformation {
    sku?: string | undefined;
    plant?: string | undefined;
    storageLocation?: string | undefined;
    valuatedUnrestrictedUseStock?: number | undefined;
    baseUnitOfMeasure?: string | undefined;
    salesOffice?: SalesOffice | undefined;
    group?: string | undefined;
    text?: string | undefined;

    constructor(data?: IStockInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["Sku"];
            this.plant = _data["Plant"];
            this.storageLocation = _data["StorageLocation"];
            this.valuatedUnrestrictedUseStock = _data["ValuatedUnrestrictedUseStock"];
            this.baseUnitOfMeasure = _data["BaseUnitOfMeasure"];
            this.salesOffice = _data["SalesOffice"] ? SalesOffice.fromJS(_data["SalesOffice"]) : <any>undefined;
            this.group = _data["Group"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): StockInformation {
        data = typeof data === 'object' ? data : {};
        let result = new StockInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sku"] = this.sku;
        data["Plant"] = this.plant;
        data["StorageLocation"] = this.storageLocation;
        data["ValuatedUnrestrictedUseStock"] = this.valuatedUnrestrictedUseStock;
        data["BaseUnitOfMeasure"] = this.baseUnitOfMeasure;
        data["SalesOffice"] = this.salesOffice ? this.salesOffice.toJSON() : <any>undefined;
        data["Group"] = this.group;
        data["Text"] = this.text;
        return data;
    }
}

export interface IStockInformation {
    sku?: string | undefined;
    plant?: string | undefined;
    storageLocation?: string | undefined;
    valuatedUnrestrictedUseStock?: number | undefined;
    baseUnitOfMeasure?: string | undefined;
    salesOffice?: SalesOffice | undefined;
    group?: string | undefined;
    text?: string | undefined;
}

export class SalesOfficeWithStock implements ISalesOfficeWithStock {
    sku?: string | undefined;
    stockLevel?: number | undefined;
    salesOffice?: SalesOffice | undefined;
    stockUnit?: string | undefined;
    hidePreciseStock?: boolean | undefined;

    constructor(data?: ISalesOfficeWithStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["Sku"];
            this.stockLevel = _data["StockLevel"];
            this.salesOffice = _data["SalesOffice"] ? SalesOffice.fromJS(_data["SalesOffice"]) : <any>undefined;
            this.stockUnit = _data["StockUnit"];
            this.hidePreciseStock = _data["HidePreciseStock"];
        }
    }

    static fromJS(data: any): SalesOfficeWithStock {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOfficeWithStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sku"] = this.sku;
        data["StockLevel"] = this.stockLevel;
        data["SalesOffice"] = this.salesOffice ? this.salesOffice.toJSON() : <any>undefined;
        data["StockUnit"] = this.stockUnit;
        data["HidePreciseStock"] = this.hidePreciseStock;
        return data;
    }
}

export interface ISalesOfficeWithStock {
    sku?: string | undefined;
    stockLevel?: number | undefined;
    salesOffice?: SalesOffice | undefined;
    stockUnit?: string | undefined;
    hidePreciseStock?: boolean | undefined;
}

export class Subscription implements ISubscription {
    id?: string | undefined;
    origin?: string | undefined;
    subscriptionType?: string | undefined;
    subscriberFirstname?: string | undefined;
    subscriberLastname?: string | undefined;
    format?: string | undefined;
    subscriptionStartDate?: string | undefined;
    accountOwner?: string | undefined;
    subscriptionExpiryDate?: string | undefined;
    accountId?: string | undefined;
    subscriptionData?: any | undefined;
    sSOId?: string | undefined;
    destination?: string | undefined;
    platform?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.origin = _data["Origin"];
            this.subscriptionType = _data["SubscriptionType"];
            this.subscriberFirstname = _data["SubscriberFirstname"];
            this.subscriberLastname = _data["SubscriberLastname"];
            this.format = _data["Format"];
            this.subscriptionStartDate = _data["SubscriptionStartDate"];
            this.accountOwner = _data["AccountOwner"];
            this.subscriptionExpiryDate = _data["SubscriptionExpiryDate"];
            this.accountId = _data["AccountId"];
            this.subscriptionData = _data["SubscriptionData"];
            this.sSOId = _data["SSOId"];
            this.destination = _data["Destination"];
            this.platform = _data["Platform"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Origin"] = this.origin;
        data["SubscriptionType"] = this.subscriptionType;
        data["SubscriberFirstname"] = this.subscriberFirstname;
        data["SubscriberLastname"] = this.subscriberLastname;
        data["Format"] = this.format;
        data["SubscriptionStartDate"] = this.subscriptionStartDate;
        data["AccountOwner"] = this.accountOwner;
        data["SubscriptionExpiryDate"] = this.subscriptionExpiryDate;
        data["AccountId"] = this.accountId;
        data["SubscriptionData"] = this.subscriptionData;
        data["SSOId"] = this.sSOId;
        data["Destination"] = this.destination;
        data["Platform"] = this.platform;
        data["Active"] = this.active;
        return data;
    }
}

export interface ISubscription {
    id?: string | undefined;
    origin?: string | undefined;
    subscriptionType?: string | undefined;
    subscriberFirstname?: string | undefined;
    subscriberLastname?: string | undefined;
    format?: string | undefined;
    subscriptionStartDate?: string | undefined;
    accountOwner?: string | undefined;
    subscriptionExpiryDate?: string | undefined;
    accountId?: string | undefined;
    subscriptionData?: any | undefined;
    sSOId?: string | undefined;
    destination?: string | undefined;
    platform?: string | undefined;
    active?: boolean | undefined;
}

export class V2ControllerResultOfObject implements IV2ControllerResultOfObject {
    readonly result?: any | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"];
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfObject {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfObject {
    result?: any | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class SubscriptionIdObj implements ISubscriptionIdObj {
    subscriptionId?: string | undefined;

    constructor(data?: ISubscriptionIdObj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["SubscriptionId"];
        }
    }

    static fromJS(data: any): SubscriptionIdObj {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionIdObj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SubscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface ISubscriptionIdObj {
    subscriptionId?: string | undefined;
}

export class ActiveSubscription implements IActiveSubscription {
    active?: boolean | undefined;
    subscriptionId?: string | undefined;

    constructor(data?: IActiveSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["Active"];
            this.subscriptionId = _data["SubscriptionId"];
        }
    }

    static fromJS(data: any): ActiveSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Active"] = this.active;
        data["SubscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IActiveSubscription {
    active?: boolean | undefined;
    subscriptionId?: string | undefined;
}

export class UpdateToken implements IUpdateToken {
    sSOId?: string | undefined;
    newToken?: string | undefined;
    oldToken?: string | undefined;

    constructor(data?: IUpdateToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sSOId = _data["SSOId"];
            this.newToken = _data["NewToken"];
            this.oldToken = _data["OldToken"];
        }
    }

    static fromJS(data: any): UpdateToken {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SSOId"] = this.sSOId;
        data["NewToken"] = this.newToken;
        data["OldToken"] = this.oldToken;
        return data;
    }
}

export interface IUpdateToken {
    sSOId?: string | undefined;
    newToken?: string | undefined;
    oldToken?: string | undefined;
}

export class GetSubscription implements IGetSubscription {
    sSOId?: string | undefined;
    types?: string[] | undefined;
    token?: string | undefined;
    accountId?: string | undefined;

    constructor(data?: IGetSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sSOId = _data["SSOId"];
            if (Array.isArray(_data["Types"])) {
                this.types = [] as any;
                for (let item of _data["Types"])
                    this.types!.push(item);
            }
            this.token = _data["Token"];
            this.accountId = _data["AccountId"];
        }
    }

    static fromJS(data: any): GetSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SSOId"] = this.sSOId;
        if (Array.isArray(this.types)) {
            data["Types"] = [];
            for (let item of this.types)
                data["Types"].push(item);
        }
        data["Token"] = this.token;
        data["AccountId"] = this.accountId;
        return data;
    }
}

export interface IGetSubscription {
    sSOId?: string | undefined;
    types?: string[] | undefined;
    token?: string | undefined;
    accountId?: string | undefined;
}

export class TokenObj implements ITokenObj {
    token?: string | undefined;

    constructor(data?: ITokenObj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
        }
    }

    static fromJS(data: any): TokenObj {
        data = typeof data === 'object' ? data : {};
        let result = new TokenObj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        return data;
    }
}

export interface ITokenObj {
    token?: string | undefined;
}

export class TrackAndTrace implements ITrackAndTrace {
    contacts?: TTContactPerson[] | undefined;

    constructor(data?: ITrackAndTrace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(TTContactPerson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackAndTrace {
        data = typeof data === 'object' ? data : {};
        let result = new TrackAndTrace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrackAndTrace {
    contacts?: TTContactPerson[] | undefined;
}

export class TTContactPerson implements ITTContactPerson {
    id?: string | undefined;
    accountHolderId?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    admin?: boolean | undefined;
    active?: boolean | undefined;
    zip?: string | undefined;
    accounts?: TTAccount[] | undefined;

    constructor(data?: ITTContactPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountHolderId = _data["AccountHolderId"];
            this.name = _data["Name"];
            this.lastName = _data["LastName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.address = _data["Address"];
            this.admin = _data["Admin"];
            this.active = _data["Active"];
            this.zip = _data["Zip"];
            if (Array.isArray(_data["Accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["Accounts"])
                    this.accounts!.push(TTAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TTContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new TTContactPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountHolderId"] = this.accountHolderId;
        data["Name"] = this.name;
        data["LastName"] = this.lastName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Address"] = this.address;
        data["Admin"] = this.admin;
        data["Active"] = this.active;
        data["Zip"] = this.zip;
        if (Array.isArray(this.accounts)) {
            data["Accounts"] = [];
            for (let item of this.accounts)
                data["Accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITTContactPerson {
    id?: string | undefined;
    accountHolderId?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    admin?: boolean | undefined;
    active?: boolean | undefined;
    zip?: string | undefined;
    accounts?: TTAccount[] | undefined;
}

export class TTAccount implements ITTAccount {
    id?: string | undefined;
    accountNumber?: string | undefined;
    addresses?: TTAddresses[] | undefined;

    constructor(data?: ITTAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.accountNumber = _data["AccountNumber"];
            if (Array.isArray(_data["Addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["Addresses"])
                    this.addresses!.push(TTAddresses.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TTAccount {
        data = typeof data === 'object' ? data : {};
        let result = new TTAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AccountNumber"] = this.accountNumber;
        if (Array.isArray(this.addresses)) {
            data["Addresses"] = [];
            for (let item of this.addresses)
                data["Addresses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITTAccount {
    id?: string | undefined;
    accountNumber?: string | undefined;
    addresses?: TTAddresses[] | undefined;
}

export class TTAddresses implements ITTAddresses {
    id?: string | undefined;
    address?: string | undefined;
    accountHolderId?: string | undefined;
    productTypes?: TTProductType[] | undefined;

    constructor(data?: ITTAddresses) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.address = _data["Address"];
            this.accountHolderId = _data["AccountHolderId"];
            if (Array.isArray(_data["ProductTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["ProductTypes"])
                    this.productTypes!.push(TTProductType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TTAddresses {
        data = typeof data === 'object' ? data : {};
        let result = new TTAddresses();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Address"] = this.address;
        data["AccountHolderId"] = this.accountHolderId;
        if (Array.isArray(this.productTypes)) {
            data["ProductTypes"] = [];
            for (let item of this.productTypes)
                data["ProductTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITTAddresses {
    id?: string | undefined;
    address?: string | undefined;
    accountHolderId?: string | undefined;
    productTypes?: TTProductType[] | undefined;
}

export class TTProductType implements ITTProductType {
    id?: string | undefined;
    name?: string | undefined;
    messageTypes?: TTMessageType[] | undefined;

    constructor(data?: ITTProductType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["MessageTypes"])) {
                this.messageTypes = [] as any;
                for (let item of _data["MessageTypes"])
                    this.messageTypes!.push(TTMessageType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TTProductType {
        data = typeof data === 'object' ? data : {};
        let result = new TTProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.messageTypes)) {
            data["MessageTypes"] = [];
            for (let item of this.messageTypes)
                data["MessageTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITTProductType {
    id?: string | undefined;
    name?: string | undefined;
    messageTypes?: TTMessageType[] | undefined;
}

export class TTMessageType implements ITTMessageType {
    type?: string | undefined;
    typeDescription?: string | undefined;
    registered?: TTRegistered[] | undefined;

    constructor(data?: ITTMessageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.typeDescription = _data["TypeDescription"];
            if (Array.isArray(_data["Registered"])) {
                this.registered = [] as any;
                for (let item of _data["Registered"])
                    this.registered!.push(TTRegistered.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TTMessageType {
        data = typeof data === 'object' ? data : {};
        let result = new TTMessageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["TypeDescription"] = this.typeDescription;
        if (Array.isArray(this.registered)) {
            data["Registered"] = [];
            for (let item of this.registered)
                data["Registered"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITTMessageType {
    type?: string | undefined;
    typeDescription?: string | undefined;
    registered?: TTRegistered[] | undefined;
}

export class TTRegistered implements ITTRegistered {
    contactId?: string | undefined;
    id?: string | undefined;
    sMS?: boolean | undefined;
    mail?: boolean | undefined;

    constructor(data?: ITTRegistered) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["ContactId"];
            this.id = _data["Id"];
            this.sMS = _data["SMS"];
            this.mail = _data["Mail"];
        }
    }

    static fromJS(data: any): TTRegistered {
        data = typeof data === 'object' ? data : {};
        let result = new TTRegistered();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContactId"] = this.contactId;
        data["Id"] = this.id;
        data["SMS"] = this.sMS;
        data["Mail"] = this.mail;
        return data;
    }
}

export interface ITTRegistered {
    contactId?: string | undefined;
    id?: string | undefined;
    sMS?: boolean | undefined;
    mail?: boolean | undefined;
}

export class V2ControllerResultOfTTDocumentFlowOf implements IV2ControllerResultOfTTDocumentFlowOf {
    readonly result?: TTDocumentFlow[] | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfTTDocumentFlowOf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Result"])) {
                (<any>this).result = [] as any;
                for (let item of _data["Result"])
                    (<any>this).result!.push(TTDocumentFlow.fromJS(item));
            }
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfTTDocumentFlowOf {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfTTDocumentFlowOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item.toJSON());
        }
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfTTDocumentFlowOf {
    result?: TTDocumentFlow[] | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class TTDocumentFlow implements ITTDocumentFlow {
    readonly vbeln?: string | undefined;
    readonly posnr?: string | undefined;
    readonly bilnr?: string | undefined;
    readonly date?: Date | undefined;
    readonly description?: string | undefined;
    readonly bilagnr?: string | undefined;
    readonly bilagpos?: number | undefined;
    readonly status?: string | undefined;
    readonly getDateFormat?: string | undefined;

    constructor(data?: ITTDocumentFlow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).vbeln = _data["Vbeln"];
            (<any>this).posnr = _data["Posnr"];
            (<any>this).bilnr = _data["Bilnr"];
            (<any>this).date = _data["Date"] ? new Date(_data["Date"].toString()) : <any>undefined;
            (<any>this).description = _data["Description"];
            (<any>this).bilagnr = _data["Bilagnr"];
            (<any>this).bilagpos = _data["Bilagpos"];
            (<any>this).status = _data["Status"];
            (<any>this).getDateFormat = _data["GetDateFormat"];
        }
    }

    static fromJS(data: any): TTDocumentFlow {
        data = typeof data === 'object' ? data : {};
        let result = new TTDocumentFlow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Vbeln"] = this.vbeln;
        data["Posnr"] = this.posnr;
        data["Bilnr"] = this.bilnr;
        data["Date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["Description"] = this.description;
        data["Bilagnr"] = this.bilagnr;
        data["Bilagpos"] = this.bilagpos;
        data["Status"] = this.status;
        data["GetDateFormat"] = this.getDateFormat;
        return data;
    }
}

export interface ITTDocumentFlow {
    vbeln?: string | undefined;
    posnr?: string | undefined;
    bilnr?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    bilagnr?: string | undefined;
    bilagpos?: number | undefined;
    status?: string | undefined;
    getDateFormat?: string | undefined;
}

export class V2ControllerResultOfWeatherResult implements IV2ControllerResultOfWeatherResult {
    readonly result?: WeatherResult | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfWeatherResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? WeatherResult.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfWeatherResult {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfWeatherResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfWeatherResult {
    result?: WeatherResult | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class WeatherResult implements IWeatherResult {
    forecasts?: Forecast[] | undefined;
    sunrise?: Date | undefined;
    sunset?: Date | undefined;

    constructor(data?: IWeatherResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Forecasts"])) {
                this.forecasts = [] as any;
                for (let item of _data["Forecasts"])
                    this.forecasts!.push(Forecast.fromJS(item));
            }
            this.sunrise = _data["Sunrise"] ? new Date(_data["Sunrise"].toString()) : <any>undefined;
            this.sunset = _data["Sunset"] ? new Date(_data["Sunset"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeatherResult {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.forecasts)) {
            data["Forecasts"] = [];
            for (let item of this.forecasts)
                data["Forecasts"].push(item.toJSON());
        }
        data["Sunrise"] = this.sunrise ? this.sunrise.toISOString() : <any>undefined;
        data["Sunset"] = this.sunset ? this.sunset.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWeatherResult {
    forecasts?: Forecast[] | undefined;
    sunrise?: Date | undefined;
    sunset?: Date | undefined;
}

export class Forecast implements IForecast {
    dayTime?: Date | undefined;
    temperature?: number | undefined;
    minTemperature?: number | undefined;
    maxTemperature?: number | undefined;
    pressure?: number | undefined;
    humidity?: number | undefined;
    weatherTitle?: string | undefined;
    weatherDescription?: string | undefined;
    weatherIcon?: string | undefined;
    clouds?: string | undefined;
    windSpeed?: number | undefined;
    windDirection?: number | undefined;
    rain?: any | undefined;
    snow?: any | undefined;

    constructor(data?: IForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayTime = _data["DayTime"] ? new Date(_data["DayTime"].toString()) : <any>undefined;
            this.temperature = _data["Temperature"];
            this.minTemperature = _data["MinTemperature"];
            this.maxTemperature = _data["MaxTemperature"];
            this.pressure = _data["Pressure"];
            this.humidity = _data["Humidity"];
            this.weatherTitle = _data["WeatherTitle"];
            this.weatherDescription = _data["WeatherDescription"];
            this.weatherIcon = _data["WeatherIcon"];
            this.clouds = _data["Clouds"];
            this.windSpeed = _data["WindSpeed"];
            this.windDirection = _data["WindDirection"];
            this.rain = _data["Rain"];
            this.snow = _data["Snow"];
        }
    }

    static fromJS(data: any): Forecast {
        data = typeof data === 'object' ? data : {};
        let result = new Forecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DayTime"] = this.dayTime ? this.dayTime.toISOString() : <any>undefined;
        data["Temperature"] = this.temperature;
        data["MinTemperature"] = this.minTemperature;
        data["MaxTemperature"] = this.maxTemperature;
        data["Pressure"] = this.pressure;
        data["Humidity"] = this.humidity;
        data["WeatherTitle"] = this.weatherTitle;
        data["WeatherDescription"] = this.weatherDescription;
        data["WeatherIcon"] = this.weatherIcon;
        data["Clouds"] = this.clouds;
        data["WindSpeed"] = this.windSpeed;
        data["WindDirection"] = this.windDirection;
        data["Rain"] = this.rain;
        data["Snow"] = this.snow;
        return data;
    }
}

export interface IForecast {
    dayTime?: Date | undefined;
    temperature?: number | undefined;
    minTemperature?: number | undefined;
    maxTemperature?: number | undefined;
    pressure?: number | undefined;
    humidity?: number | undefined;
    weatherTitle?: string | undefined;
    weatherDescription?: string | undefined;
    weatherIcon?: string | undefined;
    clouds?: string | undefined;
    windSpeed?: number | undefined;
    windDirection?: number | undefined;
    rain?: any | undefined;
    snow?: any | undefined;
}

export class V2ControllerResultOfAppFrontpageWidget implements IV2ControllerResultOfAppFrontpageWidget {
    readonly result?: AppFrontpageWidget | undefined;
    readonly success?: boolean | undefined;
    readonly message?: string | undefined;

    constructor(data?: IV2ControllerResultOfAppFrontpageWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["Result"] ? AppFrontpageWidget.fromJS(_data["Result"]) : <any>undefined;
            (<any>this).success = _data["Success"];
            (<any>this).message = _data["Message"];
        }
    }

    static fromJS(data: any): V2ControllerResultOfAppFrontpageWidget {
        data = typeof data === 'object' ? data : {};
        let result = new V2ControllerResultOfAppFrontpageWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["Success"] = this.success;
        data["Message"] = this.message;
        return data;
    }
}

export interface IV2ControllerResultOfAppFrontpageWidget {
    result?: AppFrontpageWidget | undefined;
    success?: boolean | undefined;
    message?: string | undefined;
}

export class AppFrontpageWidget implements IAppFrontpageWidget {
    widgets?: AppWidgets[] | undefined;

    constructor(data?: IAppFrontpageWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["Widgets"])
                    this.widgets!.push(AppWidgets.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppFrontpageWidget {
        data = typeof data === 'object' ? data : {};
        let result = new AppFrontpageWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.widgets)) {
            data["Widgets"] = [];
            for (let item of this.widgets)
                data["Widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppFrontpageWidget {
    widgets?: AppWidgets[] | undefined;
}

export class AppWidgets implements IAppWidgets {
    type?: string | undefined;
    items?: AppWidget[] | undefined;

    constructor(data?: IAppWidgets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(AppWidget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppWidgets {
        data = typeof data === 'object' ? data : {};
        let result = new AppWidgets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppWidgets {
    type?: string | undefined;
    items?: AppWidget[] | undefined;
}

export class AppWidget implements IAppWidget {

    constructor(data?: IAppWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AppWidget {
        data = typeof data === 'object' ? data : {};
        let result = new AppWidget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAppWidget {
}

export enum DeviceType {
    UNKNOWN = "UNKNOWN",
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export enum DeviceType2 {
    UNKNOWN = "UNKNOWN",
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export enum DeviceType3 {
    UNKNOWN = "UNKNOWN",
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export enum VersionUpdateDeviceType {
    UNKNOWN = "UNKNOWN",
    IOS = "IOS",
    ANDROID = "ANDROID",
}

export enum CatalogProductFlagType {
    None = "None",
    Mængderabat = "Mængderabat",
    FlereVarianter = "FlereVarianter",
    Tilbud = "Tilbud",
    Mængdetilbud = "Mængdetilbud",
    FastLavPris = "FastLavPris",
    FritValg = "FritValg",
    KunOnline = "KunOnline",
    DinPris = "DinPris",
    KlubPris = "KlubPris",
    OnlineDiscount = "OnlineDiscount",
    KunButik = "KunButik",
    MedarbejderPris = "MedarbejderPris",
    FarmerDiscountPercent = "FarmerDiscountPercent",
    FarmerDiscountAmount = "FarmerDiscountAmount",
    OnlineDiscountLF = "OnlineDiscountLF",
    KlubPrisOnlineDiscount = "KlubPrisOnlineDiscount",
}

export enum SearchFacetSortType {
    Count = "Count",
    ChildrenFirst = "ChildrenFirst",
    ChildrenOnly = "ChildrenOnly",
    Alphabetical = "Alphabetical",
}

export enum ProductPricePriceType {
    Unknown = "Unknown",
    Retail = "Retail",
    Wholesale = "Wholesale",
    RetailDiscountOrFee = "RetailDiscountOrFee",
    ScaleDiscountAmount = "ScaleDiscountAmount",
    ScaleDiscountPercent = "ScaleDiscountPercent",
    CustomerGroupPrice = "CustomerGroupPrice",
    LFClubPrice = "LFClubPrice",
    OnlineDiscountPortal = "OnlineDiscountPortal",
    Contract = "Contract",
    FarmerDiscountAmount = "FarmerDiscountAmount",
    FarmerDiscountPercent = "FarmerDiscountPercent",
    OnlineDiscountLF = "OnlineDiscountLF",
    HandlingFee = "HandlingFee",
    LfClubPriceAbsolute = "LfClubPriceAbsolute",
}

export enum StockStatusType {
    OutOfStock = "OutOfStock",
    FewInStock = "FewInStock",
    InStock = "InStock",
    Procured = "Procured",
}

export enum ATPStockStockStatus {
    No = "No",
    Yes = "Yes",
    Soon = "Soon",
}

export enum HaGeBasketLineType {
    Catalog = "Catalog",
    Contract = "Contract",
}

export enum HaGeBasketLineProductPriceType {
    Unknown = "Unknown",
    Retail = "Retail",
    Wholesale = "Wholesale",
    RetailDiscountOrFee = "RetailDiscountOrFee",
    ScaleDiscountAmount = "ScaleDiscountAmount",
    ScaleDiscountPercent = "ScaleDiscountPercent",
    CustomerGroupPrice = "CustomerGroupPrice",
    LFClubPrice = "LFClubPrice",
    OnlineDiscountPortal = "OnlineDiscountPortal",
    Contract = "Contract",
    FarmerDiscountAmount = "FarmerDiscountAmount",
    FarmerDiscountPercent = "FarmerDiscountPercent",
    OnlineDiscountLF = "OnlineDiscountLF",
    HandlingFee = "HandlingFee",
    LfClubPriceAbsolute = "LfClubPriceAbsolute",
}

export enum SimulationResultStatus {
    Unknown = "Unknown",
    Ok = "Ok",
    EnergyBlocked = "EnergyBlocked",
    AccountBlocked = "AccountBlocked",
    ManualProductsBlocked = "ManualProductsBlocked",
    SAP423 = "SAP423",
    PrivAccountInvalid = "PrivAccountInvalid",
    ProductSoldout = "ProductSoldout",
    OrdrerNotExist = "OrdrerNotExist",
    NoOutData = "NoOutData",
    ReturnDataError = "ReturnDataError",
    ToMuchOnLine = "ToMuchOnLine",
    MissingMabCertificate = "MissingMabCertificate",
    PartialSuccess = "PartialSuccess",
}

export enum PriceModifierKey {
    SapPriceLower = "SapPriceLower",
    LOFPalletFreight = "LOFPalletFreight",
    Charges = "Charges",
    Costs = "Costs",
    QuantityDifference = "QuantityDifference",
    Discount = "Discount",
    MonthSupplement = "MonthSupplement",
    ContractPrice = "ContractPrice",
}

export enum DigifarmDefaultResponseOfListOfDigiAddressStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export enum LocationSource {
    None = "None",
    Chauffeur = "Chauffeur",
    Customer = "Customer",
    Default = "Default",
}

export enum DigifarmDefaultResponseOfListOfLocTypeStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "Ambiguous",
    MovedPermanently = "MovedPermanently",
    Moved = "Moved",
    Found = "Found",
    Redirect = "Redirect",
    SeeOther = "SeeOther",
    RedirectMethod = "RedirectMethod",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "RedirectKeepVerb",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    UpgradeRequired = "UpgradeRequired",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

}